import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { forwardRef, FormControl, FormLabel as FormLabel$1, InputGroup, InputLeftAddon, Input as Input$3, InputRightElement, InputLeftElement, FormHelperText, FormErrorMessage, Spinner as Spinner$1, Box, Text as Text$1, Badge as Badge$1, Button as Button$1, Fade, useMultiStyleConfig, chakra, IconButton, Flex, ListItem, List, SimpleGrid, Modal as Modal$1, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Textarea as Textarea$3, extendTheme } from '@chakra-ui/react';
import * as react from '@chakra-ui/react';
export { react as Chakra };
export { AbsoluteCenter as ChakraAbsoluteCenter, Accordion as ChakraAccordion, AccordionButton as ChakraAccordionButton, AccordionIcon as ChakraAccordionIcon, AccordionItem as ChakraAccordionItem, AccordionPanel as ChakraAccordionPanel, AccordionProvider as ChakraAccordionProvider, Alert as ChakraAlert, AlertDescription as ChakraAlertDescription, AlertDialog as ChakraAlertDialog, AlertDialogBody as ChakraAlertDialogBody, AlertDialogCloseButton as ChakraAlertDialogCloseButton, AlertDialogContent as ChakraAlertDialogContent, AlertDialogFooter as ChakraAlertDialogFooter, AlertDialogHeader as ChakraAlertDialogHeader, AlertDialogOverlay as ChakraAlertDialogOverlay, AlertIcon as ChakraAlertIcon, AlertTitle as ChakraAlertTitle, AspectRatio as ChakraAspectRatio, Avatar as ChakraAvatar, AvatarBadge as ChakraAvatarBadge, AvatarGroup as ChakraAvatarGroup, Badge as ChakraBadge, Box as ChakraBox, Breadcrumb as ChakraBreadcrumb, BreadcrumbItem as ChakraBreadcrumbItem, BreadcrumbLink as ChakraBreadcrumbLink, BreadcrumbSeparator as ChakraBreadcrumbSeparator, Button as ChakraButton, ButtonGroup as ChakraButtonGroup, ButtonSpinner as ChakraButtonSpinner, CSSPolyfill as ChakraCSSPolyfill, CSSReset as ChakraCSSReset, CSSVars as ChakraCSSVars, Card as ChakraCard, CardBody as ChakraCardBody, CardFooter as ChakraCardFooter, CardHeader as ChakraCardHeader, Center as ChakraCenter, Checkbox as ChakraCheckbox, CheckboxGroup as ChakraCheckboxGroup, CheckboxIcon as ChakraCheckboxIcon, Circle as ChakraCircle, CircularProgress as ChakraCircularProgress, CircularProgressLabel as ChakraCircularProgressLabel, CloseButton as ChakraCloseButton, Code as ChakraCode, Collapse as ChakraCollapse, ColorModeContext as ChakraColorModeContext, ColorModeProvider as ChakraColorModeProvider, ColorModeScript as ChakraColorModeScript, Container as ChakraContainer, ControlBox as ChakraControlBox, DarkMode as ChakraDarkMode, Divider as ChakraDivider, Drawer as ChakraDrawer, DrawerBody as ChakraDrawerBody, DrawerCloseButton as ChakraDrawerCloseButton, DrawerContent as ChakraDrawerContent, DrawerFooter as ChakraDrawerFooter, DrawerHeader as ChakraDrawerHeader, DrawerOverlay as ChakraDrawerOverlay, EASINGS as ChakraEASINGS, Editable as ChakraEditable, EditableInput as ChakraEditableInput, EditablePreview as ChakraEditablePreview, EditableTextarea as ChakraEditableTextarea, EnvironmentProvider as ChakraEnvironmentProvider, Fade as ChakraFade, Flex as ChakraFlex, FormControl as ChakraFormControl, FormErrorIcon as ChakraFormErrorIcon, FormErrorMessage as ChakraFormErrorMessage, FormHelperText as ChakraFormHelperText, FormLabel as ChakraFormLabel, GenericAvatarIcon as ChakraGenericAvatarIcon, GlobalStyle as ChakraGlobalStyle, Grid as ChakraGrid, GridItem as ChakraGridItem, HStack as ChakraHStack, Heading as ChakraHeading, Hide as ChakraHide, Highlight as ChakraHighlight, Icon as ChakraIcon, IconButton as ChakraIconButton, Image as ChakraImage, Img as ChakraImg, Input as ChakraInput, InputAddon as ChakraInputAddon, InputGroup as ChakraInputGroup, InputLeftAddon as ChakraInputLeftAddon, InputLeftElement as ChakraInputLeftElement, InputRightAddon as ChakraInputRightAddon, InputRightElement as ChakraInputRightElement, Kbd as ChakraKbd, LightMode as ChakraLightMode, Link as ChakraLink, LinkBox as ChakraLinkBox, LinkOverlay as ChakraLinkOverlay, List as ChakraList, ListIcon as ChakraListIcon, ListItem as ChakraListItem, Mark as ChakraMark, Menu as ChakraMenu, MenuButton as ChakraMenuButton, MenuCommand as ChakraMenuCommand, MenuDescendantsProvider as ChakraMenuDescendantsProvider, MenuDivider as ChakraMenuDivider, MenuGroup as ChakraMenuGroup, MenuIcon as ChakraMenuIcon, MenuItem as ChakraMenuItem, MenuItemOption as ChakraMenuItemOption, MenuList as ChakraMenuList, MenuOptionGroup as ChakraMenuOptionGroup, MenuProvider as ChakraMenuProvider, Modal as ChakraModal, ModalBody as ChakraModalBody, ModalCloseButton as ChakraModalCloseButton, ModalContent as ChakraModalContent, ModalContextProvider as ChakraModalContextProvider, ModalFocusScope as ChakraModalFocusScope, ModalFooter as ChakraModalFooter, ModalHeader as ChakraModalHeader, ModalOverlay as ChakraModalOverlay, NumberDecrementStepper as ChakraNumberDecrementStepper, NumberIncrementStepper as ChakraNumberIncrementStepper, NumberInput as ChakraNumberInput, NumberInputField as ChakraNumberInputField, NumberInputStepper as ChakraNumberInputStepper, OrderedList as ChakraOrderedList, PinInput as ChakraPinInput, PinInputDescendantsProvider as ChakraPinInputDescendantsProvider, PinInputField as ChakraPinInputField, PinInputProvider as ChakraPinInputProvider, Popover as ChakraPopover, PopoverAnchor as ChakraPopoverAnchor, PopoverArrow as ChakraPopoverArrow, PopoverBody as ChakraPopoverBody, PopoverCloseButton as ChakraPopoverCloseButton, PopoverContent as ChakraPopoverContent, PopoverFooter as ChakraPopoverFooter, PopoverHeader as ChakraPopoverHeader, PopoverTrigger as ChakraPopoverTrigger, Portal as ChakraPortal, PortalManager as ChakraPortalManager, Progress as ChakraProgress, ProgressLabel as ChakraProgressLabel, ChakraProvider, Radio as ChakraRadio, RadioGroup as ChakraRadioGroup, RangeSlider as ChakraRangeSlider, RangeSliderFilledTrack as ChakraRangeSliderFilledTrack, RangeSliderMark as ChakraRangeSliderMark, RangeSliderProvider as ChakraRangeSliderProvider, RangeSliderThumb as ChakraRangeSliderThumb, RangeSliderTrack as ChakraRangeSliderTrack, RequiredIndicator as ChakraRequiredIndicator, ScaleFade as ChakraScaleFade, Select as ChakraSelect, SelectField as ChakraSelectField, Show as ChakraShow, SimpleGrid as ChakraSimpleGrid, Skeleton as ChakraSkeleton, SkeletonCircle as ChakraSkeletonCircle, SkeletonText as ChakraSkeletonText, Slide as ChakraSlide, SlideFade as ChakraSlideFade, Slider as ChakraSlider, SliderFilledTrack as ChakraSliderFilledTrack, SliderMark as ChakraSliderMark, SliderProvider as ChakraSliderProvider, SliderThumb as ChakraSliderThumb, SliderTrack as ChakraSliderTrack, Spacer as ChakraSpacer, Spinner as ChakraSpinner, Square as ChakraSquare, Stack as ChakraStack, StackDivider as ChakraStackDivider, StackItem as ChakraStackItem, Stat as ChakraStat, StatArrow as ChakraStatArrow, StatDownArrow as ChakraStatDownArrow, StatGroup as ChakraStatGroup, StatHelpText as ChakraStatHelpText, StatLabel as ChakraStatLabel, StatNumber as ChakraStatNumber, StatUpArrow as ChakraStatUpArrow, StylesProvider as ChakraStylesProvider, Switch as ChakraSwitch, Tab as ChakraTab, TabIndicator as ChakraTabIndicator, TabList as ChakraTabList, TabPanel as ChakraTabPanel, TabPanels as ChakraTabPanels, Table as ChakraTable, TableCaption as ChakraTableCaption, TableContainer as ChakraTableContainer, Tabs as ChakraTabs, TabsDescendantsProvider as ChakraTabsDescendantsProvider, TabsProvider as ChakraTabsProvider, Tag as ChakraTag, TagCloseButton as ChakraTagCloseButton, TagLabel as ChakraTagLabel, TagLeftIcon as ChakraTagLeftIcon, TagRightIcon as ChakraTagRightIcon, Tbody as ChakraTbody, Td as ChakraTd, Text as ChakraText, Textarea as ChakraTextarea, Tfoot as ChakraTfoot, Th as ChakraTh, Thead as ChakraThead, ThemeProvider as ChakraThemeProvider, Toast as ChakraToast, ToastProvider as ChakraToastProvider, Tooltip as ChakraTooltip, Tr as ChakraTr, UnorderedList as ChakraUnorderedList, VStack as ChakraVStack, VisuallyHidden as ChakraVisuallyHidden, VisuallyHiddenInput as ChakraVisuallyHiddenInput, Wrap as ChakraWrap, WrapItem as ChakraWrapItem, addPrefix as chakraAddPrefix, assignRef as chakraAssignRef, background as chakraBackground, border as chakraBorder, calc as chakraCalc, chakra as chakraChakra, color as chakraColor, cookieStorageManager as chakraCookieStorageManager, cookieStorageManagerSSR as chakraCookieStorageManagerSSR, createCookieStorageManager as chakraCreateCookieStorageManager, createIcon as chakraCreateIcon, createLocalStorageManager as chakraCreateLocalStorageManager, createMultiStyleConfigHelpers as chakraCreateMultiStyleConfigHelpers, createRenderToast as chakraCreateRenderToast, createStandaloneToast as chakraCreateStandaloneToast, createStylesContext as chakraCreateStylesContext, createToastFn as chakraCreateToastFn, css as chakraCss, cssVar as chakraCssVar, defineStyle as chakraDefineStyle, defineStyleConfig as chakraDefineStyleConfig, effect as chakraEffect, extendTheme as chakraExtendTheme, fadeConfig as chakraFadeConfig, filter as chakraFilter, flatten as chakraFlatten, flattenTokens as chakraFlattenTokens, flexbox as chakraFlexbox, forwardRef as chakraForwardRef, getCSSVar as chakraGetCSSVar, getCss as chakraGetCss, getScriptSrc as chakraGetScriptSrc, getToastPlacement as chakraGetToastPlacement, getToken as chakraGetToken, grid as chakraGrid, interactivity as chakraInteractivity, isChakraTheme as chakraIsChakraTheme, isStyleProp as chakraIsStyleProp, keyframes as chakraKeyframes, layout as chakraLayout, layoutPropNames as chakraLayoutPropNames, list as chakraList, localStorageManager as chakraLocalStorageManager, mergeThemeOverride as chakraMergeThemeOverride, omitThemingProps as chakraOmitThemingProps, others as chakraOthers, popperCSSVars as chakraPopperCSSVars, position as chakraPosition, propNames as chakraPropNames, pseudoPropNames as chakraPseudoPropNames, pseudoSelectors as chakraPseudoSelectors, requiredChakraThemeKeys as chakraRequiredChakraThemeKeys, resolveStyleConfig as chakraResolveStyleConfig, ring as chakraRing, scaleFadeConfig as chakraScaleFadeConfig, scroll as chakraScroll, shouldForwardProp as chakraShouldForwardProp, slideFadeConfig as chakraSlideFadeConfig, space as chakraSpace, styled as chakraStyled, systemProps as chakraSystemProps, textDecoration as chakraTextDecoration, theme as chakraTheme, toCSSObject as chakraToCSSObject, toCSSVar as chakraToCSSVar, toVarDefinition as chakraToVarDefinition, toVarReference as chakraToVarReference, tokenToCSSVar as chakraTokenToCSSVar, transform as chakraTransform, transition as chakraTransition, typography as chakraTypography, useAccordion as chakraUseAccordion, useAccordionContext as chakraUseAccordionContext, useAccordionItem as chakraUseAccordionItem, useAccordionItemState as chakraUseAccordionItemState, useAccordionStyles as chakraUseAccordionStyles, useAlertStyles as chakraUseAlertStyles, useAnimationState as chakraUseAnimationState, useAvatarStyles as chakraUseAvatarStyles, useBoolean as chakraUseBoolean, useBreadcrumbStyles as chakraUseBreadcrumbStyles, useBreakpoint as chakraUseBreakpoint, useBreakpointValue as chakraUseBreakpointValue, useButtonGroup as chakraUseButtonGroup, useCallbackRef as chakraUseCallbackRef, useChakra as chakraUseChakra, useCheckbox as chakraUseCheckbox, useCheckboxGroup as chakraUseCheckboxGroup, useClipboard as chakraUseClipboard, useColorMode as chakraUseColorMode, useColorModePreference as chakraUseColorModePreference, useColorModeValue as chakraUseColorModeValue, useConst as chakraUseConst, useControllableProp as chakraUseControllableProp, useControllableState as chakraUseControllableState, useCounter as chakraUseCounter, useDimensions as chakraUseDimensions, useDisclosure as chakraUseDisclosure, useDrawerContext as chakraUseDrawerContext, useEditable as chakraUseEditable, useEditableControls as chakraUseEditableControls, useEditableState as chakraUseEditableState, useEditableStyles as chakraUseEditableStyles, useEnvironment as chakraUseEnvironment, useEventListener as chakraUseEventListener, useEventListenerMap as chakraUseEventListenerMap, useFocusEffect as chakraUseFocusEffect, useFocusOnHide as chakraUseFocusOnHide, useFocusOnPointerDown as chakraUseFocusOnPointerDown, useFocusOnShow as chakraUseFocusOnShow, useForceUpdate as chakraUseForceUpdate, useFormControl as chakraUseFormControl, useFormControlContext as chakraUseFormControlContext, useFormControlProps as chakraUseFormControlProps, useFormControlStyles as chakraUseFormControlStyles, useFormErrorStyles as chakraUseFormErrorStyles, useHighlight as chakraUseHighlight, useId as chakraUseId, useIds as chakraUseIds, useImage as chakraUseImage, useInputGroupStyles as chakraUseInputGroupStyles, useInterval as chakraUseInterval, useLatestRef as chakraUseLatestRef, useListStyles as chakraUseListStyles, useMediaQuery as chakraUseMediaQuery, useMenu as chakraUseMenu, useMenuButton as chakraUseMenuButton, useMenuContext as chakraUseMenuContext, useMenuDescendant as chakraUseMenuDescendant, useMenuDescendants as chakraUseMenuDescendants, useMenuDescendantsContext as chakraUseMenuDescendantsContext, useMenuItem as chakraUseMenuItem, useMenuList as chakraUseMenuList, useMenuOption as chakraUseMenuOption, useMenuOptionGroup as chakraUseMenuOptionGroup, useMenuPositioner as chakraUseMenuPositioner, useMenuState as chakraUseMenuState, useMenuStyles as chakraUseMenuStyles, useMergeRefs as chakraUseMergeRefs, useModal as chakraUseModal, useModalContext as chakraUseModalContext, useModalStyles as chakraUseModalStyles, useMouseDownRef as chakraUseMouseDownRef, useMultiStyleConfig as chakraUseMultiStyleConfig, useNumberInput as chakraUseNumberInput, useNumberInputStyles as chakraUseNumberInputStyles, useOptionalPart as chakraUseOptionalPart, useOutsideClick as chakraUseOutsideClick, usePanGesture as chakraUsePanGesture, usePinInput as chakraUsePinInput, usePinInputContext as chakraUsePinInputContext, usePinInputField as chakraUsePinInputField, usePointerEvent as chakraUsePointerEvent, usePopover as chakraUsePopover, usePopoverContext as chakraUsePopoverContext, usePopoverStyles as chakraUsePopoverStyles, usePopper as chakraUsePopper, usePortalManager as chakraUsePortalManager, usePrefersReducedMotion as chakraUsePrefersReducedMotion, usePrevious as chakraUsePrevious, useProgressStyles as chakraUseProgressStyles, useQuery as chakraUseQuery, useRadio as chakraUseRadio, useRadioGroup as chakraUseRadioGroup, useRadioGroupContext as chakraUseRadioGroupContext, useRangeSlider as chakraUseRangeSlider, useRangeSliderContext as chakraUseRangeSliderContext, useRangeSliderStyles as chakraUseRangeSliderStyles, useSafeLayoutEffect as chakraUseSafeLayoutEffect, useShortcut as chakraUseShortcut, useSlider as chakraUseSlider, useSliderContext as chakraUseSliderContext, useSliderStyles as chakraUseSliderStyles, useStatStyles as chakraUseStatStyles, useStyleConfig as chakraUseStyleConfig, useStyles as chakraUseStyles, useTab as chakraUseTab, useTabIndicator as chakraUseTabIndicator, useTabList as chakraUseTabList, useTabPanel as chakraUseTabPanel, useTabPanels as chakraUseTabPanels, useTableStyles as chakraUseTableStyles, useTabs as chakraUseTabs, useTabsContext as chakraUseTabsContext, useTabsDescendant as chakraUseTabsDescendant, useTabsDescendants as chakraUseTabsDescendants, useTabsDescendantsContext as chakraUseTabsDescendantsContext, useTabsStyles as chakraUseTabsStyles, useTagStyles as chakraUseTagStyles, useTheme as chakraUseTheme, useTimeout as chakraUseTimeout, useToast as chakraUseToast, useToken as chakraUseToken, useTooltip as chakraUseTooltip, useUnmountEffect as chakraUseUnmountEffect, useUpdateEffect as chakraUseUpdateEffect, useWhyDidYouUpdate as chakraUseWhyDidYouUpdate, visuallyHiddenStyle as chakraVisuallyHiddenStyle, withDefaultColorScheme as chakraWithDefaultColorScheme, withDefaultProps as chakraWithDefaultProps, withDefaultSize as chakraWithDefaultSize, withDefaultVariant as chakraWithDefaultVariant } from '@chakra-ui/react';
import { Select as Select$1, components as components$1 } from 'chakra-react-select';
import { fontFaceLabGrotesque400NormalWoff2, fontFaceLabGrotesque500NormalWoff2, fontFaceLabGrotesque700NormalWoff2, borderRadiusMd, spacing3x, spacing4x, spacing5x, spacing6x, spacing2x, borderRadiusSm, spacing12x, shadowsLg, spacing8x, spacing1x, spacing7x, spacing10x, shadowsBase, colorPrimary900, colorPrimary100, colorPrimary200, colorPrimary300, colorPrimary400, colorPrimary500, colorPrimary600, colorPrimary700, colorPrimary800, colorSecondary100, colorSecondary200, colorSecondary300, colorSecondary400, colorSecondary500, colorSecondary600, colorSecondary700, colorSecondary800, colorSecondary900, colorGreyscale100, colorGreyscale200, colorGreyscale300, colorGreyscale400, colorGreyscale500, colorGreyscale600, colorGreyscale700, colorGreyscale800, colorGreyscale900, colorSuccess100, colorSuccess200, colorSuccess300, colorSuccess400, colorSuccess500, colorSuccess600, colorSuccess700, colorSuccess800, colorSuccess900, colorWarning100, colorWarning200, colorWarning300, colorWarning400, colorWarning500, colorWarning600, colorWarning700, colorWarning800, colorWarning900, colorDanger100, colorDanger200, colorDanger300, colorDanger400, colorDanger500, colorDanger600, colorDanger700, colorDanger800, colorDanger900, colorComplementaryBlue, lineHeightNone, lineHeightShort, lineHeightBase, fontFamilyMain, fontSizeXs, fontSizeSm, fontSizeMd, fontSizeLg, fontSizeXl, fontSize2xl, fontSize3xl, fontSize4xl, fontSize5xl, shadowsNone, shadowsMd, shadowsAlt, borderRadiusXs, borderRadiusLg, borderRadiusXl, borderRadius2xl, borderRadius3xl } from '@airhelp/design-tokens/dist/js/design-tokens';
import { createIcon } from '@chakra-ui/icon';
import debounce from 'lodash.debounce';
import { cssVar } from '@chakra-ui/theme-tools';
import { Global } from '@emotion/react';
import { AnimatePresence, motion } from 'framer-motion';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { format } from 'date-fns';
import { da, de, el, es, fi, fr, it, nb, nl, pl, pt, ro, ru, sv, ptBR, enGB, zhCN } from 'date-fns/locale';
import { useDropzone } from 'react-dropzone';
import classNames from 'classnames';
import path from 'path-browserify';
import SignaturePad from 'react-signature-pad-wrapper';

var Fonts = function Fonts() {
  return jsx(Global, {
    styles: "\n      @font-face {\n        font-family: \"Lab Grotesque\";\n        src: url(\"" + fontFaceLabGrotesque400NormalWoff2 + "\") format(\"woff2\");\n        font-weight: 400;\n        font-style: normal;\n        font-display: fallback;\n      }\n\n      @font-face {\n        font-family: \"Lab Grotesque\";\n        src:  url(\"" + fontFaceLabGrotesque500NormalWoff2 + "\") format(\"woff2\");\n        font-weight: 500;\n        font-style: normal;\n        font-display: fallback;\n      }\n\n      @font-face {\n        font-family: \"Lab Grotesque\";\n        src:  url(\"" + fontFaceLabGrotesque700NormalWoff2 + "\") format(\"woff2\");\n        font-weight: 700;\n        font-style: normal;\n        font-display: fallback;\n      }\n    "
  });
};

var Fonts$1 = Fonts;

var AcceptedPhotoId = /*#__PURE__*/createIcon({
  displayName: "AcceptedPhotoId",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9085 14.8515C11.9857 15.273 12.1852 15.6625 12.4821 15.9716C12.4987 15.9887 12.5158 16.0061 12.5338 16.023L13.9699 17.4594H3.52344C3.32336 17.4594 3.12522 17.4201 2.94035 17.3435C2.75549 17.267 2.58751 17.1548 2.44603 17.0133C2.30456 16.8718 2.19234 16.7039 2.11581 16.519C2.03928 16.3341 1.99992 16.136 2 15.9359V6.79529C1.99992 6.59521 2.03928 6.39707 2.11581 6.2122C2.19234 6.02734 2.30456 5.85936 2.44603 5.71789C2.58751 5.57641 2.75549 5.46419 2.94035 5.38766C3.12522 5.31113 3.32336 5.27177 3.52344 5.27185H17.2367C17.4368 5.27177 17.6349 5.31113 17.8198 5.38766C18.0047 5.46419 18.1726 5.57641 18.3141 5.71789C18.4556 5.85936 18.5678 6.02734 18.6443 6.2122C18.7209 6.39707 18.7602 6.59521 18.7601 6.79529V11.9718L17.4253 13.3066L16.7129 14.0193L15.6256 12.932C15.4214 12.7233 15.1777 12.5575 14.9086 12.4441C14.6396 12.3308 14.3506 12.2722 14.0587 12.2718C13.6301 12.2718 13.211 12.3977 12.8534 12.634C12.4958 12.8702 12.2156 13.2064 12.0476 13.6007C11.8796 13.9949 11.8312 14.4299 11.9085 14.8515ZM15.7109 9.08045H12.6641C12.462 9.08045 12.2683 9.1607 12.1255 9.30355C11.9826 9.4464 11.9023 9.64014 11.9023 9.84216C11.9023 10.0442 11.9826 10.2379 12.1255 10.3808C12.2683 10.5236 12.462 10.6039 12.6641 10.6039H15.7109C15.913 10.6039 16.1067 10.5236 16.2496 10.3808C16.3924 10.2379 16.4727 10.0442 16.4727 9.84216C16.4727 9.64014 16.3924 9.4464 16.2496 9.30355C16.1067 9.1607 15.913 9.08045 15.7109 9.08045ZM8.85547 9.84216C8.85547 8.97917 8.19502 8.31873 7.33203 8.31873C6.46904 8.31873 5.8086 8.97917 5.8086 9.84216C5.8086 10.7052 6.46904 11.3656 7.33203 11.3656C8.19502 11.3656 8.85547 10.7052 8.85547 9.84216ZM10.2673 14.3009C10.3387 14.2295 10.3788 14.1327 10.3789 14.0318V13.8159C10.3789 12.8197 8.9965 12.1273 7.33203 12.1273C5.66757 12.1273 4.28516 12.8197 4.28516 13.8159V14.0318C4.28523 14.1327 4.32537 14.2295 4.39675 14.3009C4.46813 14.3723 4.56492 14.4124 4.66587 14.4125H9.9982C10.0991 14.4124 10.1959 14.3723 10.2673 14.3009ZM21.0941 11.8216H21.1202C21.2953 11.8217 21.4664 11.8739 21.6116 11.9717C21.7568 12.0695 21.8695 12.2084 21.9354 12.3706C22.0013 12.5329 22.0172 12.711 21.9813 12.8824C21.9454 13.0537 21.8591 13.2105 21.7336 13.3326L17.3336 17.732C17.1686 17.897 16.9448 17.9897 16.7114 17.9897C16.478 17.9897 16.2541 17.897 16.0891 17.732L15.5554 17.1983L13.4493 15.0922C13.4406 15.0841 13.4322 15.0757 13.4241 15.067C13.3412 14.9842 13.2758 14.8857 13.2315 14.7773C13.1872 14.6689 13.165 14.5527 13.1662 14.4356C13.1673 14.3185 13.1919 14.2028 13.2383 14.0953C13.2848 13.9878 13.3522 13.8907 13.4367 13.8096C13.5212 13.7285 13.621 13.665 13.7303 13.623C13.8396 13.581 13.9562 13.5612 14.0733 13.5648C14.1903 13.5684 14.3055 13.5953 14.412 13.644C14.5185 13.6926 14.6143 13.7621 14.6936 13.8482L16.7115 15.8661L18.3472 14.2301L20.489 12.088C20.6484 11.9239 20.8654 11.8284 21.0941 11.8216Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AddPhoto = /*#__PURE__*/createIcon({
  displayName: "AddPhoto",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.5 9.5C3.95 9.5 3.5 9.05 3.5 8.5V6.5H1.5C0.95 6.5 0.5 6.05 0.5 5.5C0.5 4.95 0.95 4.5 1.5 4.5H3.5V2.5C3.5 1.95 3.95 1.5 4.5 1.5C5.05 1.5 5.5 1.95 5.5 2.5V4.5H7.5C8.05 4.5 8.5 4.95 8.5 5.5C8.5 6.05 8.05 6.5 7.5 6.5H5.5V8.5C5.5 9.05 5.05 9.5 4.5 9.5ZM10.9019 13C11.4378 12.0718 12.4282 11.5 13.5 11.5C14.5718 11.5 15.5622 12.0718 16.0981 13C16.634 13.9282 16.634 15.0718 16.0981 16C15.5622 16.9282 14.5718 17.5 13.5 17.5C12.4282 17.5 11.4378 16.9282 10.9019 16C10.366 15.0718 10.366 13.9282 10.9019 13ZM21.5 6.5H18.33L17.09 5.15C16.72 4.74 16.18 4.5 15.62 4.5H9.22C9.39 4.8 9.5 5.13 9.5 5.5C9.5 6.6 8.6 7.5 7.5 7.5H6.5V8.5C6.5 9.6 5.6 10.5 4.5 10.5C4.13 10.5 3.8 10.39 3.5 10.22V20.5C3.5 21.6 4.4 22.5 5.5 22.5H21.5C22.6 22.5 23.5 21.6 23.5 20.5V8.5C23.5 7.4 22.6 6.5 21.5 6.5ZM8.5 14.5C8.5 17.26 10.74 19.5 13.5 19.5C16.26 19.5 18.5 17.26 18.5 14.5C18.5 11.74 16.26 9.5 13.5 9.5C10.74 9.5 8.5 11.74 8.5 14.5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Agenda = /*#__PURE__*/createIcon({
  displayName: "Agenda",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2.1001 7.03599C2.1001 6.53893 2.50304 6.13599 3.0001 6.13599H21.0001C21.4972 6.13599 21.9001 6.53893 21.9001 7.03599V17.9646C21.9001 18.4616 21.4972 18.8646 21.0001 18.8646H3.0001C2.50304 18.8646 2.1001 18.4616 2.1001 17.9646V7.03599ZM3.9001 7.93599V17.0646H20.1001V7.93599H3.9001Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.95715 10.8932C5.95715 10.3961 6.3601 9.99316 6.85715 9.99316H17.1429C17.6399 9.99316 18.0429 10.3961 18.0429 10.8932C18.0429 11.3902 17.6399 11.7932 17.1429 11.7932H6.85715C6.3601 11.7932 5.95715 11.3902 5.95715 10.8932Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M5.95715 14.1075C5.95715 13.6105 6.3601 13.2075 6.85715 13.2075H13.9286C14.4256 13.2075 14.8286 13.6105 14.8286 14.1075C14.8286 14.6046 14.4256 15.0075 13.9286 15.0075H6.85715C6.3601 15.0075 5.95715 14.6046 5.95715 14.1075Z"
    })]
  })
});

var AirLuggage = /*#__PURE__*/createIcon({
  displayName: "AirLuggage",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.19 4.2825L11.19 1.1725C11.7 0.9425 12.3 0.9425 12.81 1.1725L19.81 4.2825C20.53 4.6025 21 5.3225 21 6.1125V10.8125C21 16.3625 17.16 21.5525 12 22.8125C6.84 21.5525 3 16.3625 3 10.8125V6.1125C3 5.3225 3.47 4.6025 4.19 4.2825ZM13.25 7.58518H10.75V8.16518H13.25V7.58518ZM13.875 8.16518H14.63L14.64 15.7502H9.36V8.16518H10.125V7.29018C10.1289 7.21015 10.1641 7.13488 10.2231 7.08061C10.282 7.02635 10.3599 6.99745 10.44 7.00018H13.56C13.6401 6.99745 13.718 7.02635 13.7769 7.08061C13.8359 7.13488 13.8711 7.21015 13.875 7.29018V8.16518ZM15.215 15.7502V8.16518H15.75C16.0701 8.15437 16.3815 8.27094 16.6158 8.48932C16.8501 8.70771 16.9883 9.01009 17 9.33018V14.5802C16.9883 14.9007 16.8503 15.2036 16.6161 15.4228C16.3819 15.6419 16.0706 15.7596 15.75 15.7502H15.215ZM8.25 8.16518H8.75V15.7502H8.25C7.9294 15.7596 7.61807 15.6419 7.38391 15.4228C7.14974 15.2036 7.01174 14.9007 7 14.5802V9.33018C7.01173 9.01009 7.1499 8.70771 7.38421 8.48932C7.61853 8.27094 7.92988 8.15437 8.25 8.16518Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirPayout = /*#__PURE__*/createIcon({
  displayName: "AirPayout",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.19 4.2825L11.19 1.1725C11.7 0.9425 12.3 0.9425 12.81 1.1725L19.81 4.2825C20.53 4.6025 21 5.3225 21 6.1125V10.8125C21 16.3625 17.16 21.5525 12 22.8125C6.84 21.5525 3 16.3625 3 10.8125V6.1125C3 5.3225 3.47 4.6025 4.19 4.2825ZM14.9425 8.22469C15.0049 8.3166 15.087 8.39346 15.1829 8.44967C15.2787 8.50589 15.3858 8.54006 15.4965 8.5497L15.6139 9.00007H16.6475L16.2239 7.37413C16.2074 7.31056 16.1785 7.25088 16.1389 7.19848C16.0993 7.14609 16.0497 7.10201 15.9931 7.06877C15.9365 7.03553 15.8738 7.01377 15.8088 7.00474C15.7437 6.99572 15.6775 6.9996 15.6139 7.01616L7.99508 9.00007H11.9636L14.9425 8.22469ZM7.5 10H16.5C16.6326 10 16.7598 10.0527 16.8536 10.1465C16.9473 10.2402 17 10.3674 17 10.5V15.5C17 15.6326 16.9473 15.7598 16.8536 15.8536C16.7598 15.9474 16.6326 16 16.5 16H7.5C7.36739 16 7.24021 15.9474 7.14645 15.8536C7.05268 15.7598 7 15.6326 7 15.5V10.5C7 10.3674 7.05268 10.2402 7.14645 10.1465C7.24021 10.0527 7.36739 10 7.5 10ZM15.7203 14.7203C15.7992 14.6413 15.8948 14.5809 16 14.5435L16.0002 11.4563C15.895 11.419 15.7994 11.3586 15.7204 11.2797C15.6415 11.2008 15.5811 11.1052 15.5437 11H8.4563C8.41901 11.1053 8.35869 11.2009 8.27975 11.2799C8.20081 11.3588 8.10524 11.4192 8 11.4565V14.5435C8.10524 14.5809 8.20081 14.6412 8.27975 14.7202C8.35869 14.7992 8.41901 14.8948 8.4563 15H15.5437C15.581 14.8948 15.6414 14.7992 15.7203 14.7203ZM13.5 13.0005C13.5 13.8289 12.8284 14.5005 12 14.5005C11.1716 14.5005 10.5 13.8289 10.5 13.0005C10.5 12.1721 11.1716 11.5005 12 11.5005C12.8284 11.5005 13.5 12.1721 13.5 13.0005Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Airplane = /*#__PURE__*/createIcon({
  displayName: "Airplane",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C10.8954 2 10 2.89543 10 4V9.37891L2.49023 14.0684C2.18523 14.2594 2 14.5931 2 14.9531C2 15.6581 2.68247 16.1612 3.35547 15.9512L10 13.8809V19.2402L8.33789 20.4824C8.12489 20.6414 8 20.8922 8 21.1582C8 21.7062 8.51587 22.1076 9.04688 21.9746L12 21.2363L14.9531 21.9746C15.4841 22.1076 16 21.7062 16 21.1582C16 20.8922 15.8751 20.6414 15.6621 20.4824L14 19.2402V13.8809L20.6445 15.9512C21.3175 16.1612 22 15.6581 22 14.9531C22 14.5931 21.8148 14.2594 21.5098 14.0684L14 9.37891V4C14 2.89543 13.1046 2 12 2Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneLanding = /*#__PURE__*/createIcon({
  displayName: "AirplaneLanding",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M10.8995 3.00008C10.174 3.00779 9.55556 3.62734 9.55556 4.42567V12.8845L3.54709 11.2321L2.70681 8.86942C2.60293 8.57976 2.36627 8.36261 2.07661 8.2937C1.52661 8.16227 1 8.60012 1 9.19093V12.5231C1 13.6805 1.74712 14.6944 2.81901 14.9905L20.737 19.9502V19.9452C20.8776 19.9811 21.0219 19.9995 21.1667 20C22.1792 20 23 19.143 23 18.0859C22.9998 17.1683 22.3759 16.38 21.5128 16.2067L15.4089 14.502L12.2172 3.9945C12.0706 3.51215 11.69 3.14598 11.217 3.03497C11.1105 3.00992 11.0032 2.99897 10.8995 3.00008Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneLandingAirstrip = /*#__PURE__*/createIcon({
  displayName: "AirplaneLandingAirstrip",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.0996 3.00011C10.506 3.00615 10 3.49167 10 4.1173V10.7462L5.08398 9.45128L4.39648 7.59972C4.31148 7.37272 4.11786 7.20255 3.88086 7.14855C3.43086 7.04555 3 7.38867 3 7.85167V10.463C3 11.37 3.61128 12.1646 4.48828 12.3966L19.1484 16.2833V16.2794C19.2635 16.3076 19.3815 16.322 19.5 16.3224C20.3284 16.3224 21 15.6508 21 14.8224C20.9998 14.1033 20.4894 13.4855 19.7832 13.3497L14.7891 12.0138L12.1777 3.77941C12.0577 3.40141 11.7464 3.11445 11.3594 3.02745C11.2723 3.00783 11.1844 2.99925 11.0996 3.00011ZM4 19.3224C3.448 19.3224 3 19.7704 3 20.3224C3 20.8744 3.448 21.3224 4 21.3224H20C20.552 21.3224 21 20.8744 21 20.3224C21 19.7704 20.552 19.3224 20 19.3224H4Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneModeOff = /*#__PURE__*/createIcon({
  displayName: "AirplaneModeOff",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.0621 2C8.3581 2 7.85505 2.68247 8.06405 3.35547L9.69882 7.46094L16.2398 14H19.9996C21.1096 14 21.9996 13.1 21.9996 12C21.9996 10.9 21.1096 10 19.9996 10H14.9996L9.94882 2.49023C9.75782 2.18523 9.4231 2 9.0621 2ZM3.70663 4.70703C3.45076 4.70703 3.1951 4.8045 2.9996 5C2.6086 5.391 2.6086 6.02406 2.9996 6.41406L6.58554 10H4.9996L3.61874 8.30273C3.47374 8.12473 3.33798 8 3.10898 8H2.4996C2.1746 8 1.93623 8.30609 2.01523 8.62109L2.9996 12L2.01523 15.3789C1.93623 15.6939 2.1746 16 2.4996 16H3.10898C3.33798 16 3.47374 15.8753 3.61874 15.6973L4.9996 14H10.4898L8.04257 20.6445C7.83357 21.3175 8.33757 22 9.04257 22C9.40257 22 9.73729 21.8148 9.92929 21.5098L13.2437 16.6582L17.5855 21C17.9765 21.391 18.6096 21.391 18.9996 21C19.3896 20.609 19.3906 19.9759 18.9996 19.5859L13.398 13.9844L9.42929 10H9.41366L4.41366 5C4.21866 4.8045 3.96251 4.70703 3.70663 4.70703Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneMultipleTrips = /*#__PURE__*/createIcon({
  displayName: "AirplaneMultipleTrips",
  viewBox: "0 0 25 23",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "25",
      height: "23",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.999 4.58313C13.2627 4.58313 12.6657 5.18007 12.6657 5.91643V9.50227L7.65933 12.6285C7.45601 12.7558 7.33252 12.9783 7.33252 13.2183C7.33252 13.6883 7.78749 14.0237 8.23614 13.8837L12.6657 12.5035V16.0763L11.5577 16.9044C11.4157 17.0104 11.3324 17.1776 11.3324 17.3549C11.3324 17.7203 11.6763 17.9879 12.0303 17.8992L13.999 17.407L15.9677 17.8992C16.3217 17.9879 16.6656 17.7203 16.6656 17.3549C16.6656 17.1776 16.5824 17.0104 16.4404 16.9044L15.3323 16.0763V12.5035L19.7619 13.8837C20.2105 14.0237 20.6655 13.6883 20.6655 13.2183C20.6655 12.9783 20.542 12.7558 20.3387 12.6285L15.3323 9.50227V5.91643C15.3323 5.18007 14.7354 4.58313 13.999 4.58313Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.9991 0.5C13.4468 0.5 12.9991 0.947704 12.9991 1.49997C12.9991 2.05224 13.4468 2.49995 13.9991 2.49995C18.9695 2.49995 22.9988 6.52928 22.9988 11.4997C22.9988 16.4701 18.9695 20.4995 13.9991 20.4995C9.02862 20.4995 4.99929 16.4701 4.99929 11.4997C4.99929 10.4149 5.19079 9.37646 5.5415 8.41514L5.93194 9.87229C6.07488 10.4057 6.6232 10.7223 7.15665 10.5794C7.6901 10.4364 8.00668 9.88812 7.86374 9.35467L6.56968 4.52516L1.74018 5.81923C1.20672 5.96216 0.890149 6.51049 1.03309 7.04394C1.17603 7.57739 1.72435 7.89397 2.2578 7.75103L3.81601 7.33351C3.28941 8.61942 2.99934 10.0267 2.99934 11.4997C2.99934 17.5747 7.92408 22.4994 13.9991 22.4994C20.074 22.4994 24.9988 17.5747 24.9988 11.4997C24.9988 5.42474 20.074 0.5 13.9991 0.5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneRight = /*#__PURE__*/createIcon({
  displayName: "AirplaneRight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.996 10H14.996L9.92797 2.491C9.73697 2.186 9.40197 2 9.04097 2C8.33597 2 7.83297 2.683 8.04297 3.356L10.486 10H4.99597C4.99597 10 4.99597 10 3.61597 8.3C3.46597 8.12 3.33597 8 3.10597 8H2.49597C2.16597 8 1.93597 8.31 2.01597 8.62L2.99597 12L2.01597 15.38C1.93597 15.69 2.16597 16 2.49597 16H3.10597C3.33597 16 3.46597 15.88 3.61597 15.7C4.99597 14 4.99597 14 4.99597 14H10.486L8.04497 20.644C7.83497 21.317 8.33797 22 9.04297 22C9.40397 22 9.73897 21.814 9.92997 21.509L14.996 14H19.996C21.106 14 21.996 13.1 21.996 12C21.996 10.9 21.106 10 19.996 10Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneTakeOff = /*#__PURE__*/createIcon({
  displayName: "AirplaneTakeOff",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.59151 5.00059C6.4822 5.00388 6.37134 5.02032 6.2639 5.05208C5.48523 5.28334 5.12814 6.16396 5.53217 6.85416L9.63799 13.8636L3.40154 15.4738L1.58417 13.9783C1.33563 13.7734 0.998427 13.7058 0.687446 13.798C0.0899714 13.973 -0.183208 14.6516 0.13267 15.1789L1.71091 17.8141C2.26676 18.7416 3.38381 19.1943 4.44653 18.9211L22.4744 14.2731C22.4768 14.2724 22.4791 14.2716 22.4815 14.2708C23.3593 14.1198 23.9995 13.3737 24 12.5015C24 11.5088 23.1778 10.7041 22.1635 10.7041C22.0036 10.7041 21.8445 10.7246 21.69 10.7649V10.7626L15.2862 12.4125L7.49063 5.33058C7.24362 5.1059 6.91944 4.9907 6.59151 5.00059Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneTakeOffAirstrip = /*#__PURE__*/createIcon({
  displayName: "AirplaneTakeOffAirstrip",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7.38375 4.00049C7.29447 4.00324 7.20392 4.01696 7.11617 4.04346C6.48017 4.23646 6.18852 4.97136 6.51852 5.54736L9.87203 11.397L4.77828 12.7407L3.29391 11.4927C3.09091 11.3217 2.81549 11.2653 2.56149 11.3423C2.07349 11.4883 1.85036 12.0546 2.10836 12.4946L3.39742 14.6938C3.85142 15.4678 4.7638 15.8457 5.6318 15.6177L20.3564 11.7388C20.3584 11.7381 20.3603 11.7375 20.3623 11.7368C21.0792 11.6108 21.6021 10.9882 21.6025 10.2603C21.6025 9.43183 20.9309 8.76026 20.1025 8.76026C19.9719 8.76028 19.8419 8.77735 19.7158 8.81104V8.80908L14.4853 10.186L8.11813 4.27588C7.91638 4.08838 7.6516 3.99224 7.38375 4.00049ZM3.20406 18.7603C2.65206 18.7603 2.20406 19.2083 2.20406 19.7603C2.20406 20.3123 2.65206 20.7603 3.20406 20.7603H19.2041C19.7561 20.7603 20.2041 20.3123 20.2041 19.7603C20.2041 19.2083 19.7561 18.7603 19.2041 18.7603H3.20406Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AirplaneUpgrade = /*#__PURE__*/createIcon({
  displayName: "AirplaneUpgrade",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M10 4.5C10 3.39543 10.8954 2.5 12 2.5C13.1046 2.5 14 3.39543 14 4.5V9.87891L21.5098 14.5684C21.8148 14.7594 22 15.0931 22 15.4531C22 16.1581 21.3175 16.6612 20.6445 16.4512L20.4347 16.3858V16.3806L19.5989 14.4086C19.085 13.1978 17.3688 13.1973 16.8548 14.408L16.532 15.1698L14 14.3809V16.5517L13.882 16.5617C12.5685 16.6729 12.0355 18.3099 13.0319 19.1728L14.6558 20.5796L14.2544 22.2999L12 21.7363L9.04688 22.4746C8.51587 22.6076 8 22.2062 8 21.6582C8 21.3922 8.12489 21.1414 8.33789 20.9824L10 19.7402V14.3809L3.35547 16.4512C2.68247 16.6612 2 16.1581 2 15.4531C2 15.0931 2.18523 14.7594 2.49023 14.5684L10 9.87891V4.5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.21 22.0073L20.5639 23.428C20.9353 23.6521 21.3934 23.3191 21.2949 22.897L20.67 20.2191L22.7501 18.417C23.078 18.1333 22.9027 17.5947 22.4706 17.5582L19.7326 17.3261L18.6615 14.7988C18.4924 14.4004 17.9277 14.4004 17.7586 14.7988L16.6875 17.3261L13.9494 17.5582C13.5174 17.5947 13.3421 18.1333 13.6699 18.417L15.75 20.2191L15.1252 22.897C15.0267 23.3191 15.4847 23.6521 15.8561 23.428L18.21 22.0073Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AltArrowBack = /*#__PURE__*/createIcon({
  displayName: "ArrowBack",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.5863 11.6315L15.4072 7.8105C15.8212 7.3965 15.8212 6.7245 15.4072 6.3105C14.9932 5.8965 14.3212 5.8965 13.9072 6.3105L9.29325 10.9245C8.90225 11.3155 8.90225 11.9485 9.29325 12.3385L13.9072 16.9525C14.3212 17.3665 14.9932 17.3665 15.4072 16.9525C15.8212 16.5385 15.8212 15.8665 15.4072 15.4525L11.5863 11.6315Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AltArrowCollapse = /*#__PURE__*/createIcon({
  displayName: "ArrowCollapse",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.6315 11.5863L15.4525 15.4072C15.8665 15.8212 16.5385 15.8212 16.9525 15.4072C17.3665 14.9932 17.3665 14.3212 16.9525 13.9072L12.3385 9.29325C11.9475 8.90225 11.3145 8.90225 10.9245 9.29325L6.3105 13.9072C5.8965 14.3212 5.8965 14.9932 6.3105 15.4072C6.7245 15.8212 7.3965 15.8212 7.8105 15.4072L11.6315 11.5863Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AltArrowExpand = /*#__PURE__*/createIcon({
  displayName: "ArrowExpand",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.6315 13.1315L7.8105 9.3105C7.3965 8.8965 6.7245 8.8965 6.3105 9.3105C5.8965 9.7245 5.8965 10.3965 6.3105 10.8105L10.9245 15.4245C11.3155 15.8155 11.9485 15.8155 12.3385 15.4245L16.9525 10.8105C17.3665 10.3965 17.3665 9.7245 16.9525 9.3105C16.5385 8.8965 15.8665 8.8965 15.4525 9.3105L11.6315 13.1315Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var AltArrowForward = /*#__PURE__*/createIcon({
  displayName: "ArrowForward",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.1315 11.6315L9.3105 7.8105C8.8965 7.3965 8.8965 6.7245 9.3105 6.3105C9.7245 5.8965 10.3965 5.8965 10.8105 6.3105L15.4245 10.9245C15.8155 11.3155 15.8155 11.9485 15.4245 12.3385L10.8105 16.9525C10.3965 17.3665 9.7245 17.3665 9.3105 16.9525C8.8965 16.5385 8.8965 15.8665 9.3105 15.4525L13.1315 11.6315Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ArrowDown = /*#__PURE__*/createIcon({
  displayName: "ArrowDown",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.6565 3C11.1045 3 10.6565 3.448 10.6565 4V17.0703L6.79325 13.207C6.40225 12.816 5.76919 12.816 5.37919 13.207L5.29325 13.293C4.90225 13.684 4.90225 14.317 5.29325 14.707L10.9495 20.3633C11.3405 20.7543 11.9736 20.7543 12.3636 20.3633L18.0198 14.707C18.4108 14.316 18.4108 13.683 18.0198 13.293L17.9339 13.207C17.5429 12.816 16.9098 12.816 16.5198 13.207L12.6565 17.0703V4C12.6565 3.448 12.2085 3 11.6565 3Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ArrowLeft = /*#__PURE__*/createIcon({
  displayName: "ArrowLeft",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.65653 5C9.40066 5 9.1445 5.09942 8.9495 5.29492L3.29325 10.9512C2.90225 11.3422 2.90225 11.9752 3.29325 12.3652L8.9495 18.0215C9.3405 18.4125 9.97356 18.4125 10.3636 18.0215L10.4495 17.9355C10.8405 17.5445 10.8405 16.9115 10.4495 16.5215L6.58622 12.6582H19.6565C20.2085 12.6582 20.6565 12.2102 20.6565 11.6582C20.6565 11.1062 20.2085 10.6582 19.6565 10.6582H6.58622L10.4495 6.79492C10.8405 6.40392 10.8405 5.77086 10.4495 5.38086L10.3636 5.29492C10.1681 5.09942 9.91241 5 9.65653 5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ArrowRight = /*#__PURE__*/createIcon({
  displayName: "ArrowRight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14 5C13.7441 5 13.488 5.09942 13.293 5.29492L13.207 5.38086C12.816 5.77186 12.816 6.40492 13.207 6.79492L17.0703 10.6582H4C3.448 10.6582 3 11.1062 3 11.6582C3 12.2102 3.448 12.6582 4 12.6582H17.0703L13.207 16.5215C12.816 16.9125 12.816 17.5455 13.207 17.9355L13.293 18.0215C13.684 18.4125 14.317 18.4125 14.707 18.0215L20.3633 12.3652C20.7543 11.9742 20.7543 11.3412 20.3633 10.9512L14.707 5.29492C14.5115 5.09942 14.2559 5 14 5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ArrowUp = /*#__PURE__*/createIcon({
  displayName: "ArrowUp",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.6565 3C11.4007 3 11.145 3.09942 10.9495 3.29492L5.29325 8.95117C4.90225 9.34117 4.90225 9.97423 5.29325 10.3652L5.37919 10.4512C5.76919 10.8422 6.40225 10.8422 6.79325 10.4512L10.6565 6.58789V19.6582C10.6565 20.2102 11.1045 20.6582 11.6565 20.6582C12.2085 20.6582 12.6565 20.2102 12.6565 19.6582V6.58789L16.5198 10.4512C16.9098 10.8422 17.5429 10.8422 17.9339 10.4512L18.0198 10.3652C18.4108 9.97523 18.4108 9.34217 18.0198 8.95117L12.3636 3.29492C12.1686 3.09942 11.9124 3 11.6565 3Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var BoardingPass = /*#__PURE__*/createIcon({
  displayName: "BoardingPass",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.0911 5H16.5454C16.0633 5.00057 15.6011 5.21148 15.2603 5.58646C14.9194 5.96143 14.7277 6.46985 14.7272 7.00015H12.9089C12.9077 6.47017 12.7157 5.9623 12.3751 5.58751C12.0345 5.21273 11.5728 5.0015 11.0911 5H2.90894C2.66809 5.00075 2.43729 5.10634 2.26698 5.29369C2.09667 5.48105 2.00068 5.73494 2 5.9999V18.0001C2.00068 18.2651 2.09667 18.519 2.26698 18.7063C2.43729 18.8937 2.66809 18.9992 2.90894 19H11.0911C11.5728 18.9985 12.0345 18.7873 12.3751 18.4125C12.7157 18.0377 12.9077 17.5298 12.9089 16.9998H14.7272C14.7277 17.5301 14.9194 18.0386 15.2603 18.4135C15.6011 18.7885 16.0633 18.9994 16.5454 19H21.0911C21.3321 18.9999 21.5632 18.8945 21.7337 18.707C21.9041 18.5195 21.9999 18.2653 22 18.0001V5.9999C21.9999 5.73474 21.9041 5.48046 21.7337 5.29297C21.5632 5.10547 21.3321 5.00009 21.0911 5ZM10.1824 15.0004H6.54537C6.30723 14.9955 6.08036 14.8879 5.91354 14.7009C5.74671 14.5139 5.65325 14.2623 5.65325 14.0003C5.65325 13.7383 5.74671 13.4868 5.91354 13.2997C6.08036 13.1127 6.30723 13.0052 6.54537 13.0003H10.1818C10.3026 12.9977 10.4227 13.0218 10.535 13.0709C10.6473 13.12 10.7495 13.1933 10.8358 13.2864C10.9221 13.3795 10.9906 13.4906 11.0373 13.6132C11.0841 13.7358 11.1082 13.8674 11.1082 14.0003C11.1082 14.1333 11.0841 14.2649 11.0373 14.3875C10.9906 14.51 10.9221 14.6211 10.8358 14.7143C10.7495 14.8074 10.6473 14.8806 10.535 14.9298C10.4227 14.9789 10.3026 15.0029 10.1818 15.0004H10.1824ZM10.1824 11.0005H6.54537C6.30723 10.9955 6.08036 10.888 5.91354 10.701C5.74671 10.514 5.65325 10.2624 5.65325 10.0004C5.65325 9.73837 5.74671 9.48681 5.91354 9.2998C6.08036 9.11279 6.30723 9.00525 6.54537 9.00031H10.1818C10.3026 8.9978 10.4227 9.02181 10.535 9.07094C10.6473 9.12007 10.7495 9.19334 10.8358 9.28645C10.9221 9.37957 10.9906 9.49066 11.0373 9.61325C11.0841 9.73583 11.1082 9.86744 11.1082 10.0004C11.1082 10.1333 11.0841 10.2649 11.0373 10.3875C10.9906 10.5101 10.9221 10.6212 10.8358 10.7143C10.7495 10.8074 10.6473 10.8807 10.535 10.9298C10.4227 10.979 10.3026 11.003 10.1818 11.0005H10.1824ZM13.8182 15.0004C13.6383 15.0005 13.4625 14.9419 13.3129 14.832C13.1633 14.7221 13.0468 14.5659 12.9779 14.3831C12.909 14.2003 12.891 13.9992 12.9261 13.8051C12.9611 13.611 13.0478 13.4328 13.1749 13.2929C13.3021 13.153 13.4642 13.0577 13.6406 13.0191C13.817 12.9805 13.9998 13.0004 14.166 13.0761C14.3322 13.1519 14.4742 13.2801 14.574 13.4447C14.6739 13.6092 14.7272 13.8026 14.7272 14.0005C14.727 14.2656 14.6312 14.5199 14.4607 14.7073C14.2903 14.8948 14.0592 15.0002 13.8182 15.0004ZM13.8182 11.0005C13.6384 11.0005 13.4625 10.9419 13.313 10.8321C13.1634 10.7222 13.0468 10.566 12.9779 10.3832C12.9091 10.2005 12.891 9.99933 12.9261 9.80528C12.9611 9.61123 13.0477 9.43297 13.1748 9.29304C13.302 9.15312 13.464 9.05782 13.6404 9.01919C13.8168 8.98057 13.9996 9.00036 14.1658 9.07605C14.3319 9.15175 14.474 9.27996 14.5739 9.44446C14.6738 9.60895 14.7272 9.80236 14.7272 10.0002C14.727 10.2654 14.6312 10.5196 14.4608 10.7072C14.2903 10.8947 14.0593 11.0002 13.8182 11.0005Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var BoxImportant = /*#__PURE__*/createIcon({
  displayName: "BoxImportant",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Calculator = /*#__PURE__*/createIcon({
  displayName: "Calculator",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18 2H6C4.895 2 4 2.895 4 4V20C4 21.105 4.895 22 6 22H18C19.105 22 20 21.105 20 20V4C20 2.895 19.105 2 18 2ZM17 8H7C6.448 8 6 7.552 6 7V5C6 4.448 6.448 4 7 4H17C17.552 4 18 4.448 18 5V7C18 7.552 17.552 8 17 8ZM16 20H12C11.448 20 11 19.552 11 19C11 18.448 11.448 18 12 18H16C16.552 18 17 18.448 17 19C17 19.552 16.552 20 16 20ZM9 19C9 19.552 8.552 20 8 20C7.448 20 7 19.552 7 19C7 18.448 7.448 18 8 18C8.552 18 9 18.448 9 19ZM9 15C9 15.552 8.552 16 8 16C7.448 16 7 15.552 7 15C7 14.448 7.448 14 8 14C8.552 14 9 14.448 9 15ZM9 11C9 11.552 8.552 12 8 12C7.448 12 7 11.552 7 11C7 10.448 7.448 10 8 10C8.552 10 9 10.448 9 11ZM13 15C13 15.552 12.552 16 12 16C11.448 16 11 15.552 11 15C11 14.448 11.448 14 12 14C12.552 14 13 14.448 13 15ZM13 11C13 11.552 12.552 12 12 12C11.448 12 11 11.552 11 11C11 10.448 11.448 10 12 10C12.552 10 13 10.448 13 11ZM17 15C17 15.552 16.552 16 16 16C15.448 16 15 15.552 15 15C15 14.448 15.448 14 16 14C16.552 14 17 14.448 17 15ZM17 11C17 11.552 16.552 12 16 12C15.448 12 15 11.552 15 11C15 10.448 15.448 10 16 10C16.552 10 17 10.448 17 11Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Calendar = /*#__PURE__*/createIcon({
  displayName: "Calendar",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7 2C6.448 2 6 2.448 6 3V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.448 17.552 2 17 2C16.448 2 16 2.448 16 3V4H8V3C8 2.448 7.552 2 7 2ZM5 9H19V19C19 19.552 18.552 20 18 20H6C5.448 20 5 19.552 5 19V9Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CalendarDelete = /*#__PURE__*/createIcon({
  displayName: "CalendarDelete",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7 2C6.448 2 6 2.448 6 3V4H5C3.895 4 3 4.895 3 6V20C3 21.105 3.895 22 5 22H19C20.105 22 21 21.105 21 20V6C21 4.895 20.105 4 19 4H18V3C18 2.448 17.552 2 17 2C16.448 2 16 2.448 16 3V4H8V3C8 2.448 7.552 2 7 2ZM5 9H19L19.002 20H5V9ZM10 12C9.74412 12 9.48847 12.0975 9.29297 12.293C8.90197 12.683 8.90197 13.316 9.29297 13.707L10.5859 15L9.29297 16.293C8.90197 16.683 8.90197 17.316 9.29297 17.707C9.68297 18.098 10.316 18.098 10.707 17.707L12 16.4141L13.293 17.707C13.683 18.098 14.317 18.098 14.707 17.707C15.098 17.317 15.098 16.684 14.707 16.293L13.4141 15L14.707 13.707C15.098 13.317 15.098 12.683 14.707 12.293C14.317 11.902 13.684 11.902 13.293 12.293L12 13.5859L10.707 12.293C10.512 12.0975 10.2559 12 10 12Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Cancel = /*#__PURE__*/createIcon({
  displayName: "Cancel",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.707 15.293C17.098 15.684 17.098 16.316 16.707 16.707C16.512 16.902 16.256 17 16 17C15.744 17 15.488 16.902 15.293 16.707L12 13.414L8.707 16.707C8.512 16.902 8.256 17 8 17C7.744 17 7.488 16.902 7.293 16.707C6.902 16.316 6.902 15.684 7.293 15.293L10.586 12L7.293 8.707C6.902 8.316 6.902 7.684 7.293 7.293C7.684 6.902 8.316 6.902 8.707 7.293L12 10.586L15.293 7.293C15.684 6.902 16.316 6.902 16.707 7.293C17.098 7.684 17.098 8.316 16.707 8.707L13.414 12L16.707 15.293Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CancelledFlight = /*#__PURE__*/createIcon({
  displayName: "CancelledFlight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.7378 17.5156L14.5558 18.3336L13.7378 19.1513C13.4689 19.4204 13.2637 19.7463 13.1375 20.1052C13.0112 20.464 12.9671 20.8466 13.0083 21.2247L12.993 21.2207L10.0412 21.9592C9.85264 22.0062 9.65359 21.9865 9.47789 21.9034C9.30218 21.8203 9.16065 21.6789 9.07732 21.5033C8.99399 21.3277 8.97401 21.1287 9.02076 20.94C9.0675 20.7514 9.1781 20.5847 9.33378 20.4683L10.9945 19.2263V13.8723L4.35589 15.9401C4.11349 16.0159 3.85177 16.0008 3.61972 15.8975C3.38768 15.7943 3.20122 15.61 3.09524 15.3792C2.98927 15.1484 2.97105 14.8868 3.044 14.6436C3.11695 14.4003 3.27606 14.1919 3.49155 14.0575L10.9945 9.37174V3.99848C10.9945 3.46845 11.2051 2.96013 11.5799 2.58534C11.9547 2.21055 12.463 2 12.993 2C13.523 2 14.0314 2.21055 14.4061 2.58534C14.7809 2.96013 14.9915 3.46845 14.9915 3.99848V9.37174L21.1058 13.1912C20.996 13.1768 20.8853 13.1694 20.7744 13.1692C20.4399 13.1683 20.1086 13.2337 19.7996 13.3617C19.4905 13.4897 19.21 13.6778 18.9741 13.915L18.1564 14.733L17.3384 13.915C17.1025 13.6759 16.8217 13.4859 16.5122 13.3558C16.2026 13.2257 15.8703 13.1581 15.5345 13.157C15.1987 13.1559 14.866 13.2212 14.5555 13.3491C14.2451 13.4771 13.963 13.6653 13.7255 13.9027C13.4881 14.1402 13.2999 14.4222 13.172 14.7327C13.044 15.0432 12.9787 15.3759 12.9798 15.7117C12.9809 16.0475 13.0485 16.3798 13.1786 16.6893C13.3087 16.9989 13.4987 17.2797 13.7378 17.5156ZM19.6372 18.3337L21.5148 20.2113L21.5151 20.211C21.7078 20.4081 21.815 20.6733 21.8134 20.949C21.8119 21.2246 21.7017 21.4886 21.5067 21.6835C21.3118 21.8784 21.0479 21.9886 20.7722 21.9902C20.4965 21.9918 20.2314 21.8846 20.0342 21.6919L18.1567 19.8139L16.9769 20.9937L16.2774 21.6932C16.1803 21.7906 16.0649 21.8678 15.9378 21.9205C15.8107 21.9731 15.6745 22.0001 15.537 22C15.3994 22.0001 15.2632 21.9731 15.1361 21.9205C15.0091 21.8678 14.8937 21.7906 14.7965 21.6932L14.7722 21.6672C14.5867 21.469 14.4855 21.2063 14.49 20.9348C14.4945 20.6633 14.6045 20.4043 14.7965 20.2123L15.443 19.5661L16.6754 18.3337L14.9914 16.6496L14.7975 16.4558C14.6048 16.2587 14.4976 15.9935 14.4992 15.7178C14.5008 15.4421 14.611 15.1782 14.8059 14.9833C15.0008 14.7883 15.2648 14.6781 15.5404 14.6766C15.8161 14.675 16.0813 14.7822 16.2784 14.9749L18.1563 16.8528L19.6765 15.3323L20.0339 14.9749C20.1307 14.8758 20.2463 14.797 20.3738 14.7429C20.5013 14.6888 20.6383 14.6605 20.7768 14.6597C20.9153 14.6589 21.0526 14.6856 21.1808 14.7383C21.3089 14.7909 21.4253 14.8685 21.5232 14.9664C21.6212 15.0644 21.6987 15.1808 21.7514 15.3089C21.804 15.4371 21.8307 15.5744 21.83 15.7129C21.8292 15.8514 21.8009 15.9884 21.7468 16.1159C21.6927 16.2434 21.6138 16.359 21.5148 16.4558L19.6372 18.3337Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Chat = /*#__PURE__*/createIcon({
  displayName: "Chat",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 3C2.9 3 2 3.9 2 5V15.793C2 16.238 2.53852 16.4615 2.85352 16.1465L5 14H14C15.1 14 16 13.1 16 12V5C16 3.9 15.1 3 14 3H4ZM18 8V12C18 14.209 16.209 16 14 16H8V17C8 18.1 8.9 19 10 19H19L21.1465 21.1465C21.4615 21.4615 22 21.238 22 20.793V10C22 8.9 21.1 8 20 8H18Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Check = /*#__PURE__*/createIcon({
  displayName: "Check",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.5829 7.3737C19.0274 6.84601 18.1521 6.85925 17.6128 7.40349L10.8079 14.2719L7.41722 10.7574C6.88391 10.2046 6.00481 10.1846 5.44697 10.7126C4.87509 11.254 4.8619 12.1602 5.41779 12.718L9.75115 17.0658C10.3351 17.6517 11.2832 17.6542 11.8703 17.0715L19.605 9.39375C20.1683 8.83454 20.1583 7.92043 19.5829 7.3737Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Circle = /*#__PURE__*/createIcon({
  displayName: "Circle",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CircleSolid = /*#__PURE__*/createIcon({
  displayName: "CircleSolid",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 6.50024C15.3137 6.50024 18 9.18654 18 12.5002C18 15.814 15.3137 18.5002 12 18.5002C8.68629 18.5002 6 15.814 6 12.5002C6 9.18654 8.68629 6.50024 12 6.50024Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CityRailwayStation = /*#__PURE__*/createIcon({
  displayName: "CityRailwayStation",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18 4.13V4C18 2.9 17.1 2 16 2H8C6.9 2 6 2.9 6 4V4.13C4.28 4.57 3 6.14 3 8V17C3 18.65 4.35 20 6 20V21C6 21.552 6.448 22 7 22C7.552 22 8 21.552 8 21V20H16V21C16 21.552 16.448 22 17 22C17.552 22 18 21.552 18 21V20C19.65 20 21 18.65 21 17V8C21 6.14 19.72 4.57 18 4.13ZM8 17C7.45 17 7 16.55 7 16C7 15.45 7.45 15 8 15C8.55 15 9 15.45 9 16C9 16.55 8.55 17 8 17ZM16 17C15.45 17 15 16.55 15 16C15 15.45 15.45 15 16 15C16.55 15 17 15.45 17 16C17 16.55 16.55 17 16 17ZM18 13H6C5.448 13 5 12.552 5 12V9C5 8.448 5.448 8 6 8H18C18.552 8 19 8.448 19 9V12C19 12.552 18.552 13 18 13Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Clock = /*#__PURE__*/createIcon({
  displayName: "Clock",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM14.586 16L11.293 12.707C11.105 12.519 11 12.265 11 12V7C11 6.448 11.448 6 12 6C12.552 6 13 6.448 13 7V11.586L16 14.586C16.39 14.976 16.39 15.61 16 16C15.61 16.39 14.976 16.39 14.586 16Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Commercial = /*#__PURE__*/createIcon({
  displayName: "Commercial",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.7637 3C19.2957 3 18.8682 3.26559 18.6582 3.68359L18 5L11.6055 7.74023C11.2375 7.89823 11 8.2582 11 8.6582V15.3398C11 15.7398 11.2375 16.1028 11.6055 16.2598L18 19L18.6582 20.3164C18.8682 20.7344 19.2957 21 19.7637 21C20.4467 21 21 20.4467 21 19.7637V13.7285C21.6177 13.3719 21.9987 12.7133 22 12C21.9994 11.286 21.6183 10.6265 21 10.2695V4.23633C21 3.55333 20.4467 3 19.7637 3ZM5 8C3.9 8 3 8.9 3 10V14C3 15.1 3.9 16 5 16H7V20C7 20.552 7.448 21 8 21C8.552 21 9 20.552 9 20V14V9C9 8.448 8.552 8 8 8H5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Compensation = /*#__PURE__*/createIcon({
  displayName: "Compensation",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.3657 5.89934C18.174 5.78691 18.0098 5.63321 17.8849 5.44939L11.9272 7.00015H3.99015L19.2279 3.03233C19.355 2.9992 19.4874 2.99144 19.6175 3.00949C19.7476 3.02754 19.8729 3.07105 19.9862 3.13754C20.0995 3.20402 20.1986 3.29218 20.2778 3.39697C20.357 3.50176 20.4148 3.62113 20.4479 3.74826L21.2949 7.00015H19.2279L18.9931 6.0994C18.7717 6.08011 18.5574 6.01178 18.3657 5.89934ZM21 9.00006H3C2.73478 9.00006 2.48043 9.10542 2.29289 9.29295C2.10536 9.48049 2 9.73484 2 10.0001V20.0001C2 20.2653 2.10536 20.5196 2.29289 20.7072C2.48043 20.8947 2.73478 21.0001 3 21.0001H21C21.2652 21.0001 21.5196 20.8947 21.7071 20.7072C21.8946 20.5196 22 20.2653 22 20.0001V10.0001C22 9.73484 21.8946 9.48049 21.7071 9.29295C21.5196 9.10542 21.2652 9.00006 21 9.00006ZM20 18.0871C19.7896 18.1619 19.5985 18.2826 19.4406 18.4405C19.2827 18.5985 19.1621 18.7896 19.0874 19.0001H4.91259C4.83801 18.7896 4.71738 18.5984 4.5595 18.4404C4.40162 18.2825 4.21047 18.1618 4 18.0871V11.913C4.21047 11.8384 4.40162 11.7176 4.5595 11.5597C4.71738 11.4018 4.83801 11.2106 4.91259 11.0001H19.0874C19.1622 11.2105 19.2829 11.4016 19.4409 11.5594C19.5988 11.7173 19.7899 11.838 20.0004 11.9127L20 18.0871ZM12 18.0009C13.6569 18.0009 15 16.6577 15 15.0009C15 13.344 13.6569 12.0009 12 12.0009C10.3432 12.0009 9.00002 13.344 9.00002 15.0009C9.00002 16.6577 10.3432 18.0009 12 18.0009Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CompensationIncome = /*#__PURE__*/createIcon({
  displayName: "CompensationIncome",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.0031 4.15935C16.1132 4.32141 16.258 4.45691 16.427 4.55603C16.5959 4.65515 16.7849 4.71539 16.98 4.73239L17.1871 5.52648H19.0093L18.2626 2.65966C18.2334 2.54758 18.1825 2.44234 18.1126 2.34996C18.0428 2.25758 17.9555 2.17986 17.8556 2.12125C17.7557 2.06264 17.6453 2.02428 17.5305 2.00836C17.4158 1.99245 17.2991 1.99929 17.1871 2.0285L3.75364 5.52648H10.7508L16.0031 4.15935ZM4.56738 16.1054H13.8949C13.8353 16.4172 13.8485 16.7385 13.9335 17.0443C14.0184 17.3501 14.1729 17.6322 14.3847 17.8686H2.88159C2.64778 17.8686 2.42354 17.7757 2.25821 17.6104C2.09288 17.445 2 17.2208 2 16.987V8.1711C2 7.93729 2.09288 7.71305 2.25821 7.54772C2.42354 7.38239 2.64778 7.28951 2.88159 7.28951H18.7502C18.984 7.28951 19.2082 7.38239 19.3736 7.54772C19.5389 7.71305 19.6318 7.93729 19.6318 8.1711V11.9309C19.3623 11.7877 19.0643 11.706 18.7594 11.6918C18.4545 11.6777 18.1503 11.7313 17.8686 11.849V9.85722C17.6831 9.79137 17.5146 9.68499 17.3754 9.54581C17.2361 9.40664 17.1297 9.23818 17.0637 9.05269H4.56738C4.50163 9.23826 4.39529 9.40682 4.2561 9.54606C4.11691 9.68531 3.9484 9.79172 3.76285 9.85755V15.3005C3.9484 15.3664 4.11691 15.4728 4.2561 15.612C4.39529 15.7513 4.50163 15.9198 4.56738 16.1054ZM13.4599 12.5798C13.4599 14.0405 12.2758 15.2246 10.8151 15.2246C9.35445 15.2246 8.17035 14.0405 8.17035 12.5798C8.17035 11.1192 9.35445 9.93508 10.8151 9.93508C12.2758 9.93508 13.4599 11.1192 13.4599 12.5798ZM19.6408 13.8964L21.8285 16.0841C22.1949 16.4514 21.9353 17.079 21.4181 17.0786H19.6428V20.0173C19.6445 20.1459 19.6209 20.2736 19.5732 20.3931C19.5256 20.5126 19.4549 20.6216 19.3651 20.7138C19.2754 20.8059 19.1684 20.8795 19.0502 20.9303C18.932 20.9811 18.8049 21.0082 18.6763 21.0099H18.6476C18.3882 21.0057 18.141 20.8989 17.9603 20.7127C17.7796 20.5266 17.6801 20.2764 17.6837 20.0169V17.0783H15.909C15.4 17.0783 15.1417 16.4749 15.4774 16.1053C15.4792 16.1033 15.481 16.1013 15.4828 16.0993C15.4876 16.0939 15.4924 16.0887 15.4976 16.0834L17.8672 13.7139L18.2505 13.3306C18.3599 13.2215 18.5082 13.1602 18.6627 13.1602C18.8173 13.1602 18.9655 13.2215 19.075 13.3306L19.6301 13.8857L19.6408 13.8964Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ConnectingFlightLeft = /*#__PURE__*/createIcon({
  displayName: "ConnectingFlightLeft",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.69062 7C8.44659 7 7.25351 7.49419 6.37385 8.37385C5.49419 9.25351 5 10.4466 5 11.6906C5 12.9346 5.49419 14.1277 6.37385 15.0074C7.25351 15.8871 8.44659 16.3812 9.69062 16.3812C10.7626 16.383 11.8028 16.0175 12.6381 15.3456C13.4734 14.6738 14.0534 13.736 14.2814 12.6886H18.9721V11.1916H14.3812C14.2368 10.0445 13.6824 8.98838 12.8203 8.21801C11.9583 7.44764 10.8467 7.01503 9.69062 7ZM9.69062 14.8842C9.26291 14.8976 8.83687 14.8249 8.43781 14.6704C8.03874 14.5159 7.67481 14.2828 7.3676 13.9849C7.06039 13.687 6.81619 13.3304 6.64949 12.9363C6.48279 12.5421 6.397 12.1185 6.39721 11.6906C6.39721 10.8172 6.74419 9.97946 7.36182 9.36182C7.97946 8.74419 8.81715 8.3972 9.69062 8.3972C10.1185 8.397 10.5421 8.48279 10.9363 8.64949C11.3304 8.81619 11.687 9.06039 11.9849 9.3676C12.2828 9.6748 12.5159 10.0387 12.6704 10.4378C12.8249 10.8369 12.8976 11.2629 12.8842 11.6906C12.8842 12.5376 12.5478 13.3499 11.9488 13.9488C11.3499 14.5478 10.5376 14.8842 9.69062 14.8842Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ConnectingFlightRight = /*#__PURE__*/createIcon({
  displayName: "ConnectingFlightRight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.2814 7C15.5255 7 16.7185 7.49419 17.5982 8.37385C18.4779 9.25351 18.972 10.4466 18.972 11.6906C18.972 12.9346 18.4779 14.1277 17.5982 15.0074C16.7185 15.8871 15.5255 16.3812 14.2814 16.3812C13.2095 16.383 12.1692 16.0175 11.3339 15.3456C10.4986 14.6738 9.91869 13.736 9.69061 12.6886H4.99999V11.1916H9.59081C9.73522 10.0445 10.2896 8.98838 11.1517 8.21801C12.0138 7.44764 13.1254 7.01503 14.2814 7ZM14.2814 14.8842C14.7091 14.8976 15.1352 14.8249 15.5342 14.6704C15.9333 14.5159 16.2972 14.2828 16.6044 13.9849C16.9117 13.687 17.1559 13.3304 17.3226 12.9363C17.4893 12.5421 17.575 12.1185 17.5748 11.6906C17.5748 10.8172 17.2279 9.97946 16.6102 9.36182C15.9926 8.74419 15.1549 8.3972 14.2814 8.3972C13.8535 8.397 13.4299 8.48279 13.0358 8.64949C12.6417 8.81619 12.2851 9.06039 11.9872 9.3676C11.6893 9.6748 11.4562 10.0387 11.3017 10.4378C11.1472 10.8369 11.0744 11.2629 11.0878 11.6906C11.0878 12.5376 11.4243 13.3499 12.0232 13.9488C12.6221 14.5478 13.4344 14.8842 14.2814 14.8842Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Cookies = /*#__PURE__*/createIcon({
  displayName: "Cookies",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14 2C10.8438 2 8.04688 3.94531 6.78125 6.6875C3.97656 7.93359 2 10.7422 2 14C2 18.4062 5.59375 22 10 22C13.2578 22 16.0664 20.0234 17.3125 17.2188C20.0312 15.9648 22 13.2344 22 10C22 5.55469 18.3438 2 14 2ZM14 4C15.5664 4 17.0117 4.61328 18.0938 5.625C18.043 5.74609 18 5.86328 18 6C18 6.55078 18.4492 7 19 7C19.0586 7 19.1016 6.97656 19.1562 6.96875C19.5312 7.60156 19.7852 8.30469 19.9062 9.0625C19.7773 9.02734 19.6367 9 19.5 9C18.6719 9 18 9.67188 18 10.5C18 11.3281 18.6719 12 19.5 12C19.5508 12 19.6055 12.0039 19.6562 12C19.3086 12.9414 18.707 13.7539 17.9688 14.4062C17.9766 14.2695 18 14.1367 18 14C18 11.75 17.0664 9.70703 15.5625 8.25C15.8359 7.90625 16 7.47266 16 7C16 5.89453 15.1055 5 14 5C13.1367 5 12.4062 5.54688 12.125 6.3125C11.4453 6.125 10.7383 6 10 6C9.86328 6 9.73047 6.02344 9.59375 6.03125C10.6992 4.8125 12.2891 4 14 4ZM10 8C13.3242 8 16 10.6758 16 14C16 14.6328 15.8984 15.2383 15.7188 15.8125C15.7148 15.8242 15.6914 15.832 15.6875 15.8438C15.6758 15.8633 15.6641 15.8867 15.6562 15.9062C15.5156 16.082 15.4375 16.3047 15.4375 16.5312C14.4883 18.5859 12.4219 20 10 20C8.16016 20 6.53516 19.168 5.4375 17.875C5.76172 17.7109 6 17.3906 6 17C6 16.4492 5.55078 16 5 16C4.78125 16 4.60156 16.1016 4.4375 16.2188C4.16406 15.5312 4 14.7852 4 14C4 11.5781 5.41406 9.51172 7.46875 8.5625C7.47656 8.55859 7.49219 8.56641 7.5 8.5625C7.74219 8.5625 7.97656 8.47266 8.15625 8.3125C8.73828 8.125 9.35156 8 10 8ZM8 10C6.89453 10 6 10.8945 6 12C6 13.1055 6.89453 14 8 14C9.10547 14 10 13.1055 10 12C10 10.8945 9.10547 10 8 10ZM12 10C11.4492 10 11 10.4492 11 11C11 11.5508 11.4492 12 12 12C12.5508 12 13 11.5508 13 11C13 10.4492 12.5508 10 12 10ZM13 14.5C12.1719 14.5 11.5 15.1719 11.5 16C11.5 16.8281 12.1719 17.5 13 17.5C13.8281 17.5 14.5 16.8281 14.5 16C14.5 15.1719 13.8281 14.5 13 14.5ZM10 17C9.44922 17 9 17.4492 9 18C9 18.5508 9.44922 19 10 19C10.5508 19 11 18.5508 11 18C11 17.4492 10.5508 17 10 17Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Copy = /*#__PURE__*/createIcon({
  displayName: "Copy",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 2C2.895 2 2 2.895 2 4V17C2 17.552 2.448 18 3 18C3.552 18 4 17.552 4 17V4H17C17.552 4 18 3.552 18 3C18 2.448 17.552 2 17 2H4ZM8 6C6.895 6 6 6.895 6 8V20C6 21.105 6.895 22 8 22H20C21.105 22 22 21.105 22 20V8C22 6.895 21.105 6 20 6H8ZM8 8H20V20H8V8Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var CustomerRights = /*#__PURE__*/createIcon({
  displayName: "CustomerRights",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("circle", {
      cx: "12",
      cy: "12.5",
      r: "12",
      fill: "#F3F6F9"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.0253 21.03C17.8793 17.7046 18.1859 13.8266 18.1961 7.48201C15.9793 7.11502 13.8964 6.13834 12.0251 4.95008V21.0299L12.0253 21.03ZM12.0246 21.031C6.17059 17.7056 5.86397 13.8276 5.85376 7.48296C8.07061 7.11597 10.1535 6.13929 12.0248 4.95103V21.0308L12.0246 21.031Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0068D9"
    }), /*#__PURE__*/jsx("path", {
      fill: "white",
      d: "M13.8602 10.569C13.669 10.3807 13.3617 10.386 13.1772 10.581L12.4749 11.323L10.1002 11.3481L9.78052 11.686L11.5735 12.2755L10.866 13.0232L10.1463 13.0738L9.81093 13.4283L10.5 13.7648L10.8476 14.1073L11.2012 14.7983L11.5366 14.4438L11.5612 13.7082L12.2687 12.9605L12.9087 14.7685L13.2284 14.4307L13.1701 12.008L13.8724 11.266C14.0568 11.071 14.0514 10.7574 13.8602 10.569Z"
    }), /*#__PURE__*/jsx("ellipse", {
      cx: "17.2896",
      cy: "7.5",
      rx: "3",
      ry: "3",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.2896 7.5C14.2896 5.8431 15.6327 4.5 17.2896 4.5C18.9465 4.5 20.2896 5.8431 20.2896 7.5C20.2896 9.1569 18.9465 10.5 17.2896 10.5C15.6327 10.5 14.2896 9.1569 14.2896 7.5ZM15.2776 7.7123L16.6897 9.1244L19.3018 6.51229L18.8776 6.08809L16.6897 8.276L15.7018 7.2881L15.2776 7.7123Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00C996"
    })]
  })
});

var DamagedLuggage = /*#__PURE__*/createIcon({
  displayName: "DamagedLuggage",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M17.3566 9.71097C17.0064 9.7111 16.6622 9.80287 16.3584 9.97716C16.0404 10.161 15.778 10.4275 15.5991 10.7484L11.6988 17.7158C11.6795 17.7502 11.6613 17.7855 11.644 17.821H3.53566C3.12838 17.821 2.73778 17.6592 2.44978 17.3712C2.16179 17.0832 2 16.6926 2 16.2853V7.83917C2 7.43188 2.16179 7.04128 2.44978 6.75329C2.73778 6.46529 3.12838 6.3035 3.53566 6.3035H5.07132V7.07133C5.07132 7.27498 5.15222 7.47028 5.29622 7.61427C5.44021 7.75827 5.63551 7.83917 5.83915 7.83917C6.0428 7.83917 6.2381 7.75827 6.38209 7.61427C6.52609 7.47028 6.60699 7.27498 6.60699 7.07133V5.53567C6.60699 5.12838 6.76878 4.73778 7.05677 4.44979C7.34476 4.16179 7.73536 4 8.14265 4H11.214C11.6213 4 12.0119 4.16179 12.2998 4.44979C12.5878 4.73778 12.7496 5.12838 12.7496 5.53567V7.07133C12.7496 7.27498 12.8305 7.47028 12.9745 7.61427C13.1185 7.75827 13.3138 7.83917 13.5175 7.83917C13.7211 7.83917 13.9164 7.75827 14.0604 7.61427C14.2044 7.47028 14.2853 7.27498 14.2853 7.07133V6.3035H15.821C16.2282 6.3035 16.6188 6.46529 16.9068 6.75329C17.1948 7.04128 17.3566 7.43188 17.3566 7.83917V9.71097ZM8.14265 6.3035H11.214V5.53567H8.14265V6.3035ZM17.9975 11.3737L21.8978 18.3411C22.1864 18.8564 21.8298 19.5034 21.2582 19.5034H13.4576C12.8849 19.5034 12.528 18.8564 12.8169 18.3411L13.1067 17.8212L16.7161 11.3746C16.7784 11.2589 16.8708 11.1621 16.9836 11.0946C17.0964 11.027 17.2253 10.9912 17.3568 10.991C17.4881 10.9912 17.617 11.0268 17.7298 11.0942C17.8426 11.1616 17.935 11.2582 17.9975 11.3737ZM17.9038 13.5391C17.7587 13.394 17.562 13.3125 17.3568 13.3124C17.1516 13.3125 16.9549 13.3941 16.8099 13.5392C16.6648 13.6843 16.5833 13.881 16.5832 14.0862V15.6389C16.5833 15.843 16.6641 16.0389 16.8079 16.1838C16.9517 16.3287 17.1469 16.4108 17.3511 16.4124H17.3576C17.4592 16.4124 17.5597 16.3923 17.6536 16.3534C17.7474 16.3145 17.8326 16.2575 17.9044 16.1856C17.9762 16.1138 18.0331 16.0285 18.0719 15.9346C18.1107 15.8408 18.1306 15.7402 18.1306 15.6386V14.0862C18.1305 13.881 18.0489 13.6842 17.9038 13.5391ZM18.0739 18.2517C18.1127 18.1575 18.1325 18.0567 18.1323 17.9549C18.1317 17.75 18.0499 17.5537 17.9048 17.409C17.7597 17.2644 17.5631 17.1832 17.3582 17.1834H17.3545C17.1496 17.1834 16.9531 17.2646 16.808 17.4092C16.6629 17.5538 16.5811 17.7501 16.5804 17.9549C16.5803 18.0567 16.6002 18.1575 16.639 18.2515C16.6778 18.3456 16.7348 18.4311 16.8067 18.5031C16.8786 18.5751 16.964 18.6323 17.058 18.6713C17.152 18.7103 17.2527 18.7304 17.3545 18.7304H17.3582C17.46 18.7305 17.5608 18.7105 17.6548 18.6715C17.7489 18.6325 17.8343 18.5754 17.9062 18.5034C17.9781 18.4313 18.0351 18.3458 18.0739 18.2517Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Dashboard = /*#__PURE__*/createIcon({
  displayName: "Dashboard",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M10 13H4C3.45 13 3 12.55 3 12V4C3 3.45 3.45 3 4 3H10C10.55 3 11 3.45 11 4V12C11 12.55 10.55 13 10 13ZM10 21H4C3.45 21 3 20.55 3 20V16C3 15.45 3.45 15 4 15H10C10.55 15 11 15.45 11 16V20C11 20.55 10.55 21 10 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 8V4C13 3.45 13.45 3 14 3H20C20.55 3 21 3.45 21 4V8C21 8.55 20.55 9 20 9H14C13.45 9 13 8.55 13 8Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DataDownload = /*#__PURE__*/createIcon({
  displayName: "DataDownload",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.0142 2C10.4622 2 10.0142 2.448 10.0142 3V11H6.51424C6.2381 11 6.01424 11.2239 6.01424 11.5C6.01426 11.6326 6.06695 11.7598 6.16073 11.8535C6.17072 11.8637 6.18115 11.8735 6.19198 11.8828L11.2974 16.6973L11.3306 16.7285C11.5157 16.9026 11.7602 16.9996 12.0142 17C12.2683 16.9996 12.5127 16.9026 12.6978 16.7285L12.7115 16.7168C12.7148 16.7129 12.718 16.709 12.7213 16.7051L17.8248 11.8926C17.8349 11.8839 17.8447 11.8747 17.8541 11.8652L17.8619 11.8594C17.8639 11.8574 17.8658 11.8555 17.8678 11.8535C17.9615 11.7598 18.0142 11.6326 18.0142 11.5C18.0142 11.2239 17.7904 11 17.5142 11H14.0142V3C14.0142 2.448 13.5662 2 13.0142 2H12.0142H11.0142ZM3.01424 20C2.65361 19.9949 2.31816 20.1844 2.13635 20.4959C1.95455 20.8074 1.95455 21.1926 2.13635 21.5041C2.31816 21.8156 2.65361 22.0051 3.01424 22H21.0142C21.3749 22.0051 21.7103 21.8156 21.8921 21.5041C22.0739 21.1926 22.0739 20.8074 21.8921 20.4959C21.7103 20.1844 21.3749 19.9949 21.0142 20H3.01424Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DataUpload = /*#__PURE__*/createIcon({
  displayName: "DataUpload",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.0142 2C11.7488 2.00056 11.4944 2.10666 11.3072 2.29492L6.1744 7.13477C6.17044 7.13796 6.16654 7.14122 6.16268 7.14453L6.16073 7.14648C6.06695 7.24024 6.01426 7.3674 6.01424 7.5C6.01424 7.77614 6.2381 8 6.51424 8H10.0142V16C10.0142 16.552 10.4622 17 11.0142 17H12.0142H13.0142C13.5662 17 14.0142 16.552 14.0142 16V8H17.5142C17.7904 8 18.0142 7.77614 18.0142 7.5C18.0142 7.3674 17.9615 7.24024 17.8678 7.14648L17.8365 7.11719L12.731 2.30273C12.7202 2.29207 12.7091 2.28165 12.6978 2.27148C12.5127 2.09743 12.2683 2.00036 12.0142 2ZM3.01424 20C2.65361 19.9949 2.31816 20.1844 2.13635 20.4959C1.95455 20.8074 1.95455 21.1926 2.13635 21.5041C2.31816 21.8156 2.65361 22.0051 3.01424 22H21.0142C21.3749 22.0051 21.7103 21.8156 21.8921 21.5041C22.0739 21.1926 22.0739 20.8074 21.8921 20.4959C21.7103 20.1844 21.3749 19.9949 21.0142 20H3.01424Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DelayedFlight$1 = /*#__PURE__*/createIcon({
  displayName: "DelayedFlight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.8375 11.533L13.1589 9.85926V4.85972C13.1589 4.36649 12.963 3.89346 12.6142 3.5447C12.2654 3.19593 11.7924 3 11.2992 3C10.8059 3 10.3329 3.19593 9.98415 3.5447C9.63538 3.89346 9.43945 4.36649 9.43945 4.85972V9.85988L2.45742 14.2203C2.25689 14.3454 2.10883 14.5393 2.04094 14.7657C1.97306 14.992 1.99001 15.2354 2.08863 15.4502C2.18724 15.665 2.36076 15.8365 2.5767 15.9325C2.79263 16.0286 3.03618 16.0427 3.26175 15.9722L9.43945 14.048V19.0302L7.89401 20.186C7.74915 20.2943 7.64622 20.4494 7.60272 20.6249C7.55922 20.8005 7.57782 20.9857 7.65536 21.1491C7.7329 21.3125 7.86461 21.444 8.02811 21.5214C8.19162 21.5987 8.37685 21.617 8.55236 21.5733L11.2992 20.8862L12.9667 21.303C11.9768 20.2067 11.4294 18.7818 11.4306 17.3046C11.429 14.551 13.2999 12.2261 15.8375 11.533ZM17.7546 12.7303C17.6415 12.7219 17.5277 12.7176 17.4137 12.7176C16.6624 12.7174 15.9227 12.9017 15.2593 13.2543C14.596 13.607 14.0294 14.1171 13.6094 14.7399C13.1894 15.3627 12.9287 16.0792 12.8503 16.8263C12.7719 17.5734 12.8783 18.3284 13.1599 19.0248L13.1627 19.032C13.5212 19.9082 14.1405 20.653 14.9366 21.1654C15.6748 21.641 16.5346 21.8934 17.4127 21.8922C19.9429 21.8922 22 19.8344 22 17.3049C22.0003 14.89 20.1254 12.9057 17.7546 12.7303ZM17.413 20.3638C16.8085 20.3636 16.2177 20.1842 15.7152 19.8483C15.2125 19.5123 14.8207 19.0347 14.5893 18.476C14.3579 17.9174 14.2974 17.3026 14.4154 16.7096C14.5334 16.1165 14.8245 15.5717 15.2521 15.1441C15.6796 14.7165 16.2244 14.4253 16.8174 14.3073C17.4105 14.1892 18.0252 14.2497 18.5839 14.481C19.1426 14.7123 19.6202 15.1041 19.9562 15.6068C20.2923 16.1095 20.4718 16.7005 20.4719 17.3052C20.4711 18.1163 20.1485 18.8938 19.575 19.4673C19.0015 20.0407 18.2239 20.3631 17.413 20.3638ZM18.4913 16.1425L17.9259 17.2007L18.5821 17.856C18.6621 17.9362 18.7166 18.0383 18.7386 18.1495C18.7607 18.2606 18.7493 18.3758 18.706 18.4805C18.6627 18.5852 18.5893 18.6747 18.4952 18.7377C18.401 18.8008 18.2903 18.8346 18.177 18.8348C18.1458 18.8346 18.1147 18.8319 18.084 18.8267C17.9653 18.8078 17.8557 18.7517 17.771 18.6665L16.8141 17.7112C16.7271 17.6244 16.6703 17.5119 16.6521 17.3903C16.634 17.2688 16.6555 17.1446 16.7134 17.0361L17.4573 15.6435L17.4793 15.6026C17.5511 15.4689 17.6728 15.369 17.818 15.3247C17.9632 15.2804 18.12 15.2953 18.2542 15.3661C18.3759 15.4316 18.47 15.5387 18.5192 15.6678C18.5685 15.797 18.5695 15.9395 18.5223 16.0694C18.5137 16.0945 18.5033 16.1189 18.4913 16.1425Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Delete = /*#__PURE__*/createIcon({
  displayName: "Delete",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.33643 4.00058C4.79518 4.00072 4.30797 4.32891 4.1043 4.83057C3.90063 5.33222 4.02111 5.9073 4.40899 6.28494L10.1191 11.9971L4.40899 17.7093C4.06151 18.0431 3.92154 18.5386 4.04305 19.0049C4.16457 19.4712 4.52859 19.8354 4.99471 19.9569C5.46084 20.0785 5.95624 19.9385 6.28985 19.5909L12 13.8787L17.7101 19.5909C18.0438 19.9385 18.5392 20.0785 19.0053 19.9569C19.4714 19.8354 19.8354 19.4712 19.9569 19.0049C20.0785 18.5386 19.9385 18.0431 19.591 17.7093L13.8809 11.9971L19.591 6.28494C19.9844 5.9024 20.1027 5.31751 19.8889 4.81209C19.675 4.30667 19.173 3.9844 18.6246 4.00058C18.279 4.01088 17.9511 4.15536 17.7101 4.4034L12 10.1156L6.28985 4.4034C6.03943 4.14588 5.69556 4.0006 5.33643 4.00058Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DeleteBin = /*#__PURE__*/createIcon({
  displayName: "DeleteBin",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M10 2L9 3H5C4.448 3 4 3.448 4 4C4 4.552 4.448 5 5 5H19C19.552 5 20 4.552 20 4C20 3.448 19.552 3 19 3H15L14 2H10ZM5 7V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V7H5ZM9.41016 10.4141C9.66541 10.4141 9.92073 10.5106 10.1152 10.7051L12 12.5898L13.8848 10.7051C14.2738 10.3161 14.9059 10.3161 15.2949 10.7051C15.6839 11.0941 15.6839 11.7262 15.2949 12.1152L13.4102 14L15.2949 15.8848C15.6839 16.2738 15.6839 16.9059 15.2949 17.2949C14.9059 17.6839 14.2738 17.6839 13.8848 17.2949L12 15.4102L10.1152 17.2949C9.72623 17.6839 9.09408 17.6839 8.70508 17.2949C8.31608 16.9059 8.31608 16.2738 8.70508 15.8848L10.5898 14L8.70508 12.1152C8.31608 11.7262 8.31608 11.0941 8.70508 10.7051C8.89958 10.5106 9.15491 10.4141 9.41016 10.4141Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Doctor = /*#__PURE__*/createIcon({
  displayName: "Doctor",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 2.5C3.466 2.5 2.96294 2.70794 2.58594 3.08594C2.20794 3.46394 2 3.967 2 4.5V7.5C2 10.442 3.83005 12.9544 6.4082 13.9863C6.76204 14.6019 7.32167 15.0754 8 15.3164V18.5C8 20.709 9.791 22.5 12 22.5H16C18.209 22.5 20 20.709 20 18.5V18.3262C20.5845 18.1195 21.0907 17.7368 21.4488 17.2307C21.807 16.7246 21.9995 16.12 22 15.5C22 14.7044 21.6839 13.9413 21.1213 13.3787C20.5587 12.8161 19.7956 12.5 19 12.5C18.2044 12.5 17.4413 12.8161 16.8787 13.3787C16.3161 13.9413 16 14.7044 16 15.5C16.0009 16.1197 16.1936 16.7239 16.5517 17.2296C16.9098 17.7353 17.4158 18.1177 18 18.3242V18.5C18 19.605 17.105 20.5 16 20.5H12C10.895 20.5 10 19.605 10 18.5V15.3164C10.6783 15.0754 11.238 14.6019 11.5918 13.9863C14.17 12.9535 16 10.437 16 7.47656V4.5C16 3.395 15.105 2.5 14 2.5H13C12.448 2.5 12 2.948 12 3.5C12 4.052 12.448 4.5 13 4.5H14V7.27734C14 9.88634 12.099 12.2216 9.50195 12.4746C9.31564 12.4929 9.12947 12.5018 8.94727 12.5C6.21415 12.4723 4.00102 10.2384 4.00195 7.47656L4 4.5H5C5.552 4.5 6 4.052 6 3.5C6 2.948 5.552 2.5 5 2.5H4Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Document = /*#__PURE__*/createIcon({
  displayName: "Document",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M22 0.500244H6C5.73478 0.500244 5.48043 0.605601 5.29289 0.793137C5.10536 0.980674 5 1.23503 5 1.50024V21.0002C5 21.3981 4.84196 21.7796 4.56066 22.0609C4.27936 22.3422 3.89782 22.5002 3.5 22.5002C3.10218 22.5002 2.72064 22.3422 2.43934 22.0609C2.15804 21.7796 2 21.3981 2 21.0002V14.5002H4V12.5002H1C0.734784 12.5002 0.48043 12.6056 0.292893 12.7931C0.105357 12.9807 0 13.235 0 13.5002L0 21.0002C0 21.9285 0.368749 22.8187 1.02513 23.4751C1.6815 24.1315 2.57174 24.5002 3.5 24.5002H20C20.7944 24.4963 21.5552 24.179 22.117 23.6172C22.6787 23.0555 22.9961 22.2947 23 21.5002V1.50024C23 1.23503 22.8946 0.980674 22.7071 0.793137C22.5196 0.605601 22.2652 0.500244 22 0.500244V0.500244ZM19 19.5002H9V17.5002H19V19.5002ZM19 14.5002H9V12.5002H19V14.5002ZM19 9.50024H9V4.50024H19V9.50024Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Documents$1 = /*#__PURE__*/createIcon({
  displayName: "Documents",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.1661 2.26586C16.3363 2.436 16.432 2.66674 16.4322 2.9074C16.432 3.14807 16.3363 3.37881 16.1661 3.54895C15.9959 3.71909 15.7651 3.81471 15.5244 3.81481H5.54149V15.6129C5.53475 15.8491 5.43618 16.0733 5.26675 16.238C5.09731 16.4027 4.87036 16.4948 4.63409 16.4948C4.39782 16.4948 4.17086 16.4027 4.00143 16.238C3.83199 16.0733 3.73343 15.8491 3.72668 15.6129V3.81481C3.72815 3.33394 3.91982 2.87319 4.25985 2.53316C4.59987 2.19314 5.06063 2.00147 5.54149 2H15.5244C15.7651 2.0001 15.9959 2.09572 16.1661 2.26586ZM16.9889 6.19629L20.4629 9.67035C20.6315 9.83889 20.7651 10.039 20.8563 10.2592C20.9475 10.4794 20.9944 10.7154 20.9944 10.9537V20.1851C20.9929 20.666 20.8013 21.1268 20.4613 21.4668C20.1212 21.8068 19.6605 21.9985 19.1796 22H9.19672C8.71585 21.9985 8.2551 21.8068 7.91508 21.4668C7.57505 21.1268 7.38338 20.666 7.38191 20.1851V7.47925C7.38338 6.99838 7.57505 6.53763 7.91508 6.1976C8.2551 5.85758 8.71585 5.6659 9.19672 5.66444H15.7056C15.9439 5.66447 16.1799 5.71146 16.4001 5.80271C16.6203 5.89397 16.8204 6.02771 16.9889 6.19629ZM11.9193 18.0559H16.457C16.6932 18.0491 16.9174 17.9506 17.0821 17.7811C17.2468 17.6117 17.3389 17.3848 17.3389 17.1485C17.3389 16.9122 17.2468 16.6853 17.0821 16.5158C16.9174 16.3464 16.6932 16.2478 16.457 16.2411H11.9193C11.6831 16.2478 11.4589 16.3464 11.2942 16.5158C11.1296 16.6853 11.0374 16.9122 11.0374 17.1485C11.0374 17.3848 11.1296 17.6117 11.2942 17.7811C11.4589 17.9506 11.6831 18.0491 11.9193 18.0559ZM11.9193 14.4263H16.457C16.6932 14.4195 16.9174 14.321 17.0821 14.1515C17.2468 13.9821 17.3389 13.7551 17.3389 13.5189C17.3389 13.2826 17.2468 13.0556 17.0821 12.8862C16.9174 12.7168 16.6932 12.6182 16.457 12.6115H11.9193C11.6831 12.6182 11.4589 12.7168 11.2942 12.8862C11.1296 13.0556 11.0374 13.2826 11.0374 13.5189C11.0374 13.7551 11.1296 13.9821 11.2942 14.1515C11.4589 14.321 11.6831 14.4195 11.9193 14.4263Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DocumentsToUpload = /*#__PURE__*/createIcon({
  displayName: "DocumentsToUpload",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7.19649 17.5187H13.7057C13.3684 17.0937 13.1989 16.5596 13.2296 16.0178C13.2603 15.4761 13.489 14.9645 13.8721 14.5804L16.8382 11.6139C17.0432 11.408 17.2869 11.2448 17.5554 11.1336C17.8238 11.0225 18.1116 10.9657 18.4022 10.9665V7.02581C18.4022 6.79938 18.3575 6.57516 18.2708 6.36598C18.1841 6.15679 18.0571 5.96673 17.8969 5.80666L14.5966 2.50631C14.2741 2.18308 13.8365 2.00099 13.3799 2H7.19649C6.73967 2.00139 6.30195 2.18348 5.97893 2.5065C5.65591 2.82953 5.47382 3.26724 5.47242 3.72406V15.7925C5.47326 16.2497 5.6551 16.6879 5.97819 17.0114C6.30127 17.3349 6.7393 17.5173 7.19649 17.5187ZM9.78293 6.2623H14.0938C14.3224 6.2623 14.5417 6.35312 14.7033 6.51478C14.865 6.67645 14.9558 6.89571 14.9558 7.12433C14.9558 7.35296 14.865 7.57222 14.7033 7.73388C14.5417 7.89554 14.3224 7.98636 14.0938 7.98636H9.78293C9.55431 7.98636 9.33504 7.89554 9.17338 7.73388C9.01172 7.57222 8.9209 7.35296 8.9209 7.12433C8.9209 6.89571 9.01172 6.67645 9.17338 6.51478C9.33504 6.35312 9.55431 6.2623 9.78293 6.2623ZM9.78293 9.71042H14.0938C14.3181 9.71684 14.5312 9.81047 14.6876 9.97143C14.844 10.1324 14.9315 10.348 14.9315 10.5725C14.9315 10.7969 14.844 11.0125 14.6876 11.1735C14.5312 11.3344 14.3181 11.4281 14.0938 11.4345H9.78293C9.55857 11.4281 9.34555 11.3344 9.18912 11.1735C9.03269 11.0125 8.94518 10.7969 8.94518 10.5725C8.94518 10.348 9.03269 10.1324 9.18912 9.97143C9.34555 9.81047 9.55857 9.71684 9.78293 9.71042ZM13.2078 19.2757H3.72406V8.0676C3.71765 7.84324 3.62402 7.63021 3.46306 7.47379C3.30209 7.31736 3.08648 7.22985 2.86203 7.22985C2.63758 7.22985 2.42197 7.31736 2.26101 7.47379C2.10004 7.63021 2.00641 7.84324 2 8.0676V19.2757C2.00139 19.7326 2.18348 20.1703 2.5065 20.4933C2.82953 20.8163 3.26724 20.9984 3.72406 20.9998H13.2078C13.3231 21.0031 13.4378 20.9832 13.5453 20.9414C13.6528 20.8995 13.7508 20.8366 13.8335 20.7562C13.9162 20.6758 13.9819 20.5797 14.0268 20.4735C14.0717 20.3672 14.0948 20.2531 14.0948 20.1378C14.0948 20.0224 14.0717 19.9083 14.0268 19.8021C13.9819 19.6958 13.9162 19.5997 13.8335 19.5193C13.7508 19.4389 13.6528 19.376 13.5453 19.3341C13.4378 19.2923 13.3231 19.2724 13.2078 19.2757ZM19.4577 13.3411L21.8151 15.6985C22.2099 16.0943 21.9305 16.7705 21.3721 16.7702H19.4591V19.9368C19.461 20.0755 19.4356 20.2131 19.3843 20.3419C19.333 20.4707 19.2569 20.5881 19.1602 20.6875C19.0635 20.7868 18.9482 20.8662 18.8209 20.921C18.6935 20.9758 18.5566 21.0049 18.418 21.0068H18.3871C18.1075 21.0025 17.8411 20.8874 17.6464 20.6869C17.4516 20.4863 17.3443 20.2167 17.348 19.9372V16.7706H15.4372C14.8777 16.7706 14.5994 16.0943 14.9942 15.6978L17.9603 12.7313C18.0186 12.6729 18.0879 12.6267 18.1641 12.5951C18.2404 12.5636 18.3221 12.5475 18.4046 12.5477C18.4872 12.5475 18.5689 12.5637 18.6452 12.5952C18.7214 12.6267 18.7907 12.673 18.849 12.7313L19.4577 13.3411Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Dolar = /*#__PURE__*/createIcon({
  displayName: "Dolar",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2.5C6.486 2.5 2 6.986 2 12.5C2 18.014 6.486 22.5 12 22.5C17.514 22.5 22 18.014 22 12.5C22 6.986 17.514 2.5 12 2.5ZM14.818 16.247C14.697 16.59 14.526 16.888 14.305 17.138C14.084 17.389 13.818 17.59 13.507 17.742C13.347 17.82 13.178 17.883 13 17.932V18.5C13 19.052 12.552 19.5 12 19.5C11.448 19.5 11 19.052 11 18.5V17.951C10.807 17.901 10.617 17.839 10.432 17.756C10.103 17.609 9.811 17.397 9.556 17.119C9.301 16.842 9.097 16.493 8.944 16.07C8.884 15.905 8.818 15.704 8.803 15.504C8.803 15.498 8.799 15.446 8.799 15.422C8.8 14.913 9.213 14.5 9.722 14.5C10.145 14.5 10.503 14.772 10.606 15.163C10.64 15.29 10.679 15.442 10.679 15.442C10.757 15.675 10.857 15.846 10.988 15.986C11.12 16.126 11.27 16.224 11.437 16.281C11.604 16.338 11.776 16.366 11.95 16.366C12.149 16.366 12.324 16.334 12.475 16.27C12.625 16.206 12.752 16.118 12.853 16.005C12.956 15.892 13.031 15.758 13.082 15.604C13.133 15.449 13.158 15.281 13.158 15.1C13.158 14.894 13.135 14.713 13.088 14.556C13.041 14.399 12.964 14.257 12.859 14.129C12.753 14.001 12.616 13.883 12.448 13.776C12.281 13.668 12.076 13.562 11.834 13.459C11.419 13.278 11.041 13.087 10.701 12.888C10.361 12.69 10.071 12.461 9.829 12.2C9.587 11.939 9.399 11.636 9.265 11.287C9.131 10.939 9.065 10.524 9.065 10.043C9.065 9.626 9.125 9.246 9.243 8.902C9.362 8.559 9.532 8.26 9.753 8.005C9.974 7.749 10.238 7.543 10.545 7.383C10.689 7.307 10.841 7.248 11 7.199V6.5C11 5.948 11.448 5.5 12 5.5C12.552 5.5 13 5.948 13 6.5V7.201C13.209 7.266 13.409 7.347 13.592 7.459C13.889 7.64 14.143 7.876 14.35 8.165C14.558 8.455 14.723 8.77 14.837 9.165C14.863 9.255 14.903 9.418 14.903 9.581C14.903 10.089 14.591 10.5 13.984 10.5C13.562 10.5 13.271 10.253 13.113 9.821C13.054 9.658 12.965 9.367 12.844 9.199C12.634 8.907 12.353 8.761 12.001 8.761C11.809 8.761 11.645 8.794 11.508 8.86C11.37 8.926 11.256 9.017 11.167 9.132C11.077 9.247 11.011 9.384 10.97 9.541C10.927 9.698 10.906 9.868 10.906 10.049C10.906 10.23 10.927 10.394 10.97 10.542C11.012 10.689 11.085 10.826 11.19 10.951C11.294 11.076 11.432 11.194 11.603 11.304C11.775 11.414 11.988 11.528 12.244 11.646C12.655 11.837 13.03 12.033 13.367 12.235C13.705 12.436 13.994 12.668 14.236 12.93C14.478 13.192 14.666 13.498 14.799 13.846C14.933 14.195 15 14.608 15 15.084C15 15.516 14.939 15.903 14.818 16.247Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DoubleArrowDown = /*#__PURE__*/createIcon({
  displayName: "DoubleArrowDown",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.9999 4.00028C19.7361 4.00652 19.4855 4.11673 19.3026 4.30692L12.0096 11.5999L4.71667 4.30692C4.5284 4.11339 4.26987 4.0042 3.99987 4.00419C3.59295 4.00429 3.22666 4.25094 3.07354 4.62796C2.92042 5.00497 3.01099 5.43717 3.3026 5.72098L11.3026 13.721C11.6931 14.1114 12.3261 14.1114 12.7167 13.721L20.7167 5.72098C21.0139 5.43515 21.1052 4.99619 20.9467 4.61552C20.7881 4.23486 20.4121 3.99055 19.9999 4.00028ZM19.9999 10.0003C19.7361 10.0065 19.4855 10.1167 19.3026 10.3069L12.0096 17.5999L4.71667 10.3069C4.5284 10.1134 4.26987 10.0042 3.99987 10.0042C3.59295 10.0043 3.22666 10.2509 3.07354 10.628C2.92042 11.005 3.01099 11.4372 3.3026 11.721L11.3026 19.721C11.6931 20.1114 12.3261 20.1114 12.7167 19.721L20.7167 11.721C21.0139 11.4352 21.1052 10.9962 20.9467 10.6155C20.7881 10.2349 20.4121 9.99055 19.9999 10.0003Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DoubleArrowLeft = /*#__PURE__*/createIcon({
  displayName: "DoubleArrowLeft",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.9803 3.00044C12.7205 3.00818 12.4739 3.11676 12.2928 3.30317L4.29278 11.3032C3.90241 11.6937 3.90241 12.3267 4.29278 12.7172L12.2928 20.7172C12.5436 20.9785 12.916 21.0837 13.2665 20.9924C13.6169 20.901 13.8906 20.6273 13.982 20.2769C14.0733 19.9264 13.9681 19.554 13.7068 19.3032L6.41387 12.0102L13.7068 4.71723C14.0026 4.42974 14.0915 3.99017 13.9308 3.61032C13.77 3.23047 13.3926 2.98828 12.9803 3.00044ZM18.9803 3.00044C18.7205 3.00818 18.4739 3.11676 18.2928 3.30317L10.2928 11.3032C9.90241 11.6937 9.90241 12.3267 10.2928 12.7172L18.2928 20.7172C18.5436 20.9785 18.916 21.0837 19.2665 20.9924C19.6169 20.901 19.8906 20.6273 19.982 20.2769C20.0733 19.9264 19.9681 19.554 19.7068 19.3032L12.4139 12.0102L19.7068 4.71723C20.0026 4.42974 20.0915 3.99017 19.9308 3.61032C19.77 3.23047 19.3926 2.98828 18.9803 3.00044Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DoubleArrowRight = /*#__PURE__*/createIcon({
  displayName: "DoubleArrowRight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.00475 3C4.59782 3.00011 4.23154 3.24676 4.07842 3.62377C3.92529 4.00078 4.01587 4.43298 4.30748 4.7168L11.6005 12.0098L4.30748 19.3027C4.04624 19.5536 3.94101 19.926 4.03237 20.2764C4.12373 20.6269 4.3974 20.9006 4.74784 20.9919C5.09828 21.0833 5.47073 20.978 5.72154 20.7168L13.7215 12.7168C14.1119 12.3263 14.1119 11.6933 13.7215 11.3027L5.72154 3.30273C5.53327 3.1092 5.27475 3.00002 5.00475 3ZM11.0047 3C10.5978 3.00011 10.2315 3.24676 10.0784 3.62377C9.9253 4.00078 10.0159 4.43298 10.3075 4.7168L17.6005 12.0098L10.3075 19.3027C10.0462 19.5536 9.94101 19.926 10.0324 20.2764C10.1237 20.6269 10.3974 20.9006 10.7478 20.9919C11.0983 21.0833 11.4707 20.978 11.7215 20.7168L19.7215 12.7168C20.1119 12.3263 20.1119 11.6933 19.7215 11.3027L11.7215 3.30273C11.5333 3.1092 11.2747 3.00002 11.0047 3Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var DoubleArrowUp = /*#__PURE__*/createIcon({
  displayName: "DoubleArrowUp",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9989 4.00012C11.7391 4.00426 11.4911 4.10933 11.3075 4.29309L3.30748 12.2931C3.04624 12.5439 2.94101 12.9164 3.03237 13.2668C3.12373 13.6172 3.3974 13.8909 3.74784 13.9823C4.09828 14.0736 4.47073 13.9684 4.72154 13.7071L12.0145 6.41418L19.3075 13.7071C19.5583 13.9684 19.9307 14.0736 20.2812 13.9823C20.6316 13.8909 20.9053 13.6172 20.9967 13.2668C21.088 12.9164 20.9828 12.5439 20.7215 12.2931L12.7215 4.29309C12.5302 4.10167 12.2695 3.99597 11.9989 4.00012ZM11.9989 10.0001C11.7391 10.0043 11.4911 10.1093 11.3075 10.2931L3.30748 18.2931C3.04624 18.5439 2.94101 18.9164 3.03237 19.2668C3.12373 19.6172 3.3974 19.8909 3.74784 19.9823C4.09828 20.0736 4.47073 19.9684 4.72154 19.7071L12.0145 12.4142L19.3075 19.7071C19.5583 19.9684 19.9307 20.0736 20.2812 19.9823C20.6316 19.8909 20.9053 19.6172 20.9967 19.2668C21.088 18.9164 20.9828 18.5439 20.7215 18.2931L12.7215 10.2931C12.5302 10.1017 12.2695 9.99597 11.9989 10.0001Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Edit = /*#__PURE__*/createIcon({
  displayName: "Edit",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M20.7088 5.63126C21.0988 6.02127 21.0988 6.65127 20.7088 7.04127L18.8788 8.87126L15.1288 5.12126L16.9588 3.29126C17.1456 3.10401 17.3993 2.99878 17.6638 2.99878C17.9283 2.99878 18.1819 3.10401 18.3688 3.29126L20.7088 5.63126ZM2.99878 20.5013V17.4613C2.99878 17.3213 3.04878 17.2013 3.14878 17.1013L14.0588 6.19126L17.8088 9.94127L6.88878 20.8513C6.79878 20.9513 6.66878 21.0013 6.53878 21.0013H3.49878C3.21878 21.0013 2.99878 20.7813 2.99878 20.5013Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Envelope = /*#__PURE__*/createIcon({
  displayName: "Envelope",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M20 4H4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM19.601 8.249L12.53 12.669C12.206 12.872 11.794 12.872 11.47 12.669L4.399 8.249C4.151 8.094 4 7.822 4 7.53C4 6.864 4.733 6.458 5.297 6.811L12 11L18.703 6.811C19.267 6.458 20 6.864 20 7.53C20 7.822 19.849 8.094 19.601 8.249Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Erase = /*#__PURE__*/createIcon({
  displayName: "Erase",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.6435 2C14.1389 2 13.6343 2.18885 13.2548 2.56836L2.56926 13.2578C1.81025 14.0168 1.81025 15.2761 2.56926 16.0352L7.95403 21.4199C8.34386 21.8098 8.8655 21.995 9.38372 21.9844C9.43288 21.9913 9.4825 21.9946 9.53215 21.9941H20.9931C21.3537 21.9992 21.6892 21.8098 21.871 21.4983C22.0528 21.1868 22.0528 20.8015 21.871 20.49C21.6892 20.1785 21.3537 19.989 20.9931 19.9941H12.1572L21.4169 10.7305C22.1759 9.97145 22.1759 8.71214 21.4169 7.95312L16.0322 2.56836C15.6526 2.18885 15.148 2 14.6435 2ZM9.3134 9.33984L14.6474 14.6738L9.3427 19.9805L4.00872 14.6445L9.3134 9.33984Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Error$1 = /*#__PURE__*/createIcon({
  displayName: "Error",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M22.7179 18.451L13.9209 3.816C13.6139 3.305 13.0749 3 12.4789 3C11.8829 3 11.3439 3.305 11.0379 3.815L2.23989 18.451C1.92789 18.97 1.91989 19.619 2.21789 20.146C2.51489 20.673 3.07589 21 3.68189 21H21.2769C21.8819 21 22.4439 20.673 22.7409 20.146C23.0389 19.619 23.0299 18.97 22.7179 18.451ZM12.9789 18H11.9789C11.7029 18 11.4789 17.776 11.4789 17.5V16.5C11.4789 16.224 11.7029 16 11.9789 16H12.9789C13.2549 16 13.4789 16.224 13.4789 16.5V17.5C13.4789 17.776 13.2549 18 12.9789 18ZM12.4789 14C11.9269 14 11.4789 13.552 11.4789 13V10C11.4789 9.448 11.9269 9 12.4789 9C13.0309 9 13.4789 9.448 13.4789 10V13C13.4789 13.552 13.0309 14 12.4789 14Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var EuropeNews = /*#__PURE__*/createIcon({
  displayName: "EuropeNews",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 1C2.343 1 1 2.343 1 4V17C1 18.105 1.895 19 3 19H10V16H6C5.448 16 5 15.552 5 15C5 14.448 5.448 14 6 14H10V12H6C5.448 12 5 11.552 5 11C5 10.448 5.448 10 6 10H12C12.552 10 13 10.448 13 11V12H16C16.552 12 17 11.552 17 11V4C17 3.449 17.448 3 18 3C18.565 3 19 3.43497 19 4V7C18.9949 7.36064 19.1844 7.69608 19.4959 7.87789C19.8074 8.05969 20.1926 8.05969 20.5041 7.87789C20.8156 7.69608 21.0051 7.36064 21 7V4C21 2.35503 19.645 1 18 1H4ZM6 4H12C12.552 4 13 4.448 13 5V6C13 6.552 12.552 7 12 7H6C5.448 7 5 6.552 5 6V5C5 4.448 5.448 4 6 4ZM18.9844 13.9863C18.4329 13.9949 17.9924 14.4485 18 15V19.5C18 20.8691 19.1309 22 20.5 22C21.8691 22 23 20.8691 23 19.5V15C23.0051 14.6394 22.8156 14.3039 22.5041 14.1221C22.1926 13.9403 21.8074 13.9403 21.4959 14.1221C21.1844 14.3039 20.9949 14.6394 21 15V19.5C21 19.7869 20.7869 20 20.5 20C20.2131 20 20 19.7869 20 19.5V15C20.0037 14.7297 19.8978 14.4694 19.7065 14.2784C19.5152 14.0875 19.2547 13.9821 18.9844 13.9863ZM13.0273 14C12.4751 14.0001 12.0274 14.4477 12.0273 15V17.7129C11.9724 17.8984 11.9724 18.0958 12.0273 18.2812V21C12.0274 21.5523 12.4751 21.9999 13.0273 22H16C16.3606 22.0051 16.6961 21.8156 16.8779 21.5041C17.0597 21.1926 17.0597 20.8074 16.8779 20.4959C16.6961 20.1844 16.3606 19.9949 16 20H14.0273V19H16C16.3606 19.0051 16.6961 18.8156 16.8779 18.5041C17.0597 18.1926 17.0597 17.8074 16.8779 17.4959C16.6961 17.1844 16.3606 16.9949 16 17H14.0273V16H16C16.3606 16.0051 16.6961 15.8156 16.8779 15.5041C17.0597 15.1926 17.0597 14.8074 16.8779 14.4959C16.6961 14.1844 16.3606 13.9949 16 14H13.0273Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var EuropeUnion = /*#__PURE__*/createIcon({
  displayName: "EuropeanUnion",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M0 4H24V20.8H0V4Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.3072 8.86366L12 8.3575L12.6927 8.86366L12.4483 8.01546L13.1208 7.48009L12.2771 7.46204L12 6.625L11.7229 7.46204L10.8791 7.48009L11.5516 8.01546L11.3072 8.86366Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.084 8.97375L13.925 8.89909L14.2839 9.70113L14.4761 8.83827L15.3135 8.7277L14.5913 8.26907L14.75 7.3987L14.1114 7.97812L13.372 7.55077L13.6995 8.36749L13.084 8.97375Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.3341 10.3787L14.5703 10.0019L15.3921 9.80003L15.4974 8.92079L15.9342 9.67904L16.7631 9.5125L16.2113 10.183L16.6183 10.9593L15.8404 10.6154L15.2631 11.2618L15.3341 10.3787Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.3679 11.6726L15.85 12.4L15.3679 13.1274L16.1757 12.8708L16.6856 13.5769L16.7028 12.691L17.5 12.4L16.7028 12.109L16.6856 11.2231L16.1757 11.9292L15.3679 11.6726Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.3341 14.4212L15.2631 13.5382L15.8404 14.1846L16.6183 13.8407L16.2113 14.617L16.7631 15.2875L15.9342 15.121L15.4974 15.8792L15.3921 15L14.5703 14.7981L15.3341 14.4212Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.2839 15.0989L13.925 15.9009L13.084 15.8263L13.6995 16.4325L13.372 17.2492L14.1114 16.8219L14.75 17.4013L14.5913 16.5309L15.3135 16.0723L14.4761 15.9617L14.2839 15.0989Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 16.4425L12.6927 15.9363L12.4483 16.7845L13.1208 17.3199L12.277 17.338L12 18.175L11.7229 17.338L10.8791 17.3199L11.5516 16.7845L11.3072 15.9363L12 16.4425Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M10.9159 15.8263L10.075 15.9009L9.71604 15.0989L9.52379 15.9617L8.68642 16.0723L9.40856 16.5309L9.24995 17.4013L9.88851 16.8219L10.6279 17.2492L10.3004 16.4325L10.9159 15.8263Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.66575 14.4213L9.4296 14.7981L8.60782 15L8.50252 15.8792L8.06574 15.121L7.23681 15.2875L7.78864 14.617L7.38164 13.8407L8.15947 14.1846L8.73685 13.5382L8.66575 14.4213Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.63201 13.1274L8.14995 12.4L8.63201 11.6726L7.8242 11.9292L7.31432 11.2231L7.29713 12.109L6.49995 12.4L7.29713 12.691L7.31432 13.5769L7.8242 12.8708L8.63201 13.1274Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.66575 10.3787L8.73685 11.2618L8.15947 10.6154L7.38164 10.9593L7.78864 10.183L7.23681 9.5125L8.06574 9.67904L8.50252 8.92079L8.60782 9.80003L9.4296 10.0019L8.66575 10.3787Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.71604 9.70113L10.075 8.89909L10.9159 8.97375L10.3004 8.36749L10.6279 7.55077L9.88851 7.97812L9.24995 7.3987L9.40856 8.26907L8.68642 8.7277L9.52379 8.83827L9.71604 9.70113Z",
      fill: "#FBB43A"
    })]
  })
});

var FlashOn = /*#__PURE__*/createIcon({
  displayName: "FlashOn",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.274 2H15.962C16.686 2 17.17 2.745 16.876 3.406L13.5 11H16.036C16.853 11 17.325 11.927 16.845 12.588L10.3 21.588C10.111 21.847 9.811 22 9.491 22C8.857 21.981 8.7 21.616 8.889 21L12 13H8.001C7.307 13 6.824 12.31 7.061 11.658L10.334 2.658C10.478 2.263 10.853 2 11.274 2Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Gift$1 = /*#__PURE__*/createIcon({
  displayName: "Gift",
  viewBox: "0 0 20 16",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2 0C0.897 0 0 0.897 0 2V7H3.18359C3.07159 6.686 3 6.352 3 6C3 4.346 4.346 3 6 3C6.352 3 6.686 3.07159 7 3.18359V0H2ZM9 0V3.18359C9.314 3.07159 9.648 3 10 3C11.654 3 13 4.346 13 6C13 6.352 12.9284 6.686 12.8164 7H20V2C20 0.897 19.103 0 18 0H9ZM6 5C5.449 5 5 5.449 5 6C5 6.551 5.449 7 6 7H7V6C7 5.449 6.551 5 6 5ZM10 5C9.449 5 9 5.449 9 6V7H10C10.551 7 11 6.551 11 6C11 5.449 10.551 5 10 5ZM0 9V14C0 15.105 0.895 16 2 16H7V10.4141L5.70703 11.707C5.31703 12.097 4.68297 12.097 4.29297 11.707C3.90297 11.317 3.90297 10.683 4.29297 10.293L5.58594 9H0ZM10.4141 9L11.707 10.293C12.097 10.683 12.097 11.317 11.707 11.707C11.317 12.097 10.683 12.097 10.293 11.707L9 10.4141V16H18C19.105 16 20 15.105 20 14V9H10.4141Z",
      fill: "currentColor"
    })]
  })
});

var Globe = /*#__PURE__*/createIcon({
  displayName: "Globe",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C8.74107 2 5.84869 3.57739 4.02148 6H4V6.02734C2.74995 7.69669 2 9.76039 2 12C2 17.511 6.489 22 12 22C17.511 22 22 17.511 22 12C22 6.489 17.511 2 12 2ZM15 4.58398C17.9351 5.76736 20 8.63265 20 12C20 14.0878 19.2006 15.9783 17.8984 17.4004C17.6426 16.5907 16.8946 16 16 16C15.448 16 15 15.552 15 15V13C15 12.448 14.552 12 14 12H10C9.448 12 9 11.552 9 11C9 10.448 9.448 10 10 10C10.552 10 11 9.552 11 9V8C11 7.448 11.448 7 12 7H13C14.105 7 15 6.105 15 5V4.58398ZM4.20703 10.207L9 15V16C9 17.105 9.895 18 11 18V19.9316C7.04577 19.4412 4 16.0907 4 12C4 11.3822 4.07552 10.784 4.20703 10.207Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var GlobeAround = /*#__PURE__*/createIcon({
  displayName: "GlobeAround",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.97481 2C9.71243 2.00013 9.4502 2.10078 9.2502 2.30078L7.80098 3.75L3.72481 2.57422L3.0002 3.30078L5.6252 5.92578L4.6877 6.86328L2.73653 6.21289L2.0002 6.94922L6.04707 11L6.78535 10.2617L6.13692 8.3125L7.07442 7.375L9.69746 9.99805L10.424 9.27344L9.2502 5.19922L10.6994 3.75C11.0994 3.35 11.0994 2.70178 10.6994 2.30078C10.4989 2.10028 10.2372 1.99988 9.97481 2ZM13.924 2.23047C13.4216 2.25749 13.0175 2.65353 12.9804 3.15528C12.9432 3.65704 13.2846 4.10827 13.7775 4.20898C14.5706 4.38932 15.3157 4.69253 16.0002 5.08789V9C16.0002 9.55 16.4502 10 17.0002 10C17.5522 10 18.0002 10.448 18.0002 11C18.0002 11.552 17.5522 12 17.0002 12H14.0002C13.4502 12 13.0002 12.45 13.0002 13V15C13.0002 16.1 13.9002 17 15.0002 17C15.5522 17 16.0002 17.448 16.0002 18V18.9277C14.8238 19.6065 13.4608 20 12.0002 20C11.3075 20 10.6404 19.9024 10.0002 19.7383V19C10.0002 17.9 9.1002 17 8.0002 17C7.4482 17 7.0002 16.552 7.0002 16V15C7.0002 14.45 6.5502 14 6.0002 14H4.26192C4.09777 13.3597 4.0002 12.6927 4.0002 12C4.0053 11.6394 3.81582 11.3039 3.50432 11.1221C3.19283 10.9403 2.80757 10.9403 2.49607 11.1221C2.18457 11.3039 1.9951 11.6394 2.0002 12C2.0002 17.5113 6.48886 22 12.0002 22C17.5115 22 22.0002 17.5113 22.0002 12C22.0002 7.25186 18.6752 3.27033 14.2229 2.25781C14.1575 2.24203 14.0908 2.23287 14.0236 2.23047C13.9905 2.22881 13.9572 2.22881 13.924 2.23047Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Guardian = /*#__PURE__*/createIcon({
  displayName: "Guardian",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.5 4C6.567 4 5 5.567 5 7.5C5 9.433 6.567 11 8.5 11C10.433 11 12 9.433 12 7.5C12 5.567 10.433 4 8.5 4ZM17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7ZM8.5 13C5.69 13 3.23953 14.1403 2.01953 14.8203C1.38953 15.1803 1 15.8403 1 16.5703V19C1 19.552 1.448 20 2 20H8C8.552 20 9 19.552 9 19V17.1309C9 15.7109 9.77906 14.3799 11.0391 13.6699C11.1791 13.5899 11.3398 13.5099 11.5098 13.4199C10.5898 13.1699 9.57 13 8.5 13ZM17 14C14.858 14 12.9634 14.8861 12.0234 15.4141C11.3924 15.7701 11 16.4279 11 17.1309V19C11 19.552 11.448 20 12 20H22C22.552 20 23 19.552 23 19V17.1309C23 16.4279 22.6066 15.7701 21.9746 15.4141C21.0356 14.8861 19.142 14 17 14Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Heart = /*#__PURE__*/createIcon({
  displayName: "Heart",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.2558 3.00429C13.5148 3.11629 11.9998 5.08929 11.9998 5.08929C11.9998 5.08929 10.4848 3.11629 7.74383 3.00429C5.90583 2.92929 4.22083 3.84429 3.11083 5.31129C-0.75117 10.4153 6.56083 16.3863 8.28083 17.9893C9.30983 18.9483 10.5798 20.0873 11.3378 20.7623C11.7168 21.1003 12.2818 21.1003 12.6608 20.7623C13.4188 20.0873 14.6888 18.9483 15.7178 17.9893C17.4378 16.3863 24.7508 10.4153 20.8878 5.31129C19.7788 3.84429 18.0938 2.92929 16.2558 3.00429Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Help = /*#__PURE__*/createIcon({
  displayName: "Help",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.5 19H11.5C11.224 19 11 18.776 11 18.5V17.5C11 17.224 11.224 17 11.5 17H12.5C12.776 17 13 17.224 13 17.5V18.5C13 18.776 12.776 19 12.5 19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.867 9.966 14.095 9.308 13.963 8.607C13.828 7.89 13.275 7.28 12.574 7.081C11.468 6.767 10.437 7.4 10.108 8.353C9.98 8.724 9.668 9 9.275 9H8.984C8.403 9 7.997 8.436 8.159 7.878C8.588 6.406 9.84 5.285 11.384 5.047C12.908 4.812 14.353 5.596 15.257 6.846C16.437 8.478 16.089 10.231 15.07 11.25Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var HighImportance = /*#__PURE__*/createIcon({
  displayName: "HighImportance",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M22.555 10.9128L13.072 1.42975C12.499 0.85675 11.499 0.85675 10.927 1.42975L1.444 10.9128C0.852 11.5048 0.852 12.4668 1.444 13.0577L10.927 22.5408C11.213 22.8267 11.594 22.9848 11.999 22.9848C12.404 22.9848 12.785 22.8267 13.072 22.5408L22.555 13.0577C23.147 12.4657 23.147 11.5037 22.555 10.9128ZM12.499 16.9847H11.499C11.223 16.9847 10.999 16.7607 10.999 16.4847V15.4847C10.999 15.2087 11.223 14.9847 11.499 14.9847H12.499C12.775 14.9847 12.999 15.2087 12.999 15.4847V16.4847C12.999 16.7607 12.775 16.9847 12.499 16.9847ZM12.499 12.9847H11.499C11.223 12.9847 10.999 12.7607 10.999 12.4847V7.48475C10.999 7.20875 11.223 6.98475 11.499 6.98475H12.499C12.775 6.98475 12.999 7.20875 12.999 7.48475V12.4847C12.999 12.7607 12.775 12.9847 12.499 12.9847Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Home = /*#__PURE__*/createIcon({
  displayName: "Home",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 3C11.7329 3.00003 11.4769 3.10694 11.2891 3.29688L1.20312 12.0977C1.07538 12.1919 0.999994 12.3412 1 12.5C1 12.7761 1.22386 13 1.5 13H4V21C4 21.552 4.448 22 5 22H9C9.552 22 10 21.552 10 21V15H14V21C14 21.552 14.448 22 15 22H19C19.552 22 20 21.552 20 21V13H22.5C22.7761 13 23 12.7761 23 12.5C23 12.3412 22.9246 12.1919 22.7969 12.0977L12.7168 3.30273C12.7149 3.30077 12.7129 3.29882 12.7109 3.29688C12.5231 3.10694 12.2671 3.00003 12 3Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ID$1 = /*#__PURE__*/createIcon({
  displayName: "ID",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.895 4 2 4.895 2 6ZM8 8C9.105 8 10 8.895 10 10C10 11.105 9.105 12 8 12C6.895 12 6 11.105 6 10C6 8.895 6.895 8 8 8ZM5 15.1C5 14.102 6.999 13.6 8 13.6C9.001 13.6 11 14.102 11 15.1V16H5V15.1ZM18 11H14C13.448 11 13 10.552 13 10C13 9.448 13.448 9 14 9H18C18.552 9 19 9.448 19 10C19 10.552 18.552 11 18 11ZM18 15H14C13.448 15 13 14.552 13 14C13 13.448 13.448 13 14 13H18C18.552 13 19 13.448 19 14C19 14.552 18.552 15 18 15Z",
      fill: "currentColor"
    })]
  })
});

var Idea = /*#__PURE__*/createIcon({
  displayName: "Idea",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9844 0.000122137C11.4335 0.00874321 10.9936 0.462262 11.0012 1.01379V2.01379C10.9961 2.37443 11.1853 2.70988 11.4965 2.89168C11.8076 3.07349 12.1924 3.07349 12.5035 2.89168C12.8147 2.70988 13.0039 2.37443 12.9988 2.01379V1.01379C13.0025 0.743494 12.8968 0.483207 12.7057 0.292242C12.5145 0.101277 12.2544 -0.00409959 11.9844 0.000122137ZM4.22017 3.22473C3.81321 3.22481 3.44698 3.47207 3.29436 3.84977C3.14175 4.22748 3.23325 4.66013 3.52568 4.94348L4.23188 5.65051C4.4824 5.91174 4.8544 6.01697 5.20442 5.92561C5.55444 5.83426 5.82779 5.56059 5.91904 5.21015C6.01029 4.85971 5.90518 4.48727 5.64426 4.23645L4.93807 3.52942C4.74988 3.33468 4.49082 3.22473 4.22017 3.22473ZM19.7486 3.22668C19.4891 3.23443 19.2428 3.343 19.0619 3.52942L18.3557 4.23645C18.0948 4.48727 17.9897 4.85971 18.081 5.21015C18.1722 5.56058 18.4456 5.83425 18.7956 5.92561C19.1456 6.01697 19.5176 5.91174 19.7681 5.65051L20.4743 4.94348C20.7697 4.65599 20.8586 4.21642 20.698 3.83657C20.5374 3.45672 20.1604 3.21453 19.7486 3.22668ZM12 5.01379C8.14458 5.01379 5.0083 8.15379 5.0083 12.0138C5.0083 14.7988 6.64536 17.2022 9.00356 18.3282V21.0138C9.00356 22.1168 9.89949 23.0138 11.0012 23.0138H12.9988C14.1005 23.0138 14.9964 22.1168 14.9964 21.0138V18.3282C17.3546 17.2022 18.9917 14.7988 18.9917 12.0138C18.9917 8.15379 15.8554 5.01379 12 5.01379ZM1.01304 11.0138C0.652832 11.0087 0.317784 11.1982 0.136193 11.5097C-0.0453977 11.8212 -0.0453977 12.2064 0.136193 12.5179C0.317784 12.8294 0.652832 13.0189 1.01304 13.0138H2.01185C2.37206 13.0189 2.70711 12.8294 2.8887 12.5179C3.07029 12.2064 3.07029 11.8212 2.8887 11.5097C2.70711 11.1982 2.37206 11.0087 2.01185 11.0138H1.01304ZM21.9881 11.0138C21.6279 11.0087 21.2929 11.1982 21.1113 11.5097C20.9297 11.8212 20.9297 12.2064 21.1113 12.5179C21.2929 12.8294 21.6279 13.0189 21.9881 13.0138H22.987C23.3472 13.0189 23.6822 12.8294 23.8638 12.5179C24.0454 12.2064 24.0454 11.8212 23.8638 11.5097C23.6822 11.1982 23.3472 11.0087 22.987 11.0138H21.9881ZM4.91856 18.0743C4.65907 18.0821 4.41278 18.1907 4.23188 18.3771L3.52568 19.0841C3.26476 19.3349 3.15966 19.7074 3.25091 20.0578C3.34216 20.4082 3.6155 20.6819 3.96552 20.7733C4.31554 20.8646 4.68755 20.7594 4.93807 20.4982L5.64426 19.7911C5.93967 19.5036 6.0285 19.0641 5.86793 18.6842C5.70737 18.3044 5.33036 18.0622 4.91856 18.0743ZM19.0522 18.0743C18.6457 18.0744 18.2799 18.3211 18.1269 18.6981C17.974 19.0751 18.0645 19.5073 18.3557 19.7911L19.0619 20.4982C19.3125 20.7594 19.6845 20.8646 20.0345 20.7733C20.3845 20.6819 20.6578 20.4082 20.7491 20.0578C20.8403 19.7074 20.7352 19.3349 20.4743 19.0841L19.7681 18.3771C19.5801 18.1835 19.3219 18.0744 19.0522 18.0743Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ImageFile = /*#__PURE__*/createIcon({
  displayName: "ImageFile",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM7 18L9.5 14.667L11 16.667L13.5 13.334L17 18H7ZM13 9V3.5L18.5 9H13Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Info = /*#__PURE__*/createIcon({
  displayName: "Info",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 17C11.448 17 11 16.552 11 16V12C11 11.448 11.448 11 12 11C12.552 11 13 11.448 13 12V16C13 16.552 12.552 17 12 17ZM12.5 9H11.5C11.224 9 11 8.776 11 8.5V7.5C11 7.224 11.224 7 11.5 7H12.5C12.776 7 13 7.224 13 7.5V8.5C13 8.776 12.776 9 12.5 9Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var InsertLink = /*#__PURE__*/createIcon({
  displayName: "InsertLink",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.9558 11.38C4.2358 9.91 5.6158 8.9 7.1158 8.9H10.0458C10.5658 8.9 10.9958 8.47 10.9958 7.95C10.9958 7.43 10.5658 7 10.0458 7H7.2158C4.6058 7 2.2758 8.91 2.0258 11.51C1.7358 14.49 4.0758 17 6.9958 17H10.0458C10.5658 17 10.9958 16.57 10.9958 16.05C10.9958 15.53 10.5658 15.1 10.0458 15.1H6.9958C5.0858 15.1 3.5758 13.36 3.9558 11.38ZM8.9958 13H14.9958C15.5458 13 15.9958 12.55 15.9958 12C15.9958 11.45 15.5458 11 14.9958 11H8.9958C8.4458 11 7.9958 11.45 7.9958 12C7.9958 12.55 8.4458 13 8.9958 13ZM13.9458 7H16.7758C19.3858 7 21.7258 8.91 21.9758 11.51C22.2558 14.49 19.9158 17 16.9958 17H13.9458C13.4258 17 12.9958 16.57 12.9958 16.05C12.9958 15.53 13.4258 15.1 13.9458 15.1H16.9958C18.9058 15.1 20.4158 13.36 20.0358 11.38C19.7558 9.91 18.3758 8.9 16.8758 8.9H13.9458C13.4258 8.9 12.9958 8.47 12.9958 7.95C12.9958 7.43 13.4258 7 13.9458 7Z",
      fill: "currentColor"
    })]
  })
});

var Law = /*#__PURE__*/createIcon({
  displayName: "Law",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.1427 2.99995C12.8829 3.00769 12.6363 3.11627 12.4552 3.30268L11.4552 4.30268L7.30284 8.45307C7.30116 8.45476 7.30061 8.45723 7.29894 8.45893L6.30284 9.45503C6.04161 9.70585 5.93638 10.0783 6.02774 10.4287C6.1191 10.7792 6.39277 11.0528 6.7432 11.1442C7.09364 11.2356 7.46609 11.1303 7.71691 10.8691L8.01183 10.5742L9.92589 12.4882L2.29308 20.121C2.03184 20.3719 1.92661 20.7443 2.01797 21.0947C2.10932 21.4452 2.38299 21.7189 2.73343 21.8102C3.08387 21.9016 3.45632 21.7963 3.70714 21.5351L11.34 13.9023L13.4259 15.9882L13.1329 16.2812C12.8717 16.532 12.7665 16.9045 12.8578 17.2549C12.9492 17.6053 13.2228 17.879 13.5733 17.9704C13.9237 18.0617 14.2962 17.9565 14.547 17.6953L15.545 16.6953L19.6974 12.5449L21.0353 11.207C21.331 10.9195 21.42 10.4799 21.2592 10.1001C21.0984 9.72022 20.721 9.47803 20.3087 9.49018C20.0489 9.49792 19.8023 9.6065 19.6212 9.79292L18.9903 10.4238L13.5763 5.00971L13.8693 4.71675C14.165 4.42925 14.2539 3.98968 14.0932 3.60983C13.9324 3.22999 13.555 2.98779 13.1427 2.99995ZM14.0157 20C13.6551 19.9949 13.3197 20.1843 13.1378 20.4958C12.956 20.8073 12.956 21.1926 13.1378 21.5041C13.3197 21.8156 13.6551 22.0051 14.0157 22H21.004C21.3647 22.0051 21.7001 21.8156 21.8819 21.5041C22.0637 21.1926 22.0637 20.8073 21.8819 20.4958C21.7001 20.1843 21.3647 19.9949 21.004 20H14.0157Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Lock = /*#__PURE__*/createIcon({
  displayName: "Lock",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C8.67619 2 6 4.67619 6 8V9C4.9 9 4 9.9 4 11V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V11C20 9.9 19.1 9 18 9V8C18 4.67619 15.3238 2 12 2ZM12 4C14.2762 4 16 5.72381 16 8V9H8V8C8 5.72381 9.72381 4 12 4ZM12 14C13.1 14 14 14.9 14 16C14 17.1 13.1 18 12 18C10.9 18 10 17.1 10 16C10 14.9 10.9 14 12 14Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Logout = /*#__PURE__*/createIcon({
  displayName: "Logout",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3ZM16.407 16.007L19.707 12.707C20.098 12.316 20.098 11.684 19.707 11.293L16.407 7.993C16.016 7.602 15.384 7.602 14.993 7.993C14.602 8.384 14.602 9.016 14.993 9.407L16.586 11H9C8.447 11 8 11.447 8 12C8 12.553 8.447 13 9 13H16.586L14.993 14.593C14.602 14.984 14.602 15.616 14.993 16.007C15.188 16.202 15.444 16.3 15.7 16.3C15.956 16.3 16.212 16.202 16.407 16.007Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })]
  })
});

var Lounge$1 = /*#__PURE__*/createIcon({
  displayName: "Lounge",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.00005 13.25V14H15.0001V13.25C15.0001 10.3554 17.3548 7.99999 20.25 7.99999C20.4324 7.99999 20.6153 8.01693 20.7981 8.0357C20.14 5.43676 17.8006 3.5 15.0001 3.5H9.00005C6.19953 3.5 3.86008 5.43681 3.20203 8.0357C3.38478 8.01693 3.56768 7.99999 3.75007 7.99999C6.6453 7.99999 9.00005 10.3554 9.00005 13.25Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M23.849 12.1757C23.5046 10.9487 22.4921 9.95332 21.2589 9.63162C18.7531 8.97782 16.4999 10.8507 16.4999 13.2501V15.5H7.50001V13.25C7.50001 10.8507 5.2469 8.97782 2.74108 9.63157C1.50788 9.95327 0.495386 10.9486 0.150976 12.1756C-0.207809 13.4538 0.0990606 14.6553 0.794519 15.5409C1.22893 16.0943 1.5 16.7557 1.5 17.4592V20H4.49998V21.5H7.49996V20H16.4999V21.5H19.4999V20H22.4999V17.4592C22.4999 16.7558 22.771 16.0943 23.2054 15.5409C23.9009 14.6553 24.2078 13.4538 23.849 12.1757ZM3.74995 14C3.33577 14 2.99997 13.6642 2.99997 13.2501C2.99997 12.8358 3.33577 12.5001 3.74995 12.5001C4.16413 12.5001 4.49994 12.8358 4.49994 13.2501C4.49994 13.6642 4.16413 14 3.74995 14ZM20.25 14C19.8358 14 19.5 13.6642 19.5 13.2501C19.5 12.8358 19.8358 12.5001 20.25 12.5001C20.6641 12.5001 20.9999 12.8358 20.9999 13.2501C20.9999 13.6642 20.6641 14 20.25 14Z",
      fill: "currentColor"
    })]
  })
});

var Luggage = /*#__PURE__*/createIcon({
  displayName: "Luggage",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8 5C8 3.895 8.895 3 10 3H14C15.105 3 16 3.895 16 5V6V7C16 7.552 16.448 8 17 8C17.552 8 18 7.552 18 7V6H20C21.105 6 22 6.895 22 8V19C22 20.105 21.105 21 20 21H4C2.895 21 2 20.105 2 19V8C2 6.895 2.895 6 4 6H6V7C6 7.552 6.448 8 7 8C7.552 8 8 7.552 8 7V6V5ZM14 5H10V6H14V5ZM14.5 11C15.328 11 16 11.672 16 12.5C16 13.328 15.328 14 14.5 14C13.672 14 13 13.328 13 12.5C13 11.672 13.672 11 14.5 11ZM19.0879 14.2773C18.9956 14.0921 18.8037 13.9898 18.6094 14.002C18.5446 14.006 18.4797 14.022 18.418 14.0527L13.6406 16.5684C13.3926 16.6914 13.2901 16.9932 13.4141 17.2402L13.9688 18.3457C14.0928 18.5917 14.3917 18.6923 14.6387 18.5703L19.416 16.0547C19.664 15.9317 19.7646 15.6298 19.6406 15.3828L19.0879 14.2773Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var LuggageSolid = /*#__PURE__*/createIcon({
  displayName: "LuggageSolid",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.5 4.17035H14.5V5.33035H9.5V4.17035ZM17.26 5.33035H15.75V3.58035C15.7422 3.42031 15.6718 3.26975 15.5539 3.16122C15.436 3.0527 15.2801 2.99491 15.12 3.00035H8.88C8.71986 2.99491 8.564 3.0527 8.44612 3.16122C8.32824 3.26975 8.25779 3.42031 8.25 3.58035V5.33035H6.72V20.5004H17.28L17.26 5.33035ZM18.43 5.33035V20.5004H19.5C20.1412 20.5193 20.7639 20.2839 21.2322 19.8455C21.7005 19.4072 21.9765 18.8014 22 18.1604V7.66035C21.9765 7.02017 21.7002 6.41541 21.2316 5.97865C20.7629 5.54188 20.1402 5.30875 19.5 5.33035H18.43ZM5.5 5.33035H4.5C3.85975 5.30875 3.23706 5.54188 2.76843 5.97865C2.2998 6.41541 2.02346 7.02017 2 7.66035V18.1604C2.02348 18.8014 2.29948 19.4072 2.76781 19.8455C3.23614 20.2839 3.8588 20.5193 4.5 20.5004H5.5V5.33035Z",
      fill: "currentColor"
    })]
  })
});

var Marker = /*#__PURE__*/createIcon({
  displayName: "Marker",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C8.134 2 5 5.134 5 9C5 12.966 9.404 18.82 11.226 21.071C11.626 21.565 12.374 21.565 12.774 21.071C14.596 18.82 19 12.966 19 9C19 5.134 15.866 2 12 2ZM12 11.5C10.619 11.5 9.5 10.381 9.5 9C9.5 7.619 10.619 6.5 12 6.5C13.381 6.5 14.5 7.619 14.5 9C14.5 10.381 13.381 11.5 12 11.5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Mastercard = /*#__PURE__*/createIcon({
  displayName: "Mastercard",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M15.1414 6.43921H8.69604V18.0204H15.1414V6.43921Z",
      fill: "#FF5F00"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.10537 12.2298C9.10537 9.87671 10.2103 7.78964 11.9086 6.43919C10.6604 5.45703 9.0849 4.86365 7.36614 4.86365C3.2943 4.86365 0 8.15795 0 12.2298C0 16.3016 3.2943 19.5959 7.36614 19.5959C9.0849 19.5959 10.6604 19.0025 11.9086 18.0204C10.2103 16.6904 9.10537 14.5829 9.10537 12.2298Z",
      fill: "#EB001B"
    }), /*#__PURE__*/jsx("path", {
      d: "M23.8375 12.2298C23.8375 16.3016 20.5432 19.5959 16.4714 19.5959C14.7526 19.5959 13.1771 19.0025 11.929 18.0204C13.6477 16.6699 14.7322 14.5829 14.7322 12.2298C14.7322 9.87671 13.6273 7.78964 11.929 6.43919C13.1771 5.45703 14.7526 4.86365 16.4714 4.86365C20.5432 4.86365 23.8375 8.17841 23.8375 12.2298Z",
      fill: "#F79E1B"
    })]
  })
});

var Meeting = /*#__PURE__*/createIcon({
  displayName: "Meeting",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6C7.10457 6 8 5.10457 8 4C8 2.89543 7.10457 2 6 2ZM18 2C16.8954 2 16 2.89543 16 4C16 5.10457 16.8954 6 18 6C19.1046 6 20 5.10457 20 4C20 2.89543 19.1046 2 18 2ZM5 8C3.895 8 3 8.895 3 10V16V21C3 21.552 3.448 22 4 22C4.552 22 5 21.552 5 21V16H7V21C7 21.552 7.448 22 8 22C8.552 22 9 21.552 9 21V15V12.1699L11.293 14.4648C11.684 14.8558 12.317 14.8558 12.707 14.4648L15 12.1699V16V21C15 21.552 15.448 22 16 22C16.552 22 17 21.552 17 21V16H19V21C19 21.552 19.448 22 20 22C20.552 22 21 21.552 21 21V15V10C21 8.895 20.105 8 19 8H17C16.444 8 15.9425 8.2278 15.5801 8.59375L15.5781 8.5918L12 12.1719L8.41406 8.58594L8.38867 8.55859L8.38477 8.5625C8.0252 8.21614 7.53897 8 7 8H5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Menu = /*#__PURE__*/createIcon({
  displayName: "Menu",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2.99996 5.0001C2.63932 4.995 2.30388 5.18448 2.12207 5.49597C1.94027 5.80747 1.94027 6.19273 2.12207 6.50423C2.30388 6.81573 2.63932 7.0052 2.99996 7.0001H21C21.3606 7.0052 21.696 6.81573 21.8778 6.50423C22.0597 6.19273 22.0597 5.80747 21.8778 5.49597C21.696 5.18448 21.3606 4.995 21 5.0001H2.99996ZM2.99996 11.0001C2.63932 10.995 2.30388 11.1845 2.12207 11.496C1.94027 11.8075 1.94027 12.1927 2.12207 12.5042C2.30388 12.8157 2.63932 13.0052 2.99996 13.0001H21C21.3606 13.0052 21.696 12.8157 21.8778 12.5042C22.0597 12.1927 22.0597 11.8075 21.8778 11.496C21.696 11.1845 21.3606 10.995 21 11.0001H2.99996ZM2.99996 17.0001C2.63932 16.995 2.30388 17.1845 2.12207 17.496C1.94027 17.8075 1.94027 18.1927 2.12207 18.5042C2.30388 18.8157 2.63932 19.0052 2.99996 19.0001H21C21.3606 19.0052 21.696 18.8157 21.8778 18.5042C22.0597 18.1927 22.0597 17.8075 21.8778 17.496C21.696 17.1845 21.3606 16.995 21 17.0001H2.99996Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Messenger = /*#__PURE__*/createIcon({
  displayName: "Messenger",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2 11.6325C2 14.5458 3.45333 17.145 5.72583 18.8425V22.3733L9.13083 20.505C10.0392 20.7558 11.0017 20.8925 11.9992 20.8925C17.5217 20.8925 21.9992 16.7475 21.9992 11.6333C22 6.51912 17.5225 2.37329 12 2.37329C6.4775 2.37329 2 6.51829 2 11.6325H2ZM10.945 9.03912L13.5533 11.755L18.4592 9.03912L12.9925 14.8408L10.4467 12.1258L5.4775 14.8416L10.945 9.03912Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MinusMath = /*#__PURE__*/createIcon({
  displayName: "MinusMath",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 11C10.6354 11 13.9893 11 5 11C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13C11.5405 13 12.0824 13 19 13C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11Z",
      fill: "currentColor"
    })]
  })
});

var MoneyCreditCard = /*#__PURE__*/createIcon({
  displayName: "MoneyCreditCard",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 4C2.895 4 2 4.895 2 6C2 6.552 2.448 7 3 7H21C21.552 7 22 6.552 22 6C22 4.895 21.105 4 20 4H4ZM3 10C2.448 10 2 10.448 2 11V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V11C22 10.448 21.552 10 21 10H3Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoneyBack = /*#__PURE__*/createIcon({
  displayName: "MoneyBack",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.1907 4.78693C17.6521 3.14225 15.623 2.07417 13.4263 1.75266L14.0501 1.11099C14.1088 1.05056 14.1554 0.978813 14.1872 0.899854C14.219 0.820895 14.2354 0.736267 14.2354 0.650803C14.2354 0.565338 14.219 0.48071 14.1872 0.401751C14.1554 0.322792 14.1088 0.251048 14.0501 0.190616C13.9913 0.130183 13.9216 0.0822453 13.8448 0.0495394C13.768 0.0168335 13.6858 -1.91028e-09 13.6027 0C13.5196 1.91028e-09 13.4373 0.0168335 13.3606 0.0495394C13.2838 0.0822453 13.2141 0.130183 13.1553 0.190616L11.5531 1.83877C11.4942 1.89923 11.4475 1.97103 11.4157 2.05008C11.3838 2.12912 11.3674 2.21385 11.3674 2.29942C11.3674 2.38499 11.3838 2.46972 11.4157 2.54876C11.4475 2.62781 11.4942 2.69961 11.5531 2.76007L13.1553 4.40823C13.2786 4.536 13.4407 4.59897 13.6027 4.59897C13.7647 4.59897 13.9267 4.536 14.0501 4.40823C14.1089 4.34785 14.1556 4.27612 14.1874 4.19715C14.2193 4.11819 14.2357 4.03353 14.2357 3.94804C14.2357 3.86254 14.2193 3.77789 14.1874 3.69892C14.1556 3.61996 14.1089 3.54823 14.0501 3.48785L13.6918 3.11933C15.4416 3.47176 17.0435 4.36986 18.2798 5.69156C19.8581 7.36391 20.7389 9.60431 20.7344 11.9351C20.7344 16.8888 16.8162 20.9203 11.9996 20.9203C7.18387 20.9203 3.26561 16.8898 3.26561 11.9351C3.26561 10.0453 3.82909 8.23694 4.89665 6.70546C5.93112 5.21481 7.38507 4.0863 9.06244 3.47211C9.14496 3.44685 9.22161 3.40457 9.28772 3.34783C9.35382 3.29109 9.40799 3.22109 9.44692 3.1421C9.48586 3.06311 9.50873 2.97679 9.51416 2.8884C9.51958 2.80002 9.50744 2.71142 9.47848 2.62802C9.44952 2.54462 9.40433 2.46817 9.34569 2.40333C9.28705 2.33849 9.21618 2.28662 9.13741 2.25089C9.05863 2.21515 8.97361 2.19631 8.88752 2.1955C8.80143 2.19469 8.71608 2.21193 8.63668 2.24618C6.71634 2.94924 5.05185 4.24131 3.8678 5.94805C2.64845 7.69193 1.99486 9.787 2.00003 11.9351C2.00003 14.6833 3.03968 17.2666 4.92905 19.2092C5.85541 20.1673 6.9573 20.927 8.17095 21.4442C9.38459 21.9613 10.6859 22.2258 11.9996 22.2222C14.6711 22.2222 17.1825 21.1518 19.071 19.2092C20.9595 17.2666 22 14.6833 22 11.9351C22 9.25269 21.0018 6.71379 19.1907 4.78693Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.33333 12.2222C5.33333 15.8989 8.32408 18.8889 11.9995 18.8889C15.6759 18.8889 18.6667 15.8989 18.6667 12.2222C18.6667 8.54651 15.6759 5.55556 12.0005 5.55556C8.32408 5.55556 5.33333 8.54559 5.33333 12.2222ZM12.3982 12.7999C11.4643 12.4695 10.9236 12.2093 10.5305 11.902C10.0478 11.5227 9.82638 10.8684 9.95372 10.1938C10.0921 9.46198 10.6015 8.87874 11.2853 8.67294L11.313 8.66556V8.40347C11.3193 8.23552 11.3905 8.07656 11.5115 7.95998C11.6326 7.8434 11.7941 7.77827 11.9622 7.77827C12.1302 7.77827 12.2917 7.8434 12.4128 7.95998C12.5338 8.07656 12.605 8.23552 12.6113 8.40347V8.62403C13.0635 8.73016 13.38 8.9378 13.5083 9.03285C13.5765 9.08387 13.634 9.14783 13.6775 9.22108C13.721 9.29433 13.7497 9.37543 13.7619 9.45976C13.774 9.54408 13.7695 9.62997 13.7485 9.71253C13.7274 9.7951 13.6903 9.87271 13.6393 9.94094C13.5883 10.0092 13.5244 10.0667 13.4511 10.1102C13.3779 10.1537 13.2968 10.1824 13.2125 10.1945C13.1281 10.2067 13.0423 10.2021 12.9597 10.1811C12.8771 10.1601 12.7995 10.123 12.7313 10.072C12.5938 9.96955 12.2146 9.74899 11.66 9.9151C11.3314 10.0148 11.2465 10.3368 11.229 10.4337C11.1921 10.6248 11.2336 10.8038 11.3314 10.8804C11.671 11.1471 12.2801 11.3815 12.831 11.5762C13.8387 11.9324 14.3997 12.8664 14.2253 13.9C14.1393 14.4092 13.8865 14.8754 13.5064 15.2252C13.2462 15.4651 12.9435 15.6349 12.6113 15.73V16.041C12.6113 16.2132 12.543 16.3783 12.4212 16.5C12.2995 16.6218 12.1343 16.6902 11.9622 16.6902C11.79 16.6902 11.6249 16.6218 11.5031 16.5C11.3814 16.3783 11.313 16.2132 11.313 16.041V15.7946C10.882 15.7438 10.5212 15.61 10.0368 15.2935C9.96546 15.2468 9.90403 15.1866 9.856 15.1162C9.80796 15.0458 9.77427 14.9666 9.75683 14.8832C9.73939 14.7997 9.73856 14.7137 9.75437 14.63C9.77018 14.5462 9.80233 14.4664 9.84899 14.3951C9.89564 14.3238 9.95589 14.2623 10.0263 14.2143C10.0967 14.1662 10.1758 14.1325 10.2593 14.1151C10.3427 14.0977 10.4287 14.0968 10.5125 14.1126C10.5962 14.1285 10.676 14.1606 10.7473 14.2073C11.1967 14.5017 11.3665 14.5284 11.958 14.5238C12.5403 14.5201 12.878 14.0864 12.9454 13.684C12.9786 13.4884 12.9915 13.0103 12.3982 12.7999Z",
      fill: "currentColor"
    })]
  })
});

var MoneyEuro = /*#__PURE__*/createIcon({
  displayName: "MoneyEuro",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 1C11.1151 1 10.3284 1.39067 9.7793 2H8.28125C7.63025 2 7.15255 2.61019 7.31055 3.24219L8 6H16L16.6895 3.24219C16.8475 2.61019 16.3698 2 15.7188 2H14.2207C13.6716 1.39067 12.8849 1 12 1ZM8 8C8 8 2 11.014 2 18C2 19.891 2.53036 21.3017 3.44336 22.3457C3.81636 22.7717 4.36664 23 4.93164 23H19.0684C19.6334 23 20.1846 22.7717 20.5566 22.3457C21.4706 21.3017 22 19.891 22 18C22 11.015 16 8 16 8H8ZM13.1191 11C13.3471 11 13.5751 11.0189 13.7891 11.0449C14.3141 11.1119 14.6719 11.6128 14.5879 12.1348C14.4239 12.7608 14.0271 13.0529 13.2461 12.7969C12.1971 12.7969 11.5845 13.385 11.2695 14H12.5C12.775 14 13 14.225 13 14.5C13 14.775 12.775 15 12.5 15H10.998L10.9844 16H12.5C12.775 16 13 16.225 13 16.5C13 16.775 12.775 17 12.5 17H11.2441C11.5271 17.59 12.0932 18.2188 13.1992 18.2188C13.9692 17.9527 14.46 18.1214 14.584 18.8594C14.67 19.3904 14.3016 19.8941 13.7676 19.9531C13.5216 19.9801 13.247 20 12.959 20C10.418 20 9.40238 18.425 9.10938 17H8.5C8.225 17 8 16.775 8 16.5C8 16.225 8.225 16 8.5 16H9L9.00586 15H8.5C8.225 15 8 14.775 8 14.5C8 14.225 8.225 14 8.5 14H9.15039C9.45139 12.793 10.3601 11.001 13.1191 11Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoneyFee = /*#__PURE__*/createIcon({
  displayName: "MoneyFee",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C9.603 2 7.40078 2.84972 5.67578 4.26172L9.42188 8.00781C9.51687 7.82581 9.62291 7.65491 9.75391 7.50391C9.97491 7.24791 10.2399 7.04086 10.5469 6.88086C10.6899 6.80686 10.841 6.74822 11 6.69922V6C11 5.448 11.448 5 12 5C12.552 5 13 5.448 13 6V6.70117C13.209 6.76617 13.4088 6.84698 13.5918 6.95898C13.8888 7.13998 14.1426 7.37506 14.3496 7.66406C14.5576 7.95406 14.7239 8.26906 14.8379 8.66406C14.8639 8.75406 14.9023 8.91708 14.9023 9.08008C14.9023 9.58808 14.5914 10 13.9844 10C13.5624 10 13.2713 9.75231 13.1133 9.32031C13.0543 9.15731 12.9648 8.86722 12.8438 8.69922C12.6337 8.40722 12.354 8.26172 12.002 8.26172C11.81 8.26172 11.6448 8.29338 11.5078 8.35938C11.3698 8.42537 11.257 8.51781 11.168 8.63281C11.078 8.74781 11.0117 8.88402 10.9707 9.04102C10.9327 9.18202 10.9151 9.33705 10.9121 9.49805L19.7383 18.3223C21.1503 16.5983 22 14.397 22 12C22 6.486 17.514 2 12 2ZM4.26172 5.67578C2.84972 7.40078 2 9.603 2 12C2 17.514 6.486 22 12 22C14.397 22 16.5992 21.1503 18.3242 19.7383L14.666 16.0801C14.564 16.2831 14.4487 16.4737 14.3047 16.6367C14.0837 16.8877 13.8188 17.0882 13.5078 17.2402C13.3478 17.3182 13.178 17.3826 13 17.4316V18C13 18.552 12.552 19 12 19C11.448 19 11 18.552 11 18V17.4512C10.807 17.4012 10.6166 17.3389 10.4316 17.2559C10.1026 17.1089 9.81164 16.8971 9.55664 16.6191C9.30164 16.3421 9.09636 15.9933 8.94336 15.5703C8.88336 15.4053 8.81773 15.2039 8.80273 15.0039C8.80273 14.9979 8.79883 14.9459 8.79883 14.9219C8.79983 14.4129 9.21366 14 9.72266 14C10.1457 14 10.5025 14.2711 10.6055 14.6621C10.6395 14.7891 10.6797 14.9414 10.6797 14.9414C10.7577 15.1744 10.8573 15.3463 10.9883 15.4863C11.1203 15.6263 11.2705 15.7242 11.4375 15.7812C11.6045 15.8383 11.7752 15.8652 11.9492 15.8652C12.1482 15.8652 12.3236 15.8335 12.4746 15.7695C12.6246 15.7055 12.7525 15.6189 12.8535 15.5059C12.9565 15.3929 13.031 15.2575 13.082 15.1035C13.133 14.9485 13.1582 14.7806 13.1582 14.5996C13.1582 14.5886 13.1543 14.5813 13.1543 14.5703L4.26172 5.67578Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoneyPaper = /*#__PURE__*/createIcon({
  displayName: "MoneyPaper",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.625 3.01067C19.4964 2.99178 19.3623 2.9974 19.2285 3.03215L3.99023 7.0009H11.9277L17.8848 5.45012C18.1378 5.82212 18.5432 6.06151 18.9922 6.10051L19.2285 7.0009H21.2949L20.4473 3.74895C20.343 3.34845 20.0108 3.06734 19.625 3.01067ZM3 9.0009C2.44774 9.00096 2.00006 9.44864 2 10.0009V20.0009C2.00006 20.5532 2.44774 21.0008 3 21.0009H21C21.5523 21.0008 21.9999 20.5532 22 20.0009V10.0009C21.9999 9.44864 21.5523 9.00096 21 9.0009H3ZM4.91211 11.0009H19.0879C19.239 11.4268 19.5741 11.7619 20 11.913V18.0888C19.5741 18.2399 19.239 18.575 19.0879 19.0009H4.91211C4.761 18.575 4.42591 18.2399 4 18.0888V11.913C4.42591 11.7619 4.761 11.4268 4.91211 11.0009ZM12 12.0009C10.3431 12.0009 9 13.344 9 15.0009C9 16.6578 10.3431 18.0009 12 18.0009C13.6569 18.0009 15 16.6578 15 15.0009C15 13.344 13.6569 12.0009 12 12.0009ZM7 14.0009C6.448 14.0009 6 14.4479 6 15.0009C6 15.5539 6.448 16.0009 7 16.0009C7.552 16.0009 8 15.5539 8 15.0009C8 14.4479 7.552 14.0009 7 14.0009ZM17 14.0009C16.448 14.0009 16 14.4479 16 15.0009C16 15.5539 16.448 16.0009 17 16.0009C17.552 16.0009 18 15.5539 18 15.0009C18 14.4479 17.552 14.0009 17 14.0009Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoneyProfit = /*#__PURE__*/createIcon({
  displayName: "MoneyProfit",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13.748 2C13.082 2 12.7497 2.80439 13.2207 3.27539L14.2656 4.32031L13 5.58594L10.707 3.29297C10.3165 2.9026 9.6835 2.9026 9.29297 3.29297L6.29297 6.29297C6.03173 6.54379 5.9265 6.91623 6.01786 7.26667C6.10922 7.61711 6.38289 7.89078 6.73333 7.98214C7.08377 8.0735 7.45621 7.96827 7.70703 7.70703L10 5.41406L12.293 7.70703C12.6835 8.0974 13.3165 8.0974 13.707 7.70703L15.6797 5.73438L16.7227 6.7793C17.1947 7.2513 18 6.91795 18 6.25195V3.00977C18 2.45277 17.5472 2 16.9902 2H13.748ZM3 10C2.448 10 2 10.448 2 11V21C2 21.552 2.448 22 3 22H21C21.552 22 22 21.552 22 21V11C22 10.448 21.552 10 21 10H3ZM4.91211 12H19.0879C19.239 12.4259 19.5741 12.761 20 12.9121V19.0879C19.5741 19.239 19.239 19.5741 19.0879 20H4.91211C4.761 19.5741 4.42591 19.239 4 19.0879V12.9121C4.42591 12.761 4.761 12.4259 4.91211 12ZM12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13ZM7 15C6.448 15 6 15.447 6 16C6 16.553 6.448 17 7 17C7.552 17 8 16.553 8 16C8 15.447 7.552 15 7 15ZM17 15C16.448 15 16 15.447 16 16C16 16.553 16.448 17 17 17C17.552 17 18 16.553 18 16C18 15.447 17.552 15 17 15Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoneyWallet = /*#__PURE__*/createIcon({
  displayName: "MoneyWallet",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 3.0002C4.35503 3.0002 3 4.35523 3 6.0002V19.0002C3 20.1052 3.895 21.0002 5 21.0002H19C20.105 21.0002 21 20.1052 21 19.0002V9.0002C21 7.8952 20.105 7.0002 19 7.0002H8H6C5.43497 7.0002 5 6.56523 5 6.0002C5 5.43517 5.43497 5.0002 6 5.0002H19C19.3606 5.0053 19.6961 4.81582 19.8779 4.50432C20.0597 4.19283 20.0597 3.80757 19.8779 3.49607C19.6961 3.18457 19.3606 2.9951 19 3.0002H6ZM18 13.0002C18.552 13.0002 19 13.4482 19 14.0002C19 14.5522 18.552 15.0002 18 15.0002C17.448 15.0002 17 14.5522 17 14.0002C17 13.4482 17.448 13.0002 18 13.0002Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var MoreHorizontal = /*#__PURE__*/createIcon({
  displayName: "MoreHorizontal",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 10.5002C4.9 10.5002 4 11.4002 4 12.5002C4 13.6002 4.9 14.5002 6 14.5002C7.1 14.5002 8 13.6002 8 12.5002C8 11.4002 7.1 10.5002 6 10.5002ZM18 10.5002C16.9 10.5002 16 11.4002 16 12.5002C16 13.6002 16.9 14.5002 18 14.5002C19.1 14.5002 20 13.6002 20 12.5002C20 11.4002 19.1 10.5002 18 10.5002ZM12 10.5002C10.9 10.5002 10 11.4002 10 12.5002C10 13.6002 10.9 14.5002 12 14.5002C13.1 14.5002 14 13.6002 14 12.5002C14 11.4002 13.1 10.5002 12 10.5002Z",
      fill: "currentColor"
    })]
  })
});

var MoreVertical = /*#__PURE__*/createIcon({
  displayName: "MoreVertical",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18Z",
      fill: "currentColor"
    })]
  })
});

var News = /*#__PURE__*/createIcon({
  displayName: "News",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2 3V18C2 19.654 3.346 21 5 21H19C20.645 21 22 19.645 22 18V7H20V18C20 18.565 19.565 19 19 19C18.448 19 18 18.551 18 18V3H2ZM6 6H14V9H6V6ZM6 12H14V14H6V12ZM6 16H14V18H6V16Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Ok = /*#__PURE__*/createIcon({
  displayName: "Ok",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM17.707 9.707L10.707 16.707C10.512 16.902 10.256 17 10 17C9.744 17 9.488 16.902 9.293 16.707L6.293 13.707C5.902 13.316 5.902 12.684 6.293 12.293C6.684 11.902 7.316 11.902 7.707 12.293L10 14.586L16.293 8.293C16.684 7.902 17.316 7.902 17.707 8.293C18.098 8.684 18.098 9.316 17.707 9.707Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Phone = /*#__PURE__*/createIcon({
  displayName: "Phone",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.1937 15.24L16.6737 14.95C16.0637 14.88 15.4637 15.09 15.0337 15.52L13.1837 17.37C11.7647 16.65 10.4777 15.711 9.36567 14.598C8.25267 13.486 7.31367 12.199 6.59367 10.78L8.44367 8.93C8.87367 8.5 9.08367 7.9 9.01367 7.29L8.72367 4.77C8.60367 3.76 7.75367 3 6.73367 3H5.00367C3.87367 3 2.93367 3.94 3.00367 5.07C3.26867 9.339 5.10767 13.178 7.94667 16.017C10.7857 18.856 14.6247 20.695 18.8937 20.96C20.0237 21.03 20.9637 20.09 20.9637 18.96V17.23C20.9637 16.21 20.2037 15.36 19.1937 15.24Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Play = /*#__PURE__*/createIcon({
  displayName: "Play",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8 7.00204V17.359C8 18.148 8.871 18.626 9.537 18.203L17.674 13.025C18.292 12.632 18.292 11.731 17.674 11.338L9.537 6.15804C8.871 5.73404 8 6.21304 8 7.00204Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Plus = /*#__PURE__*/createIcon({
  displayName: "Plus",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM16 13H13V16C13 16.552 12.552 17 12 17C11.448 17 11 16.552 11 16V13H8C7.448 13 7 12.552 7 12C7 11.448 7.448 11 8 11H11V8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8V11H16C16.552 11 17 11.448 17 12C17 12.552 16.552 13 16 13Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var PlusMath = /*#__PURE__*/createIcon({
  displayName: "PlusMath",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19 11H13V5C13 4.448 12.552 4 12 4C11.448 4 11 4.448 11 5V11H5C4.448 11 4 11.448 4 12C4 12.552 4.448 13 5 13H11V19C11 19.552 11.448 20 12 20C12.552 20 13 19.552 13 19V13H19C19.552 13 20 12.552 20 12C20 11.448 19.552 11 19 11Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var PriceTag = /*#__PURE__*/createIcon({
  displayName: "PriceTag",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.5857 3.586L2.58575 12.586C1.80475 13.367 1.80475 14.633 2.58575 15.414L8.58575 21.414C9.36675 22.195 10.6327 22.195 11.4137 21.414L20.4137 12.414C20.7887 12.039 20.9998 11.53 20.9998 11V5C20.9998 3.895 20.1047 3 18.9998 3H12.9998C12.4698 3 11.9607 3.211 11.5857 3.586ZM17.4998 8C16.6718 8 15.9998 7.328 15.9998 6.5C15.9998 5.672 16.6718 5 17.4998 5C18.3277 5 18.9998 5.672 18.9998 6.5C18.9998 7.328 18.3277 8 17.4998 8Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Protect = /*#__PURE__*/createIcon({
  displayName: "Protect",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.188 1.1725L4.188 4.2835C3.465 4.6045 3 5.3205 3 6.1115V10.8115C3 18.6415 9.439 22.2975 12 22.8115C14.561 22.2975 21 18.6415 21 10.8115V6.1115C21 5.3215 20.535 4.6045 19.812 4.2835L12.812 1.1725C12.295 0.9425 11.705 0.9425 11.188 1.1725ZM10.293 15.5185L7.523 12.7485C7.133 12.3585 7.133 11.7245 7.523 11.3345C7.913 10.9445 8.547 10.9445 8.937 11.3345L11 13.3975L16.085 8.3125C16.475 7.9225 17.109 7.9225 17.499 8.3125C17.889 8.7025 17.889 9.3365 17.499 9.7265L11.707 15.5185C11.317 15.9085 10.683 15.9085 10.293 15.5185Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ProtectSafe = /*#__PURE__*/createIcon({
  displayName: "ProtectSafe",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.19 4.37625L11.19 1.26625C11.7 1.03625 12.3 1.03625 12.81 1.26625L19.81 4.37625C20.53 4.69625 21 5.41625 21 6.20625V10.9062C21 16.4563 17.16 21.6462 12 22.9062C6.84 21.6462 3 16.4563 3 10.9062V6.20625C3 5.41625 3.47 4.69625 4.19 4.37625ZM9.7619 10.2857C9.7619 9.0195 10.7814 8 12.0476 8C13.3138 8 14.3333 9.0195 14.3333 10.2857V10.6667C14.7524 10.6667 15.0952 11.0095 15.0952 11.4286V15.2381C15.0952 15.6571 14.7524 16 14.3333 16H9.7619C9.34286 16 9 15.6571 9 15.2381V11.4286C9 11.0095 9.34286 10.6667 9.7619 10.6667V10.2857ZM13.5714 10.2857C13.5714 9.41857 12.9147 8.76188 12.0476 8.76188C11.1804 8.76188 10.5238 9.41857 10.5238 10.2857V10.6666H13.5714V10.2857Z",
      fill: "currentColor"
    })]
  })
});

var ProtectFlight = /*#__PURE__*/createIcon({
  displayName: "ProtectFlight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.188 4.2835L11.188 1.1725C11.705 0.9425 12.295 0.9425 12.812 1.1725L19.812 4.2835C20.535 4.6045 21 5.3215 21 6.1115V10.8115C21 18.6415 14.561 22.2975 12 22.8115C9.439 22.2975 3 18.6415 3 10.8115V6.1115C3 5.3205 3.465 4.6045 4.188 4.2835ZM14.3198 8.29248C14.661 7.93199 15.2294 7.92207 15.5829 8.27044C15.9364 8.6188 15.9465 9.19877 15.6054 9.55926L14.3067 10.9316L14.4145 15.4118L13.8233 16.0365L12.6397 12.6931L11.3313 14.0756L11.2859 15.4361L10.6657 16.0916L10.0116 14.8138L9.36887 14.1804L8.09457 13.558L8.71485 12.9026L10.0457 12.8089L11.3541 11.4263L8.03833 10.336L8.62953 9.71124L13.0211 9.6648L14.3198 8.29248Z",
      fill: "currentColor"
    })]
  })
});

var Pulse = /*#__PURE__*/createIcon({
  displayName: "Pulse",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9492 3C11.4889 3.00026 11.0882 3.31468 10.9785 3.76172L8.86133 12.375L8.69141 11.7402C8.57379 11.3031 8.17726 10.9995 7.72461 11H4.73242C3.54668 11 1 10.8954 1 12C1 13.1046 3.67961 13 4.72852 13H6.95898L7.83398 16.2598C7.9516 16.6969 8.34813 17.0005 8.80078 17H9C9.46031 16.9997 9.86099 16.6853 9.9707 16.2383L11.8008 8.79297L13.4531 19.1582C13.5309 19.6435 13.9499 20.0004 14.4414 20H14.541C15.0148 19.9997 15.4233 19.667 15.5195 19.2031L16.8125 13H19.2676C20.3071 13 23 13.1046 23 12C23 10.8954 20.5204 11 19.2715 11H16C15.5263 11.0003 15.1178 11.333 15.0215 11.7969L14.6152 13.7422L13.0371 3.8418C12.9594 3.35719 12.5416 3.00057 12.0508 3H11.9492Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var QuoteLeft = /*#__PURE__*/createIcon({
  displayName: "QuoteLeft",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.48633 5C8.17033 5 7.87455 5.14834 7.68555 5.40234L3.39453 11.166C3.13853 11.511 3 11.9294 3 12.3594V17.0273C3 18.1323 3.895 19.0273 5 19.0273H9C10.105 19.0273 11 18.1323 11 17.0273V13.0273C11 11.9233 10.105 11.0273 9 11.0273H5.99023L9.28906 6.5957C9.77906 5.9367 9.30933 5 8.48633 5ZM18.4668 5C18.1508 5 17.8531 5.14834 17.6641 5.40234L13.3945 11.1387C13.1385 11.4837 13 11.901 13 12.332V17C13 18.105 13.895 19 15 19H19C20.105 19 21 18.105 21 17V13C21 11.895 20.105 11 19 11H15.9902L19.2695 6.59766C19.7595 5.93766 19.2898 5 18.4668 5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var QuoteRight = /*#__PURE__*/createIcon({
  displayName: "QuoteRight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M15 5C13.895 5 13 5.895 13 7V11C13 12.105 13.895 13 15 13H18.0098L14.7109 17.4316C14.2209 18.0906 14.6907 19.0273 15.5137 19.0273C15.8297 19.0273 16.1255 18.879 16.3145 18.625L20.6055 12.8613C20.8615 12.5163 21 12.098 21 11.668V7C21 5.895 20.105 5 19 5H15ZM5 5.02734C3.895 5.02734 3 5.92234 3 7.02734V11.0273C3 12.1323 3.895 13.0273 5 13.0273H8.00977L4.73047 17.4297C4.24047 18.0897 4.7102 19.0273 5.5332 19.0273C5.8492 19.0273 6.14694 18.879 6.33594 18.625L10.6055 12.8887C10.8615 12.5437 11 12.1263 11 11.6953V7.02734C11 5.92234 10.105 5.02734 9 5.02734H5Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Railway = /*#__PURE__*/createIcon({
  displayName: "Railway",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 16.0002C4 17.9302 5.57 19.5002 7.5 19.5002L6 21.0002V21.5002H18V21.0002L16.5 19.5002C18.43 19.5002 20 17.9302 20 16.0002V5.50024C20 2.00024 16.42 1.50024 12 1.50024C7.58 1.50024 4 2.00024 4 5.50024V16.0002ZM12 17.5002C10.9 17.5002 10 16.6002 10 15.5002C10 14.4002 10.9 13.5002 12 13.5002C13.1 13.5002 14 14.4002 14 15.5002C14 16.6002 13.1 17.5002 12 17.5002ZM18 10.5002H6V5.50024H18V10.5002Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ReturnFlight = /*#__PURE__*/createIcon({
  displayName: "ReturnFlight",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M17 7H7.00001V10C7.00001 10.55 6.55001 11 6.00001 11C5.45001 11 5.00001 10.55 5.00001 10V6C5.00001 5.45 5.45001 5 6.00001 5H17V3.21C17 2.76 17.54 2.54 17.85 2.85L20.64 5.64C20.84 5.84 20.84 6.15 20.64 6.35L17.85 9.14C17.54 9.46 17 9.24 17 8.79V7ZM7.00001 17H17V14C17 13.45 17.45 13 18 13C18.55 13 19 13.45 19 14V18C19 18.55 18.55 19 18 19H7.00001V20.79C7.00001 21.24 6.46001 21.46 6.15001 21.15L3.36001 18.36C3.16001 18.16 3.16001 17.85 3.36001 17.65L6.15001 14.86C6.46001 14.54 7.00001 14.76 7.00001 15.21V17Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Rules = /*#__PURE__*/createIcon({
  displayName: "Rules",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18 15V6C18 4.343 16.657 3 15 3H5C3.343 3 2 4.343 2 6V8C2 8.552 2.448 9 3 9H5V18C5 19.657 6.343 21 8 21H19C20.657 21 22 19.657 22 18V16C22 15.448 21.552 15 21 15H18ZM15 12C15 12.552 14.552 13 14 13H9C8.448 13 8 12.552 8 12C8 11.448 8.448 11 9 11H14C14.552 11 15 11.448 15 12ZM15 16C15 16.552 14.552 17 14 17H9C8.448 17 8 16.552 8 16C8 15.448 8.448 15 9 15H14C14.552 15 15 15.448 15 16ZM4 6C4 5.448 4.449 5 5 5H12.171C12.061 5.313 12 5.649 12 6V7H4V6ZM20 18C20 18.552 19.551 19 19 19C18.449 19 18 18.552 18 18V17H20V18Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Search = /*#__PURE__*/createIcon({
  displayName: "Search",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9 2C5.14585 2 2 5.14585 2 9C2 12.8541 5.14585 16 9 16C10.748 16 12.345 15.348 13.5742 14.2812L14 14.707V16L19.5859 21.5859C20.1379 22.1379 21.0339 22.1379 21.5859 21.5859C22.1379 21.0339 22.1379 20.1379 21.5859 19.5859L16 14H14.707L14.2812 13.5742C15.348 12.345 16 10.748 16 9C16 5.14585 12.8541 2 9 2ZM9 4C11.7733 4 14 6.22673 14 9C14 11.7733 11.7733 14 9 14C6.22673 14 4 11.7733 4 9C4 6.22673 6.22673 4 9 4Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SelArrowBack = /*#__PURE__*/createIcon({
  displayName: "SelArrowBack",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16 17.9348V6.06479C16 5.11779 14.864 4.64379 14.2 5.31379L8.309 11.2488C7.897 11.6638 7.897 12.3368 8.309 12.7518L14.2 18.6868C14.864 19.3558 16 18.8818 16 17.9348Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SelArrowCollapse = /*#__PURE__*/createIcon({
  displayName: "SelArrowCollapse",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.29496 13.8793L10.881 8.29325C11.272 7.90225 11.905 7.90225 12.295 8.29325L17.881 13.8793C18.511 14.5093 18.065 15.5862 17.174 15.5862H6.00196C5.11096 15.5862 4.66496 14.5093 5.29496 13.8793Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SelArrowExpand = /*#__PURE__*/createIcon({
  displayName: "SelArrowExpand",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.29496 9.707L10.881 15.293C11.272 15.684 11.905 15.684 12.295 15.293L17.881 9.707C18.511 9.077 18.065 8 17.174 8H6.00196C5.11096 8 4.66496 9.077 5.29496 9.707Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SelArrowForward = /*#__PURE__*/createIcon({
  displayName: "SelArrowForward",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.8 18.6871L15.691 12.7521C16.103 12.3371 16.103 11.6641 15.691 11.2491L9.8 5.31309C9.136 4.64409 8 5.11809 8 6.06509V17.9361C8 18.8821 9.136 19.3561 9.8 18.6871Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Send = /*#__PURE__*/createIcon({
  displayName: "Send",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2.01 21.5002L23 12.5002L2.01 3.50024L2 10.5002L17 12.5002L2 14.5002L2.01 21.5002Z",
      fill: "currentColor"
    })]
  })
});

var SendWatch = /*#__PURE__*/createIcon({
  displayName: "SendWatch",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7.99862 3.00002C7.95017 3.00107 7.90187 3.00564 7.85409 3.0137H6.01424C5.65361 3.0086 5.31816 3.19807 5.13635 3.50957C4.95455 3.82107 4.95455 4.20633 5.13635 4.51782C5.31816 4.82932 5.65361 5.0188 6.01424 5.0137H7.01424V6.35745C7.01424 7.68298 7.54048 8.95525 8.47909 9.8926L10.6002 12.0137L8.47909 14.1348C7.54048 15.0721 7.01424 16.3444 7.01424 17.6699V19.0137H6.01424C5.65361 19.0086 5.31816 19.1981 5.13635 19.5096C4.95455 19.8211 4.95455 20.2063 5.13635 20.5178C5.31816 20.8293 5.65361 21.0188 6.01424 21.0137H7.84627C7.95427 21.0315 8.06445 21.0315 8.17245 21.0137H15.8463C15.9543 21.0315 16.0645 21.0315 16.1724 21.0137H18.0142C18.3749 21.0188 18.7103 20.8293 18.8921 20.5178C19.0739 20.2063 19.0739 19.8211 18.8921 19.5096C18.7103 19.1981 18.3749 19.0086 18.0142 19.0137H17.0142V17.6699C17.0142 16.3445 16.4867 15.0721 15.5494 14.1348L13.4283 12.0137L15.5494 9.8926C16.4875 8.95455 17.0142 7.68298 17.0142 6.35745V5.0137H18.0142C18.3749 5.0188 18.7103 4.82932 18.8921 4.51782C19.0739 4.20633 19.0739 3.82107 18.8921 3.50957C18.7103 3.19807 18.3749 3.0086 18.0142 3.0137H16.1822C16.0742 2.99585 15.964 2.99585 15.856 3.0137H8.16854C8.11239 3.00431 8.05554 2.99974 7.99862 3.00002ZM9.01424 5.0137H15.0142V6.35745C15.0142 6.95182 14.8376 7.52607 14.5142 8.0137H9.51424C9.19031 7.52649 9.01424 6.95241 9.01424 6.35745V5.0137ZM12.0142 13.4278L14.1353 15.5489C14.698 16.1115 15.0142 16.8754 15.0142 17.6699V19.0137H9.01424V17.6699C9.01424 16.8735 9.32975 16.1135 9.89315 15.5508L12.0142 13.4278Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SharedDocument = /*#__PURE__*/createIcon({
  displayName: "SharedDocument",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 1C2.895 1 2 1.895 2 3V19C2 20.105 2.895 21 4 21H11.0918C11.1628 20.654 11.2795 20.3143 11.4395 19.9883C11.5345 19.7923 11.6503 19.603 11.7773 19.418C11.8143 19.365 11.8584 19.3137 11.8984 19.2617C12.3204 18.7047 12.8879 18.2082 13.6289 17.8262C13.2319 17.1542 13 16.365 13 15.5C13 13.481 14.2347 11.8635 16.0117 11.2715C16.1377 11.2275 16.2704 11.1991 16.4004 11.1641C16.5954 11.1181 16.7891 11.0708 16.9941 11.0488C17.1611 11.0278 17.327 11 17.5 11C17.671 11 17.834 11.0328 18 11.0508V7.82812C18 7.29813 17.7891 6.78906 17.4141 6.41406L12.5859 1.58594C12.2109 1.21094 11.7019 1 11.1719 1H4ZM11 2.45508L16.5 8H12C11.448 8 11 7.50808 11 6.95508V2.45508ZM17.5 13C16.1193 13 15 14.1193 15 15.5C15 16.8807 16.1193 18 17.5 18C18.8807 18 20 16.8807 20 15.5C20 14.1193 18.8807 13 17.5 13ZM17.5 19C14.892 19 13 20.0188 13 21.8828V22C13 22.552 13.448 23 14 23H21C21.552 23 22 22.552 22 22V21.8828C22 20.0188 20.108 19 17.5 19Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ShieldPlusSolid = /*#__PURE__*/createIcon({
  displayName: "ShieldPlusSolid",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.93663 8.91316C10.5477 8.50632 11.2659 8.29002 12 8.29167C12.9813 8.29167 13.9224 8.68149 14.6163 9.37537C15.3102 10.0693 15.7 11.0104 15.7 11.9917C15.7016 12.7258 15.4853 13.4439 15.0785 14.055C14.6717 14.6661 14.0926 15.1427 13.4146 15.4244C12.7367 15.7062 11.9904 15.7803 11.2703 15.6375C10.5501 15.4947 9.88861 15.1413 9.36949 14.6222C8.85037 14.1031 8.49701 13.4415 8.35419 12.7214C8.21137 12.0013 8.28551 11.255 8.56722 10.577C8.84893 9.89908 9.32552 9.32 9.93663 8.91316ZM12.6417 11.3583H14.2083C14.2993 11.348 14.3914 11.357 14.4787 11.3847C14.566 11.4124 14.6464 11.4583 14.7147 11.5193C14.783 11.5802 14.8376 11.655 14.8751 11.7385C14.9125 11.8221 14.9318 11.9126 14.9318 12.0042C14.9318 12.0957 14.9125 12.1863 14.8751 12.2698C14.8376 12.3534 14.783 12.4281 14.7147 12.4891C14.6464 12.55 14.566 12.5959 14.4787 12.6236C14.3914 12.6514 14.2993 12.6604 14.2083 12.65H12.6417V14.1917C12.652 14.2826 12.643 14.3748 12.6153 14.462C12.5876 14.5493 12.5417 14.6297 12.4807 14.698C12.4198 14.7663 12.345 14.821 12.2615 14.8584C12.1779 14.8958 12.0874 14.9151 11.9958 14.9151C11.9043 14.9151 11.8137 14.8958 11.7302 14.8584C11.6466 14.821 11.5719 14.7663 11.5109 14.698C11.45 14.6297 11.4041 14.5493 11.3764 14.462C11.3486 14.3748 11.3397 14.2826 11.35 14.1917V12.65H9.80834C9.71736 12.6604 9.62523 12.6514 9.53797 12.6236C9.45071 12.5959 9.3703 12.55 9.30199 12.4891C9.23369 12.4281 9.17904 12.3534 9.14162 12.2698C9.1042 12.1863 9.08486 12.0957 9.08486 12.0042C9.08486 11.9126 9.1042 11.8221 9.14162 11.7385C9.17904 11.655 9.23369 11.5802 9.30199 11.5193C9.3703 11.4583 9.45071 11.4124 9.53797 11.3847C9.62523 11.357 9.71736 11.348 9.80834 11.3583H11.35V9.81667C11.3397 9.7257 11.3486 9.63356 11.3764 9.5463C11.4041 9.45905 11.45 9.37863 11.5109 9.31033C11.5719 9.24202 11.6466 9.18737 11.7302 9.14995C11.8137 9.11253 11.9043 9.09319 11.9958 9.09319C12.0874 9.09319 12.1779 9.11253 12.2615 9.14995C12.345 9.18737 12.4198 9.24202 12.4807 9.31033C12.5417 9.37863 12.5876 9.45905 12.6153 9.5463C12.643 9.63356 12.652 9.7257 12.6417 9.81667V11.3583Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0816 1.53965C15.2291 2.87253 17.7281 3.62055 20.3078 3.62055C20.3987 3.62043 20.4888 3.63702 20.5729 3.66936C20.6569 3.7017 20.7332 3.74917 20.7976 3.80903C20.8619 3.8689 20.9128 3.93999 20.9476 4.01823C20.9823 4.09647 21.0001 4.18032 21 4.26499V11.5811C21 16.7348 17.4711 21.3366 12.2191 22.9665C12.077 23.0115 11.9228 23.0112 11.7809 22.9655C6.52989 21.3366 3 16.7348 3 11.5802V4.26499C3 4.09407 3.07293 3.93016 3.20274 3.8093C3.33255 3.68845 3.50861 3.62055 3.69219 3.62055C6.27291 3.62055 8.77189 2.87253 10.9174 1.54057L11.6165 1.10789C11.7303 1.03753 11.8639 1 12.0005 1C12.1371 1 12.2707 1.03753 12.3845 1.10789L13.0816 1.53965ZM9.22215 16.1573C10.0444 16.7068 11.0111 17 12 17C12.6566 17 13.3068 16.8707 13.9134 16.6194C14.52 16.3681 15.0712 15.9998 15.5355 15.5355C15.9998 15.0712 16.3681 14.52 16.6194 13.9134C16.8707 13.3068 17 12.6566 17 12C17 11.0111 16.7068 10.0444 16.1573 9.22215C15.6079 8.39991 14.827 7.75904 13.9134 7.3806C12.9998 7.00217 11.9945 6.90315 11.0245 7.09608C10.0546 7.289 9.16373 7.76521 8.46447 8.46447C7.76521 9.16373 7.289 10.0546 7.09608 11.0245C6.90315 11.9945 7.00217 12.9998 7.3806 13.9134C7.75904 14.827 8.39991 15.6079 9.22215 16.1573Z",
      fill: "currentColor"
    })]
  })
});

var SleepingInBed = /*#__PURE__*/createIcon({
  displayName: "SleepingInBed",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.5 2.00005C18.3197 1.9975 18.152 2.09224 18.0611 2.24799C17.9702 2.40374 17.9702 2.59637 18.0611 2.75211C18.152 2.90786 18.3197 3.0026 18.5 3.00005H19.584L18.0879 5.16607C18.0303 5.24996 17.9996 5.34944 18 5.45122V5.50005C18 5.77618 18.2239 6.00002 18.5 6.00005H20.5C20.6803 6.0026 20.848 5.90786 20.9389 5.75211C21.0298 5.59636 21.0298 5.40374 20.9389 5.24799C20.848 5.09224 20.6803 4.9975 20.5 5.00005H19.4199L20.9121 2.83989C20.9697 2.756 21.0004 2.65652 21 2.55474V2.50005C21 2.22392 20.7761 2.00008 20.5 2.00005H18.5ZM14.5 4.00005C14.3197 3.9975 14.152 4.09224 14.0611 4.24799C13.9702 4.40374 13.9702 4.59636 14.0611 4.75211C14.152 4.90786 14.3197 5.0026 14.5 5.00005H15.584L14.0879 7.16607C14.0303 7.24996 13.9996 7.34944 14 7.45122V7.50005C14 7.77618 14.2239 8.00002 14.5 8.00005H16.5C16.6803 8.0026 16.848 7.90786 16.9389 7.75211C17.0298 7.59636 17.0298 7.40374 16.9389 7.24799C16.848 7.09224 16.6803 6.9975 16.5 7.00005H15.4199L16.9121 4.83989C16.9697 4.756 17.0004 4.65652 17 4.55474V4.50005C17 4.22392 16.7761 4.00008 16.5 4.00005H14.5ZM3 5.00005C2.448 5.00005 2 5.44805 2 6.00005V20C2 20.552 2.448 21 3 21C3.552 21 4 20.552 4 20V19H20V20C20 20.552 20.448 21 21 21C21.552 21 22 20.552 22 20V12.0001C22 10.8951 21.105 10.0001 20 10.0001H12C10.895 10.0001 10 10.8951 10 12.0001V13.0001H7H4V6.00005C4 5.44805 3.552 5.00005 3 5.00005ZM7 13C8.10457 13 9 12.1046 9 11C9 9.89548 8.10457 9.00005 7 9.00005C5.89543 9.00005 5 9.89548 5 11C5 12.1046 5.89543 13 7 13Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SocialFacebook = /*#__PURE__*/createIcon({
  displayName: "SocialFacebook",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.72522 20.6L9.7 12.6H6.5V9.4H9.7V7.4C9.7 4.43088 11.5387 3 14.1873 3C15.456 3 16.5465 3.09446 16.8642 3.13668V6.23958L15.0272 6.24042C13.5868 6.24042 13.3078 6.92492 13.3078 7.92937V9.4H17.5L15.9 12.6H13.3078V20.6H9.72522Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SocialInstagram = /*#__PURE__*/createIcon({
  displayName: "SocialInstagram",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8 3C5.239 3 3 5.239 3 8V16C3 18.761 5.239 21 8 21H16C18.761 21 21 18.761 21 16V8C21 5.239 18.761 3 16 3H8ZM18 5C18.552 5 19 5.448 19 6C19 6.552 18.552 7 18 7C17.448 7 17 6.552 17 6C17 5.448 17.448 5 18 5ZM12 7C14.761 7 17 9.239 17 12C17 14.761 14.761 17 12 17C9.239 17 7 14.761 7 12C7 9.239 9.239 7 12 7ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SocialLinkedin = /*#__PURE__*/createIcon({
  displayName: "SocialLinkedin",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M7.02484 20H3.10714V8.86081H7.02484V20ZM4.99689 6.81915C3.79969 6.81915 3 6.00122 3 4.90958C3 3.81793 3.79814 3 5.12888 3C6.32609 3 7.12578 3.81793 7.12578 4.90958C7.12578 6.00122 6.32764 6.81915 4.99689 6.81915ZM21 20H17.2081V13.9116C17.2081 12.228 16.1972 11.8397 15.8183 11.8397C15.4394 11.8397 14.1755 12.0991 14.1755 13.9116C14.1755 14.171 14.1755 20 14.1755 20H10.2578V8.86081H14.1755V10.4155C14.6801 9.50847 15.691 8.86081 17.587 8.86081C19.4829 8.86081 21 10.4155 21 13.9116V20Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SocialShare = /*#__PURE__*/createIcon({
  displayName: "SocialShare",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M18 2C16.3431 2 15 3.34315 15 5C15.0006 5.18815 15.0189 5.37583 15.0547 5.56055L7.93945 9.71094C7.39751 9.25184 6.71026 8.99992 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C6.70916 14.9986 7.3949 14.746 7.93555 14.2871L15.0547 18.4395C15.0189 18.6242 15.0006 18.8118 15 19C15 20.6569 16.3431 22 18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C17.2902 16.0009 16.6037 16.2535 16.0625 16.7129L8.94531 12.5605C8.98108 12.3758 8.99939 12.1882 9 12C8.99939 11.8118 8.98108 11.6242 8.94531 11.4395L16.0605 7.28906C16.6025 7.74816 17.2897 8.00008 18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SocialTwitter = /*#__PURE__*/createIcon({
  displayName: "SocialTwitter",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.6343 4.03182C20.8193 4.41682 19.4323 5.13882 18.7353 5.27682C18.7083 5.28382 18.6863 5.29282 18.6603 5.29982C17.8473 4.49782 16.7333 4.00082 15.5003 4.00082C13.0153 4.00082 11.0003 6.01582 11.0003 8.50082C11.0003 8.63182 10.9893 8.87282 11.0003 9.00082C7.78232 9.00082 5.43232 7.32182 3.67332 5.16382C3.43832 4.87382 3.18832 5.02482 3.13632 5.23082C3.01932 5.69682 2.97932 6.47582 2.97932 7.03182C2.97932 8.43282 4.07432 9.80882 5.77932 10.6618C5.46532 10.7428 5.11932 10.8008 4.75932 10.8008C4.33532 10.8008 3.84732 10.6898 3.42032 10.4658C3.26232 10.3828 2.92132 10.4058 3.02232 10.8098C3.42732 12.4288 5.27532 13.5658 6.92632 13.8968C6.55132 14.1178 5.75132 14.0728 5.38332 14.0728C5.24732 14.0728 4.77432 14.0408 4.46832 14.0028C4.18932 13.9688 3.76032 14.0408 4.11932 14.5848C4.89032 15.7518 6.63432 16.4848 8.13532 16.5128C6.75332 17.5968 4.49332 17.9928 2.32832 17.9928C1.89032 17.9828 1.91232 18.4818 2.26532 18.6668C3.86232 19.5048 6.47832 20.0008 8.34732 20.0008C15.7773 20.0008 20.0003 14.3378 20.0003 8.99982C20.0003 8.91382 19.9983 8.73382 19.9953 8.55282C19.9953 8.53482 20.0003 8.51782 20.0003 8.49982C20.0003 8.47282 19.9923 8.44682 19.9923 8.41982C19.9893 8.28382 19.9863 8.15682 19.9833 8.09082C20.5723 7.66582 21.4743 6.92782 21.9303 6.36282C22.0853 6.17082 21.9603 5.93782 21.7493 6.01082C21.2063 6.19982 20.2673 6.56582 19.6793 6.63582C20.8563 5.85682 21.4383 5.17882 21.9383 4.42582C22.1093 4.16882 21.8953 3.90782 21.6343 4.03182Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Sort = /*#__PURE__*/createIcon({
  displayName: "Sort",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.4999 6C12.3251 6 12.1499 6.06595 12.0165 6.19838L8.20126 9.98521C7.77124 10.4121 8.07589 11.1429 8.6846 11.1429H16.3151C16.9238 11.1429 17.2291 10.4121 16.7985 9.98521L12.9832 6.19838C12.8495 6.06595 12.6746 6 12.4999 6ZM8.68409 12.8571C8.07524 12.8571 7.77114 13.5879 8.2019 14.0147L12.0168 17.8014C12.2836 18.0662 12.7168 18.0662 12.9837 17.8014L16.7985 14.0147C17.2286 13.5879 16.9245 12.8571 16.3163 12.8571H8.68409Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SortDown = /*#__PURE__*/createIcon({
  displayName: "SortDown",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.18409 9.42859C7.57524 9.42859 7.27114 10.1593 7.7019 10.5862L11.5168 14.3728C11.7836 14.6377 12.2168 14.6377 12.4837 14.3728L16.2985 10.5862C16.7286 10.1593 16.4245 9.42859 15.8163 9.42859H8.18409Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SortUp = /*#__PURE__*/createIcon({
  displayName: "SortUp",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9999 9.42859C11.8251 9.42859 11.6499 9.49454 11.5165 9.62697L7.70126 13.4138C7.27124 13.8407 7.57589 14.5714 8.1846 14.5714H15.8151C16.4238 14.5714 16.7291 13.8407 16.2985 13.4138L12.4832 9.62697C12.3495 9.49454 12.1746 9.42859 11.9999 9.42859Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Star = /*#__PURE__*/createIcon({
  displayName: "Star",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.9427 18.8477L16.9117 21.8468C17.6957 22.3197 18.6627 21.6168 18.4547 20.7257L17.1357 15.0728L21.5267 11.2688C22.2187 10.6698 21.8487 9.53275 20.9367 9.45575L15.1567 8.96575L12.8957 3.63075C12.5387 2.78975 11.3467 2.78975 10.9897 3.63075L8.72874 8.96575L2.94874 9.45575C2.03674 9.53275 1.66674 10.6698 2.35874 11.2688L6.74974 15.0728L5.43074 20.7257C5.22274 21.6168 6.18974 22.3197 6.97374 21.8468L11.9427 18.8477Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var SubmitDocument = /*#__PURE__*/createIcon({
  displayName: "SubmitDocument",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M5 2C3.895 2 3 2.895 3 4V20C3 21.105 3.895 22 5 22H16C14.346 22 13 20.654 13 19C13 18.648 13.0716 18.314 13.1836 18H8C7.448 18 7 17.552 7 17C7 16.448 7.448 16 8 16H17V15C17 14.448 17.448 14 18 14H19V8.82812C19 8.29813 18.7891 7.78906 18.4141 7.41406L13.5859 2.58594C13.2109 2.21094 12.7019 2 12.1719 2H5ZM12 3.45508L17.5 9H13C12.448 9 12 8.552 12 8V3.45508ZM8 12H14C14.552 12 15 12.448 15 13C15 13.552 14.552 14 14 14H8C7.448 14 7 13.552 7 13C7 12.448 7.448 12 8 12ZM19.7246 15.8027C19.6467 15.8102 19.5691 15.8303 19.4941 15.8613C19.1951 15.9853 19 16.2766 19 16.5996V18H16C15.448 18 15 18.448 15 19C15 19.552 15.448 20 16 20H19V21.4004C19 21.7234 19.1951 22.0147 19.4941 22.1387C19.5931 22.1797 19.6978 22.1992 19.8008 22.1992C20.0088 22.1992 20.2122 22.1198 20.3652 21.9668L22.7656 19.5664C23.0776 19.2534 23.0776 18.7466 22.7656 18.4336L20.3652 16.0332C20.1935 15.8615 19.9584 15.7803 19.7246 15.8027Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var TechnicalSupport$1 = /*#__PURE__*/createIcon({
  displayName: "TechnicalSupport",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.1591 2.00636C10.8747 1.99475 10.5871 1.99926 10.2958 2.01807C6.28069 2.2787 3.1941 5.61067 2.86222 9.56886L2.84855 9.55128L2.00675 19.8384C1.91175 21.0034 2.83189 22.0005 4.00089 22.0005H12.829C13.381 22.0005 13.829 21.5525 13.829 21.0005C13.829 20.4485 13.381 20.0005 12.829 20.0005H10.829C7.51501 20.0005 4.82901 17.3145 4.82901 14.0005V13.0005C4.82901 11.8955 5.72401 11.0005 6.82901 11.0005H14.829C15.934 11.0005 16.829 11.8955 16.829 13.0005V16.0005H12.7411C12.5295 15.4019 11.9639 15.0014 11.329 15.0005C10.9312 15.0005 10.5497 15.1585 10.2684 15.4398C9.98705 15.7211 9.82901 16.1027 9.82901 16.5005C9.83007 17.2865 10.4376 17.9384 11.2216 17.9946C11.2573 17.9985 11.2931 18.0005 11.329 18.0005H17.829H18.829C19.929 18.0005 20.829 17.1005 20.829 16.0005V14.0005C20.829 12.9005 19.929 12.0005 18.829 12.0005V10.0005C18.829 5.69268 15.4243 2.18045 11.1591 2.00636Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var ThumbsUp = /*#__PURE__*/createIcon({
  displayName: "ThumbsUp",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.1699 2.00003C13.7875 2.00178 13.4048 2.14944 13.1133 2.44144L7.58398 7.98245C7.20998 8.35745 7 8.86456 7 9.39456V19.3867C7 20.4917 7.895 21.3867 9 21.3867H17.9922C18.7912 21.3867 19.5141 20.9108 19.8301 20.1758L22.8379 13.1739C22.9449 12.9249 23 12.6558 23 12.3848V10.3868C23 9.28175 22.105 8.38675 21 8.38675H14.6484L15.6426 3.8223C15.7526 3.3183 15.5955 2.79267 15.2285 2.43167C14.9345 2.14267 14.5523 1.99828 14.1699 2.00003ZM2 9.38675C1.448 9.38675 1 9.83475 1 10.3867V20.3867C1 20.9387 1.448 21.3867 2 21.3867H4C4.552 21.3867 5 20.9387 5 20.3867V10.3867C5 9.83475 4.552 9.38675 4 9.38675H2Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Time = /*#__PURE__*/createIcon({
  displayName: "Time",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M10 2C9.448 2 9 2.448 9 3C9 3.552 9.448 4 10 4H14C14.552 4 15 3.552 15 3C15 2.448 14.552 2 14 2H10ZM18.9941 4.20508C18.7391 4.22595 18.491 4.34564 18.3125 4.55664C17.9555 4.97764 18.0087 5.6088 18.4297 5.9668L19.8535 7.17383C20.2745 7.53083 20.9057 7.47764 21.2637 7.05664C21.6207 6.63564 21.5675 6.00448 21.1465 5.64648L19.7227 4.43945C19.5122 4.26095 19.2491 4.1842 18.9941 4.20508ZM12 5C7.038 5 3 9.038 3 14C3 18.962 7.038 23 12 23C16.962 23 21 18.962 21 14C21 9.038 16.962 5 12 5ZM12 8C12.552 8 13 8.448 13 9V14C13 14.552 12.552 15 12 15C11.448 15 11 14.552 11 14V9C11 8.448 11.448 8 12 8Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Traveler = /*#__PURE__*/createIcon({
  displayName: "Traveler",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.0014 2C14.8968 2 14.0014 2.89543 14.0014 4C14.0014 5.10457 14.8968 6 16.0014 6C17.1059 6 18.0014 5.10457 18.0014 4C18.0014 2.89543 17.1059 2 16.0014 2ZM13.765 7L9.18495 9.29102L8.68691 10.7832L8.68495 10.7812L7.29238 14.8574L5.16347 14.0391C4.64547 13.8481 4.07027 14.1138 3.88027 14.6328L2.06191 19.4355C1.87091 19.9535 2.13666 20.5287 2.65566 20.7188L3.01308 20.8887C3.07308 19.2837 4.38236 18 6.00136 18C6.72936 18 7.38861 18.2702 7.90761 18.7012L10.2279 12.3203L10.2299 12.3164L10.8178 10.709L12.5932 9.82227L10.2709 20.7949C10.1399 21.4159 10.6135 22 11.2475 22H11.2514C11.7234 22 12.1309 21.67 12.2279 21.209L13.4408 15.4727C13.9198 16.0417 14.6514 16.9639 14.9994 17.3359V21.0039C15.0004 21.5539 15.4484 22 15.9994 22H16.0033C16.5543 22 17.0014 21.553 17.0014 21.002V16.6973L15.8275 14.9375L16.6596 11.4414C16.9436 11.9454 17.285 12.3803 17.683 12.7363C18.287 13.2763 18.9845 13.6497 19.7455 13.8438C20.3805 14.0068 21.0014 13.528 21.0014 12.873C21.0014 12.402 20.6634 12.0204 20.2084 11.9004C19.7714 11.7854 19.378 11.5691 19.017 11.2461C18.51 10.7931 18.1347 10.0911 17.9037 9.16211C17.4757 7.45111 15.8184 7 15.0014 7H13.765ZM6.00136 20C5.44908 20 5.00136 20.4477 5.00136 21C5.00136 21.5523 5.44908 22 6.00136 22C6.55364 22 7.00136 21.5523 7.00136 21C7.00136 20.4477 6.55364 20 6.00136 20Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Trophy = /*#__PURE__*/createIcon({
  displayName: "Trophy",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.00577 3C2.81688 3 1.86594 4.06321 2.01553 5.25V5.25195C2.31366 7.59395 3.41947 9.29597 4.34561 10.6602C5.27175 12.0243 5.93741 13.0276 5.93741 14C5.93231 14.3606 6.12178 14.6961 6.43328 14.8779C6.74478 15.0597 7.13004 15.0597 7.44153 14.8779C7.75303 14.6961 7.94251 14.3606 7.93741 14C7.93741 13.9839 7.93367 13.9692 7.9335 13.9531C8.91199 16.1662 9.93741 17 9.93741 17H13.9374C13.9374 17 14.9628 16.1662 15.9413 13.9531C15.9411 13.9692 15.9374 13.9839 15.9374 14C15.9323 14.3606 16.1218 14.6961 16.4333 14.8779C16.7448 15.0597 17.13 15.0597 17.4415 14.8779C17.753 14.6961 17.9425 14.3606 17.9374 14C17.9374 13.0276 18.6031 12.0243 19.5292 10.6602C20.4553 9.29597 21.5612 7.59395 21.8593 5.25195C22.0111 4.06347 21.0579 3 19.869 3H4.00577ZM19.8749 4.99805C19.639 6.85105 18.7803 8.20354 17.8749 9.53711C17.5528 10.0115 17.2277 10.4945 16.9257 10.9902C17.3167 9.39313 17.5999 7.41587 17.664 5H19.869C19.8802 5 19.8751 4.99653 19.8749 4.99805ZM3.99991 5C3.9995 4.99679 3.99466 5 4.00577 5H6.21085C6.2749 7.41587 6.55815 9.39313 6.94913 10.9902C6.64712 10.4945 6.322 10.0115 5.99991 9.53711C5.09488 8.20403 4.23615 6.85197 3.99991 5ZM7.93741 19C7.38541 19 6.93741 19.448 6.93741 20C6.93741 20.552 7.38541 21 7.93741 21H15.9374C16.4894 21 16.9374 20.552 16.9374 20C16.9374 19.448 16.4894 19 15.9374 19H7.93741Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var TrustPilotLogo = /*#__PURE__*/createIcon({
  displayName: "TrustPilot",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M20 7.64341H12.3627L10.0037 0L7.6373 7.64341L0 7.63566L6.18504 12.3643L3.81865 20L10.0037 15.2791L16.1814 20L13.8223 12.3643L20 7.64341Z",
      fill: "#00B67A"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.3531 14.093L13.8223 12.3643L10.0037 15.2791L14.3531 14.093Z",
      fill: "#005128"
    })]
  })
});

var User = /*#__PURE__*/createIcon({
  displayName: "User",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3ZM12 14C8.996 14 3 15.508 3 18.5V20C3 20.552 3.448 21 4 21H20C20.552 21 21 20.552 21 20V18.5C21 15.508 15.004 14 12 14Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var UserManual = /*#__PURE__*/createIcon({
  displayName: "UserManual",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M3 4C2.448 4 2 4.448 2 5V17V18C2 19.105 2.895 20 4 20H10.5879C10.7995 20.5986 11.3651 20.9991 12 21C12.6349 20.9991 13.2005 20.5986 13.4121 20H20C21.105 20 22 19.105 22 18V17V5C22 4.448 21.552 4 21 4H16.002C14.3585 4 12.9114 4.80316 12 6.02734C11.0886 4.80316 9.64147 4 7.99805 4H3ZM16.5 7H17.5C17.776 7 18 7.224 18 7.5V8.5C18 8.776 17.776 9 17.5 9H16.5C16.224 9 16 8.776 16 8.5V7.5C16 7.224 16.224 7 16.5 7ZM17 11C17.552 11 18 11.448 18 12V15C18 15.552 17.552 16 17 16C16.448 16 16 15.552 16 15V12C16 11.448 16.448 11 17 11Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var VegetarianFood = /*#__PURE__*/createIcon({
  displayName: "VegetarianFood",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M13 2C12.45 2 12 2.45 12 3C12 3.33 12.1702 3.59906 12.4102 3.78906C11.9802 4.63906 11.4709 5.83039 11.2109 7.15039C12.1309 7.34039 13.0091 7.72906 13.7891 8.28906C15.8291 9.74906 17 12.19 17 15C17 17.39 15.8794 19.54 14.1094 21H19C20.1 21 21 20.1 21 19V9C21 6.99 20.2198 5.02906 19.5898 3.78906C19.8298 3.59906 20 3.33 20 3C20 2.45 19.55 2 19 2H13ZM6.96289 5.98818C6.5922 5.99913 6.258 6.2143 6.09461 6.54722C5.93122 6.88014 5.96547 7.27615 6.18359 7.57607C6.44984 7.9537 6.70257 8.44676 6.85547 9.01552C5.94923 9.07474 5.07646 9.38271 4.32422 9.92763C2.84722 10.9966 2 12.842 2 14.994C2 18.305 4.916 20.9999 8.5 20.9999C12.084 20.9999 15 18.305 15 14.994C15 12.844 14.135 10.992 12.627 9.91201C11.5395 9.13387 10.2231 8.85262 8.92188 9.08779C8.74275 7.97217 8.2683 7.06468 7.81641 6.42373C7.6245 6.14283 7.30296 5.97874 6.96289 5.98818Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var Visa = /*#__PURE__*/createIcon({
  displayName: "Visa",
  viewBox: "0 0 24 25",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "25",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M23.3822 4.72339H0.617847C0.276204 4.72339 0 5.00002 0 5.34124V19.6592C0 20.0004 0.276204 20.2771 0.617847 20.2771H23.3822C23.7238 20.2771 24 20.0004 24 19.6592V5.34124C24 5.00002 23.7238 4.72339 23.3822 4.72339ZM1.85822 9.42353H4.41969C4.76516 9.4367 5.04348 9.54676 5.13952 9.91602L5.6966 12.5952C5.14929 11.1938 3.83031 10.0278 1.83697 9.54506L1.85822 9.42353ZM4.95765 15.534L3.47805 10.4791C4.54164 11.1598 5.44759 12.24 5.76671 12.9917L5.93924 13.6159L7.55737 9.48175H9.30807L6.70623 15.5327L4.95765 15.534ZM10.5948 15.5383H8.94263L9.97564 9.47537H11.6286L10.5948 15.5383ZM13.4698 15.6292C12.7292 15.6215 12.0157 15.4749 11.629 15.3054L11.8615 13.9486L12.0744 14.0451C12.617 14.2715 12.9684 14.3633 13.63 14.3633C14.1047 14.3633 14.6133 14.1776 14.618 13.7714C14.621 13.5058 14.4051 13.3163 13.7618 13.0189C13.1346 12.7291 12.3042 12.2429 12.3144 11.3723C12.3234 10.1939 13.4741 9.37169 15.1071 9.37169C15.747 9.37169 16.2599 9.50342 16.5871 9.62622L16.364 10.9405L16.2149 10.8704C15.9106 10.748 15.5193 10.6299 14.9783 10.6384C14.3316 10.6384 14.0316 10.9078 14.0316 11.1598C14.0282 11.4436 14.3817 11.6306 14.9596 11.9119C15.9127 12.3445 16.3534 12.8693 16.3475 13.5589C16.3347 14.8167 15.2074 15.6292 13.4698 15.6292ZM20.6299 15.5408C20.6299 15.5408 20.479 14.8439 20.4289 14.6323C20.1884 14.6323 18.5023 14.6298 18.3127 14.6298C18.2486 14.7934 17.9656 15.5408 17.9656 15.5408H16.2306L18.6837 9.98486C18.8579 9.5901 19.1533 9.48175 19.5493 9.48175H20.8258L22.163 15.5404L20.6299 15.5408Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.7771 11.6395L19.6657 11.1168C19.5816 11.345 19.4367 11.7117 19.4461 11.6956C19.4461 11.6956 18.9238 13.0413 18.7878 13.3902H20.1599C20.0936 13.0864 19.7771 11.6395 19.7771 11.6395Z",
      fill: "currentColor"
    })]
  })
});

var VisibilityOff = /*#__PURE__*/createIcon({
  displayName: "VisibilityOff",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M2.71 4.54002C2.32 4.15002 2.32 3.52002 2.71 3.13002C3.1 2.74002 3.74 2.74002 4.13 3.13002L20.44 19.46C20.83 19.85 20.83 20.48 20.44 20.87C20.05 21.26 19.42 21.26 19.03 20.87L16.31 18.15C14.97 18.67 13.52 18.97 12 18.97C7 18.97 2.73 15.86 1 11.47C1.77 9.50002 3.06 7.80002 4.68 6.51002L2.71 4.54002ZM17 11.47C17 8.71002 14.76 6.47002 12 6.47002C11.49 6.47002 11 6.57002 10.53 6.71002L8.36 4.54002C9.51 4.17002 10.73 3.97002 12 3.97002C17 3.97002 21.27 7.08002 23 11.46C22.31 13.22 21.21 14.76 19.82 15.99L16.76 12.93C16.9 12.47 17 11.98 17 11.47ZM12 16.47C9.24 16.47 7 14.23 7 11.47C7 10.7 7.18 9.97002 7.49 9.33002L9.06 10.9C9.03 11.08 9 11.27 9 11.47C9 13.13 10.34 14.47 12 14.47C12.2 14.47 12.38 14.44 12.57 14.4L14.14 15.97C13.49 16.29 12.77 16.47 12 16.47ZM14.97 11.14C14.82 9.74002 13.72 8.65002 12.33 8.50002L14.97 11.14Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var VisibilityOn = /*#__PURE__*/createIcon({
  displayName: "VisibilityOn",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var WhatsApp = /*#__PURE__*/createIcon({
  displayName: "WhatsApp",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "24",
      height: "24",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.0769 4.92792C16.9949 2.84492 14.1549 1.79392 11.1729 2.03392C7.16389 2.35592 3.64989 5.14392 2.47389 8.98992C1.63389 11.7379 1.98689 14.6069 3.35489 16.9769L2.05889 21.2799C1.93489 21.6929 2.31189 22.0819 2.72889 21.9709L7.23289 20.7639C8.69189 21.5599 10.3339 21.9789 12.0059 21.9799H12.0099C16.2049 21.9799 20.0809 19.4139 21.4219 15.4389C22.7279 11.5629 21.7619 7.61592 19.0769 4.92792ZM16.8979 15.5539C16.6899 16.1369 15.6709 16.6989 15.2129 16.7399C14.7549 16.7819 14.3259 16.9469 12.2179 16.1159C9.68089 15.1159 8.07889 12.5149 7.95489 12.3489C7.82989 12.1819 6.93589 10.9959 6.93589 9.76792C6.93589 8.53992 7.58089 7.93592 7.80989 7.68692C8.03889 7.43692 8.30889 7.37492 8.47589 7.37492C8.64189 7.37492 8.80889 7.37492 8.95389 7.38092C9.13189 7.38792 9.32889 7.39692 9.51589 7.81192C9.73789 8.30592 10.2229 9.53992 10.2849 9.66492C10.3469 9.78992 10.3889 9.93592 10.3059 10.1019C10.2229 10.2679 10.1809 10.3719 10.0569 10.5179C9.93189 10.6639 9.79489 10.8429 9.68289 10.9549C9.55789 11.0789 9.42789 11.2149 9.57289 11.4639C9.71889 11.7139 10.2189 12.5309 10.9609 13.1919C11.9149 14.0419 12.7179 14.3049 12.9679 14.4309C13.2179 14.5559 13.3629 14.5349 13.5089 14.3679C13.6549 14.2019 14.1329 13.6399 14.2989 13.3899C14.4649 13.1399 14.6319 13.1819 14.8609 13.2649C15.0899 13.3479 16.3169 13.9519 16.5659 14.0769C16.8159 14.2019 16.9819 14.2639 17.0439 14.3679C17.1059 14.4709 17.1059 14.9709 16.8979 15.5539Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor"
    })]
  })
});

var index$3 = {
  __proto__: null,
  AcceptedPhotoId: AcceptedPhotoId,
  AddPhoto: AddPhoto,
  Agenda: Agenda,
  AirLuggage: AirLuggage,
  AirPayout: AirPayout,
  Airplane: Airplane,
  AirplaneLanding: AirplaneLanding,
  AirplaneLandingAirstrip: AirplaneLandingAirstrip,
  AirplaneModeOff: AirplaneModeOff,
  AirplaneMultipleTrips: AirplaneMultipleTrips,
  AirplaneRight: AirplaneRight,
  AirplaneTakeOff: AirplaneTakeOff,
  AirplaneTakeOffAirstrip: AirplaneTakeOffAirstrip,
  AirplaneUpgrade: AirplaneUpgrade,
  AltArrowBack: AltArrowBack,
  AltArrowCollapse: AltArrowCollapse,
  AltArrowExpand: AltArrowExpand,
  AltArrowForward: AltArrowForward,
  ArrowDown: ArrowDown,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  ArrowUp: ArrowUp,
  BoardingPass: BoardingPass,
  BoxImportant: BoxImportant,
  Calculator: Calculator,
  Calendar: Calendar,
  CalendarDelete: CalendarDelete,
  Cancel: Cancel,
  CancelledFlight: CancelledFlight,
  Chat: Chat,
  Check: Check,
  Circle: Circle,
  CircleSolid: CircleSolid,
  CityRailwayStation: CityRailwayStation,
  Clock: Clock,
  Commercial: Commercial,
  Compensation: Compensation,
  CompensationIncome: CompensationIncome,
  ConnectingFlightLeft: ConnectingFlightLeft,
  ConnectingFlightRight: ConnectingFlightRight,
  Cookies: Cookies,
  Copy: Copy,
  CustomerRights: CustomerRights,
  DamagedLuggage: DamagedLuggage,
  Dashboard: Dashboard,
  DataDownload: DataDownload,
  DataUpload: DataUpload,
  DelayedFlight: DelayedFlight$1,
  Delete: Delete,
  DeleteBin: DeleteBin,
  Doctor: Doctor,
  Document: Document,
  Documents: Documents$1,
  DocumentsToUpload: DocumentsToUpload,
  Dolar: Dolar,
  DoubleArrowDown: DoubleArrowDown,
  DoubleArrowLeft: DoubleArrowLeft,
  DoubleArrowRight: DoubleArrowRight,
  DoubleArrowUp: DoubleArrowUp,
  Edit: Edit,
  Envelope: Envelope,
  Erase: Erase,
  Error: Error$1,
  EuropeNews: EuropeNews,
  EuropeUnion: EuropeUnion,
  FlashOn: FlashOn,
  Gift: Gift$1,
  Globe: Globe,
  GlobeAround: GlobeAround,
  Guardian: Guardian,
  Heart: Heart,
  Help: Help,
  HighImportance: HighImportance,
  Home: Home,
  ID: ID$1,
  Idea: Idea,
  ImageFile: ImageFile,
  Info: Info,
  InsertLink: InsertLink,
  Law: Law,
  Lock: Lock,
  Logout: Logout,
  Lounge: Lounge$1,
  Luggage: Luggage,
  LuggageSolid: LuggageSolid,
  Marker: Marker,
  Mastercard: Mastercard,
  Meeting: Meeting,
  Menu: Menu,
  Messenger: Messenger,
  MinusMath: MinusMath,
  MoneyCreditCard: MoneyCreditCard,
  MoneyBack: MoneyBack,
  MoneyEuro: MoneyEuro,
  MoneyFee: MoneyFee,
  MoneyPaper: MoneyPaper,
  MoneyProfit: MoneyProfit,
  MoneyWallet: MoneyWallet,
  MoreHorizontal: MoreHorizontal,
  MoreVertical: MoreVertical,
  News: News,
  Ok: Ok,
  Phone: Phone,
  Play: Play,
  Plus: Plus,
  PlusMath: PlusMath,
  PriceTag: PriceTag,
  Protect: Protect,
  ProtectSafe: ProtectSafe,
  ProtectFlight: ProtectFlight,
  Pulse: Pulse,
  QuoteLeft: QuoteLeft,
  QuoteRight: QuoteRight,
  Railway: Railway,
  ReturnFlight: ReturnFlight,
  Rules: Rules,
  Search: Search,
  SelArrowBack: SelArrowBack,
  SelArrowCollapse: SelArrowCollapse,
  SelArrowExpand: SelArrowExpand,
  SelArrowForward: SelArrowForward,
  Send: Send,
  SendWatch: SendWatch,
  SharedDocument: SharedDocument,
  ShieldPlusSolid: ShieldPlusSolid,
  SleepingInBed: SleepingInBed,
  SocialFacebook: SocialFacebook,
  SocialInstagram: SocialInstagram,
  SocialLinkedin: SocialLinkedin,
  SocialShare: SocialShare,
  SocialTwitter: SocialTwitter,
  Sort: Sort,
  SortDown: SortDown,
  SortUp: SortUp,
  Star: Star,
  SubmitDocument: SubmitDocument,
  ThumbsUp: ThumbsUp,
  TechnicalSupport: TechnicalSupport$1,
  Time: Time,
  Traveler: Traveler,
  Trophy: Trophy,
  TrustPilot: TrustPilotLogo,
  User: User,
  UserManual: UserManual,
  VegetarianFood: VegetarianFood,
  Visa: Visa,
  VisibilityOff: VisibilityOff,
  VisibilityOn: VisibilityOn,
  WhatsApp: WhatsApp
};

var At = /*#__PURE__*/createIcon({
  displayName: "At",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1.5",
      y: "1",
      width: "48",
      height: "11",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "red_2",
      x: "1.5",
      y: "22",
      width: "48",
      height: "11",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1.5",
      y: "12",
      width: "48",
      height: "10",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Au = /*#__PURE__*/createIcon({
  displayName: "Au",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "blue dark",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "#0070B8"
    }), /*#__PURE__*/jsxs("g", {
      id: "UK corner",
      children: [/*#__PURE__*/jsx("path", {
        id: "blue dark_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 1V17H25.5V1H1.5Z",
        fill: "#0070B8"
      }), /*#__PURE__*/jsx("path", {
        id: "white",
        d: "M4.20416 1L25.5 15.1972V17H22.7958L1.5 2.80278L1.5 1L4.20416 1Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "white_2",
        d: "M4.20416 17L25.5 2.80278V1L22.7958 1L1.5 15.1972L1.5 17H4.20416Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "red",
        d: "M1.5 1V2.20185L11.6972 9H13.5L1.5 1Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_2",
        d: "M13.5 9V7.79815L23.6972 1H25.5L13.5 9Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_3",
        d: "M25.5 17V15.7981L15.3028 9H13.5L25.5 17Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_4",
        d: "M1.5 17L13.5 9V10.2019L3.30278 17H1.5Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "white cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 1H11V6.5H1.5V11.5H11V17H16V11.5H25.5V6.5H16V1Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "red cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 1H12V7.5H1.5V10.5H12V17H15V10.5H25.5V7.5H15V1Z",
        fill: "#FF1A26"
      })]
    }), /*#__PURE__*/jsx("path", {
      id: "star",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38 6L38.3506 7.12362L39.4216 6.7056L38.7879 7.6887L39.7727 8.29106L38.6318 8.39335L38.7889 9.5625L38 8.70695L37.2111 9.5625L37.3682 8.39335L36.2273 8.29106L37.2121 7.6887L36.5784 6.7056L37.6494 7.12362L38 6ZM42.7273 10.75L43.0779 11.8736L44.1489 11.4556L43.5152 12.4387L44.5 13.0411L43.3591 13.1434L43.5162 14.3125L42.7273 13.457L41.9383 14.3125L42.0954 13.1434L40.9545 13.0411L41.9394 12.4387L41.3057 11.4556L42.3766 11.8736L42.7273 10.75ZM33.2727 11.9375L33.6234 13.0611L34.6943 12.6431L34.0606 13.6262L35.0455 14.2286L33.9046 14.3309L34.0617 15.5L33.2727 14.6445L32.4838 15.5L32.6409 14.3309L31.5 14.2286L32.4848 13.6262L31.8511 12.6431L32.9221 13.0611L33.2727 11.9375ZM38 21.4375L38.3506 22.5611L39.4216 22.1431L38.7879 23.1262L39.7727 23.7286L38.6318 23.8309L38.7889 25L38 24.1445L37.2111 25L37.3682 23.8309L36.2273 23.7286L37.2121 23.1262L36.5784 22.1431L37.6494 22.5611L38 21.4375ZM39.7727 15.5L40.038 16.4193H40.9545L40.231 16.9812L40.4963 17.875L39.7727 17.3132L39.0492 17.8494L39.3145 16.9812L38.5909 16.4193H39.4833L39.7727 15.5Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "star_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 22L13.6923 24.2078L15.8068 23.3864L14.5556 25.3182L16.5 26.5017L14.2475 26.7027L14.5576 29L13 27.3189L11.4424 29L11.7525 26.7027L9.5 26.5017L11.4444 25.3182L10.1932 23.3864L12.3077 24.2078L13 22Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Be = /*#__PURE__*/createIcon({
  displayName: "Be",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "yellow",
      x: "17",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("rect", {
      id: "black",
      x: "1",
      y: "1",
      width: "16",
      height: "32",
      fill: "#0B0F14"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "33",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Br = /*#__PURE__*/createIcon({
  displayName: "Br",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "green",
      x: "1",
      y: "1",
      width: "48",
      height: "32",
      fill: "#00AE82"
    }), /*#__PURE__*/jsx("path", {
      id: "yellow",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 3L5 17L25 31L45 17L25 3Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M34 17C34 12.0294 29.9706 8 25 8C20.0294 8 16 12.0294 16 17C16 21.9706 20.0294 26 25 26C29.9706 26 34 21.9706 34 17Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.9399 18.0453C30.5509 15.0689 26.1074 13.2642 21.2424 13.2642C19.6319 13.2642 18.0676 13.4619 16.5724 13.8345C16.3705 14.3718 16.2185 14.9334 16.1221 15.5138C17.7433 15.0262 19.4623 14.7642 21.2424 14.7642C26.0328 14.7642 30.38 16.6618 33.5732 19.7464C33.748 19.2002 33.8721 18.6314 33.9399 18.0453Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Ca = /*#__PURE__*/createIcon({
  displayName: "Ca",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      id: "white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 1V33H49.5V1H1.5Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "red",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 1V33H10.5V1H1.5Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.5 1V33H49.5V1H40.5Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "emblem",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.2496 7L23.5467 10.1671C23.3535 10.5113 23.0072 10.4794 22.661 10.2872L21.4281 9.65057L22.347 14.5152C22.5403 15.404 21.9203 15.404 21.6143 15.0197L19.4627 12.6178L19.1134 13.8376C19.0731 13.9977 18.896 14.166 18.6303 14.1259L15.9096 13.5555L16.6242 16.1462C16.7772 16.7226 16.8965 16.9613 16.4698 17.1133L15.5 17.5678L20.1836 21.3613C20.3689 21.5047 20.4626 21.7628 20.3966 21.9966L19.9867 23.3379C21.5993 23.1526 23.0442 22.8737 24.6577 22.702C24.8001 22.6868 25.0386 22.9212 25.0376 23.0858L24.8239 28H25.608L25.4846 23.0963C25.4836 22.9317 25.6999 22.6868 25.8423 22.702C27.4558 22.8737 28.9007 23.1526 30.5133 23.3379L30.1034 21.9966C30.0374 21.7628 30.1311 21.5047 30.3164 21.3613L35 17.5678L34.0302 17.1133C33.6035 16.9613 33.7228 16.7226 33.8758 16.1462L34.5904 13.5555L31.8697 14.1259C31.604 14.166 31.4269 13.9977 31.3866 13.8376L31.0373 12.6178L28.8857 15.0197C28.5797 15.404 27.9597 15.404 28.153 14.5152L29.0718 9.65057L27.839 10.2872C27.4928 10.4794 27.1465 10.5113 26.9533 10.1671L25.2496 7Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Ch = /*#__PURE__*/createIcon({
  displayName: "Ch",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 82",
      x: "22.5",
      y: "8",
      width: "6",
      height: "18",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 83",
      x: "16.5",
      y: "14",
      width: "18",
      height: "6",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Cn = /*#__PURE__*/createIcon({
  displayName: "Cn",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "Star 5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 16.5L6.0916 19.5676L7.64682 14.4271L3.36707 11.1824L8.73663 11.0729L10.5 6L12.2633 11.0729L17.6329 11.1824L13.3532 14.4271L14.9084 19.5676L10.5 16.5Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Star 5_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7264 7.75167L17.342 8.1183L18.2005 6.972L17.424 5.76859L18.7795 6.23091L19.6841 5.12053L19.6633 6.55256L20.9988 7.06972L19.6304 7.49245L19.5513 8.92244L18.7264 7.75167Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Star 5_3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.4 11.5949L22.7909 12.8911L22.4647 11.4966L21.0437 11.3179L22.2692 10.5767L22 9.17004L23.0836 10.1065L24.3383 9.4158L23.7825 10.7358L24.8271 11.7156L23.4 11.5949Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Star 5_4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.8611 16.8846L21.5613 17.4861L22.2078 16.2081L21.2341 15.1578L22.6493 15.3778L23.3473 14.1272L23.5755 15.5411L24.9805 15.8184L23.7063 16.4724L23.8767 17.8944L22.8611 16.8846Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Star 5_5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7264 20.7517L17.342 21.1183L18.2005 19.972L17.424 18.7686L18.7795 19.2309L19.6841 18.1205L19.6633 19.5526L20.9988 20.0697L19.6304 20.4924L19.5513 21.9224L18.7264 20.7517Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var De = /*#__PURE__*/createIcon({
  displayName: "De",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "black",
      x: "1",
      y: "1",
      width: "48",
      height: "11",
      fill: "#0B0F14"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "12",
      width: "48",
      height: "10",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "yellow",
      x: "1",
      y: "22",
      width: "48",
      height: "11",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Dk = /*#__PURE__*/createIcon({
  displayName: "Dk",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1",
      y: "14",
      width: "48",
      height: "6",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "white_2",
      x: "14",
      y: "1",
      width: "6",
      height: "32",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Es = /*#__PURE__*/createIcon({
  displayName: "Es",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "yellow",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1.5",
      y: "1",
      width: "48",
      height: "8",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "red_2",
      x: "1.5",
      y: "25",
      width: "48",
      height: "8",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsxs("g", {
      id: "emblem",
      children: [/*#__PURE__*/jsx("path", {
        id: "Rectangle 77",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 13.5V23H9V24H6V23H6.5V13.5H8.5Z",
        fill: "#DEE8F0"
      }), /*#__PURE__*/jsx("ellipse", {
        id: "Oval 64",
        cx: "7.5",
        cy: "13.5",
        rx: "1",
        ry: "0.5",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsxs("g", {
        id: "Group 26",
        children: [/*#__PURE__*/jsx("path", {
          id: "Rectangle 78",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.45837 13.4106H19.5417V20.5297C19.5417 22.987 17.2845 24.0892 14.5 24.0892C11.7156 24.0892 9.45837 22.987 9.45837 20.5297V13.4106Z",
          fill: "#DEE8F0"
        }), /*#__PURE__*/jsx("rect", {
          id: "Rectangle 79",
          x: "9.91675",
          y: "13.8213",
          width: "4.58333",
          height: "4.10714",
          fill: "#FF1A26"
        }), /*#__PURE__*/jsx("path", {
          id: "Rectangle 79_2",
          d: "M9.91675 17.9285H14.5001V20.5654C14.5001 21.831 13.4741 22.857 12.2084 22.857C10.9428 22.857 9.91675 21.831 9.91675 20.5654V17.9285Z",
          fill: "#FBB43A"
        }), /*#__PURE__*/jsx("path", {
          id: "Rectangle 79_3",
          d: "M14.5 17.9285H19.0833V20.5654C19.0833 21.831 18.0573 22.857 16.7917 22.857C15.526 22.857 14.5 21.831 14.5 20.5654V17.9285Z",
          fill: "#FF1A26"
        }), /*#__PURE__*/jsx("ellipse", {
          id: "Oval 64_2",
          cx: "16.7917",
          cy: "15.875",
          rx: "1.375",
          ry: "1.64286",
          fill: "#FF1A26"
        })]
      }), /*#__PURE__*/jsx("path", {
        id: "Rectangle 77_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.5 13.5V23H23V24H20V23H20.5V13.5H22.5Z",
        fill: "#DEE8F0"
      }), /*#__PURE__*/jsx("ellipse", {
        id: "Oval 64_3",
        cx: "21.5",
        cy: "13.5",
        rx: "1",
        ry: "0.5",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("ellipse", {
        id: "Oval 64_4",
        cx: "14.5",
        cy: "11.5",
        rx: "4",
        ry: "1.5",
        fill: "#FF1A26"
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Fi = /*#__PURE__*/createIcon({
  displayName: "Fi",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5 1H20.5V33H14.5V1Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      id: "blue_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.5 14V20H1.5V14H49.5Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Fr = /*#__PURE__*/createIcon({
  displayName: "Fr",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1",
      y: "1",
      width: "16",
      height: "32",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      x: "17",
      y: "1",
      width: "16",
      height: "32",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "33",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Gb = /*#__PURE__*/createIcon({
  displayName: "Gb",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      id: "blue dark",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.5 1V33H49.5V1H1.5Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      id: "white",
      d: "M6.90833 1L49.5 29.3944V33H44.0917L1.5 4.60555L1.5 1L6.90833 1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_2",
      d: "M6.90833 33L49.5 4.60555V1L44.0917 1L1.5 29.3944L1.5 33H6.90833Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "red",
      d: "M1.5 1V3.4037L21.8944 17H25.5L1.5 1Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_2",
      d: "M25.5 17V14.5963L45.8944 1H49.5L25.5 17Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_3",
      d: "M49.5 33V30.5963L29.1056 17H25.5L49.5 33Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_4",
      d: "M1.5 33L25.5 17V19.4037L5.10555 33H1.5Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "white cross",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.5 1H20.5V12H1.5V22H20.5V33H30.5V22H49.5V12H30.5V1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "red cross",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.5 1H22.5V14H1.5V20H22.5V33H28.5V20H49.5V14H28.5V1Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Gr = /*#__PURE__*/createIcon({
  displayName: "Gr",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1V33H49V1H1Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      id: "white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 4.5V8H49V4.5L19 4.5Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 11.5V15H49V11.5L19 11.5Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 19V22.5H49V19H1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 26V29.5H49V26H1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 8V11.5H19V8H1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_6",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.25 1V19H11.75V1H8.25Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Ie = /*#__PURE__*/createIcon({
  displayName: "Ie",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "green",
      x: "1.5",
      y: "1",
      width: "16",
      height: "32",
      fill: "#00AE82"
    }), /*#__PURE__*/jsx("rect", {
      id: "orange",
      x: "33.5",
      y: "1",
      width: "16",
      height: "32",
      fill: "#E87E04"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var In = /*#__PURE__*/createIcon({
  displayName: "In",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "green",
      x: "1",
      y: "23",
      width: "48",
      height: "10",
      fill: "#00AE82"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1",
      y: "11",
      width: "48",
      height: "12",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "orange",
      x: "1",
      y: "1",
      width: "48",
      height: "10",
      fill: "#E87E04"
    }), /*#__PURE__*/jsx("circle", {
      id: "Oval 15",
      cx: "25",
      cy: "17",
      r: "5.5",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("circle", {
      id: "Oval 15_2",
      cx: "25",
      cy: "17",
      r: "4.5",
      fill: "white"
    }), /*#__PURE__*/jsx("circle", {
      id: "Oval 15_3",
      cx: "25",
      cy: "17",
      r: "1.5",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Int = /*#__PURE__*/createIcon({
  displayName: "Int",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      id: "Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1H49V33H1V1Z",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 30C32.1797 30 38 24.1797 38 17C38 9.8203 32.1797 4 25 4C17.8203 4 12 9.8203 12 17C12 24.1797 17.8203 30 25 30ZM25 28C31.0751 28 36 23.0751 36 17C36 10.9249 31.0751 6 25 6C18.9249 6 14 10.9249 14 17C14 23.0751 18.9249 28 25 28Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 105",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 11H36L37 13H13L14 11Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 105_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 21H37L36 23H14L13 21Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 30C28.866 30 32 24.1797 32 17C32 9.8203 28.866 4 25 4C21.134 4 18 9.8203 18 17C18 24.1797 21.134 30 25 30ZM25 28C27.7614 28 30 23.0751 30 17C30 10.9249 27.7614 6 25 6C22.2386 6 20 10.9249 20 17C20 23.0751 22.2386 28 25 28Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var It = /*#__PURE__*/createIcon({
  displayName: "It",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      x: "17",
      y: "1",
      width: "16",
      height: "32",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "33",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "green",
      x: "1",
      y: "1",
      width: "16",
      height: "32",
      fill: "#00AE82"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Nl = /*#__PURE__*/createIcon({
  displayName: "Nl",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1",
      y: "12",
      width: "48",
      height: "10",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "1",
      width: "48",
      height: "11",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1",
      y: "22",
      width: "48",
      height: "11",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var No = /*#__PURE__*/createIcon({
  displayName: "No",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49 12V22H1V12H49Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "white_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 1H22V33H12V1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49 14V20H1V14H49Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      id: "blue_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 1H20V33H14V1Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Nz = /*#__PURE__*/createIcon({
  displayName: "Nz",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "#0070B8"
    }), /*#__PURE__*/jsxs("g", {
      id: "UK corner",
      children: [/*#__PURE__*/jsx("path", {
        id: "blue dark",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.5 1V17H25.5V1H1.5Z",
        fill: "#0070B8"
      }), /*#__PURE__*/jsx("path", {
        id: "white",
        d: "M4.20416 1L25.5 15.1972V17H22.7958L1.5 2.80278L1.5 1L4.20416 1Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "white_2",
        d: "M4.20416 17L25.5 2.80278V1L22.7958 1L1.5 15.1972L1.5 17H4.20416Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "red",
        d: "M1.5 1V2.20185L11.6972 9H13.5L1.5 1Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_2",
        d: "M13.5 9V7.79815L23.6972 1H25.5L13.5 9Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_3",
        d: "M25.5 17V15.7981L15.3028 9H13.5L25.5 17Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "red_4",
        d: "M1.5 17L13.5 9V10.2019L3.30278 17H1.5Z",
        fill: "#FF1A26"
      }), /*#__PURE__*/jsx("path", {
        id: "white cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 1H11V6.5H1.5V11.5H11V17H16V11.5H25.5V6.5H16V1Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "red cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 1H12V7.5H1.5V10.5H12V17H15V10.5H25.5V7.5H15V1Z",
        fill: "#FF1A26"
      })]
    }), /*#__PURE__*/jsx("path", {
      id: "star",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M37.2562 4.48291L37.8677 6.5919H39.9394L38.2955 7.86225L38.9044 9.90354L37.2478 8.62338L35.5955 9.84213L36.2036 7.86171L34.5605 6.5919H36.589L37.2562 4.48291ZM43.8677 12.5919L43.2562 10.4829L42.589 12.5919H40.5605L42.2036 13.8617L41.5955 15.8421L43.2478 14.6234L44.9044 15.9035L44.2955 13.8623L45.9394 12.5919H43.8677ZM37.8677 24.5919L37.2562 22.4829L36.589 24.5919H34.5605L36.2036 25.8617L35.5955 27.8421L37.2478 26.6234L38.9044 27.9035L38.2955 25.8623L39.9394 24.5919H37.8677ZM31.8677 14.0919L31.2562 11.9829L30.589 14.0919H28.5605L30.2036 15.3617L29.5955 17.3421L31.2478 16.1234L32.9044 17.4035L32.2955 15.3623L33.9394 14.0919H31.8677Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "star_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36.842 6.78718L36.699 6.89194H35.4395L36.4693 7.68785L36.521 7.85057L36.1493 9.06099L37.161 8.31477L37.3418 8.31679L38.3507 9.09646L37.9787 7.84942L38.0307 7.68785L39.0606 6.89194H37.7552L37.6111 6.78372L37.2438 5.51709L36.842 6.78718ZM42.699 12.8919L42.842 12.7872L43.2438 11.5171L43.6111 12.7837L43.7552 12.8919H45.0606L44.0307 13.6879L43.9787 13.8494L44.3507 15.0965L43.3418 14.3168L43.161 14.3148L42.1493 15.061L42.521 13.8506L42.4693 13.6879L41.4395 12.8919H42.699ZM36.699 24.8919L36.842 24.7872L37.2438 23.5171L37.6111 24.7837L37.7552 24.8919H39.0606L38.0307 25.6879L37.9787 25.8494L38.3507 27.0965L37.3418 26.3168L37.161 26.3148L36.1493 27.061L36.521 25.8506L36.4693 25.6879L35.4395 24.8919H36.699ZM30.699 14.3919L30.842 14.2872L31.2438 13.0171L31.6111 14.2837L31.7552 14.3919H33.0606L32.0307 15.1879L31.9787 15.3494L32.3507 16.5965L31.3418 15.8168L31.161 15.8148L30.1493 16.561L30.521 15.3506L30.4693 15.1879L29.4395 14.3919H30.699Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Pl = /*#__PURE__*/createIcon({
  displayName: "Pl",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1",
      y: "17",
      width: "48",
      height: "16",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1",
      y: "1",
      width: "48",
      height: "16",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Pt = /*#__PURE__*/createIcon({
  displayName: "Pt",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "17",
      y: "1",
      width: "32",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "green",
      x: "1",
      y: "1",
      width: "16",
      height: "32",
      fill: "#00AE82"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 27C22.5228 27 27 22.5228 27 17C27 11.4772 22.5228 7 17 7C11.4772 7 7 11.4772 7 17C7 22.5228 11.4772 27 17 27ZM17 25C21.4183 25 25 21.4183 25 17C25 12.5817 21.4183 9 17 9C12.5817 9 9 12.5817 9 17C9 21.4183 12.5817 25 17 25Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 56",
      d: "M22.5 11.5V18C22.5 21.0376 20.0376 23.5 17 23.5C13.9624 23.5 11.5 21.0376 11.5 18V11.5H22.5Z",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 56_2",
      d: "M12 12H22V18C22 20.7614 19.7614 23 17 23C14.2386 23 12 20.7614 12 18V12Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "Path",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18V14H14V18Z",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 57",
      x: "16.5",
      y: "15",
      width: "1",
      height: "1",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 57_2",
      x: "15",
      y: "17",
      width: "1",
      height: "1",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 57_3",
      x: "18",
      y: "17",
      width: "1",
      height: "1",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 57_4",
      x: "16.5",
      y: "19",
      width: "1",
      height: "1",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 57_5",
      x: "16.5",
      y: "17",
      width: "1",
      height: "1",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Ro = /*#__PURE__*/createIcon({
  displayName: "Ro",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "33.5",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("rect", {
      id: "yellow",
      x: "17.5",
      y: "1",
      width: "16",
      height: "32",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1.5",
      y: "1",
      width: "16",
      height: "32",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var RoundedBr = /*#__PURE__*/createIcon({
  displayName: "RoundedBr",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#4CAF50"
    }), /*#__PURE__*/jsx("path", {
      d: "M21.862 11.72L11.931 18.44L2 11.72L11.931 5L21.862 11.72Z",
      fill: "#FFEB3B"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.931 7.80005C9.79697 7.80005 8.06897 9.55405 8.06897 11.72C8.06897 13.886 9.79697 15.64 11.931 15.64C14.065 15.64 15.793 13.886 15.793 11.72C15.793 9.55405 14.065 7.80005 11.931 7.80005Z",
      fill: "#3F51B5"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.51295 9.89788C8.32495 10.2579 8.19595 10.6529 8.12695 11.0679C9.37095 10.9129 12.75 10.7529 15.595 12.9579C15.7259 12.5583 15.7928 12.1404 15.793 11.7199V11.7159C13.067 9.84088 10.086 9.76588 8.51295 9.89788Z",
      fill: "white"
    })]
  })
});

var RoundedEarth = /*#__PURE__*/createIcon({
  displayName: "RoundedEarth",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M12 0.571533C5.68816 0.571533 0.571411 5.68828 0.571411 12.0001C0.571411 18.3119 5.68816 23.4287 12 23.4287C18.3118 23.4287 23.4286 18.3119 23.4286 12.0001C23.4286 5.68828 18.3118 0.571533 12 0.571533Z",
      fill: "#1565C0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.34284 12.5716C6.85713 12.5716 6.85713 12.1145 6.85713 11.4288C6.85713 11.3915 6.85679 11.3532 6.85644 11.314C6.85044 10.6342 6.84232 9.71449 8.57141 9.71449C9.31427 9.71449 10.2857 9.71449 10.2857 8.57164V5.7145C10.2857 5.54307 10.2286 4.80021 9.0857 4.80021C8.11427 4.80021 7.37141 4.62878 7.37141 3.94307C7.37141 3.42878 7.77141 2.22878 8.57141 1.14307C4.34284 2.45735 1.25713 6.1145 0.685697 10.5716L0.571411 11.4288H5.14284C5.62585 11.4288 5.78224 11.7917 5.91877 12.1085C6.02452 12.3539 6.11836 12.5716 6.34284 12.5716ZM16.7428 6.57164L15.6 7.42878C15.4286 7.60021 15.3714 7.82878 15.4286 8.05735L15.9428 8.68592C16 8.91449 15.8857 9.20021 15.6571 9.3145C15.6 9.34878 15.5268 9.38992 15.4464 9.43518C15.1246 9.61621 14.6857 9.86307 14.6857 10.0002C14.6857 10.4002 14.9714 11.3716 15.2 11.3716C16.2099 11.3716 16.2912 11.1116 16.4073 10.7398C16.4949 10.4595 16.6024 10.1155 17.1428 9.77164C17.8857 9.3145 19.0857 9.08592 19.3714 9.08592H20.5143V17.0859H16.5143C16.5143 17.0859 17.2 18.1716 17.8286 19.3716C18.1143 19.9431 18.8 21.0859 18.8 21.0859C21.7143 18.8574 23.3714 15.4859 23.3714 11.9431C23.3714 8.28592 21.6 4.97164 18.9143 2.91449L17.2571 5.82878C17.1428 6.17164 16.9714 6.40021 16.7428 6.57164ZM9.4857 15.0288C10.2857 16.0002 10.7428 16.0002 11.4286 16.0002V17.5431C11.4286 17.5431 10.9714 18.6288 10.8571 18.8574C10.8299 18.9389 10.7315 19.1209 10.5943 19.3746C10.1548 20.1871 9.31701 21.7361 9.14284 23.0859C8.57141 22.9145 7.99998 22.6859 7.42855 22.4574V18.8574L6.2857 14.8574L6.85713 14.2859H7.31427H8.22855C8.62855 14.2859 9.14284 14.6859 9.4857 15.0288Z",
      fill: "#43A047"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.53563 13.7806C2.86153 13.2754 2.04646 12.6646 1.71424 12.0002L0.685669 10.4573C0.91424 8.22877 2.11424 6.17163 2.11424 6.17163L2.28567 6.22877C3.42853 6.8002 3.99995 8.0002 3.99995 8.8002C3.99995 9.20925 4.26023 9.57926 4.53237 9.96612C4.83048 10.3899 5.14281 10.8339 5.14281 11.3716C4.28567 11.3716 3.99995 11.7716 3.99995 12.1145V12.6859C3.99995 12.9716 4.22853 13.1431 4.57138 13.1431C5.02853 13.1431 5.08567 13.2573 5.08567 13.5431C5.08567 13.8288 5.37138 14.2859 5.71424 14.2859H6.79995C6.79995 16.5145 7.82853 17.1431 8.97138 17.1431C11.1428 17.1431 11.4285 16.0002 11.4285 16.0002C11.7714 16.0002 12 16.6288 12 16.8573C12 18.7431 10.8571 18.8573 10.8571 18.8573C9.94281 18.8573 7.99995 20.0002 7.99995 21.7145V22.6859L6.8571 22.1716V21.1431C6.8571 20.647 6.64178 19.9787 6.39806 19.2222C6.08029 18.2359 5.71424 17.0997 5.71424 16.0002C5.71424 15.0887 4.66021 14.468 4.00149 14.0801C3.83426 13.9817 3.69251 13.8982 3.59995 13.8288C3.57867 13.8128 3.55722 13.7967 3.53563 13.7806ZM20 11.4288C20 9.71449 19.4285 9.14306 19.4285 9.14306C19.6962 8.93712 19.8452 8.50854 20.0065 8.04453C20.2927 7.22101 20.6178 6.28592 21.7142 6.28592H21.8857L22.0571 6.57163C22.9142 8.17163 23.4285 10.0573 23.4285 12.0002C23.4285 14.8573 22.3428 17.4859 20.6285 19.4859L20.5714 19.4288C18.8571 17.1431 16.5714 17.1431 16.5714 17.1431C16.5714 17.1431 14.2857 16.9145 14.2857 14.8573C14.2857 14.2288 14.2857 12.5716 17.1428 12.5716C18.8571 12.5716 20 12.0002 20 11.4288Z",
      fill: "#7CB342"
    })]
  })
});

var RoundedEu = /*#__PURE__*/createIcon({
  displayName: "RoundedEu",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#3F51B5"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.385 4.33991L12 3.55591L11.615 4.33991L10.757 4.46591L11.378 5.07591L11.23 5.94091L12 5.53091L12.771 5.94091L12.622 5.07591L13.247 4.46491L12.385 4.33991ZM8.68803 5.45491L8.30203 4.66991L7.92003 5.45491L7.05903 5.57991L7.68103 6.19091L7.53503 7.05591L8.30303 6.64591L9.07303 7.05591L8.92803 6.19091L9.54803 5.57991L8.68803 5.45491ZM5.67703 7.10791L6.05903 7.89191L6.92003 8.02091L6.29903 8.62791L6.44403 9.49291L5.67703 9.08691L4.90703 9.49291L5.05603 8.62791L4.43403 8.02091L5.29203 7.89191L5.67703 7.10791ZM15.312 5.45491L15.697 4.66991H15.698L16.08 5.45491L16.941 5.57991L16.319 6.19091L16.465 7.05591L15.697 6.64591L14.927 7.05591L15.072 6.19091L14.452 5.57991L15.312 5.45491ZM8.30303 16.5349L8.68903 17.3189L9.54903 17.4479L8.92903 18.0589L9.07403 18.9199L8.30403 18.5139L7.53603 18.9199L7.68203 18.0589L7.06003 17.4479L7.92103 17.3189L8.30303 16.5349ZM15.313 17.3189L15.699 16.5349L16.081 17.3189L16.942 17.4479L16.32 18.0589L16.466 18.9199L15.698 18.5139L14.928 18.9199L15.073 18.0589L14.453 17.4479L15.313 17.3189ZM18.324 7.10791L17.942 7.89191L17.081 8.02091L17.702 8.62791L17.557 9.49291L18.324 9.08691L19.094 9.49291L18.945 8.62791L19.567 8.02091L18.709 7.89191L18.324 7.10791ZM6.05903 14.8469L5.67703 14.0589L5.29203 14.8469L4.43403 14.9719L5.05603 15.5839L4.90703 16.4439L5.67703 16.0379L6.44403 16.4439L6.29903 15.5829L6.92003 14.9719L6.05903 14.8469ZM18.323 14.0589L17.941 14.8469L17.08 14.9719L17.701 15.5829L17.556 16.4439L18.323 16.0379L19.093 16.4439L18.944 15.5839L19.566 14.9719L18.708 14.8469L18.323 14.0589ZM19.583 11.5939L19.198 10.8059L18.816 11.5939L17.955 11.7189L18.58 12.3299L18.431 13.1939L19.201 12.7839L19.969 13.1939L19.823 12.3289L20.444 11.7189L19.583 11.5939ZM4.80203 10.8059L5.18403 11.5939L6.04503 11.7189L5.42403 12.3289L5.56903 13.1939L4.80203 12.7839L4.03203 13.1939L4.18103 12.3299L3.55603 11.7189L4.41603 11.5939L4.80203 10.8059ZM12.385 18.8439L12 18.0589L11.615 18.8439L10.757 18.9689L11.378 19.5799L11.23 20.4439L12 20.0379L12.771 20.4439L12.622 19.5789L13.247 18.9689L12.385 18.8439Z",
      fill: "#FFEB3B"
    })]
  })
});

var RoundedUs = /*#__PURE__*/createIcon({
  displayName: "RoundedUs",
  viewBox: "0 0 24 24",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("ellipse", {
      cx: "11.921",
      cy: "12",
      rx: "11.881",
      ry: "12",
      fill: "white"
    }), /*#__PURE__*/jsx("mask", {
      id: "mask0_0_2874",
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "24",
      height: "24",
      children: /*#__PURE__*/jsx("ellipse", {
        cx: "11.921",
        cy: "12",
        rx: "11.881",
        ry: "12",
        fill: "white"
      })
    }), /*#__PURE__*/jsxs("g", {
      mask: "url(#mask0_0_2874)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M-7.44446 0H31.5555V24H-7.44446V0Z",
        fill: "#ECEFF1"
      }), /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.72827 0H20.1008V2.66667H2.72827V0ZM0 5.33333H24V8H0V5.33333ZM24 10.6667H0V13.3333H24V10.6667ZM0 16H24V18.6667H0V16ZM20.1008 21.3333H2.72827V24H20.1008V21.3333Z",
        fill: "#F44336"
      }), /*#__PURE__*/jsx("path", {
        d: "M-7.44446 0H11.5555V13H-7.44446V0Z",
        fill: "#3F51B5"
      }), /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.28131 2.89818L5.85934 2L5.43736 2.89818L4.49225 3.04182L5.17579 3.74182L5.01357 4.72727L5.85934 4.26182L6.70511 4.72727L6.54288 3.74182L7.22643 3.04182L6.28131 2.89818ZM9.69903 2.89818L9.27706 2L8.85508 2.89818L7.90997 3.04182L8.59351 3.74182L8.43129 4.72727L9.27706 4.26182L10.1228 4.72727L9.9606 3.74182L10.6441 3.04182L9.69903 2.89818ZM2.21377 9.27273L2.63574 10.1709L3.58086 10.3145L2.89731 11.0145L3.05954 12L2.21377 11.5345L1.368 12L1.53022 11.0145L0.84668 10.3145L1.79179 10.1709L2.21377 9.27273ZM6.28131 10.1709L5.85934 9.27273L5.43736 10.1709L4.49225 10.3145L5.17579 11.0145L5.01357 12L5.85934 11.5345L6.70511 12L6.54288 11.0145L7.22643 10.3145L6.28131 10.1709ZM9.27706 9.27273L9.69903 10.1709L10.6441 10.3145L9.9606 11.0145L10.1228 12L9.27706 11.5345L8.43129 12L8.59351 11.0145L7.90997 10.3145L8.85508 10.1709L9.27706 9.27273ZM3.54714 6.53455L3.12516 5.63636L2.70319 6.53455L1.75807 6.67818L2.44162 7.37818L2.27939 8.36364L3.12516 7.89818L3.97093 8.36364L3.80871 7.37818L4.49225 6.67818L3.54714 6.53455ZM6.77073 5.63636L7.19271 6.53455L8.13782 6.67818L7.45427 7.37818L7.6165 8.36364L6.77073 7.89818L5.92496 8.36364L6.08719 7.37818L5.40364 6.67818L6.34876 6.53455L6.77073 5.63636ZM10.6104 6.53455L10.1885 5.63636L9.76648 6.53455L8.82136 6.67818L9.50491 7.37818L9.34268 8.36364L10.1885 7.89818L11.0342 8.36364L10.872 7.37818L11.5555 6.67818L10.6104 6.53455Z",
        fill: "white"
      })]
    })]
  })
});

var Ru = /*#__PURE__*/createIcon({
  displayName: "Ru",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      x: "1.5",
      y: "1",
      width: "48",
      height: "10",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1.5",
      y: "11",
      width: "48",
      height: "12",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      x: "1.5",
      y: "23",
      width: "48",
      height: "10",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Se = /*#__PURE__*/createIcon({
  displayName: "Se",
  viewBox: "0 0 51 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "blue",
      x: "1.5",
      y: "1",
      width: "48",
      height: "32",
      fill: "#0070B8"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 80",
      x: "13.5",
      y: "1",
      width: "6",
      height: "32",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("rect", {
      id: "Rectangle 81",
      x: "1.5",
      y: "14",
      width: "48",
      height: "6",
      fill: "#FBB43A"
    }), /*#__PURE__*/jsx("path", {
      d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
      fill: "#F3F6F9"
    })]
  })
});

var Us = /*#__PURE__*/createIcon({
  displayName: "Us",
  viewBox: "0 0 50 34",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      id: "white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1V33H49V1H1Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "red",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 1V3.5H49V1H25Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 10.8333V13.3333H49V10.8333H25Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 20.6667V23.1667H49V20.6667L1 20.6667Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 5.91675V8.41675H49V5.91675H25Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 15.75V18.25H49V15.75L25 15.75Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_6",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 25.5833V28.0833H49V25.5833H1Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "red_7",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 30.5V33H49V30.5H1Z",
      fill: "#FF1A26"
    }), /*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 1V18.25H25V1H1Z",
      fill: "#0070B8"
    }), /*#__PURE__*/jsxs("g", {
      id: "Group 3",
      children: [/*#__PURE__*/jsx("path", {
        id: "Star 55",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.00001 4L2.41222 4.30902L2.52448 3.65451L2.04895 3.19098L2.70611 3.09549L3.00001 2.5L3.2939 3.09549L3.95106 3.19098L3.47553 3.65451L3.58779 4.30902L3.00001 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00001 4L6.41222 4.30902L6.52448 3.65451L6.04895 3.19098L6.70611 3.09549L7.00001 2.5L7.2939 3.09549L7.95106 3.19098L7.47553 3.65451L7.58779 4.30902L7.00001 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 4L10.4122 4.30902L10.5245 3.65451L10.049 3.19098L10.7061 3.09549L11 2.5L11.2939 3.09549L11.9511 3.19098L11.4755 3.65451L11.5878 4.30902L11 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 4L14.4122 4.30902L14.5245 3.65451L14.049 3.19098L14.7061 3.09549L15 2.5L15.2939 3.09549L15.9511 3.19098L15.4755 3.65451L15.5878 4.30902L15 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 4L18.4122 4.30902L18.5245 3.65451L18.049 3.19098L18.7061 3.09549L19 2.5L19.2939 3.09549L19.9511 3.19098L19.4755 3.65451L19.5878 4.30902L19 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_6",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 4L18.4122 4.30902L18.5245 3.65451L18.049 3.19098L18.7061 3.09549L19 2.5L19.2939 3.09549L19.9511 3.19098L19.4755 3.65451L19.5878 4.30902L19 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_7",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 7L20.4122 7.30902L20.5245 6.65451L20.049 6.19098L20.7061 6.09549L21 5.5L21.2939 6.09549L21.9511 6.19098L21.4755 6.65451L21.5878 7.30902L21 7Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_8",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.00001 7L4.41222 7.30902L4.52448 6.65451L4.04895 6.19098L4.70611 6.09549L5.00001 5.5L5.2939 6.09549L5.95106 6.19098L5.47553 6.65451L5.58779 7.30902L5.00001 7Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_9",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00001 7L8.41222 7.30902L8.52448 6.65451L8.04895 6.19098L8.70611 6.09549L9.00001 5.5L9.2939 6.09549L9.95106 6.19098L9.47553 6.65451L9.58779 7.30902L9.00001 7Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_10",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 7L12.4122 7.30902L12.5245 6.65451L12.049 6.19098L12.7061 6.09549L13 5.5L13.2939 6.09549L13.9511 6.19098L13.4755 6.65451L13.5878 7.30902L13 7Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_11",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 7L16.4122 7.30902L16.5245 6.65451L16.049 6.19098L16.7061 6.09549L17 5.5L17.2939 6.09549L17.9511 6.19098L17.4755 6.65451L17.5878 7.30902L17 7Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_12",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 4L22.4122 4.30902L22.5245 3.65451L22.049 3.19098L22.7061 3.09549L23 2.5L23.2939 3.09549L23.9511 3.19098L23.4755 3.65451L23.5878 4.30902L23 4Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_13",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.00001 10L2.41222 10.309L2.52448 9.65451L2.04895 9.19098L2.70611 9.09549L3.00001 8.5L3.2939 9.09549L3.95106 9.19098L3.47553 9.65451L3.58779 10.309L3.00001 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_14",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00001 10L6.41222 10.309L6.52448 9.65451L6.04895 9.19098L6.70611 9.09549L7.00001 8.5L7.2939 9.09549L7.95106 9.19098L7.47553 9.65451L7.58779 10.309L7.00001 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_15",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 10L10.4122 10.309L10.5245 9.65451L10.049 9.19098L10.7061 9.09549L11 8.5L11.2939 9.09549L11.9511 9.19098L11.4755 9.65451L11.5878 10.309L11 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_16",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 10L14.4122 10.309L14.5245 9.65451L14.049 9.19098L14.7061 9.09549L15 8.5L15.2939 9.09549L15.9511 9.19098L15.4755 9.65451L15.5878 10.309L15 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_17",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 10L18.4122 10.309L18.5245 9.65451L18.049 9.19098L18.7061 9.09549L19 8.5L19.2939 9.09549L19.9511 9.19098L19.4755 9.65451L19.5878 10.309L19 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_18",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 10L18.4122 10.309L18.5245 9.65451L18.049 9.19098L18.7061 9.09549L19 8.5L19.2939 9.09549L19.9511 9.19098L19.4755 9.65451L19.5878 10.309L19 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_19",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 13L20.4122 13.309L20.5245 12.6545L20.049 12.191L20.7061 12.0955L21 11.5L21.2939 12.0955L21.9511 12.191L21.4755 12.6545L21.5878 13.309L21 13Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_20",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.00001 13L4.41222 13.309L4.52448 12.6545L4.04895 12.191L4.70611 12.0955L5.00001 11.5L5.2939 12.0955L5.95106 12.191L5.47553 12.6545L5.58779 13.309L5.00001 13Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_21",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.00001 13L8.41222 13.309L8.52448 12.6545L8.04895 12.191L8.70611 12.0955L9.00001 11.5L9.2939 12.0955L9.95106 12.191L9.47553 12.6545L9.58779 13.309L9.00001 13Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_22",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 13L12.4122 13.309L12.5245 12.6545L12.049 12.191L12.7061 12.0955L13 11.5L13.2939 12.0955L13.9511 12.191L13.4755 12.6545L13.5878 13.309L13 13Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_23",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 13L16.4122 13.309L16.5245 12.6545L16.049 12.191L16.7061 12.0955L17 11.5L17.2939 12.0955L17.9511 12.191L17.4755 12.6545L17.5878 13.309L17 13Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_24",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 10L22.4122 10.309L22.5245 9.65451L22.049 9.19098L22.7061 9.09549L23 8.5L23.2939 9.09549L23.9511 9.19098L23.4755 9.65451L23.5878 10.309L23 10Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_25",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.00001 16L2.41222 16.309L2.52448 15.6545L2.04895 15.191L2.70611 15.0955L3.00001 14.5L3.2939 15.0955L3.95106 15.191L3.47553 15.6545L3.58779 16.309L3.00001 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_26",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00001 16L6.41222 16.309L6.52448 15.6545L6.04895 15.191L6.70611 15.0955L7.00001 14.5L7.2939 15.0955L7.95106 15.191L7.47553 15.6545L7.58779 16.309L7.00001 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_27",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 16L10.4122 16.309L10.5245 15.6545L10.049 15.191L10.7061 15.0955L11 14.5L11.2939 15.0955L11.9511 15.191L11.4755 15.6545L11.5878 16.309L11 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_28",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 16L14.4122 16.309L14.5245 15.6545L14.049 15.191L14.7061 15.0955L15 14.5L15.2939 15.0955L15.9511 15.191L15.4755 15.6545L15.5878 16.309L15 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_29",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 16L18.4122 16.309L18.5245 15.6545L18.049 15.191L18.7061 15.0955L19 14.5L19.2939 15.0955L19.9511 15.191L19.4755 15.6545L19.5878 16.309L19 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_30",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 16L18.4122 16.309L18.5245 15.6545L18.049 15.191L18.7061 15.0955L19 14.5L19.2939 15.0955L19.9511 15.191L19.4755 15.6545L19.5878 16.309L19 16Z",
        fill: "white"
      }), /*#__PURE__*/jsx("path", {
        id: "Star 55_31",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 16L22.4122 16.309L22.5245 15.6545L22.049 15.191L22.7061 15.0955L23 14.5L23.2939 15.0955L23.9511 15.191L23.4755 15.6545L23.5878 16.309L23 16Z",
        fill: "white"
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
      fill: "#F3F6F9"
    })]
  })
});

var Cs = /*#__PURE__*/createIcon({
  displayName: "Cs",
  viewBox: "0 0 48 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      y: "16",
      width: "48",
      height: "16",
      fill: "#E94B35"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      width: "48",
      height: "16",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      id: "blue",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0L24 16L0 32V0Z",
      fill: "#227FBB"
    })]
  })
});

var Bg = /*#__PURE__*/createIcon({
  displayName: "Bg",
  viewBox: "0 0 48 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "white",
      width: "48",
      height: "11",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "green",
      y: "11",
      width: "48",
      height: "10",
      fill: "#1AAF5D"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      y: "21",
      width: "48",
      height: "11",
      fill: "#E94B35"
    })]
  })
});

var Hu = /*#__PURE__*/createIcon({
  displayName: "Hu",
  viewBox: "0 0 48 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "green",
      y: "21",
      width: "48",
      height: "11",
      fill: "#1AAF5D"
    }), /*#__PURE__*/jsx("rect", {
      id: "white",
      y: "11",
      width: "48",
      height: "10",
      fill: "white"
    }), /*#__PURE__*/jsx("rect", {
      id: "red",
      width: "48",
      height: "11",
      fill: "#E94B35"
    })]
  })
});

var Md = /*#__PURE__*/createIcon({
  displayName: "Md",
  viewBox: "0 0 48 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      id: "red",
      x: "32",
      width: "16",
      height: "32",
      fill: "#E94B35"
    }), /*#__PURE__*/jsx("rect", {
      id: "blue",
      width: "16",
      height: "32",
      fill: "#227FBB"
    }), /*#__PURE__*/jsx("rect", {
      id: "yellow",
      x: "16",
      width: "16",
      height: "32",
      fill: "#F2C500"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 11L22 12L20 11L19.6205 10.241C19.5724 10.1448 19.5092 10.0571 19.4332 9.98106C19.0426 9.59053 18.4095 9.59053 18.0189 9.98106L17 11V23L23 19L20 24L24 26L28 24L25 19L31 23V11L29.9811 9.98106C29.9051 9.90506 29.8173 9.84181 29.7212 9.79374C29.2272 9.54675 28.6265 9.74697 28.3795 10.241L28 11L26 12L25 11V9.61805C25.3069 9.34339 25.5 8.94425 25.5 8.5C25.5 7.67157 24.8284 7 24 7C23.1716 7 22.5 7.67157 22.5 8.5C22.5 8.94425 22.6931 9.34339 23 9.61805V11Z",
      fill: "#AF7D61"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 41",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12H28V19L24 21L20 19V12Z",
      fill: "#2C97DE"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 41_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12H28V16H20V12Z",
      fill: "#E94B35"
    }), /*#__PURE__*/jsx("path", {
      id: "Rectangle 40",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 16H25V19L24 20L23 19V16Z",
      fill: "#F2C500"
    }), /*#__PURE__*/jsx("circle", {
      id: "Oval 42",
      cx: "24",
      cy: "14",
      r: "1",
      fill: "#F2C500"
    }), /*#__PURE__*/jsx("path", {
      id: "Combined Shape_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.45 14C26.2184 15.1411 25.2095 16 24 16C22.7905 16 21.7816 15.1411 21.55 14C21.5172 14.1616 21.5 14.3288 21.5 14.5C21.5 15.8807 22.6193 17 24 17C25.3807 17 26.5 15.8807 26.5 14.5C26.5 14.3288 26.4828 14.1616 26.45 14Z",
      fill: "#F2C500"
    })]
  })
});

var Tr = /*#__PURE__*/createIcon({
  displayName: "Tr",
  viewBox: "0 0 48 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      x: "1",
      y: "1",
      width: "48",
      height: "32",
      fill: "#FF1A26",
      stroke: "#F3F6F9"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.6209 9.97068C28.805 9.66635 27.9219 9.5 27 9.5C22.8579 9.5 19.5 12.8579 19.5 17C19.5 21.1421 22.8579 24.5 27 24.5C27.9219 24.5 28.805 24.3336 29.6209 24.0293C28.0807 25.2625 26.1265 26 24 26C19.0294 26 15 21.9706 15 17C15 12.0294 19.0294 8 24 8C26.1265 8 28.0807 8.7375 29.6209 9.97068Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.5376 18.2275L31.1942 20.7364L30.6918 17.9351L27.8905 17.4327L30.3994 16.0893L30.0116 13.2699L32.0645 15.2409L34.6261 14.0008L33.386 16.5623L35.357 18.6153L32.5376 18.2275Z",
      fill: "white"
    })]
  })
});

var index$2 = {
  __proto__: null,
  At: At,
  Au: Au,
  Be: Be,
  Br: Br,
  Ca: Ca,
  Ch: Ch,
  Cn: Cn,
  De: De,
  Dk: Dk,
  Es: Es,
  Fi: Fi,
  Fr: Fr,
  Gb: Gb,
  Gr: Gr,
  Ie: Ie,
  In: In,
  It: It,
  Int: Int,
  Nl: Nl,
  No: No,
  Nz: Nz,
  Pl: Pl,
  Pt: Pt,
  Ro: Ro,
  RoundedBr: RoundedBr,
  RoundedEarth: RoundedEarth,
  RoundedEu: RoundedEu,
  RoundedUs: RoundedUs,
  Ru: Ru,
  Se: Se,
  Us: Us,
  Cs: Cs,
  Bg: Bg,
  Hu: Hu,
  Md: Md,
  Tr: Tr
};

var CanceledFlight = /*#__PURE__*/createIcon({
  displayName: "CanceledFlight",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM48.5961 56.9094C48.083 56.4586 47.6682 55.9086 47.3768 55.2932C47.0769 54.6742 46.9114 53.9996 46.8912 53.3131C46.8706 52.6298 46.988 51.9493 47.2365 51.3116C47.4857 50.6727 47.8656 50.0918 48.3521 49.6055C48.8386 49.1193 49.4213 48.7381 50.0636 48.486C50.7062 48.2387 51.3924 48.1222 52.0813 48.1435C52.7694 48.1675 53.4452 48.3314 54.0668 48.6251C54.6958 48.9145 55.2551 49.3343 55.7069 49.856L57.5197 51.697L59.3325 49.8988C59.7983 49.438 60.3523 49.0741 60.9618 48.8285C61.3659 48.6607 61.7903 48.5456 62.2243 48.486L51.0563 41.5289V31.7354C51.08 31.2416 50.9953 30.7486 50.8081 30.2905C50.6299 29.8391 50.362 29.4278 50.0204 29.081C49.6733 28.7369 49.2611 28.4642 48.8074 28.2787C48.3537 28.0932 47.8675 27.9985 47.3768 28C46.8872 27.9997 46.4026 28.098 45.9524 28.289C45.4986 28.4711 45.09 28.7486 44.7547 29.1024C44.4162 29.4434 44.1485 29.8471 43.967 30.2905C43.7933 30.7449 43.709 31.2281 43.7188 31.714V41.5289L29.9396 50.0915C29.5324 50.3297 29.2287 50.7093 29.0874 51.1568C28.946 51.6043 28.977 52.0879 29.1744 52.514C29.3717 52.9402 29.7214 53.2786 30.1558 53.4637C30.5901 53.6489 31.0782 53.6677 31.5258 53.5165L43.7188 49.749V59.4996L40.6652 61.758C40.3723 61.9715 40.1629 62.2789 40.0725 62.6281C39.982 62.9773 40.0161 63.3467 40.1688 63.6739C40.3289 63.997 40.5974 64.2548 40.9281 64.4032C41.2588 64.5516 41.6312 64.5814 41.9816 64.4873L47.0315 63.235C47.1043 62.8648 47.224 62.5052 47.3876 62.1647C47.6781 61.5516 48.0889 61.0022 48.5961 60.5485L50.4196 58.7504L48.5961 56.9094ZM64.9758 53.8376C65.0081 53.6355 65.0081 53.4296 64.9758 53.2275C64.9594 53.0184 64.9122 52.8129 64.8355 52.6174C64.6727 52.2302 64.3988 51.8989 64.0478 51.6648C63.7018 51.4287 63.2918 51.3018 62.8717 51.3009C62.5904 51.3009 62.3118 51.3555 62.0516 51.4615C61.7916 51.5714 61.554 51.7274 61.3502 51.9217L60.5625 52.7031L57.5197 55.7214L53.6783 51.9217C53.2643 51.5908 52.7418 51.4231 52.2108 51.4508C51.7907 51.4708 51.3857 51.6122 51.0455 51.8575L50.7973 52.0716C50.4222 52.4402 50.1964 52.9325 50.1625 53.4552C50.1287 53.9779 50.2893 54.4948 50.6139 54.9079L51.0131 55.3039L54.466 58.7183L52.5345 60.6342L50.6139 62.5072C50.3138 62.8781 50.1467 63.3375 50.1391 63.813V63.9736C50.166 64.5016 50.3889 65.001 50.7649 65.3757C51.1427 65.7487 51.6462 65.9698 52.1785 65.9965C52.7094 66.0242 53.232 65.8565 53.6459 65.5255L57.4873 61.7045L61.4042 65.5255C61.821 65.859 62.3479 66.0268 62.8825 65.9965C63.2798 65.9746 63.6634 65.8442 63.9907 65.6197C64.318 65.3951 64.5763 65.0851 64.7371 64.724C64.8979 64.363 64.9549 63.9648 64.9018 63.5736C64.8487 63.1823 64.6876 62.8133 64.4363 62.5072L60.5949 58.6969L64.3931 54.9079C64.6876 54.6145 64.89 54.2428 64.9758 53.8376Z",
      fill: "currentColor"
    })]
  })
});

var DelayedFlight = /*#__PURE__*/createIcon({
  displayName: "DelayedFlight",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM51.0748 48.2101C49.419 49.4428 48.1292 51.1171 47.3473 53.0488L47.3895 53.081C46.6638 54.8539 46.3923 56.7857 46.6005 58.6949C46.8087 60.6041 47.4897 62.4281 48.5796 63.9955L46.0729 63.3516L40.7541 64.7146C40.4017 64.8079 40.0282 64.7698 39.7009 64.6072C39.3827 64.4575 39.1257 64.1995 38.9742 63.8775C38.8164 63.5434 38.7791 63.1635 38.8688 62.8042C38.9542 62.4592 39.1554 62.1554 39.4376 61.9457L42.4182 59.6597V49.7862L30.443 53.5854C30.0066 53.7273 29.5342 53.7006 29.1159 53.5102C28.6965 53.3253 28.3589 52.9889 28.168 52.5658C27.978 52.1371 27.9481 51.6525 28.0838 51.2028C28.2129 50.7574 28.4976 50.3756 28.8842 50.1296L42.4182 41.5439V31.6704C42.421 30.696 42.8028 29.7624 43.48 29.0744C44.1572 28.3864 45.0745 28 46.0308 28C46.9856 28.0037 47.9008 28.3891 48.5796 29.0732C48.914 29.4144 49.1791 29.8194 49.3598 30.265C49.5405 30.7107 49.6333 31.1882 49.6328 31.6704V41.5439L56.7316 46.0621C54.688 46.2341 52.7305 46.9774 51.0748 48.2101ZM64.041 51.9111C64.599 52.5773 65.0536 53.3265 65.3892 54.1327L65.3681 54.2293C65.8399 55.3947 66.052 56.6524 65.9892 57.9115C65.9264 59.1705 65.5902 60.3997 65.0048 61.5104C64.4194 62.6211 63.5994 63.5856 62.604 64.3344C61.6086 65.0831 60.4626 65.5975 59.2485 65.8404C58.0344 66.0832 56.7826 66.0486 55.5832 65.7389C54.3839 65.4293 53.2669 64.8523 52.3129 64.0496C51.3588 63.2469 50.5914 62.2385 50.0661 61.097C49.5407 59.9556 49.2705 58.7096 49.2748 57.4489C49.2728 56.6239 49.3899 55.803 49.6223 55.0127C50.1035 53.3153 51.0942 51.8141 52.4555 50.7199C54.1589 49.3426 56.3222 48.6966 58.4856 48.919C60.6491 49.1415 62.6421 50.2149 64.041 51.9111ZM60.7128 62.1281C61.6506 61.5114 62.3846 60.6214 62.8193 59.5739H62.7561C63.1499 58.6002 63.2718 57.5345 63.1082 56.4947C62.9446 55.4549 62.502 54.4814 61.8293 53.6819C61.7435 53.5767 61.6521 53.4764 61.5554 53.3814C60.8662 52.6765 60.0066 52.1694 59.0635 51.9113C58.1204 51.6531 57.1271 51.6531 56.184 51.9111C55.9424 51.9685 55.7062 52.0475 55.4783 52.1473C54.4574 52.5758 53.5847 53.3043 52.9716 54.24C52.2556 55.3341 51.9337 56.6472 52.0607 57.9559C52.1878 59.2646 52.756 60.488 53.6686 61.4179C54.5812 62.3478 55.7818 62.9268 57.0661 63.0563C58.3504 63.1857 59.6391 62.8578 60.7128 62.1281ZM59.9229 58.5973L58.7538 57.3953L59.7333 55.5279V55.4635C59.8599 55.2152 59.8864 54.9264 59.8071 54.6586C59.7706 54.5259 59.7079 54.4022 59.6228 54.2951C59.5377 54.1881 59.4319 54.0999 59.312 54.0361C59.0705 53.9121 58.7915 53.8875 58.5327 53.9674C58.2738 54.0473 58.0551 54.2256 57.9218 54.4654L57.8586 54.5834L56.5421 57.0948C56.4347 57.2904 56.3974 57.5181 56.4367 57.7387C56.4686 57.9609 56.568 58.1674 56.7211 58.3289L58.4379 60.0783C58.6287 60.2505 58.8784 60.3392 59.133 60.3251C59.3969 60.3186 59.6487 60.2113 59.8387 60.0246C60.0219 59.8311 60.1272 59.5744 60.1336 59.3056C60.1408 59.1202 60.0931 58.937 59.9966 58.7797C59.979 58.7162 59.9543 58.655 59.9229 58.5973Z",
      fill: "currentColor"
    })]
  })
});

var Documents = /*#__PURE__*/createIcon({
  displayName: "Documents",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM31.9906 29.0159C32.6214 28.3689 33.4762 28.0042 34.3684 28.0014H52.8936C53.1203 27.9921 53.3465 28.03 53.5586 28.1126C53.7707 28.1952 53.9643 28.3209 54.1279 28.4822C54.2914 28.6434 54.4216 28.8369 54.5104 29.0509C54.5993 29.265 54.6451 29.4953 54.6451 29.7279C54.6451 29.9606 54.5993 30.1909 54.5104 30.405C54.4216 30.619 54.2914 30.8125 54.1279 30.9737C53.9643 31.135 53.7707 31.2607 53.5586 31.3433C53.3465 31.4259 53.1203 31.4638 52.8936 31.4545H34.3684V53.9098C34.3773 54.1423 34.3404 54.3742 34.2599 54.5917C34.1793 54.8092 34.0568 55.0078 33.8995 55.1756C33.7423 55.3433 33.5537 55.4768 33.345 55.568C33.1362 55.6591 32.9117 55.7061 32.6848 55.7061C32.458 55.7061 32.2334 55.6591 32.0247 55.568C31.816 55.4768 31.6273 55.3433 31.4701 55.1756C31.3129 55.0078 31.1904 54.8092 31.1098 54.5917C31.0292 54.3742 30.9923 54.1423 31.0013 53.9098V31.4545C31.0041 30.5396 31.3597 29.6629 31.9906 29.0159ZM38.7273 35.925C39.3581 35.278 40.2129 34.9133 41.1051 34.9104H53.1841C53.6257 34.9109 54.0629 35.0006 54.4707 35.1744C54.8785 35.3482 55.249 35.6027 55.5608 35.9234L62.0123 42.54C62.6428 43.1866 62.9979 44.063 63 44.9775V62.5468C62.9972 63.4622 62.6412 64.3393 62.0098 64.9864C61.3784 65.6334 60.5229 65.9979 59.6303 66H41.1051C40.2129 65.9971 39.3581 65.6324 38.7273 64.9854C38.0964 64.3384 37.7408 63.4618 37.738 62.5468V38.3636C37.7408 37.4487 38.0964 36.572 38.7273 35.925ZM54.5785 48.7232H46.1596C45.9329 48.714 45.7067 48.7518 45.4946 48.8345C45.2825 48.9171 45.0889 49.0428 44.9253 49.204C44.7618 49.3652 44.6316 49.5587 44.5427 49.7728C44.4539 49.9868 44.408 50.2171 44.408 50.4498C44.408 50.6825 44.4539 50.9128 44.5427 51.1268C44.6316 51.3409 44.7618 51.5344 44.9253 51.6956C45.0889 51.8568 45.2825 51.9825 45.4946 52.0652C45.7067 52.1478 45.9329 52.1856 46.1596 52.1764H54.5785C54.8052 52.1856 55.0313 52.1478 55.2434 52.0652C55.4555 51.9825 55.6491 51.8568 55.8127 51.6956C55.9763 51.5344 56.1064 51.3409 56.1953 51.1268C56.2842 50.9128 56.33 50.6825 56.33 50.4498C56.33 50.2171 56.2842 49.9868 56.1953 49.7728C56.1064 49.5587 55.9763 49.3652 55.8127 49.204C55.6491 49.0428 55.4555 48.9171 55.2434 48.8345C55.0313 48.7518 54.8052 48.714 54.5785 48.7232ZM54.5785 55.6323H46.1596C45.9329 55.6231 45.7067 55.6609 45.4946 55.7435C45.2825 55.8262 45.0889 55.9519 44.9253 56.1131C44.7618 56.2743 44.6316 56.4678 44.5427 56.6819C44.4539 56.8959 44.408 57.1262 44.408 57.3589C44.408 57.5916 44.4539 57.8218 44.5427 58.0359C44.6316 58.25 44.7618 58.4434 44.9253 58.6047C45.0889 58.7659 45.2825 58.8916 45.4946 58.9742C45.7067 59.0569 45.9329 59.0947 46.1596 59.0855H54.5785C54.8052 59.0947 55.0313 59.0569 55.2434 58.9742C55.4555 58.8916 55.6491 58.7659 55.8127 58.6047C55.9763 58.4434 56.1064 58.25 56.1953 58.0359C56.2842 57.8218 56.33 57.5916 56.33 57.3589C56.33 57.1262 56.2842 56.8959 56.1953 56.6819C56.1064 56.4678 55.9763 56.2743 55.8127 56.1131C55.6491 55.9519 55.4555 55.8262 55.2434 55.7435C55.0313 55.6609 54.8052 55.6231 54.5785 55.6323Z",
      fill: "currentColor"
    })]
  })
});

var Error = /*#__PURE__*/createIcon({
  displayName: "Error",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM35.1565 36.2458C35.462 35.4934 36.1928 35.0011 37.0046 35.0009C37.5433 35.0009 38.0591 35.2188 38.4348 35.6051L47 44.1734L55.5652 35.6051C55.9266 35.233 56.4185 35.0163 56.9369 35.0009C57.7595 34.9766 58.5126 35.46 58.8333 36.2181C59.154 36.9763 58.9766 37.8536 58.3865 38.4274L49.8213 46.9957L58.3865 55.564C58.9077 56.0646 59.1177 56.8079 58.9354 57.5074C58.7531 58.2068 58.2071 58.7531 57.5079 58.9354C56.8087 59.1177 56.0656 58.9077 55.5652 58.3863L47 49.818L38.4348 58.3863C37.9344 58.9077 37.1913 59.1177 36.4921 58.9354C35.7929 58.753 35.2469 58.2068 35.0646 57.5074C34.8823 56.8079 35.0923 56.0646 35.6135 55.564L44.1787 46.9957L35.6135 38.4274C35.0317 37.861 34.851 36.9983 35.1565 36.2458Z",
      fill: "currentColor"
    })]
  })
});

var Gift = /*#__PURE__*/createIcon({
  displayName: "Gift",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM27 35C27 32.794 28.794 31 31 31H41V37.3672C40.372 37.1432 39.704 37 39 37C35.692 37 33 39.692 33 43C33 43.704 33.1432 44.372 33.3672 45H27V35ZM45 37.3672V31H63C65.206 31 67 32.794 67 35V45H52.6328C52.8568 44.372 53 43.704 53 43C53 39.692 50.308 37 47 37C46.296 37 45.628 37.1432 45 37.3672ZM37 43C37 41.898 37.898 41 39 41C40.102 41 41 41.898 41 43V45H39C37.898 45 37 44.102 37 43ZM45 43C45 41.898 45.898 41 47 41C48.102 41 49 41.898 49 43C49 44.102 48.102 45 47 45H45V43ZM27 59V49H38.1719L35.5859 51.5859C34.8059 52.3659 34.8059 53.6341 35.5859 54.4141C36.3659 55.1941 37.6341 55.1941 38.4141 54.4141L41 51.8281V63H31C28.79 63 27 61.21 27 59ZM50.4141 51.5859L47.8281 49H67V59C67 61.21 65.21 63 63 63H45V51.8281L47.5859 54.4141C48.3659 55.1941 49.6341 55.1941 50.4141 54.4141C51.1941 53.6341 51.1941 52.3659 50.4141 51.5859Z",
      fill: "currentColor"
    })]
  })
});

var ID = /*#__PURE__*/createIcon({
  displayName: "ID",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM31 63C28.8 63 27 61.2 27 59V35C27 32.79 28.79 31 31 31H63C65.2 31 67 32.8 67 35V59C67 61.2 65.2 63 63 63H31ZM43 43C43 40.79 41.21 39 39 39C36.79 39 35 40.79 35 43C35 45.21 36.79 47 39 47C41.21 47 43 45.21 43 43ZM39 50.2C36.998 50.2 33 51.204 33 53.2V55H45V53.2C45 51.204 41.002 50.2 39 50.2ZM51 45H59C60.104 45 61 44.104 61 43C61 41.896 60.104 41 59 41H51C49.896 41 49 41.896 49 43C49 44.104 49.896 45 51 45ZM51 53H59C60.104 53 61 52.104 61 51C61 49.896 60.104 49 59 49H51C49.896 49 49 49.896 49 51C49 52.104 49.896 53 51 53Z",
      fill: "currentColor"
    })]
  })
});

var ImageDrop = /*#__PURE__*/createIcon({
  displayName: "ImageDrop",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM37.6851 46.8102L45.8867 54.5102C46.1845 54.7865 46.5757 54.94 46.9819 54.94C47.3881 54.94 47.7793 54.7865 48.0771 54.5102L56.2387 46.8102C56.3463 46.695 56.4221 46.5537 56.4587 46.4002C56.4877 46.2453 56.4703 46.0853 56.4087 45.9402C56.353 45.7924 56.2513 45.6662 56.1187 45.5802C55.9856 45.4906 55.8291 45.4419 55.6686 45.4402H50.1775V32.6202C50.1773 32.4078 50.1366 32.1974 50.0575 32.0002C49.9851 31.8033 49.8688 31.6255 49.7174 31.4802C49.5709 31.3258 49.3939 31.2034 49.1976 31.1208C49.0014 31.0381 48.7901 30.9971 48.5772 31.0002H45.3866C44.9622 31.0002 44.5551 31.1688 44.255 31.4689C43.9549 31.7689 43.7863 32.1759 43.7863 32.6002V45.4002H38.1952C38.0922 45.4 37.9901 45.4204 37.8951 45.4602C37.796 45.4951 37.7068 45.5534 37.6351 45.6302C37.5555 45.7016 37.4938 45.7906 37.4551 45.8902C37.4152 45.9852 37.3948 46.0872 37.395 46.1902C37.3952 46.2964 37.4165 46.4015 37.4577 46.4994C37.499 46.5972 37.5592 46.6859 37.6351 46.7602L37.6851 46.8102ZM62.88 60.8102C62.8041 60.6122 62.6883 60.4318 62.5399 60.2802C62.396 60.1294 62.2223 60.0102 62.0298 59.9302C61.837 59.8471 61.6296 59.8029 61.4197 59.8002H32.6141C32.2987 59.7995 31.99 59.8914 31.7263 60.0645C31.4627 60.2376 31.2557 60.4844 31.131 60.7741C31.0064 61.0638 30.9696 61.3837 31.0252 61.6941C31.0808 62.0045 31.2264 62.2918 31.4439 62.5202C31.7406 62.8199 32.1425 62.9921 32.5641 63.0002H61.3697C61.5811 62.9987 61.7907 62.9615 61.9898 62.8902C62.1816 62.8079 62.3575 62.6929 62.5099 62.5502C62.6608 62.4005 62.7829 62.2242 62.87 62.0302C62.9485 61.836 62.9925 61.6296 63 61.4202C63.0008 61.211 62.96 61.0036 62.88 60.8102Z",
      fill: "currentColor"
    })]
  })
});

var Lounge = /*#__PURE__*/createIcon({
  displayName: "Lounge",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83 47C83 66.8823 66.8823 83 47 83C27.1177 83 11 66.8823 11 47C11 27.1177 27.1177 11 47 11C66.8823 11 83 27.1177 83 47ZM42.2499 48.1875V49.3749H51.7499V48.1875C51.7499 43.6044 55.4782 39.875 60.0624 39.875C60.3511 39.875 60.6407 39.9018 60.9301 39.9315C59.8882 35.8165 56.184 32.75 51.7499 32.75H42.2499C37.8157 32.75 34.1116 35.8166 33.0697 39.9315C33.359 39.9018 33.6486 39.875 33.9374 39.875C38.5215 39.875 42.2499 43.6044 42.2499 48.1875ZM61.6599 42.4583C63.6125 42.9677 65.2156 44.5437 65.761 46.4864C66.329 48.5102 65.8432 50.4124 64.7419 51.8147C64.054 52.6909 63.6249 53.7382 63.6249 54.8519V58.8749H58.8749V61.2499H54.1249V58.8749H39.8749V61.2499H35.125V58.8749H30.375V54.8519C30.375 53.7382 29.9458 52.6909 29.258 51.8147C28.1568 50.4124 27.671 48.5101 28.239 46.4863C28.7844 44.5436 30.3875 42.9676 32.34 42.4583C36.3076 41.4231 39.875 44.3885 39.875 48.1874V51.75H54.1249V48.1875C54.1249 44.3886 57.6924 41.4231 61.6599 42.4583ZM32.75 48.1875C32.75 48.8433 33.2816 49.375 33.9374 49.375C34.5932 49.375 35.1249 48.8432 35.1249 48.1875C35.1249 47.5316 34.5932 47 33.9374 47C33.2816 47 32.75 47.5316 32.75 48.1875ZM58.875 48.1875C58.875 48.8433 59.4066 49.375 60.0624 49.375C60.7182 49.375 61.2499 48.8432 61.2499 48.1875C61.2499 47.5316 60.7182 47 60.0624 47C59.4066 47 58.875 47.5316 58.875 48.1875Z",
      fill: "currentColor"
    })]
  })
});

var NoFee = /*#__PURE__*/createIcon({
  displayName: "NoFee",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM36.9867 34.7477C39.7179 32.5121 43.2048 31.1667 47 31.1667C55.7305 31.1667 62.8333 38.2695 62.8333 47C62.8333 50.7952 61.4879 54.2806 59.2523 57.0103L45.2775 43.0386C45.2823 42.7837 45.3101 42.5382 45.3703 42.3149C45.4352 42.0664 45.5401 41.8507 45.6826 41.6686C45.8235 41.4865 46.0022 41.3402 46.2207 41.2357C46.4376 41.1312 46.6991 41.0811 47.0031 41.0811C47.5604 41.0811 48.0034 41.3114 48.3359 41.7738C48.4975 41.998 48.6236 42.3597 48.7151 42.6223C48.7322 42.6712 48.748 42.7167 48.7627 42.7572C49.0129 43.4412 49.4738 43.8333 50.1419 43.8333C51.103 43.8333 51.5954 43.1811 51.5954 42.3768C51.5954 42.1187 51.5345 41.8606 51.4933 41.7181C51.3128 41.0927 51.0495 40.5939 50.7202 40.1348C50.3925 39.6772 49.9906 39.305 49.5203 39.0184C49.2306 38.8411 48.9143 38.7131 48.5833 38.6102V37.5C48.5833 36.626 47.874 35.9167 47 35.9167C46.126 35.9167 45.4167 36.626 45.4167 37.5V38.6071C45.1649 38.6847 44.9256 38.7775 44.6992 38.8947C44.2131 39.148 43.7936 39.4759 43.4437 39.8812C43.2363 40.1203 43.0684 40.3909 42.918 40.679L36.9867 34.7477ZM31.1667 47C31.1667 43.2048 32.5121 39.7179 34.7477 36.9867L48.8276 51.0697C48.8276 51.0784 48.8292 51.0856 48.8307 51.0929C48.8323 51.1001 48.8338 51.1073 48.8338 51.1161C48.8338 51.4026 48.794 51.6685 48.7132 51.9139C48.6325 52.1577 48.5145 52.372 48.3514 52.5509C48.1915 52.7299 47.989 52.8671 47.7515 52.9684C47.5124 53.0698 47.2347 53.12 46.9196 53.12C46.6441 53.12 46.3738 53.0772 46.1094 52.987C45.845 52.8967 45.6071 52.7417 45.3981 52.52C45.1907 52.2984 45.033 52.0261 44.9095 51.6572C44.9095 51.6572 44.8458 51.4161 44.792 51.215C44.6289 50.5959 44.064 50.1667 43.3942 50.1667C42.5883 50.1667 41.9331 50.8204 41.9315 51.6263C41.9315 51.6516 41.9342 51.6967 41.9361 51.7267C41.937 51.7418 41.9377 51.753 41.9377 51.7562C41.9614 52.0729 42.0653 52.3917 42.1603 52.653C42.4026 53.3228 42.7276 53.8751 43.1313 54.3136C43.5351 54.7538 43.9958 55.089 44.5168 55.3218C44.8097 55.4532 45.1111 55.5519 45.4167 55.631V56.5C45.4167 57.374 46.126 58.0833 47 58.0833C47.874 58.0833 48.5833 57.374 48.5833 56.5V55.6001C48.8652 55.5225 49.134 55.4205 49.3874 55.297C49.8798 55.0564 50.2992 54.7389 50.6491 54.3415C50.8771 54.0834 51.0597 53.7815 51.2212 53.4601L57.0133 59.2523C54.2821 61.4879 50.7952 62.8333 47 62.8333C38.2695 62.8333 31.1667 55.7305 31.1667 47Z",
      fill: "currentColor"
    })]
  })
});

var PlaneTickets = /*#__PURE__*/createIcon({
  displayName: "PlaneTickets",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM61.8995 62.7437C61.4869 62.913 61.0446 63.0002 60.5979 63.0002H33.3994C32.9529 63.0002 32.5107 62.913 32.0982 62.7436C31.6857 62.5742 31.311 62.326 30.9954 62.013C30.6797 61.7001 30.4295 61.3286 30.2588 60.9197C30.0882 60.5109 30.0006 60.0728 30.0009 59.6304V56.0123C29.9895 55.6683 30.0859 55.3293 30.2768 55.0418C30.4677 54.7543 30.7438 54.5324 31.0671 54.4066C31.7438 54.1831 32.3322 53.7541 32.749 53.1805C33.1657 52.6069 33.3895 51.9178 33.3887 51.2111C33.3901 50.5039 33.1665 49.8143 32.7497 49.2402C32.333 48.6661 31.7442 48.2367 31.0671 48.013C30.7438 47.8872 30.4677 47.6653 30.2768 47.3778C30.0859 47.0903 29.9895 46.7512 30.0009 46.4073V42.7892C30.0009 42.3462 30.0892 41.9074 30.2606 41.4982C30.4321 41.089 30.6834 40.7173 31.0001 40.4045C31.3168 40.0917 31.6927 39.8439 32.1062 39.6753C32.5198 39.5067 32.9629 39.4207 33.4101 39.4221H60.5979C61.0445 39.4217 61.4867 39.5085 61.8993 39.6776C62.3119 39.8467 62.6869 40.0946 63.0028 40.4073C63.3186 40.72 63.5692 41.0914 63.7401 41.5001C63.9111 41.9088 63.9991 42.3468 63.9991 42.7892V46.4073C64.0105 46.7512 63.9141 47.0903 63.7232 47.3778C63.5323 47.6653 63.2562 47.8872 62.9329 48.013C62.2557 48.2366 61.6668 48.6657 61.2494 49.2395C60.832 49.8132 60.6075 50.5026 60.6075 51.2098C60.6075 51.917 60.832 52.6063 61.2494 53.1801C61.6668 53.7538 62.2557 54.1829 62.9329 54.4066C63.2562 54.5324 63.5323 54.7543 63.7232 55.0418C63.9141 55.3293 64.0105 55.6683 63.9991 56.0123V59.6304C63.9991 60.0729 63.9111 60.5111 63.7402 60.9199C63.5693 61.3288 63.3187 61.7003 63.0029 62.0132C62.6871 62.3261 62.3122 62.5743 61.8995 62.7437ZM61.5682 34.3964L61.992 36.0628L34.932 36.0522L56.0666 31.119C56.4159 31.037 56.7739 30.9971 57.1328 31.0002C58.1481 30.9967 59.1355 31.3289 59.9389 31.944C60.7422 32.5591 61.3156 33.4221 61.5682 34.3964Z",
      fill: "currentColor"
    })]
  })
});

var Receipt = /*#__PURE__*/createIcon({
  displayName: "Receipt",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM57.6667 30.8C58.648 30.8 59.4444 29.9936 59.4444 29H61.2222C62.2036 29 63 29.8064 63 30.8V63.2C63 64.1936 62.2036 65 61.2222 65H59.4444C59.4444 64.0064 58.648 63.2 57.6667 63.2C56.6853 63.2 55.8889 64.0064 55.8889 65H52.3333C52.3333 64.0064 51.5369 63.2 50.5556 63.2C49.5742 63.2 48.7778 64.0064 48.7778 65H45.2222C45.2222 64.0064 44.4258 63.2 43.4444 63.2C42.4631 63.2 41.6667 64.0064 41.6667 65H38.1111C38.1111 64.0064 37.3147 63.2 36.3333 63.2C35.352 63.2 34.5556 64.0064 34.5556 65H32.7778C31.7964 65 31 64.1936 31 63.2V30.8C31 29.8064 31.7964 29 32.7778 29H34.5556C34.5556 29.9936 35.352 30.8 36.3333 30.8C37.3147 30.8 38.1111 29.9936 38.1111 29H41.6667C41.6667 29.9936 42.4631 30.8 43.4444 30.8C44.4258 30.8 45.2222 29.9936 45.2222 29H48.7778C48.7778 29.9936 49.5742 30.8 50.5556 30.8C51.5369 30.8 52.3333 29.9936 52.3333 29H55.8889C55.8889 29.9936 56.6853 30.8 57.6667 30.8ZM36.3333 54.2C36.3333 55.1936 37.1298 56 38.1111 56H55.8889C56.8702 56 57.6667 55.1936 57.6667 54.2C57.6667 53.2064 56.8702 52.4 55.8889 52.4H38.1111C37.1298 52.4 36.3333 53.2064 36.3333 54.2ZM36.3333 47C36.3333 47.9936 37.1298 48.8 38.1111 48.8H55.8889C56.8702 48.8 57.6667 47.9936 57.6667 47C57.6667 46.0064 56.8702 45.2 55.8889 45.2H38.1111C37.1298 45.2 36.3333 46.0064 36.3333 47ZM36.3333 39.8C36.3333 40.7936 37.1298 41.6 38.1111 41.6H55.8889C56.8702 41.6 57.6667 40.7936 57.6667 39.8C57.6667 38.8064 56.8702 38 55.8889 38H38.1111C37.1298 38 36.3333 38.8064 36.3333 39.8Z",
      fill: "currentColor"
    })]
  })
});

var Signature = /*#__PURE__*/createIcon({
  displayName: "Signature",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM33.5699 34.5C34.3448 32.6653 36.2627 31 38.822 31C41.446 31 43.3697 32.7254 44.2301 34.566C45.0905 36.4065 45.2533 38.3859 45.225 39.9201V39.9236C45.1599 43.4348 44.2174 47.2548 42.2263 50.3645C42.1726 50.4484 42.0955 50.5128 42.0183 50.5773C41.9463 50.6375 41.8741 50.6978 41.8207 50.7742C43.0043 51.6971 44.1933 52.3332 45.225 52.3332C46.421 52.3332 47.6715 51.688 48.8304 50.8228C47.777 49.0774 47 47.1712 47 45.2221C47 44.0838 47.2093 42.8916 47.8944 41.8194C48.5796 40.7472 49.9284 39.8888 51.434 39.8888C52.9395 39.8888 54.2941 40.7476 54.9804 41.8194C55.6667 42.8912 55.8748 44.0826 55.8748 45.2221C55.8748 47.3061 54.8763 49.2864 53.5279 51.0659C54.3789 51.8054 55.2395 52.3332 55.8748 52.3332C57.0013 52.3332 57.1488 52.0339 57.3606 51.6041C57.3713 51.5824 57.3821 51.5604 57.3933 51.5381C57.6253 51.0732 57.6498 50.5554 57.6498 50.5554C57.6564 50.0883 57.8463 49.6425 58.1785 49.3145C58.5106 48.9865 58.9583 48.8026 59.4248 48.8026C59.8912 48.8026 60.3389 48.9865 60.6711 49.3145C61.0033 49.6425 61.1932 50.0883 61.1998 50.5554C61.1998 50.5554 61.2153 51.2843 61.3696 51.9027C61.4272 52.1333 61.4925 52.26 61.539 52.3501L61.5464 52.3645C61.9816 52.4477 62.37 52.6909 62.6352 53.0463C62.9005 53.4017 63.0235 53.8436 62.9801 54.2852C62.9366 54.7268 62.7299 55.1361 62.4005 55.4329C62.0711 55.7296 61.6428 55.8922 61.1998 55.8888C60.2949 55.8888 59.5733 55.3274 59.0608 54.7811C58.2287 55.408 57.1959 55.8888 55.8748 55.8888C53.9464 55.8888 52.3924 54.8423 51.0387 53.552C49.3646 54.8577 47.4535 55.8888 45.225 55.8888C43.0068 55.8888 41.0916 54.7517 39.3489 53.2672C37.5358 54.7555 35.4401 55.8888 32.8002 55.8888C32.565 55.8921 32.3315 55.8486 32.1133 55.7607C31.895 55.6729 31.6963 55.5424 31.5288 55.377C31.3613 55.2116 31.2283 55.0145 31.1375 54.7972C31.0468 54.5798 31 54.3466 31 54.111C31 53.8754 31.0468 53.6421 31.1375 53.4248C31.2283 53.2074 31.3613 53.0103 31.5288 52.8449C31.6963 52.6795 31.895 52.5491 32.1133 52.4613C32.3315 52.3734 32.565 52.3299 32.8002 52.3332C34.4541 52.3332 35.7651 51.7391 36.9222 50.8679C36.8775 50.8096 36.8235 50.7637 36.7695 50.7179C36.7127 50.6697 36.6559 50.6216 36.6102 50.5589C34.4191 47.5578 32.9328 43.7383 32.8002 39.9513C32.7428 38.3096 32.795 36.3346 33.5699 34.5ZM41.0164 36.0764C40.5301 35.036 40.1153 34.5555 38.822 34.5555C37.5012 34.5555 37.2445 34.9254 36.839 35.8854C36.4335 36.8454 36.3011 38.4245 36.3502 39.8263C36.4488 42.6444 37.651 45.7939 39.342 48.2048C40.7936 45.8271 41.6223 42.6699 41.6751 39.8576C41.6965 38.6931 41.5028 37.1167 41.0164 36.0764ZM51.9546 43.6767C51.8246 43.4698 51.8086 43.4444 51.434 43.4444C51.0646 43.4444 51.049 43.4694 50.9254 43.6681C50.9125 43.6888 50.8985 43.7114 50.8827 43.736C50.7159 43.9972 50.5499 44.5827 50.5499 45.2221C50.5499 45.6864 50.8303 46.2577 51.1222 46.8523C51.2651 47.1434 51.4107 47.4401 51.5276 47.7325C52.0076 46.7998 52.3249 45.8965 52.3249 45.2221C52.3249 44.5839 52.1596 43.9976 51.9921 43.736C51.9785 43.7148 51.9661 43.695 51.9546 43.6767ZM32.1133 59.5723C32.3315 59.4845 32.565 59.441 32.8002 59.4443H61.1998C61.435 59.441 61.6685 59.4845 61.8867 59.5723C62.105 59.6602 62.3037 59.7906 62.4712 59.956C62.6387 60.1214 62.7717 60.3185 62.8625 60.5359C62.9533 60.7532 63 60.9865 63 61.2221C63 61.4577 62.9533 61.6909 62.8625 61.9082C62.7717 62.1256 62.6387 62.3227 62.4712 62.4881C62.3037 62.6535 62.105 62.7839 61.8867 62.8718C61.6685 62.9596 61.435 63.0032 61.1998 62.9998H32.8002C32.565 63.0032 32.3315 62.9596 32.1133 62.8718C31.895 62.7839 31.6963 62.6535 31.5288 62.4881C31.3613 62.3227 31.2283 62.1256 31.1375 61.9082C31.0468 61.6909 31 61.4577 31 61.2221C31 60.9865 31.0468 60.7532 31.1375 60.5359C31.2283 60.3185 31.3613 60.1214 31.5288 59.956C31.6963 59.7906 31.895 59.6602 32.1133 59.5723Z",
      fill: "currentColor"
    })]
  })
});

var TechnicalSupport = /*#__PURE__*/createIcon({
  displayName: "TechnicalSupport",
  viewBox: "0 0 96 96",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("rect", {
      opacity: "0",
      width: "96",
      height: "96",
      fill: "white",
      fillOpacity: "0"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM46.3017 31.1953C46.7628 31.1655 47.2183 31.1584 47.6686 31.1767C54.4218 31.4524 59.8126 37.0134 59.8126 43.8341V47.0008C61.5543 47.0008 62.9793 48.4258 62.9793 50.1675V53.3341C62.9793 55.0758 61.5543 56.5008 59.8126 56.5008H58.2293H47.9376C47.8808 56.5007 47.824 56.4977 47.7675 56.4915C46.5263 56.4024 45.5643 55.3702 45.5626 54.1258C45.5626 53.4959 45.8128 52.8918 46.2582 52.4464C46.7036 52.001 47.3077 51.7508 47.9376 51.7508C48.9429 51.7522 49.8384 52.3863 50.1734 53.3341H56.6459V48.5841C56.6459 46.8345 55.2289 45.4175 53.4793 45.4175H40.8126C39.063 45.4175 37.6459 46.8345 37.6459 48.5841V50.1675C37.6459 55.4146 41.8988 59.6675 47.1459 59.6675H50.3126C51.1866 59.6675 51.8959 60.3768 51.8959 61.2508C51.8959 62.1248 51.1866 62.8341 50.3126 62.8341H36.3347C34.4838 62.8341 33.0269 61.2554 33.1774 59.4108L34.5102 43.1229L34.5318 43.1507C35.0573 36.8836 39.9444 31.6079 46.3017 31.1953Z",
      fill: "currentColor"
    })]
  })
});

var index$1 = {
  __proto__: null,
  CanceledFlight: CanceledFlight,
  DelayedFlight: DelayedFlight,
  Documents: Documents,
  Error: Error,
  Gift: Gift,
  ID: ID,
  ImageDrop: ImageDrop,
  Lounge: Lounge,
  NoFee: NoFee,
  PlaneTickets: PlaneTickets,
  Receipt: Receipt,
  Signature: Signature,
  TechnicalSupport: TechnicalSupport
};

var Airhelp = /*#__PURE__*/createIcon({
  displayName: "Airhelp",
  viewBox: "0 0 94 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M89.3909 10.8515H82.8654C82.6243 10.8519 82.3867 10.7941 82.1727 10.6832C81.9587 10.5722 81.7746 10.4113 81.636 10.2141C81.4974 10.0169 81.4083 9.78924 81.3763 9.55032C81.3444 9.31139 81.3705 9.06829 81.4524 8.84159L84.243 1.2646C84.3789 0.89579 84.6241 0.577207 84.9458 0.351362C85.2675 0.125516 85.6504 0.00314918 86.0434 0.000590284C86.4365 -0.00196861 86.821 0.115402 87.1456 0.33704C87.4702 0.558678 87.7195 0.874041 87.8602 1.24105L90.7826 8.81804C90.8705 9.04429 90.9019 9.28855 90.874 9.52967C90.8462 9.77078 90.76 10.0015 90.6229 10.2018C90.4859 10.4021 90.302 10.5659 90.0873 10.6791C89.8726 10.7923 89.6336 10.8515 89.3909 10.8515Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M89.3697 2.78943C89.0843 2.79129 88.8029 2.85601 88.5454 2.979L90.7826 8.80628C90.8706 9.03272 90.9019 9.27719 90.874 9.51849C90.846 9.75979 90.7596 9.99063 90.6223 10.191C90.4849 10.3913 90.3008 10.5551 90.0858 10.6682C89.8708 10.7813 89.6314 10.8401 89.3885 10.8398H85.0519L84.7681 11.6204C84.6853 11.847 84.6585 12.0904 84.6901 12.3296C84.7217 12.5688 84.8107 12.7968 84.9495 12.9942C85.0883 13.1915 85.2729 13.3523 85.4873 13.4629C85.7018 13.5735 85.9398 13.6305 86.1811 13.6292H92.7066C92.9494 13.6295 93.1885 13.5706 93.4034 13.4576C93.6183 13.3446 93.8024 13.1809 93.9397 12.9807C94.077 12.7805 94.1635 12.5499 94.1915 12.3087C94.2196 12.0676 94.1884 11.8233 94.1007 11.5969L91.1759 4.0187C91.0299 3.65834 90.7804 3.34928 90.459 3.13051C90.1375 2.91174 89.7585 2.79306 89.3697 2.78943Z",
      fill: "#FF6B73"
    }), /*#__PURE__*/jsx("path", {
      d: "M88.5455 2.979C88.0885 3.1967 87.733 3.58215 87.5529 4.05521L85.0578 10.8398H89.3968C89.639 10.8388 89.8773 10.7789 90.0912 10.6653C90.3052 10.5517 90.4882 10.3877 90.6246 10.1876C90.761 9.98743 90.8467 9.7571 90.8742 9.51645C90.9018 9.2758 90.8703 9.03207 90.7826 8.80628L88.5455 2.979Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.2351 24.1028H4.65806L3.45233 27.5786H0L6.22997 10.178H10.7338L16.9638 27.5786H13.4055L12.2351 24.1028ZM11.253 21.2545L10.5678 19.2445C9.81183 17.0344 9.01939 14.8596 8.44008 12.8262C7.85135 14.8596 7.06951 17.0933 6.3124 19.2916L5.65184 21.2545H11.253Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.3108 11.7029C18.3059 11.3276 18.4127 10.9593 18.6177 10.6448C18.8226 10.3304 19.1165 10.084 19.4618 9.93707C19.8072 9.79009 20.1885 9.74914 20.5571 9.81943C20.9258 9.88972 21.2653 10.0681 21.5324 10.3318C21.7994 10.5955 21.982 10.9327 22.0569 11.3005C22.1318 11.6683 22.0957 12.0501 21.953 12.3972C21.8104 12.7444 21.5677 13.0413 21.2559 13.2502C20.944 13.4591 20.5771 13.5705 20.2018 13.5703C19.9547 13.5731 19.7094 13.5269 19.4803 13.4343C19.2511 13.3418 19.0426 13.2047 18.8667 13.031C18.6909 12.8574 18.5512 12.6506 18.4558 12.4226C18.3604 12.1946 18.3111 11.95 18.3108 11.7029ZM21.7984 27.5786H18.604V15.048H21.7961L21.7984 27.5786Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M32.1884 15.2729L31.6208 18.0388C31.1019 17.8879 30.5657 17.8044 30.0254 17.7904C28.3345 17.7904 27.2831 19.1386 27.2831 21.3958V27.5786H24.0909V15.048H27.0582V16.8919C27.6469 15.6862 28.6536 14.9067 30.1914 14.9067C30.8885 14.9067 31.4207 15.0598 32.1884 15.2729Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M48.3126 27.5786H44.885V19.8827H37.1067V27.5786H33.6755V10.178H37.1043V16.9991H44.885V10.178H48.3126V27.5786Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M60.4405 23.5599L62.2255 25.5216C60.3934 27.389 58.6672 27.9684 56.6349 27.9684C52.5915 27.9684 50.0623 25.3685 50.0623 21.3745C50.0623 17.4972 52.4172 14.6371 56.3629 14.6371C60.1815 14.6371 62.2255 17.0368 62.2255 20.8906C62.2255 21.2804 62.202 21.8714 62.1784 22.1434H53.1826C53.4546 23.952 54.5308 25.2755 56.715 25.2755C58.1951 25.2731 58.9746 24.7892 60.4405 23.5599ZM53.265 19.8591H59.1288C59.0111 18.193 58.029 17.1404 56.2805 17.1404C54.5897 17.1404 53.6088 18.2401 53.265 19.8591Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M67.4511 27.5786H64.272V10.178H67.4511V27.5786Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M82.1872 21.3121C82.1872 25.3791 79.811 27.9319 76.6189 27.9319C74.9293 27.9319 73.7 27.3431 72.8722 26.2893V31.9988H69.6848V15.0598H72.6497V16.7082C73.4892 15.4542 74.7774 14.6983 76.6448 14.6983C79.8322 14.6936 82.1872 17.2581 82.1872 21.3121ZM78.9479 21.3121C78.9479 18.9572 77.7893 17.4347 75.9101 17.4347C74.0662 17.4347 72.7415 18.9007 72.7415 21.3121C72.7415 23.7589 74.1133 25.166 75.8748 25.166C77.6998 25.1554 78.9527 23.6894 78.9527 21.3121H78.9479Z",
      fill: "#0D3073"
    })]
  })
});

var AirhelpSolid = /*#__PURE__*/createIcon({
  displayName: "AirhelpSolid",
  viewBox: "0 0 94 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M89.2034 10.8519H82.6919C81.6538 10.8519 80.9342 9.81159 81.2881 8.84225L84.072 1.26487C84.3551 0.508309 85.0747 0 85.8769 0C86.679 0 87.3868 0.49649 87.6817 1.24123L90.5954 8.81861C90.9728 9.79977 90.2533 10.8519 89.2034 10.8519Z",
      fill: "white",
      fillOpacity: "0.6"
    }), /*#__PURE__*/jsx("path", {
      d: "M89.1798 2.78979C88.8848 2.78979 88.6017 2.86072 88.354 2.97893L90.5953 8.80679C90.9728 9.78795 90.2532 10.84 89.2034 10.84H84.8741L84.591 11.6202C84.2371 12.6014 84.9567 13.6298 85.9948 13.6298H92.5063C93.5562 13.6298 94.2757 12.5777 93.8983 11.5966L90.9846 4.0192C90.6897 3.28629 89.9701 2.78979 89.1798 2.78979Z",
      fill: "white",
      fillOpacity: "0.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M88.354 2.97893C87.9058 3.19172 87.552 3.57006 87.3632 4.05473L84.8741 10.84H89.2034C90.2532 10.84 90.9728 9.78795 90.5953 8.80679L88.354 2.97893Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.2091 24.1034H4.64773L3.44451 27.5789H0L6.21664 10.1781H10.711L16.9277 27.5789H13.377L12.2091 24.1034ZM11.2301 21.2545L10.5459 19.2449C9.7909 17.0344 9.00055 14.8593 8.42253 12.826C7.83272 14.8593 7.05417 17.0935 6.2992 19.2922L5.63862 21.2545H11.2301Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.2724 11.703C18.2724 10.6746 19.0982 9.83527 20.1598 9.83527C21.2215 9.83527 22.0472 10.6628 22.0472 11.703C22.0472 12.7315 21.2097 13.5708 20.1598 13.5708C19.11 13.5708 18.2724 12.7315 18.2724 11.703ZM21.7523 27.5789H18.5673V15.0484H21.7523V27.5789Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M32.1212 15.273L31.555 18.0391C30.8944 17.8618 30.3754 17.7909 29.9625 17.7909C28.2756 17.7909 27.2257 19.1385 27.2257 21.3963V27.5788H24.0408V15.0484H27.0016V16.8925C27.5914 15.6867 28.5941 14.9065 30.1276 14.9065C30.8236 14.9065 31.3544 15.0602 32.1212 15.273Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M48.2113 27.5788H44.7904V19.8832H37.0284V27.5788H33.6075V10.178H37.0284V16.9989H44.7904V10.178H48.2113V27.5788Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M60.3144 23.5596L62.0956 25.5219C60.2672 27.3897 58.5449 27.9689 56.516 27.9689C52.4817 27.9689 49.9572 25.3682 49.9572 21.3727C49.9572 17.4953 52.3047 14.6346 56.2447 14.6346C60.0549 14.6346 62.0956 17.0343 62.0956 20.888C62.0956 21.2781 62.072 21.8692 62.0484 22.141H53.0715C53.3428 23.9497 54.4162 25.2737 56.5985 25.2737C58.0731 25.2737 58.8516 24.789 60.3144 23.5596ZM53.154 19.8596H59.005C58.887 18.1928 57.9079 17.1407 56.1621 17.1407C54.4752 17.1407 53.4961 18.24 53.154 19.8596Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M67.3095 27.5788H64.1363V10.178H67.3095V27.5788Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M82.0194 21.3137C82.0194 25.3801 79.6484 27.9335 76.4634 27.9335C74.7765 27.9335 73.5497 27.3425 72.724 26.2904V32H69.539V15.0602H72.4999V16.7034C73.3374 15.4503 74.6232 14.6938 76.487 14.6938C79.6602 14.6938 82.0194 17.259 82.0194 21.3137ZM78.7873 21.3137C78.7873 18.9612 77.6312 17.4363 75.7556 17.4363C73.9154 17.4363 72.5942 18.9021 72.5942 21.3137C72.5942 23.7606 73.9626 25.1674 75.7202 25.1674C77.5369 25.1555 78.7873 23.6897 78.7873 21.3137Z",
      fill: "white"
    })]
  })
});

var AirhelpPlus = /*#__PURE__*/createIcon({
  displayName: "AirhelpPlus",
  viewBox: "0 0 149 32",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M101.92 11.5642C102.974 12.5693 103.501 13.9039 103.501 15.568C103.501 17.2321 102.974 18.5667 101.92 19.5717C100.882 20.5768 99.4811 21.0793 97.7181 21.0793H92.7258V27.5792H89.2658V10.0319H97.7181C99.4811 10.0319 100.882 10.5427 101.92 11.5642ZM97.1003 12.8988H92.7258V18.2124H97.1003C98.0229 18.2124 98.7479 17.9818 99.2751 17.5204C99.8024 17.0591 100.066 16.4083 100.066 15.568C100.066 14.7277 99.8024 14.0769 99.2751 13.6155C98.7644 13.1377 98.0394 12.8988 97.1003 12.8988Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M108.979 10.0319V27.5792H105.766V10.0319H108.979Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M119.756 14.9501H122.969V27.5792H120.028V26.2446C119.319 27.398 118.083 27.9747 116.32 27.9747C114.854 27.9747 113.742 27.6204 112.984 26.9119C112.226 26.2035 111.847 25.2231 111.847 23.9709V14.9501H115.06V23.0812C115.06 23.7402 115.241 24.2592 115.604 24.6382C115.966 25.0007 116.485 25.1819 117.161 25.1819C117.968 25.1819 118.602 24.9595 119.064 24.5146C119.525 24.0533 119.756 23.4025 119.756 22.5622V14.9501Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M136.079 16.5071L134.348 18.6079C133.624 18.0312 132.981 17.644 132.421 17.4463C131.877 17.2321 131.259 17.125 130.567 17.125C129.925 17.125 129.406 17.2403 129.01 17.471C128.631 17.7017 128.442 18.0065 128.442 18.3854C128.442 18.6491 128.532 18.855 128.714 19.0033C128.994 19.2175 129.883 19.4893 131.383 19.8189C133.212 20.2308 134.48 20.7168 135.189 21.277C135.914 21.8372 136.276 22.694 136.276 23.8473C136.276 25.0995 135.79 26.1046 134.818 26.8625C133.846 27.6039 132.528 27.9747 130.864 27.9747C129.645 27.9747 128.565 27.7934 127.626 27.4309C126.703 27.0685 125.748 26.4506 124.759 25.5774L126.613 23.5013C127.519 24.2428 128.277 24.7453 128.887 25.0089C129.513 25.2561 130.196 25.3796 130.938 25.3796C131.597 25.3796 132.124 25.2643 132.52 25.0336C132.932 24.803 133.137 24.4734 133.137 24.0451C133.137 23.6991 133.014 23.4437 132.767 23.2789C132.503 23.0647 132.207 22.9247 131.877 22.8588C131.531 22.7599 130.913 22.6116 130.023 22.4139C128.228 22.0185 127 21.5489 126.341 21.0052C125.698 20.445 125.377 19.6047 125.377 18.4843C125.377 17.3639 125.847 16.4247 126.786 15.6668C127.741 14.9089 129.027 14.53 130.641 14.53C131.745 14.53 132.709 14.6783 133.533 14.9748C134.357 15.2714 135.205 15.7822 136.079 16.5071Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.7389 21.1958L11.0216 19.174C10.2295 16.954 9.41133 14.7593 8.79487 12.7122C8.18215 14.7593 7.36393 17.0045 6.57187 19.2245L5.88068 21.1994H11.7389V21.1958ZM12.7627 24.0573H4.86072L3.60911 27.5603H0L6.49715 10.0454H11.2047L17.7018 27.5603H13.9918L12.7627 24.0573Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M22.7346 27.5602H19.4094V14.9537H22.7346V27.5602ZM19.1031 11.5769C19.1031 10.539 19.9736 9.70288 21.072 9.70288C22.1704 9.70288 23.041 10.5426 23.041 11.5769C23.041 12.6112 22.1704 13.4509 21.072 13.4509C19.9736 13.4509 19.1031 12.6112 19.1031 11.5769Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M33.5762 15.1771L32.9896 17.9665C32.2984 17.7935 31.7604 17.7215 31.327 17.7215C29.5635 17.7215 28.4614 19.0765 28.4614 21.347V27.5637H25.1362V14.9573H28.2297V16.8061C28.8425 15.5988 29.8923 14.8095 31.5026 14.8095C32.2199 14.8059 32.7841 14.9573 33.5762 15.1771Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M50.4045 27.5603H46.8253V19.8155H38.7179V27.5603H35.1386V10.0454H38.7179V16.9036H46.8253V10.0454H50.4045V27.5603Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M55.5715 19.7901H61.6839C61.5568 18.1143 60.5331 17.0512 58.7174 17.0512C56.9502 17.0512 55.9302 18.1612 55.5715 19.7901ZM63.0625 23.5166L64.9306 25.4915C63.0139 27.3655 61.2206 27.9602 59.0984 27.9602C54.8803 27.9602 52.2464 25.3437 52.2464 21.3254C52.2464 17.426 54.701 14.5429 58.8182 14.5429C62.8084 14.5429 64.9306 16.9611 64.9306 20.8353C64.9306 21.2317 64.9044 21.8227 64.8783 22.093H55.4931C55.7733 23.9166 56.8979 25.25 59.1769 25.25C60.7125 25.2428 61.5307 24.7491 63.0625 23.5166Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M70.3776 10.0454H67.0524V27.5603H70.3776V10.0454Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M82.3708 21.246C82.3708 18.8782 81.1677 17.3502 79.1988 17.3502C77.2821 17.3502 75.8998 18.8314 75.8998 21.246C75.8998 23.7147 77.3307 25.1202 79.1726 25.1202C81.0668 25.1202 82.3708 23.639 82.3708 21.246ZM85.7482 21.246C85.7482 25.34 83.2674 27.906 79.9423 27.906C78.1788 27.906 76.8973 27.3149 76.0305 26.2518V32H72.7054V14.9536H75.7989V16.6078C76.6694 15.35 78.0219 14.586 79.9684 14.586C83.2936 14.586 85.7482 17.1772 85.7482 21.246Z",
      fill: "#0D3073"
    }), /*#__PURE__*/jsx("path", {
      d: "M144.203 10.7217H137.756C136.729 10.7217 136.016 9.69388 136.367 8.73617L139.123 1.24969C139.403 0.502211 140.116 0 140.91 0C141.704 0 142.405 0.490534 142.697 1.22633L145.582 8.71281C145.955 9.6822 145.243 10.7217 144.203 10.7217Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M144.18 2.75633C143.888 2.75633 143.608 2.82641 143.362 2.9432L145.582 8.70114C145.955 9.67053 145.243 10.71 144.203 10.71H139.917L139.637 11.4808C139.286 12.4502 139.999 13.4663 141.027 13.4663H147.474C148.513 13.4663 149.226 12.4269 148.852 11.4575L145.967 3.97099C145.675 3.24687 144.963 2.75633 144.18 2.75633Z",
      fill: "#FF6B73"
    }), /*#__PURE__*/jsx("path", {
      d: "M143.362 2.9432C142.919 3.15343 142.568 3.52715 142.381 4.00601L139.917 10.71H144.203C145.243 10.71 145.955 9.67053 145.582 8.70114L143.362 2.9432Z",
      fill: "#0D3073"
    })]
  })
});

var AirhelpPlusSolid = /*#__PURE__*/createIcon({
  displayName: "AirhelpPlusSolid",
  viewBox: "0 0 149 33",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M101.918 11.779C102.972 12.7841 103.5 14.1187 103.5 15.7828C103.5 17.4469 102.972 18.7815 101.918 19.7865C100.88 20.7916 99.4794 21.2941 97.7165 21.2941H92.7243V27.794H89.2643V10.2467H97.7165C99.4794 10.2467 100.88 10.7575 101.918 11.779ZM97.0986 13.1136H92.7243V18.4272H97.0986C98.0213 18.4272 98.7463 18.1965 99.2735 17.7352C99.8007 17.2739 100.064 16.6231 100.064 15.7828C100.064 14.9425 99.8007 14.2917 99.2735 13.8303C98.7627 13.3525 98.0378 13.1136 97.0986 13.1136Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M108.977 10.2467V27.794H105.764V10.2467H108.977Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M119.754 15.1649H122.967V27.794H120.026V26.4594C119.317 27.6128 118.081 28.1894 116.318 28.1894C114.852 28.1894 113.74 27.8352 112.982 27.1267C112.224 26.4182 111.845 25.4379 111.845 24.1857V15.1649H115.058V23.296C115.058 23.955 115.239 24.474 115.602 24.853C115.964 25.2155 116.483 25.3967 117.159 25.3967C117.966 25.3967 118.6 25.1743 119.062 24.7294C119.523 24.2681 119.754 23.6173 119.754 22.777V15.1649Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M136.076 16.7219L134.346 18.8226C133.621 18.246 132.979 17.8588 132.419 17.6611C131.875 17.4469 131.257 17.3398 130.565 17.3398C129.922 17.3398 129.403 17.4551 129.008 17.6858C128.629 17.9164 128.44 18.2213 128.44 18.6002C128.44 18.8638 128.53 19.0698 128.711 19.2181C128.992 19.4323 129.881 19.7041 131.381 20.0337C133.209 20.4456 134.478 20.9316 135.187 21.4918C135.911 22.052 136.274 22.9088 136.274 24.0621C136.274 25.3143 135.788 26.3194 134.816 27.0773C133.844 27.8187 132.526 28.1894 130.862 28.1894C129.642 28.1894 128.563 28.0082 127.624 27.6457C126.701 27.2832 125.746 26.6654 124.757 25.7921L126.611 23.7161C127.517 24.4576 128.275 24.9601 128.884 25.2237C129.511 25.4708 130.194 25.5944 130.936 25.5944C131.595 25.5944 132.122 25.4791 132.517 25.2484C132.929 25.0177 133.135 24.6882 133.135 24.2598C133.135 23.9138 133.012 23.6585 132.765 23.4937C132.501 23.2795 132.204 23.1394 131.875 23.0735C131.529 22.9747 130.911 22.8264 130.021 22.6287C128.225 22.2332 126.998 21.7637 126.339 21.22C125.696 20.6598 125.375 19.8195 125.375 18.6991C125.375 17.5787 125.845 16.6395 126.784 15.8816C127.739 15.1237 129.025 14.7448 130.639 14.7448C131.743 14.7448 132.707 14.893 133.531 15.1896C134.355 15.4862 135.203 15.997 136.076 16.7219Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M11.7388 21.4106L11.0214 19.3888C10.2294 17.1688 9.41118 14.974 8.79473 12.927C8.18201 14.974 7.36381 17.2193 6.57176 19.4393L5.88059 21.4142H11.7388V21.4106ZM12.7624 24.2721H4.86064L3.60905 27.7751H0L6.49704 10.2602H11.2045L17.7015 27.7751H13.9916L12.7624 24.2721Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M22.7342 27.7749H19.4091V15.1685H22.7342V27.7749ZM19.1027 11.7917C19.1027 10.7538 19.9732 9.91766 21.0717 9.91766C22.1701 9.91766 23.0406 10.7574 23.0406 11.7917C23.0406 12.826 22.1701 13.6657 21.0717 13.6657C19.9732 13.6657 19.1027 12.826 19.1027 11.7917Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M33.5756 15.3919L32.989 18.1813C32.2979 18.0083 31.7599 17.9362 31.3265 17.9362C29.563 17.9362 28.4609 19.2913 28.4609 21.5617V27.7785H25.1358V15.1721H28.2293V17.0208C28.842 15.8135 29.8918 15.0243 31.5021 15.0243C32.2194 15.0207 32.7835 15.1721 33.5756 15.3919Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M50.4037 27.7751H46.8245V20.0303H38.7172V27.7751H35.1381V10.2602H38.7172V17.1184H46.8245V10.2602H50.4037V27.7751Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M55.5706 20.0049H61.6828C61.5558 18.3291 60.5321 17.266 58.7164 17.266C56.9492 17.266 55.9293 18.376 55.5706 20.0049ZM63.0614 23.7314L64.9295 25.7063C63.0129 27.5803 61.2196 28.1749 59.0975 28.1749C54.8794 28.1749 52.2455 25.5585 52.2455 21.5402C52.2455 17.6408 54.7001 14.7577 58.8173 14.7577C62.8074 14.7577 64.9295 17.1759 64.9295 21.0501C64.9295 21.4465 64.9033 22.0375 64.8772 22.3078H55.4922C55.7724 24.1314 56.8969 25.4648 59.1759 25.4648C60.7114 25.4576 61.5297 24.9639 63.0614 23.7314Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M70.3764 10.2602H67.0513V27.7751H70.3764V10.2602Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M82.3694 21.4608C82.3694 19.093 81.1664 17.565 79.1975 17.565C77.2809 17.565 75.8985 19.0462 75.8985 21.4608C75.8985 23.9294 77.3294 25.335 79.1713 25.335C81.0655 25.335 82.3694 23.8538 82.3694 21.4608ZM85.7468 21.4608C85.7468 25.5548 83.2661 28.1208 79.9409 28.1208C78.1775 28.1208 76.896 27.5297 76.0293 26.4666V32.2148H72.7042V15.1684H75.7976V16.8226C76.6681 15.5648 78.0206 14.8008 79.9671 14.8008C83.2922 14.8008 85.7468 17.392 85.7468 21.4608Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      d: "M144.201 10.9365H137.754C136.726 10.9365 136.014 9.90867 136.364 8.95096L139.121 1.46447C139.401 0.716994 140.113 0.214783 140.907 0.214783C141.702 0.214783 142.402 0.705317 142.694 1.44112L145.579 8.9276C145.953 9.89699 145.24 10.9365 144.201 10.9365Z",
      fill: "white",
      fillOpacity: "0.6"
    }), /*#__PURE__*/jsx("path", {
      d: "M144.178 2.97112C143.886 2.97112 143.605 3.04119 143.36 3.15799L145.579 8.91592C145.953 9.88531 145.24 10.9248 144.201 10.9248H139.915L139.634 11.6956C139.284 12.665 139.996 13.6811 141.024 13.6811H147.471C148.511 13.6811 149.223 12.6416 148.849 11.6723L145.965 4.18577C145.673 3.46165 144.96 2.97112 144.178 2.97112Z",
      fill: "white",
      fillOpacity: "0.5"
    }), /*#__PURE__*/jsx("path", {
      d: "M143.36 3.15799C142.916 3.36822 142.566 3.74193 142.379 4.22079L139.915 10.9248H144.201C145.24 10.9248 145.953 9.88531 145.579 8.91592L143.36 3.15799Z",
      fill: "white"
    })]
  })
});

var APRA = /*#__PURE__*/createIcon({
  displayName: "APRA",
  viewBox: "0 0 164 40",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M0 30.4096L21.0894 0H31.5853L22.6495 30.4096H0Z",
      fill: "#4D98FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M47.7631 30.4096H29.533L22.3082 4.78377H30.7085L47.7631 30.4096Z",
      fill: "#0D73FF"
    }), /*#__PURE__*/jsx("path", {
      d: "M30.1788 4.78328L26.1623 18.4508L22.3069 4.78328H30.1788Z",
      fill: "#004D91"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.4158 24.7287H69.4818L71.2607 30.4096H79.1503L67.8914 0H60.9853L49.8101 30.4096H57.6579L59.4158 24.7287ZM67.5507 19.1341H61.0686L64.2993 8.54203L67.5507 19.1341ZM88.5118 20.0921V30.4096H81.1973V0H93.3048C95.6249 0 97.6775 0.428153 99.4627 1.28447C101.248 2.14079 102.63 3.35911 103.61 4.93947C104.589 6.51983 105.079 8.3125 105.079 10.3175C105.079 13.2833 104.02 15.6538 101.901 17.4291C99.7822 19.2044 96.8752 20.0921 93.1797 20.0921H88.5118ZM93.1878 14.6923H88.3618V5.80855H93.2717C94.6007 5.82265 95.6498 6.25978 96.4192 7.11995C97.1885 7.98012 97.5732 9.12935 97.5732 10.5677C97.5732 11.8791 97.199 12.8944 96.4506 13.6135C95.7022 14.3327 94.6146 14.6923 93.1878 14.6923ZM120.151 19.6743H116.176V30.4096H108.832V0H120.821C124.433 0 127.258 0.800611 129.295 2.40186C131.331 4.0031 132.349 6.2657 132.349 9.18971C132.349 11.3061 131.92 13.0605 131.063 14.4529C130.205 15.8453 128.862 16.9731 127.035 17.8364L133.396 30.0963V30.4096H125.528L120.151 19.6743ZM120.993 14.3506H116.337V5.80855H120.993C122.377 5.80855 123.425 6.18938 124.138 6.95104C124.851 7.71271 125.208 8.76266 125.208 10.1009C125.208 11.4392 124.855 12.482 124.149 13.2294C123.443 13.9769 122.391 14.3506 120.993 14.3506ZM154.091 24.7287H144.025L142.267 30.4096H134.419L145.594 0H152.5L163.759 30.4096H155.87L154.091 24.7287ZM152.16 19.1341H145.677L148.908 8.54203L152.16 19.1341Z",
      fill: "#2C3B4C"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.49401 38.4825C7.49401 38.2585 7.43669 38.0893 7.32203 37.9748C7.20737 37.8603 6.99884 37.7414 6.69644 37.6181C6.14457 37.4092 5.74768 37.1645 5.50576 36.8839C5.26384 36.6033 5.14288 36.2717 5.14288 35.8892C5.14288 35.4261 5.30731 35.0543 5.63617 34.7737C5.96503 34.4931 6.38271 34.3528 6.88922 34.3528C7.2269 34.3528 7.52803 34.4239 7.79263 34.5661C8.05723 34.7083 8.26071 34.909 8.40309 35.1682C8.54547 35.4274 8.61666 35.7218 8.61666 36.0515H7.50913C7.50913 35.7948 7.45433 35.5992 7.34471 35.4645C7.23509 35.3299 7.07696 35.2626 6.87032 35.2626C6.67628 35.2626 6.52509 35.3198 6.41673 35.4343C6.30837 35.5488 6.25419 35.703 6.25419 35.8967C6.25419 36.0477 6.31467 36.1843 6.43563 36.3063C6.55659 36.4284 6.77078 36.5548 7.07822 36.6857C7.61498 36.8795 8.00494 37.1173 8.24812 37.3991C8.49129 37.681 8.61288 38.0396 8.61288 38.475C8.61288 38.9531 8.46042 39.3268 8.15551 39.5961C7.85059 39.8653 7.43606 40 6.9119 40C6.55658 40 6.23277 39.927 5.94045 39.781C5.64814 39.6351 5.41945 39.4262 5.25439 39.1544C5.08933 38.8826 5.00681 38.5618 5.00681 38.1918H6.12189C6.12189 38.5089 6.18363 38.7392 6.30711 38.8826C6.43059 39.0261 6.63218 39.0978 6.9119 39.0978C7.29998 39.0978 7.49401 38.8927 7.49401 38.4825ZM1.55358 38.7996H3.06934L3.36418 39.9245H4.55108L2.81986 34.4284H1.80306L0.0831775 39.9245H1.25874L1.55358 38.7996ZM1.7955 37.8748L2.30958 35.9156L2.82365 37.8748H1.7955ZM11.6069 37.9748C11.7216 38.0893 11.7789 38.2585 11.7789 38.4825C11.7789 38.8927 11.5848 39.0978 11.1968 39.0978C10.9171 39.0978 10.7155 39.0261 10.592 38.8826C10.4685 38.7392 10.4068 38.5089 10.4068 38.1918H9.29167C9.29167 38.5618 9.3742 38.8826 9.53926 39.1544C9.70432 39.4262 9.93301 39.6351 10.2253 39.781C10.5176 39.927 10.8415 40 11.1968 40C11.7209 40 12.1355 39.8653 12.4404 39.5961C12.7453 39.3268 12.8978 38.9531 12.8978 38.475C12.8978 38.0396 12.7762 37.681 12.533 37.3991C12.2898 37.1173 11.8998 36.8795 11.3631 36.6857C11.0557 36.5548 10.8415 36.4284 10.7205 36.3063C10.5995 36.1843 10.5391 36.0477 10.5391 35.8967C10.5391 35.703 10.5932 35.5488 10.7016 35.4343C10.81 35.3198 10.9612 35.2626 11.1552 35.2626C11.3618 35.2626 11.52 35.3299 11.6296 35.4645C11.7392 35.5992 11.794 35.7948 11.794 36.0515H12.9015C12.9015 35.7218 12.8303 35.4274 12.688 35.1682C12.5456 34.909 12.3421 34.7083 12.0775 34.5661C11.8129 34.4239 11.5118 34.3528 11.1741 34.3528C10.6676 34.3528 10.2499 34.4931 9.92104 34.7737C9.59218 35.0543 9.42775 35.4261 9.42775 35.8892C9.42775 36.2717 9.54871 36.6033 9.79063 36.8839C10.0325 37.1645 10.4294 37.4092 10.9813 37.6181C11.2837 37.7414 11.4922 37.8603 11.6069 37.9748ZM17.6135 37.6709C17.6135 38.4083 17.439 38.9808 17.09 39.3885C16.741 39.7961 16.2565 40 15.6366 40C15.0192 40 14.5341 39.798 14.1813 39.3941C13.8285 38.9902 13.6496 38.4246 13.6445 37.6973V36.7574C13.6445 36.0024 13.8197 35.4129 14.17 34.9889C14.5202 34.5649 15.0066 34.3528 15.629 34.3528C16.2414 34.3528 16.7239 34.5611 17.0767 34.9776C17.4295 35.3941 17.6085 35.9785 17.6135 36.731V37.6709ZM16.2867 35.6438C16.4278 35.8854 16.4984 36.2541 16.4984 36.7499V37.7049C16.4959 38.173 16.4241 38.5184 16.2829 38.7411C16.1418 38.9638 15.9264 39.0752 15.6366 39.0752C15.3367 39.0752 15.1149 38.9613 14.9713 38.7335C14.8277 38.5058 14.7558 38.1516 14.7558 37.6709V36.6932C14.7609 36.2176 14.834 35.8634 14.9751 35.6306C15.1162 35.3978 15.3342 35.2815 15.629 35.2815C15.9264 35.2815 16.1456 35.4022 16.2867 35.6438ZM22.2461 38.0937C22.2184 38.7203 22.042 39.1947 21.7169 39.5168C21.3918 39.8389 20.9332 40 20.341 40C19.7186 40 19.2417 39.7955 18.9103 39.3866C18.5789 38.9776 18.4132 38.3944 18.4132 37.6369V36.7121C18.4132 35.9571 18.5846 35.3752 18.9273 34.9662C19.27 34.5573 19.7463 34.3528 20.3561 34.3528C20.9559 34.3528 21.4114 34.5202 21.7226 34.8549C22.0338 35.1896 22.2108 35.6702 22.2537 36.2969H21.1386C21.1285 35.9093 21.0687 35.6419 20.959 35.4947C20.8494 35.3475 20.6485 35.2739 20.3561 35.2739C20.0588 35.2739 19.8484 35.3777 19.7249 35.5853C19.6014 35.7929 19.5359 36.1346 19.5283 36.6102V37.6483C19.5283 38.1944 19.5894 38.5693 19.7117 38.7732C19.8339 38.977 20.0437 39.0789 20.341 39.0789C20.6333 39.0789 20.8349 39.0078 20.9458 38.8657C21.0567 38.7235 21.1197 38.4661 21.1348 38.0937H22.2461ZM23.0836 39.9245H24.1949V34.4284H23.0836V39.9245ZM27.9279 38.7996H26.4121L26.1173 39.9245H24.9417L26.6616 34.4284H27.6784L29.4096 39.9245H28.2227L27.9279 38.7996ZM27.6822 37.8748H26.654L27.1681 35.9156L27.6822 37.8748ZM33.1388 35.3532H31.778V39.9245H30.663V35.3532H29.3249V34.4284H33.1388V35.3532ZM33.9309 39.9245H35.0423V34.4284H33.9309V39.9245ZM39.9546 37.6709C39.9546 38.4083 39.7801 38.9808 39.4311 39.3885C39.082 39.7961 38.5976 40 37.9777 40C37.3603 40 36.8752 39.798 36.5224 39.3941C36.1696 38.9902 35.9907 38.4246 35.9856 37.6973V36.7574C35.9856 36.0024 36.1608 35.4129 36.511 34.9889C36.8613 34.5649 37.3477 34.3528 37.9701 34.3528C38.5825 34.3528 39.065 34.5611 39.4178 34.9776C39.7706 35.3941 39.9495 35.9785 39.9546 36.731V37.6709ZM38.6279 35.6438C38.769 35.8854 38.8395 36.2541 38.8395 36.7499V37.7049C38.837 38.173 38.7652 38.5184 38.6241 38.7411C38.483 38.9638 38.2675 39.0752 37.9777 39.0752C37.6778 39.0752 37.4561 38.9613 37.3124 38.7335C37.1688 38.5058 37.097 38.1516 37.097 37.6709V36.6932C37.102 36.2176 37.1751 35.8634 37.3162 35.6306C37.4573 35.3978 37.6753 35.2815 37.9701 35.2815C38.2675 35.2815 38.4867 35.4022 38.6279 35.6438ZM44.7044 39.9245H43.593L41.9677 36.3195V39.9245H40.8564V34.4284H41.9677L43.5968 38.0371V34.4284H44.7044V39.9245ZM50.9399 39.3885C51.2889 38.9808 51.4634 38.4083 51.4634 37.6709V36.731C51.4584 35.9785 51.2795 35.3941 50.9267 34.9776C50.5739 34.5611 50.0913 34.3528 49.4789 34.3528C48.8565 34.3528 48.3702 34.5649 48.0199 34.9889C47.6696 35.4129 47.4945 36.0024 47.4945 36.7574V37.6973C47.4995 38.4246 47.6784 38.9902 48.0312 39.3941C48.384 39.798 48.8691 40 49.4865 40C50.1064 40 50.5909 39.7961 50.9399 39.3885ZM50.3484 36.7499C50.3484 36.2541 50.2778 35.8854 50.1367 35.6438C49.9956 35.4022 49.7763 35.2815 49.479 35.2815C49.1841 35.2815 48.9662 35.3978 48.8251 35.6306C48.6839 35.8634 48.6109 36.2176 48.6058 36.6932V37.6709C48.6058 38.1516 48.6776 38.5058 48.8213 38.7335C48.9649 38.9613 49.1867 39.0752 49.4865 39.0752C49.7763 39.0752 49.9918 38.9638 50.1329 38.7411C50.274 38.5184 50.3459 38.173 50.3484 37.7049V36.7499ZM53.4765 37.6823H55.2039V36.7612H53.4765V35.3532H55.4118V34.4284H52.3652V39.9245H53.4765V37.6823ZM59.1508 37.9918V39.9245H58.0395V34.4284H59.9143C60.4586 34.4284 60.8927 34.597 61.2165 34.9342C61.5403 35.2714 61.7022 35.7093 61.7022 36.2478C61.7022 36.7864 61.5422 37.2117 61.2222 37.5237C60.9021 37.8358 60.4586 37.9918 59.8916 37.9918H59.1508ZM59.9143 37.067H59.1507V35.3532H59.9256C60.1247 35.3557 60.2835 35.4381 60.4019 35.6004C60.5203 35.7627 60.5796 35.9811 60.5796 36.2554C60.5796 36.5196 60.5216 36.7209 60.4057 36.8593C60.2898 36.9977 60.126 37.067 59.9143 37.067ZM64.5016 38.7996H62.9858L62.691 39.9245H61.5154L63.2353 34.4284H64.2521L65.9833 39.9245H64.7964L64.5016 38.7996ZM64.2559 37.8748H63.2277L63.7418 35.9156L64.2559 37.8748ZM68.9262 38.4825C68.9262 38.2585 68.8689 38.0893 68.7542 37.9748C68.6396 37.8603 68.4311 37.7414 68.1287 37.6181C67.5768 37.4092 67.1799 37.1645 66.938 36.8839C66.6961 36.6033 66.5751 36.2717 66.5751 35.8892C66.5751 35.4261 66.7395 35.0543 67.0684 34.7737C67.3972 34.4931 67.8149 34.3528 68.3214 34.3528C68.6591 34.3528 68.9603 34.4239 69.2249 34.5661C69.4894 34.7083 69.6929 34.909 69.8353 35.1682C69.9777 35.4274 70.0489 35.7218 70.0489 36.0515H68.9414C68.9414 35.7948 68.8866 35.5992 68.7769 35.4645C68.6673 35.3299 68.5092 35.2626 68.3026 35.2626C68.1085 35.2626 67.9573 35.3198 67.849 35.4343C67.7406 35.5488 67.6864 35.703 67.6864 35.8967C67.6864 36.0477 67.7469 36.1843 67.8679 36.3063C67.9888 36.4284 68.203 36.5548 68.5104 36.6857C69.0472 36.8795 69.4372 37.1173 69.6803 37.3991C69.9235 37.681 70.0451 38.0396 70.0451 38.475C70.0451 38.9531 69.8927 39.3268 69.5877 39.5961C69.2828 39.8653 68.8683 40 68.3441 40C67.9888 40 67.665 39.927 67.3727 39.781C67.0804 39.6351 66.8517 39.4262 66.6866 39.1544C66.5216 38.8826 66.439 38.5618 66.439 38.1918H67.5541C67.5541 38.5089 67.6159 38.7392 67.7393 38.8826C67.8628 39.0261 68.0644 39.0978 68.3441 39.0978C68.7322 39.0978 68.9262 38.8927 68.9262 38.4825ZM73.0391 37.9748C73.1537 38.0893 73.2111 38.2585 73.2111 38.4825C73.2111 38.8927 73.017 39.0978 72.629 39.0978C72.3492 39.0978 72.1477 39.0261 72.0242 38.8826C71.9007 38.7392 71.839 38.5089 71.839 38.1918H70.7239C70.7239 38.5618 70.8064 38.8826 70.9715 39.1544C71.1365 39.4262 71.3652 39.6351 71.6575 39.781C71.9498 39.927 72.2736 40 72.629 40C73.1531 40 73.5676 39.8653 73.8726 39.5961C74.1775 39.3268 74.3299 38.9531 74.3299 38.475C74.3299 38.0396 74.2084 37.681 73.9652 37.3991C73.722 37.1173 73.332 36.8795 72.7953 36.6857C72.4878 36.5548 72.2737 36.4284 72.1527 36.3063C72.0317 36.1843 71.9713 36.0477 71.9713 35.8967C71.9713 35.703 72.0254 35.5488 72.1338 35.4343C72.2421 35.3198 72.3933 35.2626 72.5874 35.2626C72.794 35.2626 72.9522 35.3299 73.0618 35.4645C73.1714 35.5992 73.2262 35.7948 73.2262 36.0515H74.3337C74.3337 35.7218 74.2625 35.4274 74.1202 35.1682C73.9778 34.909 73.7743 34.7083 73.5097 34.5661C73.2451 34.4239 72.944 34.3528 72.6063 34.3528C72.0998 34.3528 71.6821 34.4931 71.3532 34.7737C71.0244 35.0543 70.8599 35.4261 70.8599 35.8892C70.8599 36.2717 70.9809 36.6033 71.2228 36.8839C71.4647 37.1645 71.8616 37.4092 72.4135 37.6181C72.7159 37.7414 72.9244 37.8603 73.0391 37.9748ZM78.0138 37.5464H76.2826V39.0035H78.3313V39.9245H75.1712V34.4284H78.3237V35.3532H76.2826V36.6517H78.0138V37.5464ZM81.811 39.9245H82.9223V34.4284H81.8148V38.0371L80.1856 34.4284H79.0743V39.9245H80.1856V36.3195L81.811 39.9245ZM87.6608 39.3016C87.4466 39.5332 87.1838 39.7074 86.8726 39.8245C86.5614 39.9415 86.2206 40 85.8502 40C85.2176 40 84.7262 39.8043 84.376 39.413C84.0257 39.0217 83.8455 38.4523 83.8354 37.7049V36.7159C83.8354 35.9584 84.0011 35.3752 84.3325 34.9662C84.6639 34.5573 85.1471 34.3528 85.7821 34.3528C86.3793 34.3528 86.8298 34.5001 87.1335 34.7945C87.4371 35.0889 87.6129 35.5507 87.6608 36.1799H86.5797C86.5494 35.8301 86.4764 35.5916 86.3605 35.4645C86.2445 35.3374 86.0631 35.2739 85.8161 35.2739C85.5163 35.2739 85.2983 35.3834 85.1622 35.6023C85.0261 35.8212 84.9556 36.1698 84.9505 36.6479V37.6445C84.9505 38.1453 85.0255 38.5096 85.1754 38.7373C85.3254 38.9651 85.5717 39.0789 85.9144 39.0789C86.1337 39.0789 86.3113 39.0349 86.4474 38.9468L86.5457 38.8789V37.871H85.767V37.033H87.6608V39.3016ZM89.6625 37.5464H91.3937V36.6517H89.6625V35.3532H91.7037V34.4284H88.5512V39.9245H91.7112V39.0035H89.6625V37.5464ZM94.1212 37.9163H93.5693V39.9245H92.458V34.4284H94.2308C94.7878 34.4284 95.218 34.5724 95.5217 34.8606C95.8253 35.1487 95.9772 35.5583 95.9772 36.0893C95.9772 36.8191 95.7113 37.3299 95.1796 37.6219L96.1435 39.8717V39.9245H94.949L94.1212 37.9163ZM94.2006 36.9915H93.5693V35.3532H94.2195C94.6504 35.3532 94.8658 35.6287 94.8658 36.1799C94.8658 36.4265 94.8104 36.6234 94.6995 36.7706C94.5886 36.9178 94.4223 36.9915 94.2006 36.9915ZM100.4 37.9163H99.8484V39.9245H98.737V34.4284H100.51C101.067 34.4284 101.497 34.5724 101.801 34.8606C102.104 35.1487 102.256 35.5583 102.256 36.0893C102.256 36.8191 101.99 37.3299 101.459 37.6219L102.423 39.8717V39.9245H101.228L100.4 37.9163ZM100.48 36.9915H99.8484V35.3532H100.499C100.929 35.3532 101.145 35.6287 101.145 36.1799C101.145 36.4265 101.089 36.6234 100.979 36.7706C100.868 36.9178 100.701 36.9915 100.48 36.9915ZM104.284 39.9245H103.173V34.4284H104.284V39.9245ZM108.276 39.8245C108.588 39.7074 108.85 39.5332 109.064 39.3016V37.033H107.171V37.871H107.949V38.8789L107.851 38.9468C107.715 39.0349 107.537 39.0789 107.318 39.0789C106.975 39.0789 106.729 38.9651 106.579 38.7373C106.429 38.5096 106.354 38.1453 106.354 37.6445V36.6479C106.359 36.1698 106.43 35.8212 106.566 35.6023C106.702 35.3834 106.92 35.2739 107.22 35.2739C107.467 35.2739 107.648 35.3374 107.764 35.4645C107.88 35.5916 107.953 35.8301 107.983 36.1799H109.064C109.017 35.5507 108.841 35.0889 108.537 34.7945C108.233 34.5001 107.783 34.3528 107.186 34.3528C106.551 34.3528 106.068 34.5573 105.736 34.9662C105.405 35.3752 105.239 35.9584 105.239 36.7159V37.7049C105.249 38.4523 105.429 39.0217 105.78 39.413C106.13 39.8043 106.621 40 107.254 40C107.624 40 107.965 39.9415 108.276 39.8245ZM113.814 39.9245H112.707V37.5728H111.066V39.9245H109.955V34.4284H111.066V36.6517H112.707V34.4284H113.814V39.9245ZM116.905 35.3532H118.265V34.4284H114.451V35.3532H115.789V39.9245H116.905V35.3532ZM121.273 38.4825C121.273 38.2585 121.215 38.0893 121.101 37.9748C120.986 37.8603 120.777 37.7414 120.475 37.6181C119.923 37.4092 119.526 37.1645 119.284 36.8839C119.042 36.6033 118.921 36.2717 118.921 35.8892C118.921 35.4261 119.086 35.0543 119.415 34.7737C119.744 34.4931 120.161 34.3528 120.668 34.3528C121.005 34.3528 121.307 34.4239 121.571 34.5661C121.836 34.7083 122.039 34.909 122.182 35.1682C122.324 35.4274 122.395 35.7218 122.395 36.0515H121.288C121.288 35.7948 121.233 35.5992 121.123 35.4645C121.014 35.3299 120.856 35.2626 120.649 35.2626C120.455 35.2626 120.304 35.3198 120.195 35.4343C120.087 35.5488 120.033 35.703 120.033 35.8967C120.033 36.0477 120.093 36.1843 120.214 36.3063C120.335 36.4284 120.549 36.5548 120.857 36.6857C121.394 36.8795 121.783 37.1173 122.027 37.3991C122.27 37.681 122.391 38.0396 122.391 38.475C122.391 38.9531 122.239 39.3268 121.934 39.5961C121.629 39.8653 121.215 40 120.69 40C120.335 40 120.011 39.927 119.719 39.781C119.427 39.6351 119.198 39.4262 119.033 39.1544C118.868 38.8826 118.785 38.5618 118.785 38.1918H119.9C119.9 38.5089 119.962 38.7392 120.086 38.8826C120.209 39.0261 120.411 39.0978 120.69 39.0978C121.079 39.0978 121.273 38.8927 121.273 38.4825ZM126.232 38.7996H127.748L128.043 39.9245H129.23L127.499 34.4284H126.482L124.762 39.9245H125.938L126.232 38.7996ZM126.474 37.8748H127.502L126.988 35.9156L126.474 37.8748ZM129.848 34.4284V39.9245H131.273C131.944 39.9245 132.47 39.7188 132.851 39.3073C133.233 38.8959 133.424 38.329 133.424 37.6068V36.7159C133.416 36.0062 133.222 35.4476 132.84 35.0399C132.458 34.6322 131.946 34.4284 131.303 34.4284H129.848ZM130.959 35.3532V39.0034H131.292C131.663 39.0034 131.923 38.9059 132.075 38.7109C132.226 38.5159 132.305 38.1793 132.313 37.7011V36.7461C132.313 36.2327 132.241 35.8747 132.097 35.6721C131.954 35.4696 131.709 35.3632 131.364 35.3532H130.959ZM136.96 34.4284L136.034 38.4146L135.112 34.4284H133.88L135.456 39.9245H136.613L138.2 34.4284H136.96ZM142.648 37.6709C142.648 38.4083 142.473 38.9808 142.124 39.3885C141.775 39.7961 141.291 40 140.671 40C140.053 40 139.568 39.798 139.215 39.3941C138.863 38.9902 138.684 38.4246 138.679 37.6973V36.7574C138.679 36.0024 138.854 35.4129 139.204 34.9889C139.554 34.5649 140.041 34.3528 140.663 34.3528C141.275 34.3528 141.758 34.5611 142.111 34.9776C142.464 35.3941 142.643 35.9785 142.648 36.731V37.6709ZM141.321 35.6438C141.462 35.8854 141.533 36.2541 141.533 36.7499V37.7049C141.53 38.173 141.458 38.5184 141.317 38.7411C141.176 38.9638 140.96 39.0752 140.671 39.0752C140.371 39.0752 140.149 38.9613 140.005 38.7335C139.862 38.5058 139.79 38.1516 139.79 37.6709V36.6932C139.795 36.2176 139.868 35.8634 140.009 35.6306C140.15 35.3978 140.368 35.2815 140.663 35.2815C140.96 35.2815 141.18 35.4022 141.321 35.6438ZM147.28 38.0937C147.252 38.7203 147.076 39.1947 146.751 39.5168C146.426 39.8389 145.967 40 145.375 40C144.753 40 144.276 39.7955 143.944 39.3866C143.613 38.9776 143.447 38.3944 143.447 37.6369V36.7121C143.447 35.9571 143.619 35.3752 143.961 34.9662C144.304 34.5573 144.78 34.3528 145.39 34.3528C145.99 34.3528 146.445 34.5202 146.757 34.8549C147.068 35.1896 147.245 35.6702 147.288 36.2969H146.173C146.163 35.9093 146.103 35.6419 145.993 35.4947C145.883 35.3475 145.683 35.2739 145.39 35.2739C145.093 35.2739 144.882 35.3777 144.759 35.5853C144.635 35.7929 144.57 36.1346 144.562 36.6102V37.6483C144.562 38.1944 144.624 38.5693 144.746 38.7732C144.868 38.977 145.078 39.0789 145.375 39.0789C145.667 39.0789 145.869 39.0078 145.98 38.8657C146.091 38.7235 146.154 38.4661 146.169 38.0937H147.28ZM149.18 38.7996H150.696L150.991 39.9245H152.177L150.446 34.4284H149.429L147.71 39.9245H148.885L149.18 38.7996ZM149.422 37.8748H150.45L149.936 35.9156L149.422 37.8748ZM154.546 35.3532H155.907V34.4284H152.093V35.3532H153.431V39.9245H154.546V35.3532ZM159.492 37.5464H157.761V39.0035H159.81V39.9245H156.65V34.4284H159.802V35.3532H157.761V36.6517H159.492V37.5464ZM162.705 37.9748C162.82 38.0893 162.877 38.2585 162.877 38.4825C162.877 38.8927 162.683 39.0978 162.295 39.0978C162.016 39.0978 161.814 39.0261 161.69 38.8826C161.567 38.7392 161.505 38.5089 161.505 38.1918H160.39C160.39 38.5618 160.473 38.8826 160.638 39.1544C160.803 39.4262 161.031 39.6351 161.324 39.781C161.616 39.927 161.94 40 162.295 40C162.819 40 163.234 39.8653 163.539 39.5961C163.844 39.3268 163.996 38.9531 163.996 38.475C163.996 38.0396 163.875 37.681 163.631 37.3991C163.388 37.1173 162.998 36.8795 162.462 36.6857C162.154 36.5548 161.94 36.4284 161.819 36.3063C161.698 36.1843 161.638 36.0477 161.638 35.8967C161.638 35.703 161.692 35.5488 161.8 35.4343C161.908 35.3198 162.06 35.2626 162.254 35.2626C162.46 35.2626 162.618 35.3299 162.728 35.4645C162.838 35.5992 162.892 35.7948 162.892 36.0515H164C164 35.7218 163.929 35.4274 163.786 35.1682C163.644 34.909 163.441 34.7083 163.176 34.5661C162.911 34.4239 162.61 34.3528 162.273 34.3528C161.766 34.3528 161.348 34.4931 161.02 34.7737C160.691 35.0543 160.526 35.4261 160.526 35.8892C160.526 36.2717 160.647 36.6033 160.889 36.8839C161.131 37.1645 161.528 37.4092 162.08 37.6181C162.382 37.7414 162.591 37.8603 162.705 37.9748Z",
      fill: "#2C3B4C"
    })]
  })
});

var APRASolid = /*#__PURE__*/createIcon({
  displayName: "APRASolid",
  viewBox: "0 0 164 40",
  path: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M0 30.4096L21.0894 0H31.5853L22.6495 30.4096H0Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M47.7631 30.4096H29.533L22.3082 4.78377H30.7085L47.7631 30.4096Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      d: "M30.1788 4.78328L26.1623 18.4508L22.3069 4.78328H30.1788Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.4158 24.7287H69.4818L71.2607 30.4096H79.1503L67.8914 0H60.9853L49.8101 30.4096H57.6579L59.4158 24.7287ZM67.5507 19.1341H61.0686L64.2993 8.54203L67.5507 19.1341ZM88.5118 20.0921V30.4096H81.1973V0H93.3048C95.6249 0 97.6775 0.428153 99.4627 1.28447C101.248 2.14079 102.63 3.35911 103.61 4.93947C104.589 6.51983 105.079 8.3125 105.079 10.3175C105.079 13.2833 104.02 15.6538 101.901 17.4291C99.7822 19.2044 96.8752 20.0921 93.1797 20.0921H88.5118ZM93.1878 14.6923H88.3618V5.80855H93.2717C94.6007 5.82265 95.6498 6.25978 96.4192 7.11995C97.1885 7.98012 97.5732 9.12935 97.5732 10.5677C97.5732 11.8791 97.199 12.8944 96.4506 13.6135C95.7022 14.3327 94.6146 14.6923 93.1878 14.6923ZM120.151 19.6743H116.176V30.4096H108.832V0H120.821C124.433 0 127.258 0.800611 129.295 2.40186C131.331 4.0031 132.349 6.2657 132.349 9.18971C132.349 11.3061 131.92 13.0605 131.063 14.4529C130.205 15.8453 128.862 16.9731 127.035 17.8364L133.396 30.0963V30.4096H125.528L120.151 19.6743ZM120.993 14.3506H116.337V5.80855H120.993C122.377 5.80855 123.425 6.18938 124.138 6.95104C124.851 7.71271 125.208 8.76266 125.208 10.1009C125.208 11.4392 124.855 12.482 124.149 13.2294C123.443 13.9769 122.391 14.3506 120.993 14.3506ZM154.091 24.7287H144.025L142.267 30.4096H134.419L145.594 0H152.5L163.759 30.4096H155.87L154.091 24.7287ZM152.16 19.1341H145.677L148.908 8.54203L152.16 19.1341Z",
      fill: "currentColor"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.49401 38.4825C7.49401 38.2585 7.43669 38.0893 7.32203 37.9748C7.20737 37.8603 6.99884 37.7414 6.69644 37.6181C6.14457 37.4092 5.74768 37.1645 5.50576 36.8839C5.26384 36.6033 5.14288 36.2717 5.14288 35.8892C5.14288 35.4261 5.30731 35.0543 5.63617 34.7737C5.96503 34.4931 6.38271 34.3528 6.88922 34.3528C7.2269 34.3528 7.52803 34.4239 7.79263 34.5661C8.05723 34.7083 8.26071 34.909 8.40309 35.1682C8.54547 35.4274 8.61666 35.7218 8.61666 36.0515H7.50913C7.50913 35.7948 7.45433 35.5992 7.34471 35.4645C7.23509 35.3299 7.07696 35.2626 6.87032 35.2626C6.67628 35.2626 6.52509 35.3198 6.41673 35.4343C6.30837 35.5488 6.25419 35.703 6.25419 35.8967C6.25419 36.0477 6.31467 36.1843 6.43563 36.3063C6.55659 36.4284 6.77078 36.5548 7.07822 36.6857C7.61498 36.8795 8.00494 37.1173 8.24812 37.3991C8.49129 37.681 8.61288 38.0396 8.61288 38.475C8.61288 38.9531 8.46042 39.3268 8.15551 39.5961C7.85059 39.8653 7.43606 40 6.9119 40C6.55658 40 6.23277 39.927 5.94045 39.781C5.64814 39.6351 5.41945 39.4262 5.25439 39.1544C5.08933 38.8826 5.00681 38.5618 5.00681 38.1918H6.12189C6.12189 38.5089 6.18363 38.7392 6.30711 38.8826C6.43059 39.0261 6.63218 39.0978 6.9119 39.0978C7.29998 39.0978 7.49401 38.8927 7.49401 38.4825ZM1.55358 38.7996H3.06934L3.36418 39.9245H4.55108L2.81986 34.4284H1.80306L0.0831775 39.9245H1.25874L1.55358 38.7996ZM1.7955 37.8748L2.30958 35.9156L2.82365 37.8748H1.7955ZM11.6069 37.9748C11.7216 38.0893 11.7789 38.2585 11.7789 38.4825C11.7789 38.8927 11.5848 39.0978 11.1968 39.0978C10.9171 39.0978 10.7155 39.0261 10.592 38.8826C10.4685 38.7392 10.4068 38.5089 10.4068 38.1918H9.29167C9.29167 38.5618 9.3742 38.8826 9.53926 39.1544C9.70432 39.4262 9.93301 39.6351 10.2253 39.781C10.5176 39.927 10.8415 40 11.1968 40C11.7209 40 12.1355 39.8653 12.4404 39.5961C12.7453 39.3268 12.8978 38.9531 12.8978 38.475C12.8978 38.0396 12.7762 37.681 12.533 37.3991C12.2898 37.1173 11.8998 36.8795 11.3631 36.6857C11.0557 36.5548 10.8415 36.4284 10.7205 36.3063C10.5995 36.1843 10.5391 36.0477 10.5391 35.8967C10.5391 35.703 10.5932 35.5488 10.7016 35.4343C10.81 35.3198 10.9612 35.2626 11.1552 35.2626C11.3618 35.2626 11.52 35.3299 11.6296 35.4645C11.7392 35.5992 11.794 35.7948 11.794 36.0515H12.9015C12.9015 35.7218 12.8303 35.4274 12.688 35.1682C12.5456 34.909 12.3421 34.7083 12.0775 34.5661C11.8129 34.4239 11.5118 34.3528 11.1741 34.3528C10.6676 34.3528 10.2499 34.4931 9.92104 34.7737C9.59218 35.0543 9.42775 35.4261 9.42775 35.8892C9.42775 36.2717 9.54871 36.6033 9.79063 36.8839C10.0325 37.1645 10.4294 37.4092 10.9813 37.6181C11.2837 37.7414 11.4922 37.8603 11.6069 37.9748ZM17.6135 37.6709C17.6135 38.4083 17.439 38.9808 17.09 39.3885C16.741 39.7961 16.2565 40 15.6366 40C15.0192 40 14.5341 39.798 14.1813 39.3941C13.8285 38.9902 13.6496 38.4246 13.6445 37.6973V36.7574C13.6445 36.0024 13.8197 35.4129 14.17 34.9889C14.5202 34.5649 15.0066 34.3528 15.629 34.3528C16.2414 34.3528 16.7239 34.5611 17.0767 34.9776C17.4295 35.3941 17.6085 35.9785 17.6135 36.731V37.6709ZM16.2867 35.6438C16.4278 35.8854 16.4984 36.2541 16.4984 36.7499V37.7049C16.4959 38.173 16.4241 38.5184 16.2829 38.7411C16.1418 38.9638 15.9264 39.0752 15.6366 39.0752C15.3367 39.0752 15.1149 38.9613 14.9713 38.7335C14.8277 38.5058 14.7558 38.1516 14.7558 37.6709V36.6932C14.7609 36.2176 14.834 35.8634 14.9751 35.6306C15.1162 35.3978 15.3342 35.2815 15.629 35.2815C15.9264 35.2815 16.1456 35.4022 16.2867 35.6438ZM22.2461 38.0937C22.2184 38.7203 22.042 39.1947 21.7169 39.5168C21.3918 39.8389 20.9332 40 20.341 40C19.7186 40 19.2417 39.7955 18.9103 39.3866C18.5789 38.9776 18.4132 38.3944 18.4132 37.6369V36.7121C18.4132 35.9571 18.5846 35.3752 18.9273 34.9662C19.27 34.5573 19.7463 34.3528 20.3561 34.3528C20.9559 34.3528 21.4114 34.5202 21.7226 34.8549C22.0338 35.1896 22.2108 35.6702 22.2537 36.2969H21.1386C21.1285 35.9093 21.0687 35.6419 20.959 35.4947C20.8494 35.3475 20.6485 35.2739 20.3561 35.2739C20.0588 35.2739 19.8484 35.3777 19.7249 35.5853C19.6014 35.7929 19.5359 36.1346 19.5283 36.6102V37.6483C19.5283 38.1944 19.5894 38.5693 19.7117 38.7732C19.8339 38.977 20.0437 39.0789 20.341 39.0789C20.6333 39.0789 20.8349 39.0078 20.9458 38.8657C21.0567 38.7235 21.1197 38.4661 21.1348 38.0937H22.2461ZM23.0836 39.9245H24.1949V34.4284H23.0836V39.9245ZM27.9279 38.7996H26.4121L26.1173 39.9245H24.9417L26.6616 34.4284H27.6784L29.4096 39.9245H28.2227L27.9279 38.7996ZM27.6822 37.8748H26.654L27.1681 35.9156L27.6822 37.8748ZM33.1388 35.3532H31.778V39.9245H30.663V35.3532H29.3249V34.4284H33.1388V35.3532ZM33.9309 39.9245H35.0423V34.4284H33.9309V39.9245ZM39.9546 37.6709C39.9546 38.4083 39.7801 38.9808 39.4311 39.3885C39.082 39.7961 38.5976 40 37.9777 40C37.3603 40 36.8752 39.798 36.5224 39.3941C36.1696 38.9902 35.9907 38.4246 35.9856 37.6973V36.7574C35.9856 36.0024 36.1608 35.4129 36.511 34.9889C36.8613 34.5649 37.3477 34.3528 37.9701 34.3528C38.5825 34.3528 39.065 34.5611 39.4178 34.9776C39.7706 35.3941 39.9495 35.9785 39.9546 36.731V37.6709ZM38.6279 35.6438C38.769 35.8854 38.8395 36.2541 38.8395 36.7499V37.7049C38.837 38.173 38.7652 38.5184 38.6241 38.7411C38.483 38.9638 38.2675 39.0752 37.9777 39.0752C37.6778 39.0752 37.4561 38.9613 37.3124 38.7335C37.1688 38.5058 37.097 38.1516 37.097 37.6709V36.6932C37.102 36.2176 37.1751 35.8634 37.3162 35.6306C37.4573 35.3978 37.6753 35.2815 37.9701 35.2815C38.2675 35.2815 38.4867 35.4022 38.6279 35.6438ZM44.7044 39.9245H43.593L41.9677 36.3195V39.9245H40.8564V34.4284H41.9677L43.5968 38.0371V34.4284H44.7044V39.9245ZM50.9399 39.3885C51.2889 38.9808 51.4634 38.4083 51.4634 37.6709V36.731C51.4584 35.9785 51.2795 35.3941 50.9267 34.9776C50.5739 34.5611 50.0913 34.3528 49.4789 34.3528C48.8565 34.3528 48.3702 34.5649 48.0199 34.9889C47.6696 35.4129 47.4945 36.0024 47.4945 36.7574V37.6973C47.4995 38.4246 47.6784 38.9902 48.0312 39.3941C48.384 39.798 48.8691 40 49.4865 40C50.1064 40 50.5909 39.7961 50.9399 39.3885ZM50.3484 36.7499C50.3484 36.2541 50.2778 35.8854 50.1367 35.6438C49.9956 35.4022 49.7763 35.2815 49.479 35.2815C49.1841 35.2815 48.9662 35.3978 48.8251 35.6306C48.6839 35.8634 48.6109 36.2176 48.6058 36.6932V37.6709C48.6058 38.1516 48.6776 38.5058 48.8213 38.7335C48.9649 38.9613 49.1867 39.0752 49.4865 39.0752C49.7763 39.0752 49.9918 38.9638 50.1329 38.7411C50.274 38.5184 50.3459 38.173 50.3484 37.7049V36.7499ZM53.4765 37.6823H55.2039V36.7612H53.4765V35.3532H55.4118V34.4284H52.3652V39.9245H53.4765V37.6823ZM59.1508 37.9918V39.9245H58.0395V34.4284H59.9143C60.4586 34.4284 60.8927 34.597 61.2165 34.9342C61.5403 35.2714 61.7022 35.7093 61.7022 36.2478C61.7022 36.7864 61.5422 37.2117 61.2222 37.5237C60.9021 37.8358 60.4586 37.9918 59.8916 37.9918H59.1508ZM59.9143 37.067H59.1507V35.3532H59.9256C60.1247 35.3557 60.2835 35.4381 60.4019 35.6004C60.5203 35.7627 60.5796 35.9811 60.5796 36.2554C60.5796 36.5196 60.5216 36.7209 60.4057 36.8593C60.2898 36.9977 60.126 37.067 59.9143 37.067ZM64.5016 38.7996H62.9858L62.691 39.9245H61.5154L63.2353 34.4284H64.2521L65.9833 39.9245H64.7964L64.5016 38.7996ZM64.2559 37.8748H63.2277L63.7418 35.9156L64.2559 37.8748ZM68.9262 38.4825C68.9262 38.2585 68.8689 38.0893 68.7542 37.9748C68.6396 37.8603 68.4311 37.7414 68.1287 37.6181C67.5768 37.4092 67.1799 37.1645 66.938 36.8839C66.6961 36.6033 66.5751 36.2717 66.5751 35.8892C66.5751 35.4261 66.7395 35.0543 67.0684 34.7737C67.3972 34.4931 67.8149 34.3528 68.3214 34.3528C68.6591 34.3528 68.9603 34.4239 69.2249 34.5661C69.4894 34.7083 69.6929 34.909 69.8353 35.1682C69.9777 35.4274 70.0489 35.7218 70.0489 36.0515H68.9414C68.9414 35.7948 68.8866 35.5992 68.7769 35.4645C68.6673 35.3299 68.5092 35.2626 68.3026 35.2626C68.1085 35.2626 67.9573 35.3198 67.849 35.4343C67.7406 35.5488 67.6864 35.703 67.6864 35.8967C67.6864 36.0477 67.7469 36.1843 67.8679 36.3063C67.9888 36.4284 68.203 36.5548 68.5104 36.6857C69.0472 36.8795 69.4372 37.1173 69.6803 37.3991C69.9235 37.681 70.0451 38.0396 70.0451 38.475C70.0451 38.9531 69.8927 39.3268 69.5877 39.5961C69.2828 39.8653 68.8683 40 68.3441 40C67.9888 40 67.665 39.927 67.3727 39.781C67.0804 39.6351 66.8517 39.4262 66.6866 39.1544C66.5216 38.8826 66.439 38.5618 66.439 38.1918H67.5541C67.5541 38.5089 67.6159 38.7392 67.7393 38.8826C67.8628 39.0261 68.0644 39.0978 68.3441 39.0978C68.7322 39.0978 68.9262 38.8927 68.9262 38.4825ZM73.0391 37.9748C73.1537 38.0893 73.2111 38.2585 73.2111 38.4825C73.2111 38.8927 73.017 39.0978 72.629 39.0978C72.3492 39.0978 72.1477 39.0261 72.0242 38.8826C71.9007 38.7392 71.839 38.5089 71.839 38.1918H70.7239C70.7239 38.5618 70.8064 38.8826 70.9715 39.1544C71.1365 39.4262 71.3652 39.6351 71.6575 39.781C71.9498 39.927 72.2736 40 72.629 40C73.1531 40 73.5676 39.8653 73.8726 39.5961C74.1775 39.3268 74.3299 38.9531 74.3299 38.475C74.3299 38.0396 74.2084 37.681 73.9652 37.3991C73.722 37.1173 73.332 36.8795 72.7953 36.6857C72.4878 36.5548 72.2737 36.4284 72.1527 36.3063C72.0317 36.1843 71.9713 36.0477 71.9713 35.8967C71.9713 35.703 72.0254 35.5488 72.1338 35.4343C72.2421 35.3198 72.3933 35.2626 72.5874 35.2626C72.794 35.2626 72.9522 35.3299 73.0618 35.4645C73.1714 35.5992 73.2262 35.7948 73.2262 36.0515H74.3337C74.3337 35.7218 74.2625 35.4274 74.1202 35.1682C73.9778 34.909 73.7743 34.7083 73.5097 34.5661C73.2451 34.4239 72.944 34.3528 72.6063 34.3528C72.0998 34.3528 71.6821 34.4931 71.3532 34.7737C71.0244 35.0543 70.8599 35.4261 70.8599 35.8892C70.8599 36.2717 70.9809 36.6033 71.2228 36.8839C71.4647 37.1645 71.8616 37.4092 72.4135 37.6181C72.7159 37.7414 72.9244 37.8603 73.0391 37.9748ZM78.0138 37.5464H76.2826V39.0035H78.3313V39.9245H75.1712V34.4284H78.3237V35.3532H76.2826V36.6517H78.0138V37.5464ZM81.811 39.9245H82.9223V34.4284H81.8148V38.0371L80.1856 34.4284H79.0743V39.9245H80.1856V36.3195L81.811 39.9245ZM87.6608 39.3016C87.4466 39.5332 87.1838 39.7074 86.8726 39.8245C86.5614 39.9415 86.2206 40 85.8502 40C85.2176 40 84.7262 39.8043 84.376 39.413C84.0257 39.0217 83.8455 38.4523 83.8354 37.7049V36.7159C83.8354 35.9584 84.0011 35.3752 84.3325 34.9662C84.6639 34.5573 85.1471 34.3528 85.7821 34.3528C86.3793 34.3528 86.8298 34.5001 87.1335 34.7945C87.4371 35.0889 87.6129 35.5507 87.6608 36.1799H86.5797C86.5494 35.8301 86.4764 35.5916 86.3605 35.4645C86.2445 35.3374 86.0631 35.2739 85.8161 35.2739C85.5163 35.2739 85.2983 35.3834 85.1622 35.6023C85.0261 35.8212 84.9556 36.1698 84.9505 36.6479V37.6445C84.9505 38.1453 85.0255 38.5096 85.1754 38.7373C85.3254 38.9651 85.5717 39.0789 85.9144 39.0789C86.1337 39.0789 86.3113 39.0349 86.4474 38.9468L86.5457 38.8789V37.871H85.767V37.033H87.6608V39.3016ZM89.6625 37.5464H91.3937V36.6517H89.6625V35.3532H91.7037V34.4284H88.5512V39.9245H91.7112V39.0035H89.6625V37.5464ZM94.1212 37.9163H93.5693V39.9245H92.458V34.4284H94.2308C94.7878 34.4284 95.218 34.5724 95.5217 34.8606C95.8253 35.1487 95.9772 35.5583 95.9772 36.0893C95.9772 36.8191 95.7113 37.3299 95.1796 37.6219L96.1435 39.8717V39.9245H94.949L94.1212 37.9163ZM94.2006 36.9915H93.5693V35.3532H94.2195C94.6504 35.3532 94.8658 35.6287 94.8658 36.1799C94.8658 36.4265 94.8104 36.6234 94.6995 36.7706C94.5886 36.9178 94.4223 36.9915 94.2006 36.9915ZM100.4 37.9163H99.8484V39.9245H98.737V34.4284H100.51C101.067 34.4284 101.497 34.5724 101.801 34.8606C102.104 35.1487 102.256 35.5583 102.256 36.0893C102.256 36.8191 101.99 37.3299 101.459 37.6219L102.423 39.8717V39.9245H101.228L100.4 37.9163ZM100.48 36.9915H99.8484V35.3532H100.499C100.929 35.3532 101.145 35.6287 101.145 36.1799C101.145 36.4265 101.089 36.6234 100.979 36.7706C100.868 36.9178 100.701 36.9915 100.48 36.9915ZM104.284 39.9245H103.173V34.4284H104.284V39.9245ZM108.276 39.8245C108.588 39.7074 108.85 39.5332 109.064 39.3016V37.033H107.171V37.871H107.949V38.8789L107.851 38.9468C107.715 39.0349 107.537 39.0789 107.318 39.0789C106.975 39.0789 106.729 38.9651 106.579 38.7373C106.429 38.5096 106.354 38.1453 106.354 37.6445V36.6479C106.359 36.1698 106.43 35.8212 106.566 35.6023C106.702 35.3834 106.92 35.2739 107.22 35.2739C107.467 35.2739 107.648 35.3374 107.764 35.4645C107.88 35.5916 107.953 35.8301 107.983 36.1799H109.064C109.017 35.5507 108.841 35.0889 108.537 34.7945C108.233 34.5001 107.783 34.3528 107.186 34.3528C106.551 34.3528 106.068 34.5573 105.736 34.9662C105.405 35.3752 105.239 35.9584 105.239 36.7159V37.7049C105.249 38.4523 105.429 39.0217 105.78 39.413C106.13 39.8043 106.621 40 107.254 40C107.624 40 107.965 39.9415 108.276 39.8245ZM113.814 39.9245H112.707V37.5728H111.066V39.9245H109.955V34.4284H111.066V36.6517H112.707V34.4284H113.814V39.9245ZM116.905 35.3532H118.265V34.4284H114.451V35.3532H115.789V39.9245H116.905V35.3532ZM121.273 38.4825C121.273 38.2585 121.215 38.0893 121.101 37.9748C120.986 37.8603 120.777 37.7414 120.475 37.6181C119.923 37.4092 119.526 37.1645 119.284 36.8839C119.042 36.6033 118.921 36.2717 118.921 35.8892C118.921 35.4261 119.086 35.0543 119.415 34.7737C119.744 34.4931 120.161 34.3528 120.668 34.3528C121.005 34.3528 121.307 34.4239 121.571 34.5661C121.836 34.7083 122.039 34.909 122.182 35.1682C122.324 35.4274 122.395 35.7218 122.395 36.0515H121.288C121.288 35.7948 121.233 35.5992 121.123 35.4645C121.014 35.3299 120.856 35.2626 120.649 35.2626C120.455 35.2626 120.304 35.3198 120.195 35.4343C120.087 35.5488 120.033 35.703 120.033 35.8967C120.033 36.0477 120.093 36.1843 120.214 36.3063C120.335 36.4284 120.549 36.5548 120.857 36.6857C121.394 36.8795 121.783 37.1173 122.027 37.3991C122.27 37.681 122.391 38.0396 122.391 38.475C122.391 38.9531 122.239 39.3268 121.934 39.5961C121.629 39.8653 121.215 40 120.69 40C120.335 40 120.011 39.927 119.719 39.781C119.427 39.6351 119.198 39.4262 119.033 39.1544C118.868 38.8826 118.785 38.5618 118.785 38.1918H119.9C119.9 38.5089 119.962 38.7392 120.086 38.8826C120.209 39.0261 120.411 39.0978 120.69 39.0978C121.079 39.0978 121.273 38.8927 121.273 38.4825ZM126.232 38.7996H127.748L128.043 39.9245H129.23L127.499 34.4284H126.482L124.762 39.9245H125.938L126.232 38.7996ZM126.474 37.8748H127.502L126.988 35.9156L126.474 37.8748ZM129.848 34.4284V39.9245H131.273C131.944 39.9245 132.47 39.7188 132.851 39.3073C133.233 38.8959 133.424 38.329 133.424 37.6068V36.7159C133.416 36.0062 133.222 35.4476 132.84 35.0399C132.458 34.6322 131.946 34.4284 131.303 34.4284H129.848ZM130.959 35.3532V39.0034H131.292C131.663 39.0034 131.923 38.9059 132.075 38.7109C132.226 38.5159 132.305 38.1793 132.313 37.7011V36.7461C132.313 36.2327 132.241 35.8747 132.097 35.6721C131.954 35.4696 131.709 35.3632 131.364 35.3532H130.959ZM136.96 34.4284L136.034 38.4146L135.112 34.4284H133.88L135.456 39.9245H136.613L138.2 34.4284H136.96ZM142.648 37.6709C142.648 38.4083 142.473 38.9808 142.124 39.3885C141.775 39.7961 141.291 40 140.671 40C140.053 40 139.568 39.798 139.215 39.3941C138.863 38.9902 138.684 38.4246 138.679 37.6973V36.7574C138.679 36.0024 138.854 35.4129 139.204 34.9889C139.554 34.5649 140.041 34.3528 140.663 34.3528C141.275 34.3528 141.758 34.5611 142.111 34.9776C142.464 35.3941 142.643 35.9785 142.648 36.731V37.6709ZM141.321 35.6438C141.462 35.8854 141.533 36.2541 141.533 36.7499V37.7049C141.53 38.173 141.458 38.5184 141.317 38.7411C141.176 38.9638 140.96 39.0752 140.671 39.0752C140.371 39.0752 140.149 38.9613 140.005 38.7335C139.862 38.5058 139.79 38.1516 139.79 37.6709V36.6932C139.795 36.2176 139.868 35.8634 140.009 35.6306C140.15 35.3978 140.368 35.2815 140.663 35.2815C140.96 35.2815 141.18 35.4022 141.321 35.6438ZM147.28 38.0937C147.252 38.7203 147.076 39.1947 146.751 39.5168C146.426 39.8389 145.967 40 145.375 40C144.753 40 144.276 39.7955 143.944 39.3866C143.613 38.9776 143.447 38.3944 143.447 37.6369V36.7121C143.447 35.9571 143.619 35.3752 143.961 34.9662C144.304 34.5573 144.78 34.3528 145.39 34.3528C145.99 34.3528 146.445 34.5202 146.757 34.8549C147.068 35.1896 147.245 35.6702 147.288 36.2969H146.173C146.163 35.9093 146.103 35.6419 145.993 35.4947C145.883 35.3475 145.683 35.2739 145.39 35.2739C145.093 35.2739 144.882 35.3777 144.759 35.5853C144.635 35.7929 144.57 36.1346 144.562 36.6102V37.6483C144.562 38.1944 144.624 38.5693 144.746 38.7732C144.868 38.977 145.078 39.0789 145.375 39.0789C145.667 39.0789 145.869 39.0078 145.98 38.8657C146.091 38.7235 146.154 38.4661 146.169 38.0937H147.28ZM149.18 38.7996H150.696L150.991 39.9245H152.177L150.446 34.4284H149.429L147.71 39.9245H148.885L149.18 38.7996ZM149.422 37.8748H150.45L149.936 35.9156L149.422 37.8748ZM154.546 35.3532H155.907V34.4284H152.093V35.3532H153.431V39.9245H154.546V35.3532ZM159.492 37.5464H157.761V39.0035H159.81V39.9245H156.65V34.4284H159.802V35.3532H157.761V36.6517H159.492V37.5464ZM162.705 37.9748C162.82 38.0893 162.877 38.2585 162.877 38.4825C162.877 38.8927 162.683 39.0978 162.295 39.0978C162.016 39.0978 161.814 39.0261 161.69 38.8826C161.567 38.7392 161.505 38.5089 161.505 38.1918H160.39C160.39 38.5618 160.473 38.8826 160.638 39.1544C160.803 39.4262 161.031 39.6351 161.324 39.781C161.616 39.927 161.94 40 162.295 40C162.819 40 163.234 39.8653 163.539 39.5961C163.844 39.3268 163.996 38.9531 163.996 38.475C163.996 38.0396 163.875 37.681 163.631 37.3991C163.388 37.1173 162.998 36.8795 162.462 36.6857C162.154 36.5548 161.94 36.4284 161.819 36.3063C161.698 36.1843 161.638 36.0477 161.638 35.8967C161.638 35.703 161.692 35.5488 161.8 35.4343C161.908 35.3198 162.06 35.2626 162.254 35.2626C162.46 35.2626 162.618 35.3299 162.728 35.4645C162.838 35.5992 162.892 35.7948 162.892 36.0515H164C164 35.7218 163.929 35.4274 163.786 35.1682C163.644 34.909 163.441 34.7083 163.176 34.5661C162.911 34.4239 162.61 34.3528 162.273 34.3528C161.766 34.3528 161.348 34.4931 161.02 34.7737C160.691 35.0543 160.526 35.4261 160.526 35.8892C160.526 36.2717 160.647 36.6033 160.889 36.8839C161.131 37.1645 161.528 37.4092 162.08 37.6181C162.382 37.7414 162.591 37.8603 162.705 37.9748Z",
      fill: "currentColor"
    })]
  })
});

var TheNewYorkTimes = /*#__PURE__*/createIcon({
  displayName: "TheNewYorkTimes",
  viewBox: "0 0 176 24",
  path: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1378 0.00244229C11.6862 -0.0439795 13.5165 0.563725 13.5165 2.48137C13.5165 4.30448 12.0145 5.28778 10.5135 5.3342V8.46894L12.1085 9.73162L10.5135 10.9951V15.2052C11.6397 14.5502 12.5781 13.334 13.189 12.0704H13.2821C13.3295 15.3917 10.9831 18.5264 6.94692 18.5264C3.23823 18.5264 0 15.5791 0 11.5564C0 8.18788 2.72208 5.47515 5.67854 4.68092L5.72508 4.77376C4.64623 5.42873 3.66046 6.41119 3.14431 7.72113L8.11969 5.476V12.3523L4.03615 14.3172C5.11585 15.4862 6.42908 15.9074 7.88446 15.9074C8.68238 15.9074 9.57423 15.7673 10.3722 15.2997V10.996L8.87023 9.68604L10.3722 8.42252V5.28862C9.57423 5.19494 8.11969 4.82103 6.75823 4.44628C6.34524 4.33728 5.96059 4.22835 5.60181 4.12673C4.5742 3.8357 3.75882 3.60478 3.09777 3.60478C2.112 3.60478 1.73631 4.30532 1.73631 4.82019C1.73631 5.42873 1.92415 5.66253 2.20592 5.84991L2.15854 5.94359L2.13157 5.93166C1.6904 5.73654 0.610077 5.25876 0.610077 3.83857C0.610077 2.06104 2.112 0.610146 4.03615 0.610146C4.94252 0.610146 6.00769 0.966202 7.15866 1.35094C7.25949 1.38464 7.36098 1.41857 7.46308 1.45249C7.62964 1.5056 7.79621 1.55965 7.96159 1.61332C8.96067 1.93754 9.91605 2.24757 10.56 2.24757C11.4518 2.24757 11.7802 1.68713 11.7802 1.26512C11.7802 0.657412 11.077 0.282661 10.1378 0.189818V0.00244229ZM3.94222 14.1299L5.11584 13.5213L5.16238 7.01974L3.09776 7.95493C2.86253 8.6099 2.76945 9.54508 2.76945 10.2473C2.76945 11.9312 3.23822 13.1947 3.94222 14.1299ZM23.8421 8.00134L23.0441 8.60904L20.6978 6.50487L17.9283 8.60989V0.470029L14.1739 3.04264C14.597 3.1836 15.1132 3.41739 15.1132 4.39985V15.72L13.8456 16.7025L13.9861 16.8434L14.6435 16.375L16.8495 18.3872L19.8533 16.4223L19.712 16.2349L18.9615 16.7497L17.9292 15.72V8.89011L18.6323 8.37525L20.2755 9.77972V15.72C20.2755 19.4625 19.4302 20.2584 17.7405 20.8661V20.9589C20.5565 21.0999 23.0915 20.1174 23.0915 15.2997V8.84369L23.936 8.14229L23.8421 8.00134ZM33.1819 14.8785L28.864 18.3407L25.4853 15.9074L24.5461 16.656L24.4056 16.5159L25.3906 15.7673V9.26484L30.4125 6.50485L32.6658 10.0127L28.16 13.1947V14.4573L30.7882 16.4687L33.0415 14.6911L33.1819 14.8785ZM28.16 12.9136V8.00135L30.3185 11.4163L28.16 12.9136ZM50.9887 0.857576C51.0563 1.10184 51.1102 1.29686 51.1102 1.54619C51.1102 3.2773 49.7496 4.39986 48.1538 4.49355V18.3872H47.7315L39.7058 4.44628V14.3628C40.9725 14.5502 41.6765 14.9714 42.7561 15.9538L43.5075 15.1115L43.648 15.2516L40.7854 18.4328C40.2685 17.8715 39.7058 17.3566 38.9078 17.3566C38.1091 17.3566 37.4998 17.8242 37.4998 18.6666C37.4998 19.4616 38.016 19.9765 39.0957 20.1166V20.2111C37.4051 20.304 35.7635 19.4152 35.7635 17.544C35.7635 15.5327 37.4059 14.4101 39.5179 14.3628V10.1528C39.4757 10.1528 39.4242 10.1434 39.3673 10.1331C39.2977 10.1205 39.2201 10.1064 39.1422 10.1064C38.4391 10.1064 38.016 10.3866 38.016 10.9479C38.016 11.2747 38.1559 11.4149 38.3432 11.6026L38.3443 11.6037V11.6965C37.125 11.5092 36.7019 10.2456 36.7019 9.63793C36.7019 8.23515 37.7342 7.3928 39.5179 7.3928V4.16522C39.2361 3.69763 38.8139 3.18277 38.2504 3.18277C37.5938 3.18277 37.2654 3.88416 37.1241 4.44544H37.0311C36.8424 2.20031 38.0634 0.843949 39.6118 0.843949C40.9725 0.843949 41.7238 1.96651 42.1935 2.71602L47.9659 12.7735V4.49355C46.7374 4.49355 46.1586 4.03654 45.6096 3.60311C45.5502 3.5562 45.4912 3.50957 45.4317 3.46383L44.6338 4.39986L44.4925 4.25975C44.4925 4.25975 47.355 1.03132 47.355 0.984903C47.7315 1.35881 48.3881 1.87367 49.2335 1.87367C50.1718 1.87367 50.5001 1.4525 50.8293 0.610152H50.9224C50.945 0.699592 50.9675 0.781003 50.9887 0.857576ZM53.8323 18.3399L58.1502 14.8785L58.0098 14.6911L55.7565 16.4687L53.1283 14.4109V13.1474L57.6341 9.96624L55.3816 6.4576L50.3597 9.21759V15.72L49.3739 16.4687L49.5144 16.6088L50.4536 15.861L53.8323 18.3399ZM53.1757 8.00135V12.9136L55.3342 11.4163L53.1757 8.00135ZM73.5443 7.62741L72.8877 8.14227L71.0101 6.55127L68.8042 8.51618L69.696 9.35853V16.7497L67.4435 15.2051V9.21757L68.2415 8.65629L65.9416 6.504L63.7822 8.46976L64.6741 9.31126V16.4687L64.5336 16.5624L62.4216 15.0186V9.17115C62.4216 7.82275 61.7259 7.39859 60.888 6.88782L60.8732 6.87876C60.1218 6.41116 59.7461 5.98999 59.7461 5.33502C59.7461 4.58636 60.4035 4.25972 60.6379 4.16603C59.8865 4.11877 57.7745 4.91385 57.728 6.83233C57.685 7.73974 58.122 8.16834 58.5591 8.59694C58.5952 8.63239 58.6314 8.66784 58.6672 8.70356C59.1834 9.17115 59.6522 9.63874 59.6522 10.4338V16.1884L58.6198 16.9835L58.7603 17.1236L59.7461 16.375L62.2803 18.4336L64.7215 16.7497L67.3962 18.4336L72.6059 15.3461V8.65629L73.7795 7.76752L73.5443 7.62741ZM90.0181 2.90256L91.0038 2.01463L91.1917 2.1539L90.112 3.13635V15.5799C90.112 17.685 88.9384 18.199 87.483 18.199C86.7092 18.199 86.0799 18.0309 85.3356 17.8322C85.0424 17.7539 84.7308 17.6707 84.3861 17.5913C83.2598 17.3111 82.368 17.1709 81.4296 17.1709C79.7398 17.1709 79.0358 17.8251 79.0358 18.6683C79.0358 19.5562 79.8803 19.8837 80.5843 19.8837C81.0074 19.8837 82.2275 19.7436 83.5881 19.4161C84.8083 19.135 86.3102 18.8548 87.1555 18.8548C88.7505 18.8548 90.2051 19.79 90.2051 21.2873C90.2051 22.7373 89.2675 23.6725 87.6243 24V23.9072C88 23.7671 88.2818 23.4387 88.2818 22.7373C88.2818 22.1761 87.9535 21.8486 87.2021 21.8486C86.592 21.8486 85.5123 22.0824 84.48 22.3162L84.3129 22.3533C83.1243 22.6174 82.1671 22.8302 80.8661 22.8302C78.8945 22.8302 77.5805 21.5211 77.5805 19.8845C77.5805 18.6674 78.2371 17.7322 79.6925 17.2174V10.996H79.5055C78.7541 10.996 78.1914 11.1825 78.1914 11.7438C78.1914 11.9776 78.2845 12.2122 78.7075 12.3996V12.4925C77.44 12.446 77.0178 11.2762 77.0178 10.6212C77.0178 9.49868 78.0501 8.46896 79.739 8.37611V4.49356C79.739 3.18362 79.2228 2.80971 78.6136 2.80971C78.0501 2.80971 77.6278 3.32373 77.5331 3.93228H77.44C77.471 2.35767 78.7712 1.10374 80.3499 1.12587C82.1336 1.12587 82.8376 2.48138 82.8376 3.46384V17.0291C83.2184 17.1006 83.5871 17.1839 83.9009 17.2547C84.2057 17.3235 84.4587 17.3806 84.6205 17.4039V1.17229H84.8083V3.41742L87.8121 0.984912L90.0181 2.90256ZM86.9203 8.5162C86.6385 8.79727 86.3576 9.03106 85.8415 9.03106C85.2779 9.03106 84.9962 8.75 84.7618 8.5162V3.65119L85.4658 3.08991L86.9212 4.30532V8.51705L86.9203 8.5162ZM85.8415 10.3875C86.3576 10.3875 86.6859 10.6213 86.9203 10.8551V8.7973C86.6859 9.0311 86.3576 9.2649 85.8415 9.2649C85.3467 9.2649 85.0248 9.00753 84.7926 8.82191L84.7618 8.7973V10.8551C84.9496 10.6685 85.3253 10.3875 85.8415 10.3875ZM86.9203 15.72C86.9203 16.516 86.4981 17.4047 85.4649 17.4047C85.3648 17.4047 85.2104 17.3912 85.0671 17.3786C84.9429 17.3677 84.827 17.3575 84.7618 17.3575V11.0888C84.9962 10.855 85.3245 10.574 85.8415 10.574C86.3576 10.574 86.6385 10.8086 86.9203 11.0888V15.72ZM100.202 15.3461L95.3683 18.3399L92.1775 16.0011L91.3795 16.656L91.2848 16.5159L92.224 15.7673V9.26484L97.0581 6.50485L100.202 8.79641V15.3461ZM95.04 14.9722V7.95492L97.4803 9.73245V16.7025L95.04 14.9722ZM108.369 7.06614C108.744 7.06614 109.073 6.92603 109.448 6.64496C109.308 8.1887 108.463 9.6396 107.336 9.6396C106.68 9.6396 106.116 9.17116 105.6 8.60987V15.5799L106.82 16.7025L107.619 16.2349L107.712 16.375L104.662 18.3872L102.268 16.375L101.61 16.8434L101.47 16.7025L102.737 15.72V9.35853L101.658 8.1887L100.859 8.70356L100.766 8.51619L103.722 6.50485L105.506 8.4225C105.506 8.4225 107.29 6.55128 107.29 6.50485C107.524 6.83234 107.994 7.06614 108.369 7.06614ZM120.9 16.0475L120.008 16.6088L114.986 9.17116L115.268 8.79725C115.378 8.86088 115.484 8.9298 115.591 8.99954C116.035 9.28863 116.501 9.59233 117.333 9.59233C118.365 9.59233 119.68 8.51619 119.82 6.50485C119.54 6.87876 119.023 7.29993 118.179 7.29993C117.568 7.29993 116.958 6.87876 116.582 6.50485L113.156 11.51L117.662 18.3872L120.948 16.2349L120.9 16.0475ZM114.799 16.2349L114.048 16.7497L113.016 15.72V0.470029L109.26 3.04264C109.684 3.1836 110.2 3.41739 110.2 4.39985V15.72L108.932 16.7025L109.073 16.8434L109.73 16.375L111.936 18.3872L114.94 16.4223L114.799 16.2349ZM136.81 2.48137C136.81 0.563725 134.979 -0.0439795 133.431 0.00244229V0.189818C134.37 0.282661 135.073 0.657412 135.073 1.26512C135.073 1.68713 134.745 2.24757 133.853 2.24757C133.209 2.24757 132.255 1.93789 131.256 1.61387C131.09 1.56002 130.923 1.50578 130.756 1.45249C130.654 1.41856 130.553 1.38463 130.452 1.35092C129.301 0.966193 128.236 0.610146 127.329 0.610146C125.405 0.610146 123.903 2.06104 123.903 3.83857C123.903 5.25876 124.983 5.73654 125.425 5.93166L125.452 5.94359L125.499 5.84991C125.217 5.66253 125.029 5.42873 125.029 4.82019C125.029 4.30532 125.405 3.60478 126.391 3.60478C127.052 3.60478 127.867 3.8357 128.895 4.12673C129.254 4.22833 129.638 4.3373 130.051 4.44628C131.413 4.82103 132.867 5.19494 133.665 5.28862V8.42252L132.163 9.68604L133.665 10.996V15.2997C132.867 15.7673 131.975 15.9074 131.178 15.9074C129.722 15.9074 128.409 15.4862 127.329 14.3172L131.413 12.3523V5.476L126.391 7.67386C126.907 6.36477 127.893 5.38231 128.972 4.72734L128.925 4.63365C125.969 5.42873 123.246 8.1423 123.246 11.51C123.246 15.5335 126.485 18.48 130.193 18.48C134.229 18.48 136.575 15.3461 136.529 12.0249H136.435C135.825 13.2875 134.886 14.5038 133.759 15.1588V10.9487L135.355 9.68604L133.759 8.42252V5.28862C135.308 5.28862 136.81 4.30617 136.81 2.48137ZM127.189 14.1299L128.362 13.5213L128.408 7.01974L126.343 7.95493C126.108 8.6099 126.015 9.54508 126.015 10.2473C126.015 11.9312 126.485 13.1947 127.189 14.1299ZM139.861 1.73354L137.796 3.46381L139.579 5.47598L141.644 3.74487L139.861 1.73354ZM142.301 16.7498L143.052 16.2349L143.146 16.4223L140.142 18.3872L137.937 16.375L137.279 16.8434L137.139 16.7025L138.406 15.72V9.35855L137.467 8.18872L136.762 8.65632L136.669 8.46978L139.532 6.50403L141.269 8.56347L142.019 8.00135L142.161 8.1423L141.269 8.84369V15.72L142.301 16.7498ZM159.009 16.1425L158.305 16.6088L157.179 15.5335V8.84369L158.071 8.1423L157.93 8.00135L157.132 8.60905L154.785 6.50487L152.11 8.56347L149.763 6.50403L147.135 8.56347L145.351 6.50403L142.489 8.46978L142.582 8.65632L143.287 8.18872L144.319 9.35855V15.6736L143.521 16.4687L145.774 18.3872L147.98 16.4223L147.089 15.5799V8.79727L147.698 8.37525L149.341 9.77972V15.6736L148.59 16.4687L150.89 18.3872L153.049 16.4223L152.157 15.5799V8.79727L152.721 8.32883L154.362 9.77972V15.5799L153.706 16.2813L156.005 18.3872L159.057 16.3277L159.009 16.1425ZM165.063 16.5159L167.317 14.7376L167.411 14.9249L163.093 18.3872L159.667 15.9074V9.26484L164.689 6.50485L166.941 10.0127L162.435 13.1947V14.4565L165.063 16.5159ZM162.436 12.9136V8.00135L164.596 11.4163L162.436 12.9136ZM174.076 10.5275L176 11.9776V15.5799C176 15.5799 171.776 18.1061 171.776 18.1534L171.764 18.1394C171.433 17.7625 170.872 17.1236 169.898 17.1236C169.148 17.1236 168.82 17.6385 168.82 17.966C168.82 18.3781 168.999 18.5211 169.226 18.7026L169.241 18.7146L169.148 18.8547C168.303 18.5273 167.786 17.825 167.786 16.9371C167.786 16.0948 168.116 15.1587 169.804 13.6623L168.116 12.3523V8.79725L172.527 6.36474C172.996 6.87876 173.466 7.29993 174.216 7.29993C174.968 7.29993 175.484 6.83234 175.672 6.31747H175.766C175.766 6.44926 175.78 6.59605 175.793 6.72416C175.803 6.82334 175.812 6.91131 175.812 6.97245C175.812 8.00132 175.343 9.40495 174.076 10.5275ZM175.014 9.07747C174.358 10.2473 172.902 11.4163 172.01 12.0713L170.932 11.1825V7.72111C171.354 8.65629 172.246 9.45138 173.372 9.45138C174.076 9.45138 174.498 9.31126 175.014 9.07747ZM170.415 14.925C171.636 14.925 172.668 15.7201 173.184 16.8426V13.2411L172.01 12.2587C170.274 13.2876 168.96 14.6448 168.49 15.3926C169.191 14.9133 170.014 14.9213 170.349 14.9245C170.374 14.9248 170.396 14.925 170.415 14.925Z",
    fill: "currentColor"
  })
});

var TheWashingtonPost = /*#__PURE__*/createIcon({
  displayName: "TheWashingtonPost",
  viewBox: "0 0 160 24",
  path: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0331 14.6332L41.3038 18.9973L38.1115 16.2402L35.6777 18.9973L32.3708 16.1479V11.6469H31.7285C31.1538 11.6469 30.8785 11.9915 30.7869 12.4515H30.5577C30.5115 12.2669 30.4423 11.9461 30.4423 11.5776C30.4423 10.9807 30.6946 9.41903 32.3708 9.41903V5.9265C32.3708 5.22517 32.1307 4.86855 31.8993 4.52476C31.684 4.20485 31.4762 3.89605 31.4762 3.33095C31.4762 2.02317 32.7146 0.80463 34.9892 0.000732422L35.1946 0.18536C34.4377 0.551537 33.8177 1.01157 33.8177 2.00009C33.8177 2.67201 34.1065 2.9692 34.428 3.30005C34.8317 3.71541 35.2869 4.18382 35.2869 5.51339V6.43268L37.9738 3.60712L40.7985 6.38653L43.4615 3.60635L46.0323 6.13266L46.0331 14.6332ZM19.3538 8.86669L19.0554 8.56821L18.4354 9.16594L16.4385 7.35044L14.44 9.46442V3.35326L14.3938 3.33018L11.96 5.9265V16.0802L11.1331 16.9526V17.0449L13.2692 18.9973L15.1292 17.0218V16.9295L14.44 16.2864V10.0606L15.0369 9.46442L16.1623 10.4983V18.7212C16.1623 19.8697 15.45 20.8113 14.3715 21.3406L14.5092 21.5698C16.69 21.1336 18.6423 19.6397 18.6423 17.4349V9.55596L19.3538 8.86669ZM0 12.2131V13.4954C0.271538 16.9572 2.62462 19.0889 5.66846 19.0889C8.88385 19.0889 10.9954 16.1479 11.2477 13.117L10.9731 12.9785C10.5823 14.1963 10.0546 15.1148 8.97462 15.7579V7.3512C10.8346 6.8681 11.2715 5.42031 11.2946 3.92791H11.0185C10.6277 4.77796 10.0769 5.14491 9.08923 5.14491C8.07637 5.14491 7.24295 4.73047 6.44121 4.33179C5.69819 3.9623 4.98238 3.60635 4.17615 3.60635C1.55769 3.60635 0.294615 5.99496 0.294615 8.13202C0.294615 8.29203 0.294615 8.45281 0.317692 8.61436H0.64C0.64 7.46506 1.60385 6.34037 3.25769 6.34037C3.5991 6.33948 3.93898 6.38582 4.26769 6.47807C1.92 7.95124 0.226923 9.62289 0 12.2131ZM6.99879 7.35111L3.55615 9.28056L3.78538 9.64828L4.52 9.25748V15.0686L3.80846 15.4594C2.72923 14.5409 2.29231 13.1162 2.29231 11.693C2.29231 9.09747 3.44077 7.81123 4.61154 6.59346C4.93682 6.68623 5.24699 6.79789 5.55881 6.91015C6.01744 7.07526 6.47965 7.24165 6.99879 7.35111ZM8.53846 15.9879C7.87411 16.2875 7.15416 16.444 6.42539 16.4472C5.46154 16.4472 4.77308 16.2172 4.15308 15.7579L7.09154 14.1501V7.37428C7.39077 7.44275 7.68923 7.46506 8.01077 7.46506C8.19462 7.46506 8.37769 7.46506 8.53846 7.44198V15.9879ZM22.4538 13.6908L24.4515 12.22L22.5 9.05054L22.4538 9.07362V13.6908ZM22.4546 14.2424L26.77 11.0945L24.3592 7.3512L20.0192 10.5206V16.2864L19.3069 17.0218L19.5838 17.3203L20.2262 16.6764L23.1646 19.0204L26.4262 15.5279L26.1277 15.2294L24.5208 16.9064L22.4546 15.2756V14.2424ZM37.9508 7.53429V15.781L37.2385 16.5856L35.2869 14.9086V7.02888L36.3438 5.94958L37.9508 7.53429ZM43.14 16.838V7.23581L41.8539 5.94958L40.8662 6.93733V14.8848L43.1162 16.8603L43.1392 16.8372L43.14 16.838ZM53.4208 18.9973L55.8092 16.4695L55.4646 16.1479L54.7985 16.838L53.7423 15.8718V9.64828L54.5692 8.86669L54.2246 8.56821L53.5815 9.21132L51.1931 7.32813L46.8308 10.4514V16.4933L46.1646 17.1818L46.4631 17.4803L46.9915 16.9526L49.3108 18.9973L51.2162 17.0218H51.2623L53.4208 18.9973ZM51.2631 16.3772V10.406L49.3562 8.91207L49.31 8.95823V15.6664L50.7108 16.9072L51.2623 16.3779L51.2631 16.3772ZM60.5846 11.5084L63.2708 7.6043L63.0423 7.44275C62.5369 7.85585 61.8715 7.94817 61.4115 7.94817C60.8146 7.94817 60.4477 7.71815 59.9877 7.35044L56.1769 10.0383V14.3117H58.1285L54.9592 18.8589L55.28 18.9743C55.8315 18.3765 56.3823 18.055 57.0715 18.055C57.9208 18.055 58.61 18.4458 59.0915 18.9973L62.7439 16.4241V11.5084H60.5846ZM60.2631 17.5042V13.5308H59.1846L56.6354 17.1826L56.6585 17.2288C57.1862 16.8841 57.6223 16.6541 58.4039 16.6541C59.0915 16.6541 59.8038 16.9757 60.2408 17.528L60.2631 17.5042ZM61.7323 9.02823L61.7554 9.05131L61.7546 9.05208L59.5285 12.2677H58.6554V8.91361L58.7015 8.89053C59.1377 9.35056 59.6892 9.55673 60.1477 9.55673C60.9523 9.55673 61.2508 9.37287 61.7323 9.02823ZM71.6292 8.86746L70.9169 9.55673V17.4357C70.9169 19.6405 68.9654 21.1344 66.7839 21.5706L66.6462 21.3413C67.7254 20.8121 68.4369 19.8705 68.4369 18.7219V10.4983L67.3123 9.46519L66.7146 10.0614V16.2872L67.4038 16.9303V17.0226L65.5439 18.9981L63.4085 17.0449V16.9526L64.2346 16.081V5.9265L66.6692 3.33095L66.7154 3.35402V9.46519L68.7131 7.3512L70.7108 9.16671L71.3308 8.56898L71.6292 8.86746ZM75.4185 18.9981L77.76 16.4703L77.4608 16.1487L76.7731 16.861L75.8077 15.9656V9.39595L76.5892 8.6159L76.2677 8.2928L75.6477 8.93669L73.9023 7.3512L71.5823 9.80905L71.8823 10.1083L72.5015 9.51057L73.3277 10.2691V16.8157L72.5708 17.5965L72.8692 17.895L73.5115 17.2518L75.4185 18.9981ZM76.4746 5.308L74.7523 7.14427L72.87 5.42108L74.5915 3.58481L76.4746 5.308ZM85.3354 18.9966L87.7462 16.401L87.4708 16.1018L86.7131 16.8826L85.8169 16.0325V9.60135L86.6215 8.79668L86.3223 8.47512L85.6569 9.14209L83.6585 7.34967L81.4777 9.67058V9.21056L79.3877 7.34967L77.0469 9.85367L77.3677 10.1522L78.0562 9.46365L78.9977 10.3129V16.1018L78.1708 16.9741V17.0434L80.3069 18.9966L82.1892 17.0211V16.9287L81.4777 16.2625V10.2668L82.2585 9.46365L83.3377 10.4729V17.1811L85.3354 18.9966ZM95.99 8.79668L95.2092 9.57827V17.3649C95.2092 18.0051 95.4005 18.289 95.5781 18.5525C95.7319 18.7808 95.8754 18.9937 95.8754 19.4097C95.8754 20.3175 94.7243 21.1713 92.8892 22.5325C92.6346 22.7215 92.3659 22.9207 92.0862 23.1307C91.3285 22.3037 90.8008 21.9598 90.0892 21.9598C89.3315 21.9598 88.3892 22.2583 87.6315 22.786L87.4023 22.603L90.5477 18.9043L88.4808 17.2734L87.8154 17.9388L87.5169 17.6411L88.2969 16.8372V10.4506L92.6608 7.32736L95.0023 9.16517L95.6915 8.4982L95.99 8.79668ZM93.4408 19.1573C94.0154 19.5243 94.3592 19.8235 94.3592 20.282C94.3592 20.8567 94.0385 21.2252 93.6023 21.5921C93.0054 21.0636 92.3385 20.6728 91.4208 20.6728C90.3408 20.6728 89.79 20.949 89.0562 21.3852L89.0331 21.3621L92.7292 17.0664V17.4111C92.7292 18.3988 92.8677 18.7896 93.4408 19.1573ZM92.7285 16.3772V10.4052L90.8238 8.9113L90.7777 8.95746V16.0102L92.1323 17.0664L92.7285 16.3772ZM102.075 16.0795L102.373 16.4006L99.9623 18.9966L97.9415 17.4103L97.3223 18.0319L97.0231 17.7334L97.7354 16.9972V9.05054H96.4031L96.3569 9.00362L97.1608 7.8097H97.7354V6.27113L100.168 3.67481L100.215 3.72097V7.8097H102.052L102.098 7.85585L101.294 9.04978H100.215V16.0102L101.317 16.8595L102.075 16.0795ZM110.732 9.04978L109.996 9.78521V16.1472L106.116 19.0189L103.292 16.8826L102.649 17.5265L102.351 17.2272L103.085 16.4687V10.2668L107.15 7.34967L109.767 9.39441L110.433 8.72822L110.732 9.04978ZM107.517 10.4729V17.2965L107.516 17.2957L105.565 15.8256V8.98054L105.588 8.95746L107.517 10.4729ZM121.502 16.3772L119.089 18.9735L117.092 17.158V10.4506L116.013 9.44057L115.232 10.2437V16.2395L115.944 16.9064V16.9972L114.062 18.9735L111.925 17.0211V16.9518L112.752 16.0795V10.2906L111.811 9.44057L111.122 10.1291L110.8 9.83059L113.143 7.32736L115.232 9.18748V9.64751L117.413 7.32736L119.412 9.11824L120.077 8.45281L120.376 8.77437L119.572 9.57827V16.0095L120.468 16.8595L121.225 16.0795L121.502 16.3772ZM127.715 24.0007H127.79L130.425 21.5698L131.688 22.7414L131.735 22.7183V17.9396C132.308 18.1011 132.79 18.5142 133.181 18.9966L137.199 15.9656V5.97265L134.604 3.60635L131.735 6.66193V4.48025H131.298V7.12119L130.632 7.83354V5.58186L128.474 3.60635L125.925 6.22498L126.246 6.52346L126.89 5.88034L127.716 6.61577V9.09593H127.578C126.339 9.09593 125.581 9.94522 125.581 11.0707C125.581 11.6453 125.672 11.9446 125.741 12.1277H126.017C126.108 11.623 126.568 11.163 127.234 11.163H127.715V15.6417C126.223 16.1479 125.35 17.4572 125.19 19.225L125.374 19.3404C126.039 18.5135 126.912 18.008 127.715 17.8234V24.0007ZM131.298 21.7983V7.55737L130.632 8.24665V21.179L131.298 21.7983ZM134.305 7.02888V16.6072L134.306 16.608L134.283 16.631C133.617 15.9187 132.814 15.5517 131.735 15.4133V7.0758L132.952 5.7888L134.305 7.02888ZM146.224 9.04978L145.488 9.78521V16.1472L141.608 19.0189L138.783 16.8826L138.142 17.5265L137.842 17.2272L138.576 16.4687V10.2668L142.642 7.34967L145.258 9.39441L145.925 8.72822L146.224 9.04978ZM143.008 10.4729V17.2951L141.057 15.8256V8.98054L141.08 8.95746L143.008 10.4729ZM153.869 7.60353L151.182 11.5076H153.342V16.4233L149.691 18.9966C149.208 18.445 148.52 18.0542 147.671 18.0542C146.982 18.0542 146.431 18.3758 145.878 18.9735L145.558 18.8581L148.727 14.3109H146.775V10.0375L150.586 7.34967C151.045 7.71738 151.413 7.9474 152.009 7.9474C152.469 7.9474 153.135 7.85508 153.64 7.44198L153.869 7.60353ZM150.862 13.5293V17.5026L150.838 17.5265C150.402 16.9741 149.691 16.6526 149.002 16.6526C148.222 16.6526 147.785 16.8826 147.256 17.2272L147.233 17.1811L149.782 13.5293H150.862ZM152.354 9.04977L152.332 9.0267C151.849 9.37133 151.551 9.55519 150.747 9.55519C150.288 9.55519 149.736 9.34902 149.301 8.889L149.255 8.91207V12.2661H150.127L152.355 9.05054L152.354 9.04977ZM157.588 18.9973L160 16.4018L159.702 16.0802L158.944 16.8603L157.842 16.011V9.05054H158.92L159.725 7.85662L159.678 7.81046H157.842V3.72174L157.795 3.67558L155.362 6.2719V7.81046H154.788L153.984 9.00439L154.03 9.05131H155.362V16.998L154.649 17.7342L154.948 18.0327L155.568 17.4111L157.588 18.9973Z",
    fill: "currentColor"
  })
});

var USAToday = /*#__PURE__*/createIcon({
  displayName: "USAToday",
  viewBox: "0 0 68 24",
  path: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9572 24C6.37 24 1 18.627 1 12C1 5.373 6.334 0 12.9572 0C19.5798 0 24.9137 5.373 24.9137 12C24.9137 18.627 19.5438 24 12.9572 24ZM28.1357 3.1875H30.355V7.62975C30.355 8.48925 30.463 9.3495 31.6082 9.3495C32.7535 9.3495 32.8607 8.48925 32.8607 7.62975V3.18825H35.152V8.27475C35.152 10.245 33.8995 11.355 31.6442 11.355C29.317 11.355 28.1357 10.245 28.1357 8.27475V3.1875ZM38.6965 9.564C37.909 9.564 37.2287 9.135 36.835 8.6325L35.725 10.245C36.1908 10.746 37.336 11.391 38.8037 11.391C40.7725 11.391 41.8825 10.245 41.8825 8.7045C41.8825 7.236 40.8805 6.627 39.5912 6.2325C39.5288 6.21172 39.4668 6.19161 39.4056 6.17178C38.8349 5.98688 38.3387 5.82615 38.3387 5.373C38.3387 5.0505 38.5892 4.8 39.1622 4.8C39.8417 4.8 40.4147 5.0865 40.7372 5.48025L41.7752 3.9405C41.2022 3.3675 40.2715 3.009 39.0542 3.009C37.336 3.009 36.0827 4.04775 36.0827 5.55225C36.0827 6.91275 37.1215 7.5225 38.2667 7.88025L38.281 7.88442C39.1318 8.1331 39.6272 8.27792 39.6272 8.84775C39.6272 9.3135 39.2695 9.564 38.6965 9.564ZM44.9613 3.1875H47.467L50.4385 11.1757H48.076L47.7175 10.0297H44.71L44.353 11.1757H42.025L44.9605 3.18825L44.9613 3.1875ZM46.501 6.2685L47.1092 8.20275L45.2477 8.2035L45.856 6.2685C46.0018 5.88843 46.0981 5.49116 46.1425 5.0865H46.2145C46.232 5.16552 46.2495 5.25314 46.268 5.3462C46.3253 5.63282 46.3929 5.9714 46.501 6.2685ZM28.0998 14.6152H30.0685V20.775H32.3598V14.6152H34.3293V12.7522H28.0998V14.6152ZM43.207 16.764C43.207 14.7938 41.8112 12.609 38.8397 12.609C35.8682 12.609 34.4725 14.7938 34.4725 16.764C34.4725 18.7343 35.8682 20.919 38.8397 20.919C41.8112 20.919 43.207 18.7343 43.207 16.764ZM38.8398 14.6152C37.7658 14.6152 36.7998 15.3675 36.7998 16.8C36.7998 18.2325 37.7298 18.9495 38.8398 18.9495C39.9498 18.9495 40.8798 18.2325 40.8798 16.8C40.8798 15.3315 39.9498 14.6152 38.8398 14.6152ZM46.966 12.7522H44.0305V20.7757H46.966C49.7582 20.7757 51.4053 19.2 51.4053 16.7647C51.4053 14.2568 49.7935 12.7522 46.966 12.7522ZM46.3218 18.9135H46.8228C48.2905 18.9135 49.078 18.1973 49.078 16.764C49.078 15.3315 48.2905 14.6152 46.8228 14.6152H46.3218V18.9135ZM56.56 12.7522H54.0543L51.1188 20.7405H53.446L53.803 19.5938H56.8105L57.169 20.7397H59.5315L56.56 12.7522ZM56.2023 17.8027L55.5933 15.8685C55.486 15.572 55.4186 15.2347 55.3615 14.9485C55.3428 14.8547 55.3251 14.7661 55.3075 14.6865H55.2715C55.2271 15.0912 55.1308 15.4884 54.985 15.8685L54.3768 17.8035L56.2023 17.8027ZM57.9925 12.7522L60.9632 17.9107V20.7757H63.3618V17.9107L66.3333 12.7522H63.8988L62.8247 14.7225C62.6102 15.1163 62.2878 15.7612 62.2165 16.191H62.1805C62.1096 15.799 61.7896 15.1579 61.5751 14.7282L61.5723 14.7225L60.4975 12.7522H57.9925Z",
    fill: "currentColor"
  })
});

var WSJ = /*#__PURE__*/createIcon({
  displayName: "WSJ",
  viewBox: "0 0 47 24",
  path: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.429 7.9095H33.024C33.024 6.42225 31.542 0.60825 28.578 0.60825C27.4995 0.60825 25.7475 0.9465 25.7475 3.58275C25.7475 5.91951 28.0756 8.04308 29.4496 9.29639C29.6261 9.45741 29.7869 9.60411 29.925 9.735C30.0365 9.8407 30.1668 9.95953 30.3115 10.0915C31.7407 11.395 34.575 13.9801 34.575 17.8477C34.575 22.1077 31.677 23.865 29.049 23.865C27.3592 23.865 26.4494 23.3056 25.8001 22.9064C25.44 22.6849 25.16 22.5128 24.8715 22.5128C24.063 22.5128 23.9287 23.7292 23.9287 23.7292H23.5238V16.0222H23.9287C23.9287 18.1185 25.4783 23.3242 29.049 23.3242C30.3967 23.3242 32.2162 22.4453 32.2162 19.2C32.2162 16.3932 28.9904 13.536 27.6829 12.3779C27.4787 12.197 27.3212 12.0575 27.2302 11.9663C27.1584 11.8942 27.0582 11.8007 26.9366 11.6871C25.917 10.7351 23.3895 8.37512 23.3895 5.47575C23.3895 1.0815 26.4893 0 28.6447 0C30.0039 0 30.8275 0.510423 31.4365 0.887817C31.7937 1.10916 32.077 1.28475 32.3512 1.28475C33.0923 1.28475 33.0923 0.135 33.0923 0.135H33.429V7.9095ZM0.75 0.135H7.2855V0.54075C7.2855 0.54075 5.46675 0.67575 5.601 1.8255C5.8035 2.9745 9.24 16.6305 9.24 16.6305L11.8673 6.4905C11.8673 6.4905 10.857 2.63625 10.6545 1.6905C10.3853 0.8115 9.846 0.6075 9.1725 0.54V0.0675H15.843V0.4725C15.843 0.4725 13.8218 0.4725 14.0235 1.89225C14.226 3.312 17.5275 16.6297 17.5275 16.6297C17.5275 16.6297 20.8965 3.04125 21.0315 2.433C21.1665 1.82475 20.964 0.4725 19.1445 0.4725V0.0675H23.9955V0.4725C23.9955 0.4725 22.3785 0.6075 21.9743 2.09475C21.57 3.582 16.6515 23.7285 16.6515 23.7285H16.2472L12.2723 7.84125L8.22975 23.7285H7.89225C7.89225 23.7285 2.77125 2.907 2.502 1.8255C2.25022 0.816997 1.23736 0.630232 0.82872 0.55488C0.799142 0.549426 0.772729 0.544556 0.75 0.54V0.135ZM46.9725 0.135H39.9645V0.54075C42.1882 0.54075 42.0532 2.43375 42.0532 2.43375V19.8757C42.0532 23.0535 40.5037 23.3243 39.6278 23.3243C38.7518 23.3243 37.3372 22.7153 37.3372 21.4988C37.3372 20.9723 37.7027 20.7368 38.1176 20.4695C38.6618 20.1188 39.291 19.7134 39.291 18.5243C39.291 18.456 39.291 16.9013 37.674 16.9013C36.1245 16.9013 35.5845 18.7267 35.5845 19.5375C35.5845 20.349 36.1245 24 40.032 24C45.288 24 45.0855 18.321 45.0855 18.321V2.29875C45.0855 0.54075 46.9725 0.54075 46.9725 0.54075V0.135Z",
    fill: "currentColor"
  })
});

var index = {
  __proto__: null,
  Airhelp: Airhelp,
  AirhelpSolid: AirhelpSolid,
  AirhelpPlus: AirhelpPlus,
  AirhelpPlusSolid: AirhelpPlusSolid,
  APRA: APRA,
  APRASolid: APRASolid,
  TheNewYorkTimes: TheNewYorkTimes,
  TheWashingtonPost: TheWashingtonPost,
  USAToday: USAToday,
  WSJ: WSJ
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function getSelectStyles() {
  return {
    container: function container(provided) {
      return _extends({}, provided, {
        width: "100%"
      });
    },
    placeholder: function placeholder(provided) {
      return _extends({}, provided, {
        color: "greyscale.500",
        marginRight: 0
      });
    },
    control: function control(provided, state) {
      return _extends({}, provided, {
        cursor: "pointer",
        borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
        paddingY: spacing3x + " !important",
        paddingX: spacing4x + " !important",
        width: "auto",
        minWidth: "auto",
        minHeight: "auto",
        lineHeight: spacing5x,
        color: "font.primary",
        "> div": {
          padding: "unset"
        },
        _invalid: {
          borderColor: state.selectProps.colorScheme === "warning" ? "warning.600" : "danger.700",
          _hover: {
            borderColor: {
              md: state.selectProps.colorScheme === "warning" ? "warning.700" : "danger.800"
            }
          },
          _focus: {
            borderColor: "primary.500"
          }
        },
        input: {
          maxHeight: spacing6x
        }
      });
    },
    menu: function menu(provided) {
      return _extends({}, provided, {
        margin: "unset",
        zIndex: "10"
      });
    },
    menuList: function menuList(provided) {
      return _extends({}, provided, {
        color: "greyscale.700",
        background: "greyscale.100",
        border: "1px solid",
        borderColor: "primary.500",
        borderTop: "none !important",
        borderTopRadius: 0,
        paddingX: "unset",
        paddingY: "unset",
        maxHeight: "12.25em",
        minWidth: "auto",
        "::-webkit-scrollbar": {
          width: spacing2x
        },
        "::-webkit-scrollbar-track": {
          background: "greyscale.100",
          borderRadius: borderRadiusMd,
          marginBottom: "3px"
        },
        "::-webkit-scrollbar-thumb": {
          background: "greyscale.400",
          borderRadius: "24px"
        },
        "::-webkit-scrollbar-thumb:hover": {
          background: {
            md: "greyscale.400"
          }
        }
      });
    },
    option: function option(provided, state) {
      return _extends({}, provided, {
        paddingX: spacing4x + " !important",
        paddingY: spacing2x + " !important",
        background: state.isFocused || state.isSelected ? "primary.100" : "greyscale.100",
        color: state.isFocused || state.isSelected ? "primary.500" : "font.primary",
        borderRadius: borderRadiusSm,
        width: "auto",
        cursor: "pointer",
        _hover: {
          color: {
            md: "primary.500"
          }
        },
        _active: {
          background: "primary.200"
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(provided, state) {
      return _extends({}, provided, {
        background: state.isDisabled ? "greyscale.300" : "transparent",
        border: "none",
        color: state.selectProps.isDisabled ? "greyscale.500" : "greyscale.700",
        paddingX: "unset",
        transform: state.selectProps.menuIsOpen && "rotate(180deg)",
        display: "flex",
        justifyContent: state.selectProps.menuIsOpen ? "start" : "end",
        minWidth: "auto",
        svg: {
          boxSize: 5,
          color: "primary.900"
        }
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _extends({}, provided, {
        display: "none"
      });
    },
    inputContainer: function inputContainer(provided) {
      return _extends({}, provided, {
        cursor: "text"
      });
    }
  };
}

function getAutocompleteStyles() {
  return _extends({}, getSelectStyles(), {
    placeholder: function placeholder(provided) {
      return _extends({}, provided, {
        color: "greyscale.500",
        marginRight: 0
      });
    },
    control: function control(provided, state) {
      return _extends({}, provided, {
        cursor: "text",
        borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
        flexDirection: "row-reverse",
        paddingY: spacing3x + " !important",
        paddingX: spacing4x + " !important",
        width: "auto",
        minWidth: "auto",
        minHeight: "auto",
        lineHeight: spacing5x,
        color: "font.primary",
        "> div": {
          padding: "unset",
          flexWrap: "nowrap",
          "> div": {
            marginLeft: "0",
            marginRight: "0"
          },
          "[class$=singleValue]": {
            color: "inherit"
          }
        },
        _invalid: {
          borderColor: state.selectProps.colorScheme === "warning" ? "warning.600" : "danger.700",
          _hover: {
            borderColor: {
              md: state.selectProps.colorScheme === "warning" ? "warning.700" : "danger.800"
            }
          },
          _focus: {
            borderColor: "primary.500"
          }
        },
        input: {
          maxHeight: spacing6x
        }
      });
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _extends({}, provided, {
        div: {
          padding: "unset",
          marginRight: 0,
          pointerEvents: "none"
        }
      });
    },
    inputContainer: function inputContainer(provided) {
      return _extends({}, provided, {
        cursor: "text"
      });
    }
  });
}
function getAutocompleteWithIconStyles() {
  return _extends({}, getAutocompleteStyles(), {
    placeholder: function placeholder(provided) {
      return _extends({}, provided, {
        color: "greyscale.500",
        marginRight: 0
      });
    },
    control: function control(provided, state) {
      return _extends({}, provided, {
        cursor: "text",
        borderBottomRadius: state.menuIsOpen ? 0 : borderRadiusMd,
        flexDirection: "row-reverse",
        paddingY: spacing3x + " !important",
        paddingLeft: spacing12x + " !important",
        paddingRight: spacing4x + " !important",
        width: "auto",
        minWidth: "auto",
        minHeight: "auto",
        lineHeight: spacing5x,
        color: "font.primary",
        "> div": {
          padding: "unset",
          whiteSpace: "pre",
          flexWrap: "nowrap",
          "> div": {
            marginLeft: "0",
            marginRight: "0"
          },
          "[class$=singleValue]": {
            color: "inherit"
          }
        },
        _invalid: {
          borderColor: state.selectProps.colorScheme === "warning" ? "warning.600" : "danger.700",
          _hover: {
            borderColor: {
              md: state.selectProps.colorScheme === "warning" ? "warning.700" : "danger.800"
            }
          },
          _focus: {
            borderColor: "primary.500"
          }
        },
        input: {
          maxHeight: spacing6x
        }
      });
    }
  });
}

var desktopWidth = 992;

var RESIZE_DEBOUNCE_TIME = 200;

var getWindowWidth = function getWindowWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};
function useMobileDetect() {
  var _React$useState = React.useState(window.innerWidth < desktopWidth),
      isMobile = _React$useState[0],
      setIsMobile = _React$useState[1];

  var handleSizeChange = function handleSizeChange() {
    return debounce(function () {
      var width = getWindowWidth();
      setIsMobile(width < desktopWidth);
    }, RESIZE_DEBOUNCE_TIME)();
  };

  React.useEffect(function () {
    handleSizeChange();
    window.addEventListener("resize", handleSizeChange);
    return function () {
      window.removeEventListener("resize", handleSizeChange);
    };
  }, [isMobile]);
  return isMobile;
}

var _excluded$a = ["icon", "label", "errorMessage", "placeholder", "caption", "isDisabled", "isInvalid", "isDouble", "colorScheme", "iconPlacement", "leftAddonText"];
var ErrorIconColor = {
  danger: "danger.700",
  dangerHovered: "danger.800",
  warning: "warning.600",
  warningHovered: "warning.700"
};
var defaultErrorIconColor = function defaultErrorIconColor(colorScheme) {
  return colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger;
};
var defaultHoverErrorIconColor = function defaultHoverErrorIconColor(colorScheme) {
  return colorScheme === "warning" ? ErrorIconColor.warningHovered : ErrorIconColor.dangerHovered;
};
var Input$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      label = _ref.label,
      errorMessage = _ref.errorMessage,
      placeholder = _ref.placeholder,
      caption = _ref.caption,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      isDouble = _ref.isDouble,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? "error" : _ref$colorScheme,
      _ref$iconPlacement = _ref.iconPlacement,
      iconPlacement = _ref$iconPlacement === void 0 ? "left" : _ref$iconPlacement,
      leftAddonText = _ref.leftAddonText,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  var isLeftSideIcon = icon && iconPlacement === "left";
  var isRightSideIcon = icon && iconPlacement === "right";

  var _useState = useState("greyscale.500"),
      iconColor = _useState[0],
      setIconColor = _useState[1];

  var _useState2 = useState(defaultErrorIconColor(colorScheme)),
      errorIconColor = _useState2[0],
      setErrorIconColor = _useState2[1];

  var _useState3 = useState(false),
      isInputFocused = _useState3[0],
      setIsInputFocused = _useState3[1];

  var isMobile = useMobileDetect();

  var hoveredErrorIconColor = function hoveredErrorIconColor() {
    return isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
  };

  var onFocus = function onFocus() {
    setIconColor("primary.500");
    setErrorIconColor("transparent");
    setIsInputFocused(true);
  };

  var onBlur = function onBlur() {
    setIconColor("greyscale.500");
    setErrorIconColor(defaultErrorIconColor(colorScheme));
    setIsInputFocused(false);
  };

  var onMouseOver = function onMouseOver() {
    if (!isInputFocused) setErrorIconColor(hoveredErrorIconColor());
  };

  var onMouseOut = function onMouseOut() {
    if (!isInputFocused) setErrorIconColor(defaultErrorIconColor(colorScheme));
  };

  useEffect(function () {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
  }, [colorScheme]);
  return jsxs(FormControl, {
    alignItems: "start",
    isInvalid: isInvalid,
    children: [jsx(FormLabel$1, {
      fontWeight: "bold",
      children: label
    }), isDouble ? jsxs(InputGroup, {
      children: [jsx(InputLeftAddon, {
        display: "flex",
        justifyContent: "center",
        children: leftAddonText
      }), jsx(Input$3, _extends({
        placeholder: placeholder,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        colorScheme: colorScheme,
        maxW: "68px"
      }, props))]
    }) : jsxs(InputGroup, {
      color: iconColor,
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      children: [jsx(Input$3, _extends({
        placeholder: placeholder,
        isDisabled: isDisabled,
        colorScheme: colorScheme,
        ref: ref
      }, props)), isRightSideIcon && !isInvalid ? jsx(InputRightElement, {
        pointerEvents: "none",
        children: icon
      }) : null, isLeftSideIcon ? jsx(InputLeftElement, {
        pointerEvents: "none",
        children: icon
      }) : null, isInvalid && jsxs(InputRightElement, {
        pointerEvents: "none",
        right: isRightSideIcon ? 4 : 0,
        children: [jsx(Info, {
          boxSize: 4,
          color: errorIconColor,
          mr: isRightSideIcon ? 1 : 0
        }), isRightSideIcon ? icon : null]
      })]
    }), !isInvalid ? caption && jsx(FormHelperText, {
      children: caption
    }) : errorMessage && jsx(FormErrorMessage, {
      colorScheme: colorScheme,
      children: errorMessage
    })]
  });
});
var Input$2 = Input$1;

var _excluded$9 = ["icon", "label", "caption", "isInvalid", "colorScheme", "dataTestId", "handleChange", "errorMessage", "formControlStyles"];

function getAutocompleteIcon$1(iconColor, icon) {
  return function (dropdownIndicatorProps) {
    return icon ? jsx(components$1.DropdownIndicator, _extends({}, dropdownIndicatorProps, {
      children: jsx(InputLeftElement, {
        color: iconColor,
        height: "46px",
        children: icon
      })
    })) : null;
  };
}

function getLoadingIndicator$1() {
  return function () {
    return jsx(Spinner$1, {
      size: "xs",
      position: "absolute",
      right: 4
    });
  };
}

function getSingleValue$1() {
  return function (singleValueProps) {
    return jsx(components$1.SingleValue, _extends({}, singleValueProps, {
      children: singleValueProps.data.label
    }));
  };
}

function Autocomplete(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      caption = _ref.caption,
      isInvalid = _ref.isInvalid,
      colorScheme = _ref.colorScheme,
      dataTestId = _ref.dataTestId,
      handleChange = _ref.handleChange,
      errorMessage = _ref.errorMessage,
      formControlStyles = _ref.formControlStyles,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  var _useState = useState(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger),
      errorIconColor = _useState[0],
      setErrorIconColor = _useState[1];

  var _useState2 = useState("greyscale.500"),
      iconColor = _useState2[0],
      setIconColor = _useState2[1];

  var _useState3 = useState(false),
      isAutocompleteFocused = _useState3[0],
      setIsAutocompleteFocused = _useState3[1];

  var reactSelectStyles = useMemo(function () {
    return icon ? getAutocompleteWithIconStyles() : getAutocompleteStyles();
  }, [icon]);
  useEffect(function () {
    setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
  }, [colorScheme]);

  var onFocus = function onFocus() {
    setIconColor("primary.500");
    setErrorIconColor("transparent");
    setIsAutocompleteFocused(true);
  };

  var onBlur = function onBlur() {
    setIconColor("greyscale.500");
    setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
    setIsAutocompleteFocused(false);
  };

  var onMouseOver = function onMouseOver() {
    if (!isAutocompleteFocused) {
      setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warningHovered : ErrorIconColor.dangerHovered);
    }
  };

  var onMouseOut = function onMouseOut() {
    if (!isAutocompleteFocused) {
      setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
    }
  };

  return jsxs(FormControl, _extends({}, formControlStyles, {
    alignItems: "start",
    isInvalid: isInvalid,
    children: [label && jsx(FormLabel$1, {
      fontWeight: "bold",
      children: label
    }), jsx(InputGroup, {
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      "data-testid": dataTestId,
      isolation: "unset",
      children: jsx(Select$1, _extends({}, props, {
        colorScheme: colorScheme,
        isInvalid: isInvalid,
        chakraStyles: reactSelectStyles,
        onChange: handleChange,
        components: {
          DropdownIndicator: getAutocompleteIcon$1(iconColor, icon),
          LoadingIndicator: getLoadingIndicator$1(),
          ClearIndicator: function ClearIndicator() {
            return null;
          },
          SingleValue: getSingleValue$1()
        },
        noOptionsMessage: function noOptionsMessage() {
          return null;
        },
        loadingMessage: function loadingMessage() {
          return null;
        },
        openMenuOnFocus: false,
        openMenuOnClick: false,
        backspaceRemovesValue: true,
        isClearable: true,
        isSearchable: true,
        blurInputOnSelect: true,
        closeMenuOnSelect: true
      }))
    }), jsx(FormErrorMessage, {
      colorScheme: colorScheme,
      children: errorMessage
    }), isInvalid && jsx(InputGroup, {
      children: jsx(InputRightElement, {
        right: 1,
        top: "unset",
        bottom: "30px",
        pointerEvents: "none",
        children: jsx(Info, {
          boxSize: 4,
          pointerEvents: "none",
          color: errorIconColor
        })
      })
    }), caption && !isInvalid && jsx(FormHelperText, {
      children: caption
    })]
  }));
}

var _excluded$8 = ["icon", "label", "caption", "isInvalid", "colorScheme", "dataTestId", "handleChange", "errorMessage", "formControlStyles"];

function getAutocompleteIcon(iconColor, icon) {
  return function (dropdownIndicatorProps) {
    return icon ? jsx(components$1.DropdownIndicator, _extends({}, dropdownIndicatorProps, {
      children: jsx(InputLeftElement, {
        color: iconColor,
        height: "46px",
        children: icon
      })
    })) : null;
  };
}

function getLoadingIndicator() {
  return function () {
    return jsx(Spinner$1, {
      size: "xs",
      position: "absolute",
      right: 4
    });
  };
}

function getSingleValue() {
  return function (singleValueProps) {
    return jsxs(components$1.SingleValue, _extends({}, singleValueProps, {
      children: [singleValueProps.data.value.name, ", ", singleValueProps.data.value.iata]
    }));
  };
}

function AirportAutocomplete(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      caption = _ref.caption,
      isInvalid = _ref.isInvalid,
      colorScheme = _ref.colorScheme,
      dataTestId = _ref.dataTestId,
      handleChange = _ref.handleChange,
      errorMessage = _ref.errorMessage,
      formControlStyles = _ref.formControlStyles,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  var _useState = useState(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger),
      errorIconColor = _useState[0],
      setErrorIconColor = _useState[1];

  var _useState2 = useState("greyscale.500"),
      iconColor = _useState2[0],
      setIconColor = _useState2[1];

  var _useState3 = useState(false),
      isAutocompleteFocused = _useState3[0],
      setIsAutocompleteFocused = _useState3[1];

  var reactSelectStyles = useMemo(function () {
    return icon ? getAutocompleteWithIconStyles() : getAutocompleteStyles();
  }, [icon]);
  useEffect(function () {
    setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
  }, [colorScheme]);

  var onFocus = function onFocus() {
    setIconColor("primary.500");
    setErrorIconColor("transparent");
    setIsAutocompleteFocused(true);
  };

  var onBlur = function onBlur() {
    setIconColor("greyscale.500");
    setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
    setIsAutocompleteFocused(false);
  };

  var onMouseOver = function onMouseOver() {
    if (!isAutocompleteFocused) {
      setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warningHovered : ErrorIconColor.dangerHovered);
    }
  };

  var onMouseOut = function onMouseOut() {
    if (!isAutocompleteFocused) {
      setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
    }
  };

  var formatOptionLabel = function formatOptionLabel(option) {
    return jsxs(Box, {
      children: [jsxs(Text$1, {
        fontSize: "md",
        color: "none",
        children: [option.value.name, ", ", option.value.iata]
      }), jsxs(Text$1, {
        fontSize: "sm",
        color: "none",
        children: [option.value.city, ", ", option.value.country]
      })]
    });
  };

  return jsxs(FormControl, _extends({}, formControlStyles, {
    alignItems: "start",
    isInvalid: isInvalid,
    children: [label && jsx(FormLabel$1, {
      fontWeight: "bold",
      children: label
    }), jsx(InputGroup, {
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      "data-testid": dataTestId,
      isolation: "unset",
      children: jsx(Select$1, _extends({
        colorScheme: colorScheme,
        isInvalid: isInvalid,
        onChange: handleChange,
        noOptionsMessage: function noOptionsMessage() {
          return null;
        },
        loadingMessage: function loadingMessage() {
          return null;
        },
        openMenuOnFocus: false,
        openMenuOnClick: false,
        backspaceRemovesValue: true,
        isClearable: true,
        isSearchable: true,
        blurInputOnSelect: true,
        isOptionDisabled: function isOptionDisabled(option) {
          return Boolean(option.isDisabled);
        },
        closeMenuOnSelect: true,
        filterOption: function filterOption() {
          return true;
        },
        formatOptionLabel: formatOptionLabel
      }, props, {
        chakraStyles: reactSelectStyles,
        components: {
          DropdownIndicator: getAutocompleteIcon(iconColor, icon),
          LoadingIndicator: getLoadingIndicator(),
          ClearIndicator: function ClearIndicator() {
            return null;
          },
          SingleValue: getSingleValue()
        }
      }))
    }), jsx(FormErrorMessage, {
      colorScheme: colorScheme,
      children: errorMessage
    }), isInvalid && jsx(InputGroup, {
      children: jsx(InputRightElement, {
        right: 1,
        top: "unset",
        bottom: "30px",
        pointerEvents: "none",
        children: jsx(Info, {
          boxSize: 4,
          pointerEvents: "none",
          color: errorIconColor
        })
      })
    }), caption && !isInvalid && jsx(FormHelperText, {
      children: caption
    })]
  }));
}

var _excluded$7 = ["text"];

var ConsumerRights = function ConsumerRights(_ref) {
  var text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return jsxs(Badge$1, _extends({
    display: "flex",
    alignItems: "center"
  }, props, {
    children: [jsx(Protect, {
      mr: 2,
      boxSize: 6,
      color: "primary.900"
    }), jsx("div", {
      children: text
    })]
  }));
};

var ConsumerRights$1 = ConsumerRights;

var _excluded$6 = ["text"];

var EURegulation = function EURegulation(_ref) {
  var text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  return jsxs(Badge$1, _extends({
    display: "flex",
    alignItems: "center"
  }, props, {
    children: [jsx(EuropeUnion, {
      mr: 2,
      boxSize: 6
    }), jsx("div", {
      children: text
    })]
  }));
};

var EURegulation$1 = EURegulation;

var _excluded$5 = ["text"];

var Trustpilot = function Trustpilot(_ref) {
  var text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  return jsxs(Box, _extends({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, props, {
    children: [jsx(TrustPilotLogo, {
      mr: 2,
      w: 5,
      h: 5
    }), jsx(Text$1, {
      fontSize: "sm",
      fontWeight: "bold",
      color: "font.primary",
      children: text
    })]
  }));
};

var Trustpilot$1 = Trustpilot;

var _excluded$4 = ["hideNotice", "buttonText", "htmlText", "onClick"];
var cookieTextStyles = {
  a: {
    textDecoration: "underline",
    color: "greyscale.600",
    cursor: "pointer"
  }
};
var animationVariants = {
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: "easeOut"
    }
  },
  enter: {
    opacity: 1,
    transition: {
      duration: 0.1,
      ease: "easeIn"
    }
  }
};

var CookiesNotice = function CookiesNotice(_ref) {
  var hideNotice = _ref.hideNotice,
      buttonText = _ref.buttonText,
      htmlText = _ref.htmlText,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return jsxs(Box, _extends({
    as: Fade,
    "in": !hideNotice,
    variants: animationVariants,
    unmountOnExit: true,
    zIndex: 999,
    position: "fixed",
    display: {
      base: "inline",
      md: "inline-grid"
    },
    boxShadow: "alt",
    bg: "white",
    borderRadius: {
      base: "none",
      md: "md"
    },
    w: {
      base: "100%",
      md: "311px"
    },
    right: {
      md: 4
    },
    bottom: {
      base: 0,
      md: "70px"
    },
    py: {
      base: 4,
      md: "8"
    },
    px: 6,
    boxSizing: "border-box",
    "data-testid": "cookiesNotice"
  }, props, {
    children: [jsx(Text$1, {
      fontSize: "md",
      color: "greyscale.600",
      mb: {
        base: 0,
        md: 5
      },
      mr: {
        base: 3,
        md: 0
      },
      sx: cookieTextStyles,
      dangerouslySetInnerHTML: {
        __html: htmlText
      },
      as: "span"
    }), jsx(Button$1, {
      title: buttonText,
      variant: "linkPrimary",
      bg: "transparent",
      border: "none",
      color: "primary.500",
      _focus: {
        boxShadow: "none"
      },
      _hover: {
        md: {
          color: "primary.600"
        }
      },
      fontWeight: "semibold",
      justifyContent: "left",
      onClick: onClick,
      cursor: "pointer",
      fontFamily: "Lab Grotesque",
      "data-testid": "cookiesNoticeButton",
      pl: 0,
      children: buttonText
    })]
  }));
};

var CookiesNotice$1 = CookiesNotice;

var _excluded$3 = ["children", "title", "headingIcon", "isChat", "variant", "width"];
var MotionBox = /*#__PURE__*/motion(chakra.div);
var variants$e = {
  visible: {
    opacity: 1,
    height: "auto"
  },
  hidden: {
    opacity: 0,
    height: 0,
    overflow: "hidden"
  }
};

var Collapsible$1 = function Collapsible(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$headingIcon = _ref.headingIcon,
      headingIcon = _ref$headingIcon === void 0 ? undefined : _ref$headingIcon,
      _ref$isChat = _ref.isChat,
      isChat = _ref$isChat === void 0 ? false : _ref$isChat,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "primary" : _ref$variant,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "full" : _ref$width,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var styles = useMultiStyleConfig("Collapsible", {
    variant: variant
  });

  var _useState = useState(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var handleOnClick = function handleOnClick() {
    return setIsVisible(function (prevState) {
      return !prevState;
    });
  };

  var actionIcon = isVisible ? jsx(AltArrowCollapse, {}) : jsx(AltArrowExpand, {});
  var containerBorderRadius = isChat ? {
    borderTopRightRadius: "lg",
    borderBottomRadius: "lg"
  } : undefined;
  var contentPadding = headingIcon ? {
    paddingLeft: 12,
    paddingRight: 6
  } : 0;
  return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsxs(chakra.div, _extends({
      __css: styles.container
    }, containerBorderRadius, {
      w: width
    }, props, {
      children: [jsxs(chakra.div, {
        __css: styles.header,
        onClick: handleOnClick,
        "data-testid": "collapsible",
        children: [jsxs(chakra.div, {
          __css: styles.headerInner,
          children: [headingIcon && jsx(chakra.div, {
            __css: styles.iconContainer,
            children: headingIcon
          }), jsx(chakra.p, {
            __css: styles.title,
            children: title
          })]
        }), jsx(chakra.button, {
          __css: styles.actionButton,
          children: actionIcon
        })]
      }), jsx(AnimatePresence, {
        initial: false,
        children: isVisible && jsx(MotionBox, _extends({
          initial: "hidden",
          animate: "visible",
          exit: "hidden",
          variants: variants$e,
          transition: {
            duration: 0.2
          }
        }, contentPadding, {
          __css: styles.body,
          children: children
        }))
      })]
    }))
  );
};

var Collapsible$2 = Collapsible$1;

var CustomInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inputPlaceholder = _ref.inputPlaceholder,
      onClick = _ref.onClick,
      label = _ref.label,
      errorMessage = _ref.errorMessage,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      value = _ref.value,
      isReadOnly = _ref.isReadOnly;
  return jsx(Input$2, {
    name: "datepicker",
    label: label,
    placeholder: inputPlaceholder || "",
    isDisabled: disabled || false,
    isInvalid: invalid,
    errorMessage: errorMessage,
    colorScheme: colorScheme,
    icon: jsx(Calendar, {
      boxSize: 6
    }),
    onChange: function onChange() {
      return undefined;
    },
    value: value,
    autoComplete: "off",
    onClick: onClick,
    ref: ref,
    isReadOnly: isReadOnly,
    "data-testid": "datePicker"
  });
});

var NavigationHeader = function NavigationHeader(_ref2) {
  var date = _ref2.date,
      decreaseMonth = _ref2.decreaseMonth,
      increaseMonth = _ref2.increaseMonth,
      changeYear = _ref2.changeYear,
      locale = _ref2.locale,
      onNavClick = _ref2.onNavClick,
      modeConfig = _ref2.modeConfig;
  var onPreviousClick = useCallback(function () {
    if (modeConfig.yearDelta) {
      changeYear(date.getFullYear() - modeConfig.yearDelta);
    } else {
      decreaseMonth();
    }
  }, [date, modeConfig, changeYear, decreaseMonth]);
  var onNextClick = useCallback(function () {
    if (modeConfig.yearDelta) {
      changeYear(date.getFullYear() + modeConfig.yearDelta);
    } else {
      increaseMonth();
    }
  }, [date, modeConfig, changeYear, increaseMonth]);
  return jsxs("div", {
    className: "header-navigation",
    children: [jsx(IconButton, {
      "aria-label": "Previous",
      icon: jsx(AltArrowBack, {
        color: "primary.900"
      }),
      onClick: onPreviousClick,
      "data-testid": "previous",
      bg: "none",
      _hover: {
        md: {
          bg: "greyscale.200"
        }
      },
      _active: {
        bg: "greyscale.300"
      },
      _focus: {
        boxShadow: "none"
      },
      minW: 8,
      minH: 8
    }), jsx(Button$1, {
      variant: "subtle",
      size: "md",
      color: "primary.900",
      onClick: onNavClick,
      "data-testid": "current",
      _focus: {
        boxShadow: "none"
      },
      children: modeConfig.formatDate(date, locale)
    }), jsx(IconButton, {
      "aria-label": "Next",
      icon: jsx(AltArrowForward, {
        color: "primary.900"
      }),
      onClick: onNextClick,
      "data-testid": "next",
      bg: "none",
      _hover: {
        md: {
          bg: "greyscale.200"
        }
      },
      _active: {
        bg: "greyscale.300"
      },
      _focus: {
        boxShadow: "none"
      },
      minW: 8,
      minH: 8
    })]
  });
};

var modes = {
  day: {
    formatDate: function formatDate(date, locale) {
      return format(date, "LLLL yyyy", {
        locale: locale
      });
    },
    nextMode: "month"
  },
  month: {
    yearDelta: 1,
    formatDate: function formatDate(date, locale) {
      return format(date, "yyyy", {
        locale: locale
      });
    },
    nextMode: "year",
    previousMode: "day"
  },
  year: {
    yearDelta: 12,
    formatDate: function formatDate(date) {
      var mod = date.getFullYear() % 12;
      var delta = mod === 0 ? 12 : mod;
      var minYear = date.getFullYear() - delta + 1;
      var maxYear = date.getFullYear() - delta + 12;
      return minYear + " - " + maxYear;
    },
    previousMode: "month"
  }
};

var DatePicker = function DatePicker(_ref3) {
  var value = _ref3.value,
      _onChange = _ref3.onChange,
      label = _ref3.label,
      placeholder = _ref3.placeholder,
      disabled = _ref3.disabled,
      invalid = _ref3.invalid,
      maxDate = _ref3.maxDate,
      minDate = _ref3.minDate,
      locale = _ref3.locale,
      _ref3$dateFormat = _ref3.dateFormat,
      dateFormat = _ref3$dateFormat === void 0 ? "dd/MM/yyyy" : _ref3$dateFormat,
      errorMessage = _ref3.errorMessage,
      colorScheme = _ref3.colorScheme,
      isReadOnly = _ref3.isReadOnly;
  var calendarRef = useRef(null);

  var _useState = useState("day"),
      mode = _useState[0],
      setMode = _useState[1];

  var _modes$mode = modes[mode],
      nextMode = _modes$mode.nextMode,
      previousMode = _modes$mode.previousMode;

  var changeMode = function changeMode(modeOption) {
    return modeOption && setMode(modeOption);
  };

  var _useState2 = useState(minDate),
      internalMinDate = _useState2[0],
      setInternalMinDate = _useState2[1];

  useEffect(function () {
    if (minDate !== undefined) {
      var date = new Date(minDate);

      switch (mode) {
        case "day":
          setInternalMinDate(minDate);
          break;

        case "month":
          date.setMonth(new Date(minDate).getMonth() - 1);
          setInternalMinDate(date);
          break;

        case "year":
          date.setFullYear(new Date(minDate).getFullYear() - 1);
          setInternalMinDate(date);
          break;
      }
    }
  }, [mode, minDate]);
  return jsx(ReactDatePicker, {
    allowSameDay: true,
    ref: calendarRef,
    dateFormat: dateFormat,
    locale: locale,
    selected: value,
    onChange: function onChange(newValue) {
      if (mode === "day") {
        var _calendarRef$current;

        _onChange(newValue);

        calendarRef == null ? void 0 : (_calendarRef$current = calendarRef.current) == null ? void 0 : _calendarRef$current.setOpen(false);
      } else {
        changeMode(previousMode);
      }
    },
    customInput: jsx(CustomInput, {
      label: label,
      inputPlaceholder: placeholder,
      disabled: disabled,
      invalid: invalid,
      errorMessage: errorMessage,
      colorScheme: colorScheme,
      isReadOnly: isReadOnly
    }),
    disabled: disabled,
    showPopperArrow: false,
    maxDate: maxDate,
    minDate: internalMinDate,
    renderCustomHeader: function renderCustomHeader(props) {
      return jsx(NavigationHeader, _extends({}, props, {
        locale: locale,
        onNavClick: function onNavClick() {
          return changeMode(nextMode);
        },
        modeConfig: modes[mode]
      }));
    },
    popperPlacement: "bottom-start",
    onCalendarClose: function onCalendarClose() {
      setMode("day");
    },
    showYearPicker: mode === "year",
    showMonthYearPicker: mode === "month",
    shouldCloseOnSelect: false,
    popperModifiers: [{
      name: "preventOverflow",
      options: {
        rootBoundary: "viewport",
        tether: false,
        altAxis: true
      }
    }, {
      name: "offset",
      options: {
        offset: [-2, -2]
      }
    }]
  });
};

var DatePicker$1 = DatePicker;

var locales = {
  da: da,
  de: de,
  el: el,
  es: es,
  fi: fi,
  fr: fr,
  it: it,
  nb: nb,
  nl: nl,
  pl: pl,
  pt: pt,
  ro: ro,
  ru: ru,
  sv: sv,
  "pt-BR": ptBR,
  en: enGB,
  "zh-CN": zhCN
};
var registerLocales = function registerLocales() {
  Object.keys(locales).forEach(function (localeKey) {
    registerLocale(localeKey, locales[localeKey]);
  });
};

var styles$6 = {"documentsUploader":"DocumentsUploader-module_documentsUploader__zyFoW","isFocused":"DocumentsUploader-module_isFocused__qTHYo","isFilesView":"DocumentsUploader-module_isFilesView__lIcJl","hasError":"DocumentsUploader-module_hasError__6DnL4","heading":"DocumentsUploader-module_heading__jp9nV","selectFile":"DocumentsUploader-module_selectFile__gFDKJ","supportedFiles":"DocumentsUploader-module_supportedFiles__o5w6J","loadingLabel":"DocumentsUploader-module_loadingLabel__TLNxG","fadeInDown":"DocumentsUploader-module_fadeInDown__11nI4"};

var styles$5 = {"filesView":"FilesView-module_filesView__mSGau","uploadButton":"FilesView-module_uploadButton__TfnLu","fileList":"FilesView-module_fileList__sg-pa","fileItem":"FilesView-module_fileItem__o-kUZ","fileWithErrorWrapper":"FilesView-module_fileWithErrorWrapper__ge3il","withDeleteIcon":"FilesView-module_withDeleteIcon__G1Q4G","fileNameWrapper":"FilesView-module_fileNameWrapper__hAHDi","fileName":"FilesView-module_fileName__YByfL","fileError":"FilesView-module_fileError__HBvxv","fadeInDown":"FilesView-module_fadeInDown__F-ZzV"};

var UploadButton = function UploadButton(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick;
  return jsx(Button$1, {
    onClick: onClick,
    leftIcon: jsx(PlusMath, {
      color: "primary.500"
    }),
    variant: "subtle",
    size: "md",
    _focus: {
      boxShadow: "none"
    },
    children: text
  });
};

var UploadButton$1 = UploadButton;

var DeleteButton = function DeleteButton(_ref) {
  var onClick = _ref.onClick;
  return jsx(IconButton, {
    "aria-label": "Delete file",
    icon: jsx(Delete, {
      color: "#A0AFC0",
      boxSize: 6,
      width: 4,
      height: 4
    }),
    onClick: onClick,
    _hover: {
      md: {
        bg: "greyscale.200"
      }
    },
    _active: {
      bg: "greyscale.300"
    },
    _focus: {
      boxShadow: "none"
    },
    minW: 6,
    minH: 6,
    background: "greyscale.100",
    "data-testid": "deleteFile"
  });
};

var FileItem = function FileItem(_ref2) {
  var _classNames;

  var file = _ref2.file,
      onDelete = _ref2.onDelete;
  var fileExtension = path.extname(file.fileName);
  var fileName = path.basename(file.fileName, fileExtension);
  return jsxs("li", {
    className: styles$5.fileItem,
    children: [jsxs("div", {
      className: classNames(styles$5.fileWithErrorWrapper, (_classNames = {}, _classNames[styles$5.withDeleteIcon] = !!onDelete, _classNames)),
      children: [jsxs("div", {
        className: styles$5.fileNameWrapper,
        children: [jsx("span", {
          className: styles$5.fileName,
          children: fileName
        }), jsx("span", {
          children: fileExtension
        })]
      }), file.error && jsx("div", {
        className: styles$5.fileError,
        "data-testid": "errorMessage",
        children: file.error
      })]
    }), onDelete && jsx(DeleteButton, {
      onClick: function onClick() {
        return onDelete(file);
      }
    })]
  });
};

var FilesView = function FilesView(_ref3) {
  var files = _ref3.files,
      uploadFileButtonText = _ref3.uploadFileButtonText,
      openFile = _ref3.openFile,
      onDelete = _ref3.onDelete;
  return jsxs("div", {
    className: styles$5.filesView,
    children: [jsx("ul", {
      className: styles$5.fileList,
      children: files.map(function (file) {
        return jsx(FileItem, {
          file: file,
          onDelete: onDelete
        }, "file-" + file.id);
      })
    }), jsx(UploadButton$1, {
      text: uploadFileButtonText,
      onClick: openFile
    })]
  });
};

var styles$4 = {"loadingLabel":"LoadingView-module_loadingLabel__oBpas","fadeInDown":"LoadingView-module_fadeInDown__Xov-G"};

var LoadingView = function LoadingView(_ref) {
  var loadingLabel = _ref.loadingLabel;
  var isMobile = useMobileDetect();
  return jsxs(Fragment, {
    children: [jsx(Spinner$1, {
      variant: isMobile ? "contentMedium" : "contentLarge",
      "data-testid": "spinner"
    }), jsx("div", {
      className: styles$4.loadingLabel,
      children: loadingLabel
    })]
  });
};

var LoadingView$1 = LoadingView;

var styles$3 = {"heading":"DropFileView-module_heading__IiiwS","fadeInDown":"DropFileView-module_fadeInDown__ZwKYj"};

var DropFileView = function DropFileView(_ref) {
  var heading = _ref.heading;
  return jsxs(Fragment, {
    children: [jsx(ImageDrop, {
      boxSize: "94px"
    }), jsx("div", {
      className: styles$3.heading,
      children: heading
    })]
  });
};

var DropFileView$1 = DropFileView;

var styles$2 = {"heading":"InitialView-module_heading__Qkg0l","selectFile":"InitialView-module_selectFile__DkxrZ","supportedFiles":"InitialView-module_supportedFiles__q07Ls","fadeInDown":"InitialView-module_fadeInDown__VSKY1"};

var DesktopDescription = function DesktopDescription(_ref) {
  var heading = _ref.heading,
      selectFileText = _ref.selectFileText,
      supportedFilesText = _ref.supportedFilesText;
  return jsxs(Fragment, {
    children: [jsx("div", {
      className: styles$2.heading,
      children: heading
    }), jsx("div", {
      className: styles$2.selectFile,
      children: selectFileText
    }), jsx("div", {
      className: styles$2.supportedFiles,
      children: supportedFilesText
    })]
  });
};

var InitialView = function InitialView(_ref2) {
  var heading = _ref2.heading,
      selectFileText = _ref2.selectFileText,
      supportedFilesText = _ref2.supportedFilesText,
      uploadFileButtonText = _ref2.uploadFileButtonText,
      docsIcon = _ref2.docsIcon;
  var isMobile = useMobileDetect();
  return jsxs(Fragment, {
    children: [jsx(Flex, {
      bg: "transparent",
      boxSize: "94px",
      direction: "column",
      justify: "center",
      align: "center",
      children: jsx(Flex, {
        bg: "primary.400",
        boxSize: 16,
        borderRadius: "50%",
        justify: "center",
        align: "center",
        children: docsIcon
      })
    }), isMobile ? jsx(UploadButton$1, {
      text: uploadFileButtonText
    }) : jsx(DesktopDescription, {
      heading: heading,
      selectFileText: selectFileText,
      supportedFilesText: supportedFilesText
    })]
  });
};

var InitialView$1 = InitialView;

var DocumentsUploaderContent = function DocumentsUploaderContent(_ref) {
  var dropText = _ref.dropText,
      heading = _ref.heading,
      selectFileText = _ref.selectFileText,
      supportedFilesText = _ref.supportedFilesText,
      uploadFileButtonText = _ref.uploadFileButtonText,
      isLoading = _ref.isLoading,
      loadingLabel = _ref.loadingLabel,
      files = _ref.files,
      isDragActive = _ref.isDragActive,
      openFile = _ref.openFile,
      onDelete = _ref.onDelete,
      docsIcon = _ref.docsIcon;

  if (isLoading) {
    return jsx(LoadingView$1, {
      loadingLabel: loadingLabel
    });
  }

  if (isDragActive) {
    return jsx(DropFileView$1, {
      heading: dropText
    });
  }

  if (files.length > 0) {
    return jsx(FilesView, {
      onDelete: onDelete,
      files: files,
      openFile: openFile,
      uploadFileButtonText: uploadFileButtonText
    });
  }

  return jsx(InitialView$1, {
    heading: heading,
    selectFileText: selectFileText,
    supportedFilesText: supportedFilesText,
    uploadFileButtonText: uploadFileButtonText,
    docsIcon: docsIcon
  });
};

var DocumentsUploaderContent$1 = DocumentsUploaderContent;

var DEFAULT_SUPPORTED_FILES = {
  "image/jpeg": [".jpeg"],
  "image/png": [".png"],
  "application/pdf": [".pdf"]
};

var DocumentsUploader = function DocumentsUploader(_ref) {
  var _classNames;

  var onClick = _ref.onClick,
      onDelete = _ref.onDelete,
      dropText = _ref.dropText,
      heading = _ref.heading,
      selectFileText = _ref.selectFileText,
      supportedFilesText = _ref.supportedFilesText,
      uploadFileButtonText = _ref.uploadFileButtonText,
      isLoading = _ref.isLoading,
      loadingLabel = _ref.loadingLabel,
      files = _ref.files,
      error = _ref.error,
      _ref$multipleFiles = _ref.multipleFiles,
      multipleFiles = _ref$multipleFiles === void 0 ? false : _ref$multipleFiles,
      _ref$supportedFiles = _ref.supportedFiles,
      supportedFiles = _ref$supportedFiles === void 0 ? DEFAULT_SUPPORTED_FILES : _ref$supportedFiles,
      maxSize = _ref.maxSize,
      maxFiles = _ref.maxFiles,
      docsIcon = _ref.docsIcon;

  var _useDropzone = useDropzone({
    onDrop: onClick,
    accept: supportedFiles,
    multiple: multipleFiles,
    disabled: isLoading,
    maxSize: maxSize,
    maxFiles: maxFiles,
    minSize: 1
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      isFocused = _useDropzone.isFocused,
      openFile = _useDropzone.open;

  var filesViewActive = files.length > 0 && !isLoading && !isDragActive;

  var onClickDropzone = function onClickDropzone(event) {
    if (filesViewActive) {
      event.stopPropagation(); // upload button will handle click event itself with openFile callback
    }
  };

  return jsxs(Fragment, {
    children: [jsxs("section", _extends({}, getRootProps({
      onClick: onClickDropzone
    }), {
      className: classNames(styles$6.documentsUploader, (_classNames = {}, _classNames[styles$6.isFocused] = isDragActive || isFocused, _classNames[styles$6.isFilesView] = filesViewActive, _classNames[styles$6.hasError] = !!error, _classNames)),
      children: [jsx("input", _extends({}, getInputProps(), {
        "data-testid": "documentUploader"
      })), jsx(DocumentsUploaderContent$1, {
        onDelete: onDelete,
        files: files,
        heading: heading,
        loadingLabel: loadingLabel,
        selectFileText: selectFileText,
        supportedFilesText: supportedFilesText,
        uploadFileButtonText: uploadFileButtonText,
        dropText: dropText,
        isLoading: isLoading,
        isDragActive: isDragActive,
        openFile: openFile,
        docsIcon: docsIcon
      })]
    })), error && jsx(FormControl, {
      isInvalid: true,
      children: jsx(FormErrorMessage, {
        mt: "2",
        children: error
      })
    })]
  });
};

var DocumentsUploader$1 = DocumentsUploader;

var _excluded$2 = ["children", "variant", "icon", "isChat"];

var InfoBox$1 = function InfoBox(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "primary" : _ref$variant,
      icon = _ref.icon,
      isChat = _ref.isChat,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var styles = useMultiStyleConfig("InfoBox", {
    variant: variant
  });
  var borderTopLeftRadius = isChat ? 0 : "lg";
  return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsxs(chakra.div, _extends({
      "data-testid": "infobox",
      __css: styles.container,
      borderTopLeftRadius: borderTopLeftRadius
    }, props, {
      children: [icon && jsx(chakra.div, {
        __css: styles.icon,
        children: icon
      }), jsx(chakra.div, {
        children: children
      })]
    }))
  );
};

var InfoBox$2 = InfoBox$1;

var FLAG_ICON_MAP = {
  Bg: Bg,
  Cs: Cs,
  Da: Dk,
  De: De,
  DeAt: At,
  DeCh: Ch,
  El: Gr,
  EnAu: Au,
  EnCa: Ca,
  EnGb: Gb,
  EnIe: Ie,
  EnIn: In,
  EnInt: Int,
  EnNz: Nz,
  EnUs: Us,
  Es: Es,
  Fi: Fi,
  Fr: Fr,
  FrBe: Be,
  FrCa: Ca,
  Hu: Hu,
  It: It,
  Nb: No,
  Nl: Nl,
  Pl: Pl,
  Pt: Pt,
  PtBr: Br,
  Ro: Ro,
  RoMd: Md,
  Ru: Ru,
  Sv: Se,
  ZhCn: Cn,
  Tr: Tr
};

var ActionButton = function ActionButton(_ref) {
  var flagKey = _ref.flagKey,
      handleOnClick = _ref.handleOnClick;
  var FlagIcon = FLAG_ICON_MAP[flagKey];
  return jsx(Button$1, {
    variant: "subtle",
    bg: "none",
    color: "font.primary",
    _hover: {
      md: {
        color: "primary.500"
      }
    },
    _focus: {
      bg: "none"
    },
    _active: {
      bg: "none"
    },
    border: "none",
    fontSize: "md",
    cursor: "pointer",
    fontWeight: "medium",
    onClick: handleOnClick,
    leftIcon: jsx(FlagIcon, {
      boxSize: 6
    }),
    "data-testid": "languageSwitcherButton",
    children: flagKey.substring(0, 2).toUpperCase()
  });
};

var ActionButton$1 = ActionButton;

var LanguageSwitcherListItem = function LanguageSwitcherListItem(_ref) {
  var item = _ref.item,
      onItemClick = _ref.onItemClick,
      isActive = _ref.isActive;
  return jsx(ListItem, {
    color: isActive ? "primary.900" : "greyscale.600",
    _hover: {
      md: {
        textDecoration: "none",
        backgroundColor: "primary.100",
        color: "primary.900"
      }
    },
    onClick: function onClick() {
      return onItemClick(item);
    },
    cursor: "pointer",
    bg: isActive ? "primary.200" : "initial",
    borderRadius: "md",
    p: 3,
    my: "px",
    transition: ".3s",
    "data-testid": isActive && "languageSwitcherListItemActive",
    children: jsxs(Flex, {
      align: "center",
      children: [item.icon && jsx(item.icon, {
        w: 6,
        h: 4
      }), jsx(Box, {
        ml: 3,
        fontSize: "md",
        fontWeight: "normal",
        children: item.name
      })]
    })
  });
};

var LanguageSwitcherListItem$1 = LanguageSwitcherListItem;

var LanguageSwitcherList = function LanguageSwitcherList(_ref) {
  var listHeading = _ref.listHeading,
      listItems = _ref.listItems,
      _ref$listAutoflow = _ref.listAutoflow,
      listAutoflow = _ref$listAutoflow === void 0 ? "row" : _ref$listAutoflow,
      onItemClick = _ref.onItemClick,
      activeItems = _ref.activeItems;
  return jsxs(Box, {
    mb: 10,
    children: [jsx(Text$1, {
      mb: 2,
      variant: "medium",
      fontWeight: "medium",
      "data-testid": "languageSwitcherListHeading",
      children: listHeading
    }), jsx(List, {
      "data-testid": "languageSwitcherList",
      children: jsx(SimpleGrid, {
        columns: {
          base: 1,
          md: 3,
          lg: 3
        },
        spacingX: 6,
        autoFlow: listAutoflow,
        templateRows: {
          lg: "repeat(" + Math.ceil(listItems.length / 3) + ", 1fr)"
        },
        children: listItems.map(function (item) {
          return jsx(LanguageSwitcherListItem$1, {
            item: item,
            onItemClick: onItemClick,
            isActive: activeItems.includes(item.id)
          }, item.id);
        })
      })
    })]
  });
};

var LanguageSwitcherList$1 = LanguageSwitcherList;

var LanguageSwitcher = function LanguageSwitcher(_ref) {
  var onItemClick = _ref.onItemClick,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      activeItems = _ref.activeItems;
  return jsx(Flex, {
    flexDir: "column",
    children: lists && lists.map(function (_ref2) {
      var listAutoflow = _ref2.listAutoflow,
          listHeading = _ref2.listHeading,
          listItems = _ref2.listItems;
      return jsx(LanguageSwitcherList$1, {
        listHeading: listHeading,
        listItems: listItems,
        listAutoflow: listAutoflow,
        onItemClick: onItemClick,
        activeItems: activeItems
      }, listHeading);
    })
  });
};

var LanguageSwitcher$1 = LanguageSwitcher;

var LanguageSwitcherModal = function LanguageSwitcherModal(_ref) {
  var onItemClick = _ref.onItemClick,
      flagKey = _ref.flagKey,
      lists = _ref.lists,
      activeItems = _ref.activeItems,
      onClose = _ref.onClose,
      isOpen = _ref.isOpen,
      onOpen = _ref.onOpen;
  return jsxs(Fragment, {
    children: [jsx(ActionButton$1, {
      flagKey: flagKey,
      handleOnClick: onOpen
    }), jsxs(Modal$1, {
      "data-testid": "languageSwitcherModal",
      isOpen: isOpen,
      onClose: onClose,
      size: "4xl",
      isCentered: false,
      children: [jsx(ModalOverlay, {}), jsxs(ModalContent, {
        overflow: "hidden",
        "data-testid": "languageSwitcherModalContent",
        maxW: {
          md: "fit-content"
        },
        children: [jsx(ModalHeader, {
          pb: {
            base: 10,
            md: 10
          },
          pt: "unset"
        }), jsx(ModalCloseButton, {}), jsx(ModalBody, {
          children: jsx(LanguageSwitcher$1, {
            onItemClick: onItemClick,
            activeItems: activeItems,
            lists: lists
          })
        })]
      })]
    })]
  });
};

var LanguageSwitcherModal$1 = LanguageSwitcherModal;

var _excluded$1 = ["label", "placeholder", "caption", "errorMessage", "colorScheme", "isDisabled", "isInvalid", "dataTestId", "formControlStyles", "handleChange"];

function Select(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      caption = _ref.caption,
      errorMessage = _ref.errorMessage,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? "error" : _ref$colorScheme,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      dataTestId = _ref.dataTestId,
      formControlStyles = _ref.formControlStyles,
      handleChange = _ref.handleChange,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var _useState = useState(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger),
      errorIconColor = _useState[0],
      setErrorIconColor = _useState[1];

  var _useState2 = useState(false),
      isSelectFocused = _useState2[0],
      setIsSelectFocused = _useState2[1];

  var isMobile = useMobileDetect();

  var hoveredErrorIconColor = function hoveredErrorIconColor() {
    return isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
  };

  useEffect(function () {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
  }, [colorScheme]);

  var onFocus = function onFocus() {
    setErrorIconColor("transparent");
    setIsSelectFocused(true);
  };

  var onBlur = function onBlur() {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
    setIsSelectFocused(false);
  };

  var onMouseOver = function onMouseOver() {
    if (!isSelectFocused) {
      setErrorIconColor(hoveredErrorIconColor());
    }
  };

  var onMouseOut = function onMouseOut() {
    if (!isSelectFocused) {
      setErrorIconColor(defaultErrorIconColor(colorScheme));
    }
  };

  return jsxs(FormControl, _extends({}, formControlStyles, {
    alignItems: "start",
    isInvalid: isInvalid,
    children: [label && jsx(FormLabel$1, {
      fontWeight: "bold",
      children: label
    }), jsx(InputGroup, {
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      "data-testid": dataTestId,
      isolation: "unset",
      children: jsx(Select$1, _extends({}, props, {
        placeholder: placeholder,
        chakraStyles: getSelectStyles(),
        isSearchable: false,
        isDisabled: isDisabled,
        colorScheme: colorScheme,
        onChange: handleChange
      }))
    }), jsx(FormErrorMessage, {
      colorScheme: colorScheme,
      children: errorMessage
    }), isInvalid && jsx(InputGroup, {
      children: jsx(InputRightElement, {
        right: 6,
        top: "unset",
        bottom: "27px",
        pointerEvents: "none",
        children: jsx(Info, {
          boxSize: 4,
          pointerEvents: "none",
          color: errorIconColor
        })
      })
    }), caption && !isInvalid && jsx(FormHelperText, {
      children: caption
    })]
  }));
}

var styles$1 = {"signature":"SignatureBox-module_signature__QBOL4","error":"SignatureBox-module_error__PAzvg","active":"SignatureBox-module_active__zE394","placeholder":"SignatureBox-module_placeholder__2bnEN","signatureField":"SignatureBox-module_signatureField__j79f6","signatureArea":"SignatureBox-module_signatureArea__tSTxB","signatureHeader":"SignatureBox-module_signatureHeader__sPz71","fadeInDown":"SignatureBox-module_fadeInDown__8baUe"};

var ClearSignatureButton = function ClearSignatureButton(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick;
  return jsx(Button$1, {
    size: "xs",
    variant: "subtle",
    paddingX: 2,
    mt: 2,
    mb: "-8px",
    onClick: onClick,
    leftIcon: jsx(Erase, {
      boxSize: 4,
      color: "primary.500"
    }),
    color: "primary.500",
    pointerEvents: "auto",
    _focus: {
      boxShadow: "none"
    },
    children: text
  });
};

var SignatureBox = function SignatureBox(_ref2) {
  var _classNames;

  var onChange = _ref2.onChange,
      onClear = _ref2.onClear,
      onError = _ref2.onError,
      errorMessage = _ref2.errorMessage,
      header = _ref2.header,
      subheader = _ref2.subheader,
      clearSignatureText = _ref2.clearSignatureText,
      signatureDataURL = _ref2.signatureDataURL,
      signatureHeader = _ref2.signatureHeader;

  var _useState = useState(false),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(false),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(true),
      showHeaders = _useState3[0],
      setShowHeaders = _useState3[1];

  var _useState4 = useState(true),
      showSignatureHeader = _useState4[0],
      setShowSignatureHeader = _useState4[1]; // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var signaturePadRef = useRef(null);

  var _useMemo = useMemo(function () {
    var _signaturePadRef$curr;

    var canvas = (_signaturePadRef$curr = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr.canvas.current;

    if (canvas) {
      var parentElement = canvas.parentElement;

      if (parentElement) {
        return {
          width: parentElement.offsetWidth,
          height: parentElement.offsetHeight
        };
      }
    }

    return {
      width: 0,
      height: 0
    };
  }, [signaturePadRef]),
      width = _useMemo.width,
      height = _useMemo.height;

  var handleSignaturePadClick = function handleSignaturePadClick() {
    return setShowHeaders(false);
  };

  var onBegin = useCallback(function () {
    setActive(true);
    setShowSignatureHeader(false);
  }, [setActive]);
  var onEnd = useCallback(function () {
    var _signaturePadRef$curr2, _signatureData$, _signatureData$$point;

    setActive(false);
    var signatureData = (_signaturePadRef$curr2 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr2.toData();
    var errorOccurred = signatureData && signatureData.length <= 1 && ((_signatureData$ = signatureData[0]) == null ? void 0 : (_signatureData$$point = _signatureData$.points) == null ? void 0 : _signatureData$$point.length) <= 1;
    setError(!!errorOccurred);

    if (onChange) {
      onChange(signaturePadRef.current);
    }

    if (errorOccurred && onError) {
      onError();
    }
  }, [onChange, onError]);
  var clearSignature = useCallback(function () {
    var _signaturePadRef$curr3;

    setError(false);
    setShowHeaders(true);
    setShowSignatureHeader(true);
    (_signaturePadRef$curr3 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr3.instance.clear();

    if (onClear) {
      onClear();
    }
  }, [onClear]);
  useEffect(function () {
    var _signaturePadRef$curr4, _signaturePadRef$curr5;

    (_signaturePadRef$curr4 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr4.instance.addEventListener("beginStroke", onBegin);
    (_signaturePadRef$curr5 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr5.instance.addEventListener("endStroke", onEnd);
    return function () {
      var _signaturePadRef$curr6, _signaturePadRef$curr7;

      (_signaturePadRef$curr6 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr6.instance.removeEventListener("beginStroke", onBegin); // eslint-disable-next-line react-hooks/exhaustive-deps

      (_signaturePadRef$curr7 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr7.instance.removeEventListener("endStroke", onEnd);
    };
  }, [onBegin, onEnd, clearSignature]);
  useEffect(function () {
    setShowHeaders(!signatureDataURL);

    if (signatureDataURL) {
      var _signaturePadRef$curr8;

      (_signaturePadRef$curr8 = signaturePadRef.current) == null ? void 0 : _signaturePadRef$curr8.fromDataURL(signatureDataURL);
    }
  }, [signatureDataURL]);
  return jsxs("div", {
    children: [jsxs("div", {
      className: classNames(styles$1.signature, (_classNames = {}, _classNames[styles$1.error] = error, _classNames[styles$1.active] = active, _classNames)),
      children: [showHeaders && jsxs("button", {
        type: "button",
        className: styles$1.placeholder,
        onClick: handleSignaturePadClick,
        children: [jsx(Flex, {
          bg: "transparent",
          boxSize: "96px",
          direction: "column",
          justify: "center",
          align: "center",
          children: jsx(Flex, {
            bg: "primary.400",
            boxSize: {
              base: 10,
              md: 12
            },
            borderRadius: "3xl",
            justify: "center",
            align: "center",
            children: jsx(Signature, {
              boxSize: {
                base: "64px",
                md: "96px"
              },
              color: "primary.200"
            })
          })
        }), header && jsx(Text$1, {
          fontWeight: "medium",
          fontSize: {
            base: "lg",
            md: "xl"
          },
          p: 0,
          m: 0,
          color: "font.primary",
          mt: {
            base: 0,
            md: 3
          },
          children: header
        }), subheader && jsx(Text$1, {
          variant: "medium",
          fontSize: {
            base: "md",
            md: "sm"
          },
          p: 0,
          m: 0,
          color: "greyscale.500",
          mt: {
            base: 0,
            md: 1
          },
          children: subheader
        })]
      }), !showHeaders && jsxs("div", {
        className: styles$1.signatureField,
        children: [jsx("div", {
          className: styles$1.signatureArea,
          children: jsx("div", {
            className: styles$1.signatureHeader,
            children: showSignatureHeader && signatureHeader
          })
        }), jsx(ClearSignatureButton, {
          text: clearSignatureText,
          onClick: clearSignature
        })]
      }), jsx(SignaturePad, {
        options: {
          minWidth: 1,
          maxWidth: 2,
          penColor: "#1D2836"
        },
        ref: signaturePadRef,
        width: width,
        height: height,
        redrawOnResize: true
      })]
    }), error && jsx(FormControl, {
      isInvalid: true,
      children: jsx(FormErrorMessage, {
        mt: "2",
        children: errorMessage
      })
    })]
  });
};

var SignatureBox$1 = SignatureBox;

var _excluded = ["label", "placeholder", "caption", "errorMessage", "isDisabled", "isInvalid", "colorScheme", "rows", "counter", "maxLength"];

var Textarea$1 = function Textarea(_ref) {
  var _props$value;

  var label = _ref.label,
      placeholder = _ref.placeholder,
      caption = _ref.caption,
      errorMessage = _ref.errorMessage,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? "error" : _ref$colorScheme,
      rows = _ref.rows,
      counter = _ref.counter,
      maxLength = _ref.maxLength,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useState = useState(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger),
      errorIconColor = _useState[0],
      setErrorIconColor = _useState[1];

  var _useState2 = useState(false),
      isTextareaFocused = _useState2[0],
      setIsTextareaFocused = _useState2[1];

  var _useState3 = useState(((_props$value = props.value) == null ? void 0 : _props$value.toString().length) || 0),
      textareaLength = _useState3[0],
      setTextareaLength = _useState3[1];

  var isMobile = useMobileDetect();

  var hoveredErrorIconColor = function hoveredErrorIconColor() {
    return isMobile ? defaultErrorIconColor(colorScheme) : defaultHoverErrorIconColor(colorScheme);
  };

  useEffect(function () {
    setErrorIconColor(colorScheme === "warning" ? ErrorIconColor.warning : ErrorIconColor.danger);
  }, [colorScheme]);

  var onFocus = function onFocus() {
    setErrorIconColor("transparent");
    setIsTextareaFocused(true);
  };

  var onBlur = function onBlur() {
    setErrorIconColor(defaultErrorIconColor(colorScheme));
    setIsTextareaFocused(false);
  };

  var onMouseOver = function onMouseOver() {
    if (!isTextareaFocused) {
      setErrorIconColor(hoveredErrorIconColor());
    }
  };

  var onMouseOut = function onMouseOut() {
    if (!isTextareaFocused) {
      setErrorIconColor(defaultErrorIconColor(colorScheme));
    }
  };

  return jsxs(FormControl, {
    isInvalid: isInvalid,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    children: [jsx(FormLabel$1, {
      fontWeight: "bold",
      children: label
    }), jsx(Textarea$3, _extends({
      placeholder: placeholder,
      rows: rows,
      maxLength: maxLength,
      isDisabled: isDisabled,
      colorScheme: colorScheme,
      _focus: {
        borderColor: "primary.500",
        position: "unset"
      }
    }, props, {
      onChange: function onChange(event) {
        setTextareaLength(event.target.value.length);
        return (props == null ? void 0 : props.onChange) && props.onChange(event);
      },
      "data-testid": "textarea"
    })), counter && jsx(FormLabel$1, {
      fontWeight: "normal",
      m: 0,
      bottom: isInvalid || caption ? 7 : 0,
      right: 3,
      position: "absolute",
      color: "greyscale.500",
      "data-testid": "counter",
      children: textareaLength + "/" + maxLength
    }), caption && !isInvalid && jsx(FormHelperText, {
      children: caption
    }), isInvalid && jsx(Info, {
      position: "absolute",
      top: label ? "46px" : 3,
      right: 4,
      boxSize: 4,
      color: errorIconColor,
      pointerEvents: "none"
    }), jsx(FormErrorMessage, {
      colorScheme: colorScheme,
      children: errorMessage
    })]
  });
};

var Textarea$2 = Textarea$1;

var LinkGenerator = function LinkGenerator(_ref) {
  var onClick = _ref.onClick,
      link = _ref.link,
      beforeCopyText = _ref.beforeCopyText,
      afterCopyText = _ref.afterCopyText,
      dataTestId = _ref.dataTestId;

  var _useState = useState(false),
      didCopy = _useState[0],
      setDidCopy = _useState[1];

  var copyToClipboard = useCallback(function () {
    navigator.clipboard.writeText(link);
  }, [link]);
  var onClickCallback = useCallback(function () {
    if (onClick) {
      onClick();
    }

    copyToClipboard();
    setDidCopy(true);
  }, [copyToClipboard, onClick]);
  var buttonColor = didCopy ? "success.600" : "primary.500";
  return jsx(Flex, {
    children: jsxs(InputGroup, {
      size: "lg",
      children: [jsx(Input$3, {
        value: link,
        isReadOnly: true,
        name: "copy-link",
        width: "100%",
        borderColor: "greyscale.500",
        onClick: onClickCallback,
        textOverflow: "ellipsis"
      }), jsx(InputRightElement, {
        width: "auto",
        children: jsx(Button$1, {
          variant: "primary",
          backgroundColor: buttonColor,
          _hover: {
            backgroundColor: buttonColor
          },
          onClick: onClickCallback,
          borderStartRadius: "none",
          whiteSpace: "nowrap",
          leftIcon: didCopy ? jsx(Check, {
            width: 5,
            height: 5,
            name: "Check"
          }) : undefined,
          maxHeight: "48px",
          "data-testid": dataTestId,
          _focus: {
            boxShadow: "none"
          },
          children: didCopy ? afterCopyText : beforeCopyText
        })
      })]
    })
  });
};

var LinkGenerator$1 = LinkGenerator;

var baseStyleButton = {
  _expanded: {
    bg: "transparent",
    boxShadow: "none"
  },
  _hover: {
    bg: "transparent"
  },
  py: {
    base: 4,
    lg: 6
  }
};
var baseStylePanel = {
  pb: {
    base: 4,
    lg: 6
  }
};
var baseStyleIcon = {
  color: "primary.500",
  boxSize: 6,
  ml: 2
};
var primary = {
  container: {
    bg: "transparent",
    borderColor: "greyscale.400",
    _first: {
      borderTop: "none"
    },
    _last: {
      borderBottom: "none"
    }
  },
  button: {
    px: 0
  },
  panel: {
    px: 0,
    pt: {
      base: 0,
      lg: 1
    }
  }
};
var secondaryButtonPanelStyles = {
  px: {
    base: 4,
    lg: 6
  },
  bg: "greyscale.100",
  borderRadius: "lg",
  mb: 2
};
var secondary = {
  container: {
    border: "none"
  },
  button: /*#__PURE__*/_extends({}, secondaryButtonPanelStyles, {
    _expanded: {
      mb: 0,
      borderBottomRadius: "none",
      bg: "greyscale.100"
    },
    _hover: {
      bg: {
        md: "greyscale.100"
      }
    }
  }),
  panel: /*#__PURE__*/_extends({}, secondaryButtonPanelStyles, {
    borderTopRadius: "none",
    pt: 0
  })
};
var variants$d = {
  primary: primary,
  secondary: secondary
};
var baseStyle$k = {
  panel: baseStylePanel,
  button: baseStyleButton,
  icon: baseStyleIcon
};
var defaultProps$g = {
  variant: "primary"
};
var Accordion = {
  defaultProps: defaultProps$g,
  baseStyle: baseStyle$k,
  variants: variants$d
};

var baseStyleContainer = {
  bg: "primary.700",
  color: "white"
};
var baseStyle$j = {
  container: baseStyleContainer
};

var getSize = function getSize(size) {
  return {
    container: {
      width: size,
      height: size,
      fontSize: "calc(" + size + " / 2)"
    },
    excessLabel: {
      width: size,
      height: size
    },
    label: {
      fontSize: "calc(" + size + " / 2)",
      lineHeight: size !== "100%" ? size : undefined
    }
  };
};

var sizes$8 = {
  xs: /*#__PURE__*/getSize("24px"),
  sm: /*#__PURE__*/getSize("28px"),
  md: /*#__PURE__*/getSize("32px"),
  lg: /*#__PURE__*/getSize("40px"),
  xl: /*#__PURE__*/getSize("48px")
};
var defaultProps$f = {
  size: "xl"
};
var Avatar = {
  baseStyle: baseStyle$j,
  sizes: sizes$8,
  defaultProps: defaultProps$f
};

var baseStyle$i = {
  fontSize: "sm",
  fontWeight: "bold",
  textTransform: "none",
  padding: spacing4x,
  whiteSpace: "normal",
  width: {
    base: "100%",
    md: "fit-content"
  },
  div: {
    color: "primary.500"
  }
};
var variantBasic$1 = {
  background: {
    base: "primary.200",
    md: "transparent"
  }
};
var variants$c = {
  basic: variantBasic$1
};
var defaultProps$e = {
  variant: "basic"
};
var Badge = {
  baseStyle: baseStyle$i,
  variants: variants$c,
  defaultProps: defaultProps$e
};

var baseStyleLink = {
  color: "primary.700",
  fontSize: "sm",
  _visited: {
    color: "primary.500",
    _hover: {
      color: "primary.600"
    }
  },
  _activeLink: {
    pointerEvents: "none"
  },
  _hover: {
    textDecoration: "none"
  },
  _active: {
    color: "primary.700"
  },
  _focus: {
    boxShadow: "none"
  }
};
var baseStyle$h = {
  link: baseStyleLink
};
var Breadcrumb = {
  baseStyle: baseStyle$h
};

var baseStyle$g = {
  borderRadius: "md",
  fontWeight: "medium",
  lineHeight: "base",
  whiteSpace: "normal",
  _loading: {
    opacity: 1
  },
  _disabled: {
    opacity: 1
  }
};
var disabledStyle$1 = {
  color: "greyscale.500",
  background: "greyscale.300"
};
var variantPrimary = {
  color: "greyscale.100",
  background: "primary.500",
  _hover: {
    background: {
      md: "primary.600"
    },
    _disabled: {
      color: "primary.300",
      background: "primary.100"
    }
  },
  _active: {
    background: "primary.700"
  },
  _loading: {
    color: "greyscale.100",
    background: "primary.700",
    _hover: {
      color: "greyscale.100",
      background: "primary.700"
    }
  },
  _disabled: {
    color: "primary.300",
    background: "primary.100"
  }
};
var variantSecondary = {
  color: "primary.500",
  background: "greyscale.100",
  borderColor: "primary.500",
  border: "2px",
  _hover: {
    color: {
      md: "primary.600"
    },
    background: {
      md: "primary.100"
    },
    _disabled: {
      color: "primary.300"
    }
  },
  _active: {
    color: "primary.700",
    background: "greyscale.100"
  },
  _loading: {
    color: "primary.700",
    _hover: {
      color: "primary.700"
    }
  },
  _disabled: {
    color: "primary.300"
  }
};
var variantPrimaryAlternative = {
  color: "greyscale.100",
  background: "secondary.500",
  _hover: {
    color: {
      md: "secondary.500"
    },
    background: {
      md: "secondary.100"
    },
    _disabled: {
      color: "greyscale.500",
      background: "greyscale.300"
    }
  },
  _active: {
    color: "secondary.500",
    background: "secondary.200"
  },
  _loading: {
    color: "secondary.500",
    background: "secondary.200",
    _hover: {
      color: "secondary.500",
      background: "secondary.200"
    }
  },
  _disabled: disabledStyle$1
};
var variantSubtle = {
  color: "primary.500",
  background: "greyscale.100",
  _hover: {
    background: {
      md: "greyscale.200"
    }
  },
  _disabled: {
    color: "primary.300",
    _hover: {
      background: "greyscale.100"
    }
  },
  _active: {
    background: "greyscale.300"
  },
  _loading: {
    color: "primary.500",
    background: "greyscale.300",
    _hover: {
      color: "primary.500",
      background: "greyscale.300"
    }
  }
};
var variantDanger = {
  color: "greyscale.100",
  background: "danger.700",
  _hover: {
    background: {
      md: "danger.800"
    },
    _disabled: {
      color: "greyscale.500",
      background: "greyscale.300"
    }
  },
  _active: {
    background: "danger.900"
  },
  _loading: {
    color: "greyscale.100",
    background: "danger.900",
    _hover: {
      color: "greyscale.100",
      background: "danger.900"
    }
  },
  _disabled: disabledStyle$1
};
var variantLink = {
  p: 0,
  height: "auto",
  color: "primary.500",
  _hover: {
    textDecoration: "none",
    color: {
      md: "primary.600"
    }
  },
  _active: {
    color: "primary.700"
  },
  _visited: {
    color: "greyscale.500"
  }
};
var variants$b = {
  primary: variantPrimary,
  secondary: variantSecondary,
  primaryAlt: variantPrimaryAlternative,
  subtle: variantSubtle,
  danger: variantDanger,
  link: variantLink
};
var sizes$7 = {
  xs: {
    fontSize: "sm",
    height: "auto",
    minH: 8,
    minW: 10,
    py: 2,
    px: 3,
    div: {
      boxSize: 4
    },
    svg: {
      boxSize: 4
    }
  },
  s: {
    fontSize: "sm",
    height: "auto",
    minH: 10,
    minW: 14,
    px: "18px",
    py: "10px",
    div: {
      boxSize: 5
    },
    svg: {
      boxSize: 5
    }
  },
  m: {
    fontSize: "md",
    px: 5,
    py: 3,
    height: "auto",
    minH: 12,
    minW: 16,
    div: {
      boxSize: 6
    },
    svg: {
      boxSize: 6
    }
  },
  l: {
    fontSize: "lg",
    height: "auto",
    minH: "60px",
    minW: "76px",
    px: 6,
    py: 4,
    div: {
      boxSize: 7
    },
    svg: {
      boxSize: 7
    }
  }
};
var defaultProps$d = {
  size: "m",
  variant: "primary"
};
var Button = {
  baseStyle: baseStyle$g,
  variants: variants$b,
  sizes: sizes$7,
  defaultProps: defaultProps$d
};

var baseStyle$f = {
  control: {
    bg: "greyscale.100",
    border: "1px",
    borderColor: "greyscale.500",
    borderRadius: borderRadiusSm,
    _focus: {
      boxShadow: "none"
    },
    _checked: {
      bg: "primary.500",
      borderColor: "primary.500",
      _hover: {
        bg: {
          md: "primary.600"
        },
        borderColor: {
          md: "primary.600"
        }
      },
      _disabled: {
        bg: "greyscale.400",
        borderColor: "greyscale.400",
        color: "greyscale.500"
      },
      _active: {
        bg: "primary.700",
        borderColor: "primary.700"
      }
    },
    _disabled: {
      bg: "greyscale.200",
      borderColor: "greyscale.400",
      pointerEvents: "none"
    },
    _hover: {
      borderColor: {
        md: "primary.300"
      },
      _invalid: {
        borderColor: {
          md: "danger.800"
        }
      }
    },
    _active: {
      borderColor: "primary.700"
    },
    _invalid: {
      borderColor: "danger.700",
      _checked: {
        borderColor: "primary.500",
        _hover: {
          borderColor: {
            md: "primary.500"
          }
        }
      }
    }
  },
  label: {
    color: "greyscale.700",
    a: {
      textDecoration: "underline"
    },
    _disabled: {
      color: "greyscale.600"
    }
  }
};
var sizes$6 = {
  lg: {
    label: {
      fontSize: "sm"
    }
  }
};
var defaultProps$c = {
  size: "lg"
};
var Checkbox = {
  baseStyle: baseStyle$f,
  sizes: sizes$6,
  defaultProps: defaultProps$c
};

var baseStyle$e = {
  container: {
    color: "font.primary"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 4,
    cursor: "pointer",
    userSelect: "none"
  },
  title: {
    color: "font.primary",
    fontWeight: "medium"
  },
  headerInner: {
    display: "flex",
    color: "font.primary"
  },
  iconContainer: {
    mr: 2
  },
  actionButton: {
    svg: {
      color: "primary.500",
      boxSize: 6
    }
  },
  body: {
    position: "relative",
    mt: -2,
    px: 4,
    pb: 4,
    fontSize: "md"
  }
};
var variants$a = {
  primary: {
    container: {
      bg: "greyscale.100"
    }
  },
  secondary: {
    container: {
      bg: "greyscale.300"
    }
  }
};
var Collapsible = {
  variants: variants$a,
  baseStyle: baseStyle$e
};

var baseStyleHelperText = {
  fontSize: "sm",
  lineHeight: "base",
  fontWeight: "normal",
  color: "greyscale.600"
};
var baseStyle$d = {
  helperText: baseStyleHelperText
};
var Form = {
  baseStyle: baseStyle$d
};

var baseStyleText = function baseStyleText(props) {
  var colorScheme = props.colorScheme;
  return {
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "base",
    color: colorScheme === "warning" ? colorScheme + ".600" : "danger.700"
  };
};

var baseStyle$c = function baseStyle(props) {
  return {
    text: baseStyleText(props)
  };
};

var defaultProps$b = {
  colorScheme: "danger"
};
var FormError = {
  baseStyle: baseStyle$c,
  defaultProps: defaultProps$b
};

var baseStyle$b = {
  color: "font.primary"
};
var variantNormal = {
  fontSize: "sm",
  fontWeight: "medium",
  lineHeight: "base"
};
var variantSmall = {
  fontSize: "xs",
  fontWeight: "medium",
  lineHeight: "base"
};
var variantMuted = {
  fontSize: "sm",
  fontWeight: "normal",
  lineHeight: "base"
};
var variantCapitals = {
  fontSize: "xs",
  fontWeight: "medium",
  lineHeight: "base",
  textTransform: "uppercase"
};
var variantSmallMuted = {
  fontSize: "xs",
  fontWeight: "normal",
  lineHeight: "base"
};
var variantSmallCapitals = {
  fontSize: "10px",
  fontWeight: "medium",
  lineHeight: "base",
  textTransform: "uppercase"
};
var variants$9 = {
  normal: variantNormal,
  small: variantSmall,
  capitals: variantCapitals,
  muted: variantMuted,
  smallMuted: variantSmallMuted,
  smallCapitals: variantSmallCapitals
};
var defaultProps$a = {
  variant: "normal"
};
var FormLabel = {
  baseStyle: baseStyle$b,
  variants: variants$9,
  defaultProps: defaultProps$a
};

var baseStyle$a = {
  color: "font.primary"
};
var variants$8 = {
  h1: {
    as: "h1",
    fontSize: ["2.25rem", null, "3rem"],
    lineHeight: "short"
  },
  h2: {
    as: "h2",
    fontSize: ["1.875rem", null, "2.25rem"],
    lineHeight: "short"
  },
  h3: {
    as: "h3",
    fontSize: ["1.5rem", null, "1.875rem"],
    lineHeight: "short"
  },
  h4: {
    as: "h4",
    fontSize: ["1.375rem", null, "1.5rem"],
    lineHeight: "base"
  },
  h5: {
    as: "h5",
    fontSize: "1.25rem",
    lineHeight: "base"
  }
};
var defaultProps$9 = {
  variant: "h1"
};
var Heading = {
  baseStyle: baseStyle$a,
  variants: variants$8,
  defaultProps: defaultProps$9
};

var baseStyle$9 = {
  container: {
    display: "flex",
    alignItems: "flex-start",
    p: 4,
    borderRadius: "lg",
    color: "greyscale.700"
  },
  icon: {
    mr: 2
  }
};
var variants$7 = {
  primary: {
    container: {
      background: "greyscale.300"
    },
    icon: {
      color: "primary.500"
    }
  },
  secondary: {
    container: {
      border: "1px solid",
      borderColor: "greyscale.400",
      bg: "greyscale.100"
    },
    icon: {
      color: "greyscale.400"
    }
  },
  danger: {
    container: {
      border: "1px solid",
      borderColor: "danger.300",
      background: "danger.100"
    },
    icon: {
      color: "danger.500"
    }
  }
};
var InfoBox = {
  baseStyle: baseStyle$9,
  variants: variants$7
};

var variantOutline = function variantOutline(props) {
  var colorScheme = props.colorScheme;
  return {
    field: {
      fontSize: "md",
      border: "1px",
      borderColor: "greyscale.500",
      borderRadius: "md",
      color: "font.primary",
      bg: "greyscale.100",
      paddingY: spacing3x,
      paddingX: spacing4x,
      height: spacing12x,
      lineHeight: "base",
      _hover: {
        borderColor: {
          md: "primary.300"
        },
        _disabled: {
          opacity: 1,
          bg: "greyscale.300",
          borderColor: "greyscale.500"
        }
      },
      _focus: {
        boxShadow: "none",
        bg: "greyscale.100",
        borderColor: "primary.500"
      },
      _readOnly: {
        boxShadow: "none",
        userSelect: "all"
      },
      _disabled: {
        opacity: 1,
        color: "greyscale.500",
        bg: "greyscale.300"
      },
      _invalid: {
        boxShadow: "none",
        borderColor: colorScheme === "warning" ? colorScheme + ".600" : "danger.700",
        _hover: {
          borderColor: {
            md: colorScheme === "warning" ? colorScheme + ".700" : "danger.800"
          }
        },
        _focus: {
          borderColor: "primary.500"
        }
      },
      _placeholder: {
        color: "greyscale.500"
      }
    },
    addon: {
      background: "greyscale.300",
      borderColor: "greyscale.500",
      color: "greyscale.500",
      height: spacing12x,
      minWidth: "65px"
    }
  };
};

var variants$6 = {
  outline: variantOutline
};
var defaultProps$8 = {
  colorScheme: "danger",
  variant: "outline"
};
var Input = {
  variants: variants$6,
  defaultProps: defaultProps$8
};

var baseStyle$8 = {
  fontWeight: "medium",
  lineHeight: "base",
  textDecoration: "none",
  _visited: {
    color: "greyscale.600",
    svgr: {
      color: "greyscale.600"
    }
  },
  _hover: {
    textDecoration: "none"
  }
};
var variantBasic = {
  color: "primary.500",
  _hover: {
    color: {
      md: "primary.600"
    }
  },
  _active: {
    color: "primary.700"
  }
};
var variantFooterLight = {
  color: "greyscale.600",
  _hover: {
    color: {
      md: "primary.500"
    }
  },
  _active: {
    color: "primary.700"
  }
};
var variantFooterDark = {
  color: "primary.900",
  _hover: {
    color: {
      md: "primary.500"
    }
  },
  _active: {
    color: "primary.700"
  },
  _visited: {
    color: "primary.900",
    svgr: {
      color: "primary.900"
    }
  }
};
var variants$5 = {
  basic: variantBasic,
  footerLight: variantFooterLight,
  footerDark: variantFooterDark
};
var sizes$5 = {
  s: {
    fontSize: "sm",
    svg: {
      boxSize: 4
    }
  },
  m: {
    fontSize: "md",
    svg: {
      boxSize: 5
    }
  },
  l: {
    fontSize: "lg",
    svg: {
      boxSize: 6
    }
  }
};
var defaultProps$7 = {
  variant: "basic",
  size: "m"
};
var Link = {
  baseStyle: baseStyle$8,
  sizes: sizes$5,
  variants: variants$5,
  defaultProps: defaultProps$7
};

var baseStyleOverlay = {
  zIndex: "modal",
  background: "greyscale.400",
  opacity: "0.8!important"
};

var baseStyleDialogContainer = function baseStyleDialogContainer(props) {
  var isCentered = props.isCentered,
      scrollBehavior = props.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: isCentered === false ? "flex-start" : "center",
    overflow: scrollBehavior === "inside" ? "scroll" : undefined
  };
};

var baseStyleDialog = {
  color: "primary.900",
  backgroundColor: "grayscale.100",
  borderRadius: borderRadiusMd,
  boxShadow: shadowsLg,
  margin: "16px"
};
var baseStyleHeader$1 = {
  fontSize: "20px",
  fontWeight: "bold",
  color: "font.primary",
  lineHeight: "base",
  paddingTop: 0,
  paddingBottom: {
    base: spacing6x,
    md: spacing8x
  },
  paddingLeft: {
    base: spacing4x,
    md: spacing8x
  },
  paddingRight: {
    base: "80px",
    md: "96px"
  },
  marginTop: {
    base: spacing4x,
    md: spacing8x
  }
};
var baseStyleCloseButton = {
  top: {
    base: spacing4x,
    md: spacing8x
  },
  right: {
    base: spacing4x,
    md: spacing8x
  },
  padding: spacing3x,
  width: "unset",
  height: "unset",
  color: "primary.900",
  background: "greyscale.300",
  cursor: "pointer",
  _focus: {
    outline: "none"
  },
  svg: {
    width: spacing4x,
    height: spacing4x
  }
};
var baseStyleBody$1 = {
  fontWeight: "normal",
  fontSize: "md",
  paddingTop: "none",
  paddingBottom: spacing6x,
  paddingX: {
    base: spacing4x,
    md: spacing8x
  },
  overflow: "scroll",
  scrollBehavior: "smooth",
  "::-webkit-scrollbar": {
    width: spacing2x
  },
  "::-webkit-scrollbar-track": {
    background: "greyscale.100",
    borderRadius: borderRadiusMd
  },
  "::-webkit-scrollbar-thumb": {
    background: "greyscale.400",
    borderRadius: "3xl"
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: {
      md: "greyscale.400"
    }
  }
};
var baseStyleFooter = {
  paddingTop: "unset",
  paddingX: {
    base: spacing4x,
    md: spacing8x
  },
  paddingBottom: {
    base: spacing4x,
    md: spacing8x
  },
  display: "flex",
  flexDirection: {
    base: "column",
    md: "row"
  },
  gap: spacing2x,
  alignItems: "stretch",
  button: {
    width: {
      base: "100%",
      md: "unset"
    }
  }
};

var baseStyle$7 = function baseStyle(props) {
  return {
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer(props),
    dialog: baseStyleDialog,
    header: baseStyleHeader$1,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody$1,
    footer: baseStyleFooter
  };
};

var Modal = {
  baseStyle: baseStyle$7
};

var _baseStyleContent;
var $arrowShadowColor = /*#__PURE__*/cssVar("popper-arrow-shadow-color");
var baseStylePopper = {
  zIndex: 10
};
var baseStyleContent = (_baseStyleContent = {}, _baseStyleContent[$arrowShadowColor.variable] = "none", _baseStyleContent.backgroundColor = "grayscale.100", _baseStyleContent.color = "greyscale.700", _baseStyleContent.boxShadow = "md", _baseStyleContent.borderColor = "transparent", _baseStyleContent.padding = spacing4x, _baseStyleContent.borderRadius = borderRadiusMd, _baseStyleContent.fontSize = "sm", _baseStyleContent.fontWeight = "normal", _baseStyleContent.lineHeight = "lineHeightBase", _baseStyleContent._focus = {
  outline: "none",
  boxShadow: "md"
}, _baseStyleContent);
var baseStyleHeader = {
  fontWeight: "medium",
  marginBottom: spacing1x,
  padding: "unset",
  border: "none"
};
var baseStyleBody = {
  padding: "unset"
};
var baseStyle$6 = {
  popper: baseStylePopper,
  content: baseStyleContent,
  header: baseStyleHeader,
  body: baseStyleBody,
  arrow: {}
};
var Popover = {
  baseStyle: baseStyle$6
};

var baseStyleTrack$1 = {
  bg: "greyscale.400",
  borderRadius: "8px"
};
var baseStyleFilledTrack = {
  bg: "primary.500"
};
var baseStyle$5 = {
  filledTrack: baseStyleFilledTrack,
  track: baseStyleTrack$1
};
var sizes$4 = {
  sm: {
    track: {
      w: 9,
      h: 1
    }
  }
};
var defaultProps$6 = {
  size: "sm"
};
var Progress = {
  sizes: sizes$4,
  baseStyle: baseStyle$5,
  defaultProps: defaultProps$6
};

var disabledStyle = {
  borderColor: "greyscale.400",
  background: "greyscale.100",
  span: {
    borderColor: "greyscale.400",
    background: "greyscale.200",
    _checked: {
      borderColor: "greyscale.400",
      background: "greyscale.100",
      _before: {
        background: "greyscale.400"
      }
    }
  }
};
var baseStyle$4 = {
  container: {
    padding: spacing4x,
    border: "1px solid",
    borderColor: "greyscale.500",
    borderRadius: borderRadiusMd,
    background: "greyscale.100",
    marginTop: "-1px !important",
    _disabled: disabledStyle,
    _hover: {
      zIndex: 1,
      borderColor: {
        md: "primary.300"
      },
      _disabled: /*#__PURE__*/_extends({}, disabledStyle, {
        "span:first-of-type": {
          borderColor: "greyscale.400",
          background: "greyscale.200",
          _before: {
            background: "greyscale.200"
          }
        }
      }),
      "span:first-of-type": {
        borderColor: {
          md: "primary.300"
        },
        _before: {
          md: {
            background: "primary.300",
            content: "''",
            display: "inline-block",
            position: "relative",
            w: spacing2x,
            h: spacing2x,
            borderRadius: "50%"
          }
        }
      }
    },
    _active: {
      borderColor: "greyscale.500",
      background: "greyscale.300",
      _disabled: /*#__PURE__*/_extends({}, disabledStyle),
      span: {
        borderColor: "primary.700",
        _before: {
          background: "primary.700"
        },
        _checked: {
          background: "greyscale.300"
        }
      },
      _hover: {
        borderColor: "greyscale.500",
        background: "greyscale.300",
        _disabled: /*#__PURE__*/_extends({}, disabledStyle),
        span: {
          borderColor: "primary.700",
          _before: {
            background: "greyscale.100"
          }
        },
        _checked: {
          "span:first-of-type": {
            background: "greyscale.100",
            _before: {
              background: "primary.700"
            }
          }
        }
      }
    },
    _checked: {
      zIndex: 1,
      borderColor: "primary.500",
      _disabled: disabledStyle,
      _hover: {
        borderColor: {
          md: "primary.300"
        },
        _disabled: disabledStyle
      },
      _active: {
        borderColor: "greyscale.500",
        _disabled: disabledStyle
      }
    }
  },
  control: /*#__PURE__*/_extends({}, Checkbox.baseStyle.control, {
    borderRadius: "full",
    _checked: /*#__PURE__*/_extends({}, Checkbox.baseStyle.control._checked, {
      background: "greyscale.100",
      _hover: {
        borderColor: {
          md: "primary.300"
        },
        background: {
          md: "greyscale.100"
        },
        _before: {
          background: {
            md: "primary.300"
          }
        }
      },
      _active: {
        borderColor: "primary.700",
        _before: {
          background: "primary.700"
        }
      },
      _before: {
        w: spacing2x,
        h: spacing2x,
        bg: "primary.500"
      }
    })
  }),
  label: /*#__PURE__*/_extends({}, Checkbox.baseStyle.label, {
    width: "100%"
  })
};
var variants$4 = {
  top: {
    container: {
      borderBottomRadius: 0
    }
  },
  bottom: {
    container: {
      borderTopRadius: 0
    }
  },
  left: {
    container: {
      borderRightRadius: 0
    }
  },
  right: {
    container: {
      borderLeftRadius: 0
    }
  },
  center: {
    container: {
      borderRadius: 0
    }
  },
  rounded: {
    container: {
      borderRadius: borderRadiusMd
    }
  }
};
var defaultProps$5 = {
  variant: "rounded"
};
var Radio = {
  baseStyle: baseStyle$4,
  defaultProps: defaultProps$5,
  variants: variants$4
};

var _variantContentMedium, _variantContentLarge, _xs, _sm, _md, _lg, _xl;
var $size = /*#__PURE__*/cssVar("spinner-size");
var baseStyle$3 = {
  width: [$size.reference],
  height: [$size.reference],
  color: "primary.500",
  margin: "unset !important"
};
var variantContentMedium = (_variantContentMedium = {}, _variantContentMedium[$size.variable] = spacing12x, _variantContentMedium.borderWidth = "6px", _variantContentMedium);
var variantContentLarge = (_variantContentLarge = {}, _variantContentLarge[$size.variable] = "4rem", _variantContentLarge.borderWidth = "7px", _variantContentLarge);
var sizes$3 = {
  xs: (_xs = {}, _xs[$size.variable] = spacing4x, _xs),
  sm: (_sm = {}, _sm[$size.variable] = spacing5x, _sm),
  md: (_md = {}, _md[$size.variable] = spacing6x, _md.borderWidth = "3px", _md),
  lg: (_lg = {}, _lg[$size.variable] = spacing7x, _lg.borderWidth = "3px", _lg),
  xl: (_xl = {}, _xl[$size.variable] = spacing8x, _xl.borderWidth = spacing1x, _xl)
};
var defaultProps$4 = {
  size: "md"
};
var variants$3 = {
  contentLarge: variantContentLarge,
  contentMedium: variantContentMedium
};
var Spinner = {
  baseStyle: baseStyle$3,
  sizes: sizes$3,
  variants: variants$3,
  defaultProps: defaultProps$4
};

var _container;
var $width = /*#__PURE__*/cssVar("switch-track-width");
var $height = /*#__PURE__*/cssVar("switch-track-height");
var baseStyleTrack = {
  background: "greyscale.300",
  borderRadius: "18px",
  padding: "unset",
  transitionProperty: "common",
  transitionDuration: "fast",
  _hover: {
    background: {
      md: "primary.300"
    },
    _checked: {
      background: {
        md: "primary.600"
      }
    }
  },
  _active: {
    background: "greyscale.500",
    _checked: {
      background: "primary.700"
    }
  },
  _focus: {
    boxShadow: "none"
  },
  _disabled: {
    background: "greyscale.400",
    _hover: {
      background: "greyscale.400"
    },
    _active: {
      background: "greyscale.400"
    },
    _checked: {
      background: "greyscale.300",
      _hover: {
        background: "greyscale.300"
      },
      _active: {
        background: "greyscale.300"
      }
    }
  },
  _checked: {
    background: "primary.500"
  }
};
var baseStyleThumb = {
  background: "greyscale.100",
  boxShadow: shadowsBase,
  width: "22px",
  height: "22px",
  position: "absolute",
  top: "1px",
  left: "1px"
};
var sizes$2 = {
  md: {
    container: (_container = {}, _container[$width.variable] = spacing10x, _container[$height.variable] = spacing6x, _container)
  }
};
var defaultProps$3 = {
  size: "md"
};
var baseStyle$2 = {
  track: baseStyleTrack,
  thumb: baseStyleThumb
};
var Switch = {
  baseStyle: baseStyle$2,
  sizes: sizes$2,
  defaultProps: defaultProps$3
};

var baseStyle$1 = {
  color: "font.primary"
};
var variantLarge = {
  fontSize: "lg",
  lineHeight: "base",
  fontWeight: "normal"
};
var variantMedium = {
  fontSize: "md",
  lineHeight: "base",
  fontWeight: "normal"
};
var variants$2 = {
  large: variantLarge,
  medium: variantMedium
};
var defaultProps$2 = {
  variant: "large"
};
var Text = {
  baseStyle: baseStyle$1,
  variants: variants$2,
  defaultProps: defaultProps$2
};

var variants$1 = {
  outline: function outline(props) {
    var _Input$variants$outli;

    return (_Input$variants$outli = Input.variants.outline(props).field) != null ? _Input$variants$outli : {};
  }
};
var defaultProps$1 = {
  variant: "outline"
};
var Textarea = {
  variants: variants$1,
  defaultProps: defaultProps$1
};

var baseStyle = {
  container: {
    borderRadius: "24px",
    textTransform: "uppercase"
  }
};
var sizes$1 = {
  s: {
    container: {
      minW: "59px",
      minH: "28px",
      fontSize: "xs",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "1.5px",
      px: 3,
      py: 1
    }
  },
  xs: {
    container: {
      minW: "44px",
      minH: "23px",
      fontSize: "10px",
      fontWeight: 700,
      lineHeight: "15px",
      letterSpacing: "0.5px",
      px: 2,
      py: 1
    }
  }
};
var variants = {
  primary: function primary(_ref) {
    var colorScheme = _ref.colorScheme;
    return {
      container: {
        color: "greyscale.100",
        bg: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".400" : colorScheme + ".500"
      }
    };
  },
  secondary: function secondary(_ref2) {
    var colorScheme = _ref2.colorScheme;
    return {
      container: {
        bg: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".100" : colorScheme + ".200",
        color: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".400" : colorScheme + ".500"
      }
    };
  },
  tertiary: function tertiary(_ref3) {
    var colorScheme = _ref3.colorScheme;
    return {
      container: {
        border: "1px solid",
        borderColor: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".400" : colorScheme + ".500",
        color: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".400" : colorScheme + ".500",
        bg: colorScheme.replace("info", "primary") + ".100"
      }
    };
  },
  quaternary: function quaternary(_ref4) {
    var colorScheme = _ref4.colorScheme;
    return {
      container: {
        bg: "none",
        color: colorScheme === "info" ? colorScheme.replace("info", "primary") + ".400" : colorScheme + ".500"
      }
    };
  }
};
var defaultProps = {
  size: "s",
  colorScheme: "info",
  variant: "primary"
};
var Tag = {
  variants: variants,
  baseStyle: baseStyle,
  sizes: sizes$1,
  defaultProps: defaultProps
};

var components = {
  Accordion: Accordion,
  Avatar: Avatar,
  Badge: Badge,
  Breadcrumb: Breadcrumb,
  Button: Button,
  Checkbox: Checkbox,
  Form: Form,
  FormError: FormError,
  FormLabel: FormLabel,
  Heading: Heading,
  Radio: Radio,
  Input: Input,
  Link: Link,
  Modal: Modal,
  Popover: Popover,
  Progress: Progress,
  InfoBox: InfoBox,
  Spinner: Spinner,
  Switch: Switch,
  Text: Text,
  Textarea: Textarea,
  Collapsible: Collapsible,
  Tag: Tag
};

var colors = {
  font: {
    primary: colorPrimary900
  },
  primary: {
    100: colorPrimary100,
    200: colorPrimary200,
    300: colorPrimary300,
    400: colorPrimary400,
    500: colorPrimary500,
    600: colorPrimary600,
    700: colorPrimary700,
    800: colorPrimary800,
    900: colorPrimary900
  },
  secondary: {
    100: colorSecondary100,
    200: colorSecondary200,
    300: colorSecondary300,
    400: colorSecondary400,
    500: colorSecondary500,
    600: colorSecondary600,
    700: colorSecondary700,
    800: colorSecondary800,
    900: colorSecondary900
  },
  greyscale: {
    100: colorGreyscale100,
    200: colorGreyscale200,
    300: colorGreyscale300,
    400: colorGreyscale400,
    500: colorGreyscale500,
    600: colorGreyscale600,
    700: colorGreyscale700,
    800: colorGreyscale800,
    900: colorGreyscale900
  },
  success: {
    100: colorSuccess100,
    200: colorSuccess200,
    300: colorSuccess300,
    400: colorSuccess400,
    500: colorSuccess500,
    600: colorSuccess600,
    700: colorSuccess700,
    800: colorSuccess800,
    900: colorSuccess900
  },
  warning: {
    100: colorWarning100,
    200: colorWarning200,
    300: colorWarning300,
    400: colorWarning400,
    500: colorWarning500,
    600: colorWarning600,
    700: colorWarning700,
    800: colorWarning800,
    900: colorWarning900
  },
  danger: {
    100: colorDanger100,
    200: colorDanger200,
    300: colorDanger300,
    400: colorDanger400,
    500: colorDanger500,
    600: colorDanger600,
    700: colorDanger700,
    800: colorDanger800,
    900: colorDanger900
  },
  complementary: {
    blue: colorComplementaryBlue
  }
};

var sizes = {
  "18": "4.5rem"
};

var styles = {
  global: {
    body: {
      color: "primary.900"
    }
  }
};

var typography = {
  lineHeights: {
    none: lineHeightNone,
    "short": lineHeightShort,
    shorter: lineHeightShort,
    base: lineHeightBase
  },
  fonts: {
    body: fontFamilyMain,
    heading: fontFamilyMain
  },
  fontSizes: {
    xs: fontSizeXs,
    sm: fontSizeSm,
    md: fontSizeMd,
    lg: fontSizeLg,
    xl: fontSizeXl,
    "2xl": fontSize2xl,
    "3xl": fontSize3xl,
    "4xl": fontSize4xl,
    "5xl": fontSize5xl
  }
};

var shadows = {
  none: shadowsNone,
  base: shadowsBase,
  md: shadowsMd,
  lg: shadowsLg,
  alt: shadowsAlt
};

var radii = {
  xs: borderRadiusXs,
  sm: borderRadiusSm,
  md: borderRadiusMd,
  lg: borderRadiusLg,
  xl: borderRadiusXl,
  "2xl": borderRadius2xl,
  "3xl": borderRadius3xl
};

var ChakraTheme = /*#__PURE__*/extendTheme( /*#__PURE__*/_extends({
  colors: colors,
  components: components,
  sizes: sizes,
  styles: styles,
  shadows: shadows,
  radii: radii
}, typography));

export { ActionButton$1 as ActionButton, AirportAutocomplete, Autocomplete, ChakraTheme, Collapsible$2 as Collapsible, ConsumerRights$1 as ConsumerRights, CookiesNotice$1 as CookiesNotice, DatePicker$1 as DatePicker, DocumentsUploader$1 as DocumentsUploader, EURegulation$1 as EURegulation, index$2 as Flags, Fonts$1 as Fonts, index$3 as Icons, index$1 as Illustrations, InfoBox$2 as InfoBox, Input$2 as Input, LanguageSwitcher$1 as LanguageSwitcher, LanguageSwitcherModal$1 as LanguageSwitcherModal, LinkGenerator$1 as LinkGenerator, index as Logos, Select, SignatureBox$1 as SignatureBox, Textarea$2 as Textarea, Trustpilot$1 as Trustpilot, registerLocales };
//# sourceMappingURL=react-ui-components.esm.js.map
